/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axiosClient";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axiosClient";
import type { AddressAutocompleteControllerSuggestQueryResponse, AddressAutocompleteControllerSuggestQueryParams, AikanControllerGetAikanAssetsQueryResponse, AikanControllerGetAikanAssetsQueryParams, AikanControllerGetAikanDocumentByIdQueryResponse, AikanControllerGetAikanDocumentByIdQueryParams, AppControllerIndexQueryResponse, AuthControllerCheckEmailMutationRequest, AuthControllerCheckEmailMutationResponse, AssetControllerBatchCreateAssetsMutationRequest, AssetControllerBatchCreateAssetsMutationResponse, AssetControllerBatchCreateAssetsQueryParams, AssetControllerBatchEditAssetsMutationRequest, AssetControllerBatchEditAssetsMutationResponse, AssetControllerBatchEditAssetsQueryParams, AssetControllerBatchRemoveAssetsMutationRequest, AssetControllerBatchRemoveAssetsMutationResponse, AssetControllerBatchRemoveAssetsQueryParams, AssetControllerCreateAssetMutationRequest, AssetControllerCreateAssetMutationResponse, AssetControllerCreateAssetQueryParams, AssetControllerCreateAsset400, AssetControllerCreateAsset403, AssetControllerCreateAsset404, AssetControllerCreateAsset409, AssetControllerReplaceAssetMutationRequest, AssetControllerReplaceAssetMutationResponse, AssetControllerReplaceAssetPathParams, AssetControllerReplaceAssetQueryParams, AssetControllerReplaceAsset400, AssetControllerReplaceAsset404, AssetControllerReplaceAsset409, AssetControllerEditAssetMutationRequest, AssetControllerEditAssetMutationResponse, AssetControllerEditAssetPathParams, AssetControllerEditAssetQueryParams, AssetControllerEditAsset400, AssetControllerEditAsset403, AssetControllerEditAsset404, AssetControllerEditAsset409, AssetControllerGetAssetQueryResponse, AssetControllerGetAssetPathParams, AssetControllerGetAssetQueryParams, AssetControllerGetAsset403, AssetControllerGetAsset404, AssetControllerRemoveAssetMutationResponse, AssetControllerRemoveAssetPathParams, AssetControllerRemoveAssetQueryParams, AssetControllerRemoveAsset400, AssetControllerRemoveAsset403, AssetControllerRemoveAsset404, AssetControllerRemoveAsset409, AssetControllerPushAssetEventMutationRequest, AssetControllerPushAssetEventMutationResponse, AssetControllerPushAssetEventPathParams, AssetControllerPushAssetEventQueryParams, AssetControllerPushAssetEvent400, AssetControllerPushAssetEvent404, AssetControllerGetAssetExternalQuoteQueryResponse, AssetControllerGetAssetExternalQuotePathParams, AssetControllerGetAssetExternalQuoteQueryParams, AssetControllerGetAssetExternalQuote404, BillingControllerGetInvoicesQueryResponse, BillingControllerGetInvoicesQueryParams, BillingControllerListInvoiceEventsQueryResponse, BillingControllerListInvoiceEventsPathParams, BillingControllerListInvoiceEvents404, BillingControllerListInvoicesMutationRequest, BillingControllerListInvoicesMutationResponse, BillingControllerCreateManualInvoiceMutationRequest, BillingControllerCreateManualInvoiceMutationResponse, BillingControllerSetInvoiceCleanupMutationRequest, BillingControllerSetInvoiceCleanupMutationResponse, BillingControllerIssueInvoicesMutationRequest, BillingControllerIssueInvoicesMutationResponse, BillingControllerDeleteInvoicesMutationRequest, BillingControllerDeleteInvoicesMutationResponse, BranchControllerEditBranchMutationRequest, BranchControllerEditBranchMutationResponse, BranchControllerEditBranchPathParams, BranchControllerEditBranch400, BranchControllerEditBranch404, BranchControllerEditBranch409, BranchControllerCreateBranchMutationRequest, BranchControllerCreateBranchMutationResponse, BranchControllerCreateBranchPathParams, BranchControllerCreateBranchQueryParams, BranchControllerCreateBranch400, BranchControllerCreateBranch404, BranchControllerCreateBranch409, PolicyControllerListBranchesQueryResponse, PolicyControllerListBranchesPathParams, PolicyControllerListBranchesQueryParams, PolicyControllerListBranches403, PolicyControllerListBranches404, BranchControllerGetBranchEffectiveDateQueryResponse, BranchControllerGetBranchEffectiveDatePathParams, BranchControllerGetBranchEffectiveDateQueryParams, BranchControllerForkBranchMutationRequest, BranchControllerForkBranchMutationResponse, BranchControllerForkBranchPathParams, BranchControllerForkBranchQueryParams, BranchControllerForkBranch400, BranchControllerForkBranch404, BranchControllerForkBranch409, BranchControllerForkBranchWithoutPolicyMutationRequest, BranchControllerForkBranchWithoutPolicyMutationResponse, BranchControllerForkBranchWithoutPolicyPathParams, BranchControllerForkBranchWithoutPolicyQueryParams, BranchControllerForkBranchWithoutPolicy400, BranchControllerForkBranchWithoutPolicy404, BranchControllerForkBranchWithoutPolicy409, BranchControllerInvalidateBranchMutationRequest, BranchControllerInvalidateBranchMutationResponse, BranchControllerInvalidateBranchPathParams, BranchControllerInvalidateBranchQueryParams, BranchControllerInvalidateBranch403, BranchControllerInvalidateBranch404, BranchControllerInvalidateBranch409, BrokerControllerAtMeQueryResponse, BrokerControllerCreateBrokerMutationRequest, BrokerControllerCreateBrokerMutationResponse, BrokerControllerCreateBrokerPathParams, BrokerControllerCreateBroker404, BrokerControllerListBrokersQueryResponse, BrokerControllerListBrokersPathParams, BrokerControllerListBrokersQueryParams, BrokerControllerListBrokers404, BrokerControllerUpdateBrokerMutationRequest, BrokerControllerUpdateBrokerMutationResponse, BrokerControllerUpdateBrokerPathParams, BrokerControllerUpdateBroker404, BrokerControllerDeleteBrokerMutationResponse, BrokerControllerDeleteBrokerPathParams, BrokerControllerDeleteBroker404, BrokerControllerListDescendantBrokersQueryResponse, BrokerControllerListDescendantBrokersPathParams, BrokerControllerListDescendantBrokersQueryParams, BrokerControllerListDescendantBrokers404, BrokerControllerGetBrokerQueryResponse, BrokerControllerGetBrokerPathParams, BrokerControllerGetBroker404, EmailAccountControllerListMineQueryResponse, EmailAccountControllerConnectMutationRequest, EmailAccountControllerConnectMutationResponse, EmailAccountControllerReconnectMutationRequest, EmailAccountControllerReconnectMutationResponse, EmailAccountControllerReconnectPathParams, EmailAccountControllerDisconnectMutationResponse, EmailAccountControllerDisconnectPathParams, EmailControllerAttachPoliciesMutationRequest, EmailControllerAttachPoliciesMutationResponse, EmailControllerAttachPoliciesPathParams, EmailControllerAttachPolicies400, EmailControllerAttachPolicies401, EmailControllerAttachPolicies403, EmailControllerDetachPoliciesMutationRequest, EmailControllerDetachPoliciesMutationResponse, EmailControllerDetachPolicies400, EmailControllerDetachPolicies401, EmailControllerDetachPolicies403, EmailControllerDetachPolicyMutationResponse, EmailControllerDetachPolicyPathParams, EmailControllerDetachPolicy400, EmailControllerDetachPolicy401, EmailControllerDetachPolicy403, EmailControllerMovePolicyMutationRequest, EmailControllerMovePolicyMutationResponse, EmailControllerMovePolicyPathParams, EmailControllerMovePolicy400, EmailControllerMovePolicy401, EmailControllerMovePolicy403, EmailControllerGetAttachmentDownloadUrlQueryResponse, EmailControllerGetAttachmentDownloadUrlPathParams, EmailControllerGetAttachmentDownloadUrl401, EmailControllerGetAttachmentDownloadUrl409, EmailControllerGetEmailQueryResponse, EmailControllerGetEmailPathParams, EmailControllerGetEmail400, EmailControllerGetEmail401, EmailThreadControllerListThreadsQueryResponse, EmailThreadControllerListThreadsQueryParams, EmailThreadControllerListThreads400, EmailThreadControllerListThreads401, EmailThreadControllerSetThreadsArchivedMutationRequest, EmailThreadControllerSetThreadsArchivedMutationResponse, EmailThreadControllerSetThreadsArchived400, EmailThreadControllerSetThreadsArchived401, EmailThreadControllerGetThreadQueryResponse, EmailThreadControllerGetThreadPathParams, EmailThreadControllerGetThread400, EmailThreadControllerGetThread401, EmailThreadControllerAttachThreadsPoliciesMutationRequest, EmailThreadControllerAttachThreadsPoliciesMutationResponse, EmailThreadControllerAttachThreadsPolicies400, EmailThreadControllerAttachThreadsPolicies401, EmailThreadControllerAttachThreadsPolicies403, GeneralInboxControllerGetSummaryQueryResponse, ClaimManagementControllerLookupCustomerMutationRequest, ClaimManagementControllerLookupCustomerMutationResponse, ClaimManagementControllerLookupCustomer400, ClaimManagementControllerLookupCustomer404, ClaimManagementControllerCheckCoverageMutationRequest, ClaimManagementControllerCheckCoverageMutationResponse, ClaimManagementControllerCheckCoverage400, ClaimManagementControllerCheckCoverage422, ClaimManagementControllerGenerateFnolUploadUrlMutationRequest, ClaimManagementControllerGenerateFnolUploadUrlMutationResponse, ClaimManagementControllerGenerateFnolUploadUrl400, ClaimManagementControllerGenerateFnolUploadUrl413, ClaimManagementControllerBootstrapMutationRequest, ClaimManagementControllerBootstrapMutationResponse, ClaimManagementControllerBootstrap400, ClaimManagementControllerBootstrap422, ClaimManagementControllerListQueryResponse, ClaimManagementControllerListQueryParams, ClaimManagementControllerList400, ClaimManagementControllerListMyClaimsQueryResponse, ClaimManagementControllerListMyClaimsQueryParams, ClaimManagementControllerListMyClaims400, ClaimManagementControllerUpdateDraftMutationRequest, ClaimManagementControllerUpdateDraftMutationResponse, ClaimManagementControllerUpdateDraftPathParams, ClaimManagementControllerUpdateDraft400, ClaimManagementControllerUpdateDraft404, ClaimManagementControllerUpdateDraft409, ClaimManagementControllerGetQueryResponse, ClaimManagementControllerGetPathParams, ClaimManagementControllerGet400, ClaimManagementControllerGet404, ClaimManagementControllerUpdateCustomFieldsMutationRequest, ClaimManagementControllerUpdateCustomFieldsMutationResponse, ClaimManagementControllerUpdateCustomFieldsPathParams, ClaimManagementControllerUpdateCustomFields400, ClaimManagementControllerUpdateCustomFields404, ClaimManagementControllerUpdateCustomFields409, ClaimManagementControllerAttachDocumentMutationRequest, ClaimManagementControllerAttachDocumentMutationResponse, ClaimManagementControllerAttachDocumentPathParams, ClaimManagementControllerAttachDocument400, ClaimManagementControllerAttachDocument404, ClaimManagementControllerAttachDocument409, ClaimManagementControllerGenerateDocumentMutationRequest, ClaimManagementControllerGenerateDocumentMutationResponse, ClaimManagementControllerGenerateDocumentPathParams, ClaimManagementControllerGenerateDocument400, ClaimManagementControllerGenerateDocument404, ClaimManagementControllerGenerateDocument409, ClaimManagementControllerGetDocumentGenerationPayloadMutationRequest, ClaimManagementControllerGetDocumentGenerationPayloadMutationResponse, ClaimManagementControllerGetDocumentGenerationPayload400, ClaimManagementControllerGetDocumentGenerationPayload404, ClaimManagementControllerGetDocumentGenerationPayload409, ClaimManagementControllerDetachDocumentMutationResponse, ClaimManagementControllerDetachDocumentPathParams, ClaimManagementControllerDetachDocument400, ClaimManagementControllerDetachDocument404, ClaimManagementControllerDetachDocument409, ClaimManagementControllerTransitionMutationRequest, ClaimManagementControllerTransitionMutationResponse, ClaimManagementControllerTransitionPathParams, ClaimManagementControllerTransition400, ClaimManagementControllerTransition404, ClaimManagementControllerTransition409, ClaimManagementControllerRetryForwardMutationResponse, ClaimManagementControllerRetryForwardPathParams, ClaimManagementControllerRetryForward400, ClaimManagementControllerRetryForward404, ClaimManagementControllerAddNoteMutationRequest, ClaimManagementControllerAddNoteMutationResponse, ClaimManagementControllerAddNotePathParams, ClaimManagementControllerAddNote400, ClaimManagementControllerAddNote404, ClaimManagementControllerStartClaimsExportMutationResponse, ClaimManagementControllerStartClaimsExportQueryParams, ClaimManagementControllerStartClaimsExport400, ClaimManagementControllerGetClaimsExportStatusQueryResponse, ClaimManagementControllerGetClaimsExportStatusPathParams, ClaimManagementControllerGetClaimsExportStatus400, ClaimManagementControllerAvailableTransitionsQueryResponse, ClaimManagementControllerAvailableTransitionsPathParams, ClaimManagementControllerAvailableTransitions400, ClaimManagementControllerAvailableTransitions404, ClaimManagementControllerGetClaimExtractionsQueryResponse, ClaimManagementControllerGetClaimExtractionsPathParams, ClaimManagementControllerGetClaimExtractions400, ClaimManagementControllerGetClaimExtractions404, ClaimManagementControllerStatusHistoryQueryResponse, ClaimManagementControllerStatusHistoryPathParams, ClaimManagementControllerStatusHistory400, ClaimManagementControllerStatusHistory404, ClaimManagementControllerDocumentFraudScoresQueryResponse, ClaimManagementControllerDocumentFraudScoresPathParams, ClaimManagementControllerDocumentFraudScores400, ClaimManagementControllerFraudNarrativeQueryResponse, ClaimManagementControllerFraudNarrativePathParams, ClaimManagementControllerFraudNarrative400, ClaimManagementControllerCorrectDocumentFraudVerdictMutationRequest, ClaimManagementControllerCorrectDocumentFraudVerdictMutationResponse, ClaimManagementControllerCorrectDocumentFraudVerdictPathParams, ClaimManagementControllerCorrectDocumentFraudVerdict400, ClaimManagementControllerTimelineQueryResponse, ClaimManagementControllerTimelinePathParams, ClaimManagementControllerTimeline400, ClaimManagementControllerTimeline404, ExternalClaimsControllerCreateMutationRequest, ExternalClaimsControllerCreateMutationResponse, ExternalClaimsControllerResyncMutationResponse, ExternalClaimsControllerResyncPathParams, ClaimsControllerCreateMutationRequest, ClaimsControllerCreateMutationResponse, ClaimsControllerCreate400, ClaimsControllerCreate409, ClaimsControllerListQueryResponse, ClaimsControllerListQueryParams, ClaimsControllerList400, ClaimsControllerUpdateMutationRequest, ClaimsControllerUpdateMutationResponse, ClaimsControllerUpdatePathParams, ClaimsControllerUpdate400, ClaimsControllerUpdate404, ClaimsControllerUpdate409, ClaimsControllerDeleteMutationResponse, ClaimsControllerDeletePathParams, ClaimsControllerDelete400, ClaimsControllerDelete404, ClaimsControllerGetQueryResponse, ClaimsControllerGetPathParams, ClaimsControllerGet400, ClaimsControllerGet404, ConfigControllerListTenantsQueryResponse, ConfigControllerGetTenantConfigQueryResponse, ConfigControllerGetTenantConfig400, ConfigControllerGetProductConfigQueryResponse, ConfigControllerGetProductConfigPathParams, ConfigControllerGetProductConfig400, ConfigControllerGetPublicTenantConfigByDomainQueryResponse, ConfigControllerGetPublicTenantConfigByDomainQueryParams, ConfigControllerGetPublicTenantConfigByDomain400, ConfigControllerGetPublicProductConfigQueryResponse, ConfigControllerGetPublicProductConfigPathParams, ConfigControllerGetPublicProductConfig400, ConfigControllerGetPublicTenantConfigQueryResponse, ConfigControllerGetPublicTenantConfig400, ConfigControllerGetProductsForTenantQueryResponse, ConfigControllerGetProductsForTenant400, ConfigControllerGetBusinessRolePermissionsQueryResponse, ConfigControllerGetBusinessRolePermissionsQueryParams, ConfigControllerGetBusinessRolePermissions400, FeatureFlagControllerAtMeQueryResponse, FeatureFlagControllerAtMeQueryParams, FeatureFlagControllerFindAllQueryResponse, FeatureFlagControllerUpdateMutationRequest, FeatureFlagControllerUpdateMutationResponse, CustomerControllerGetCustomerQueryResponse, CustomerControllerGetCustomerPathParams, CustomerControllerGetCustomerQueryParams, CustomerControllerGetCustomer404, CustomerControllerEditCustomerMutationRequest, CustomerControllerEditCustomerMutationResponse, CustomerControllerEditCustomerPathParams, CustomerControllerEditCustomerQueryParams, CustomerControllerEditCustomer400, CustomerControllerEditCustomer404, CustomerControllerEditCustomer409, CustomerControllerGetCustomerPaymentMethodsQueryResponse, CustomerControllerGetCustomerPaymentMethodsPathParams, CustomerControllerGetCustomerPaymentMethodsQueryParams, CustomerControllerGetCustomerPaymentMethods404, CustomerControllerGetPaymentMethodSetupSecretQueryResponse, CustomerControllerGetPaymentMethodSetupSecretPathParams, CustomerControllerGetPaymentMethodSetupSecretQueryParams, CustomerControllerGetPaymentMethodSetupSecret400, CustomerControllerGetPaymentMethodSetupSecret404, CustomerControllerGetPaymentMethodSetupSecret409, CustomerControllerListCustomersQueryResponse, CustomerControllerListCustomersQueryParams, CustomerControllerInitializeCustomerMutationRequest, CustomerControllerInitializeCustomerMutationResponse, CustomerControllerInitializeCustomerQueryParams, CustomerControllerInitializeCustomer400, CustomerControllerInitializeCustomer404, CustomerControllerInitializeCustomer409, CustomerControllerPushCustomerEventMutationRequest, CustomerControllerPushCustomerEventMutationResponse, CustomerControllerPushCustomerEventPathParams, CustomerControllerPushCustomerEventQueryParams, CustomerControllerPushCustomerEvent400, CustomerControllerPushCustomerEvent404, CustomerControllerGetInvoicingScheduleQueryResponse, CustomerControllerGetInvoicingSchedulePathParams, CustomerControllerGetInvoicingScheduleQueryParams, CustomerControllerGetInvoicingSchedule400, CustomerControllerGetInvoicingSchedule404, CustomerControllerGenerateMandateSignatureRequestMutationRequest, CustomerControllerGenerateMandateSignatureRequestMutationResponse, CustomerControllerGenerateMandateSignatureRequestPathParams, CustomerControllerGenerateMandateSignatureRequestQueryParams, CustomerControllerGenerateMandateSignatureRequest400, CustomerControllerGenerateMandateSignatureRequest404, CustomerControllerGenerateMandateSignatureRequest409, CustomerControllerGenerateMandateSignatureRequest425, CustomerControllerUpdatePreferredPaymentMethodMutationResponse, CustomerControllerUpdatePreferredPaymentMethodPathParams, CustomerControllerUpdatePreferredPaymentMethodQueryParams, CustomerControllerUpdatePreferredPaymentMethod400, CustomerControllerUpdatePreferredPaymentMethod404, CustomerControllerUpdatePreferredPaymentMethod409, CustomerControllerDeletePaymentMethodMutationResponse, CustomerControllerDeletePaymentMethodPathParams, CustomerControllerDeletePaymentMethod404, CustomerControllerDeletePaymentMethod409, CustomerControllerUpdatePaymentModeMutationRequest, CustomerControllerUpdatePaymentModeMutationResponse, CustomerControllerUpdatePaymentModePathParams, CustomerControllerUpdatePaymentModeQueryParams, CustomerControllerUpdatePaymentMode400, CustomerControllerUpdatePaymentMode404, CustomerControllerUpdatePaymentMode409, CustomerControllerGetBankTransferAccountQueryResponse, CustomerControllerGetBankTransferAccountPathParams, CustomerControllerGetBankTransferAccount400, CustomerControllerGetBankTransferAccount404, CustomerControllerGetBankTransferAccount409, CustomerControllerChargeMutationRequest, CustomerControllerChargeMutationResponse, CustomerControllerChargePathParams, CustomerControllerChargeQueryParams, CustomerControllerCharge400, CustomerControllerCharge404, CustomerControllerManuallyMarkInvoiceMutationRequest, CustomerControllerManuallyMarkInvoiceMutationResponse, CustomerControllerManuallyMarkInvoicePathParams, CustomerControllerManuallyMarkInvoice400, CustomerControllerManuallyMarkInvoice404, CustomerControllerManuallyMarkInvoice409, CustomerControllerManuallyMarkInvoice500, CustomerControllerGetCustomerBalanceQueryResponse, CustomerControllerGetCustomerBalancePathParams, CustomerControllerGetCustomerBalance404, CustomerControllerGetMigratedBillingTakeoverQueryResponse, CustomerControllerGetMigratedBillingTakeoverPathParams, CustomerControllerSetMigratedBillingTakeoverMutationRequest, CustomerControllerSetMigratedBillingTakeoverMutationResponse, CustomerControllerSetMigratedBillingTakeoverPathParams, CustomerControllerUnlockMigratedBillingTakeoverMutationResponse, CustomerControllerUnlockMigratedBillingTakeoverPathParams, CustomerControllerCreateCustomerForPolicyMutationRequest, CustomerControllerCreateCustomerForPolicyMutationResponse, CustomerControllerCreateCustomerForPolicyPathParams, CustomerControllerCreateCustomerForPolicyQueryParams, CustomerControllerCreateCustomerForPolicy404, CustomerControllerDeleteCustomerFromPolicyMutationResponse, CustomerControllerDeleteCustomerFromPolicyPathParams, CustomerControllerDeleteCustomerFromPolicyQueryParams, CustomerControllerDeleteCustomerFromPolicy403, CustomerControllerDeleteCustomerFromPolicy404, CustomerControllerDeleteCustomerFromPolicy409, DebugControllerClearTestDataMutationResponse, DebugControllerClearProjectionsDataMutationResponse, DebugControllerClearProjectionsDataQueryParams, DebugControllerClearLegacyCacheMutationResponse, DebugControllerClearLegacyCacheQueryParams, DebugControllerGetProjectionsQueryResponse, DebugControllerGetProjectionsPathParams, DebugControllerGetProjectionsQueryParams, DebugControllerCountCoreEventsQueryResponse, DebugControllerCountCoreEventsPathParams, DebugControllerCountCoreEventsQueryParams, DebugControllerToggleIgnoreCoreEventsMutationRequest, DebugControllerToggleIgnoreCoreEventsMutationResponse, DebugControllerBillCustomerMutationResponse, DebugControllerBillCustomerPathParams, DebugControllerBillCustomerQueryParams, DebugControllerBatchBillCustomersMutationRequest, DebugControllerBatchBillCustomersMutationResponse, DebugControllerBatchBillCustomersQueryParams, DebugControllerBatchChargeInvoicesMutationRequest, DebugControllerBatchChargeInvoicesMutationResponse, DebugControllerStartDailyStagingCleanupMutationResponse, DebugControllerCreateDistributionRequestsAndFeesMutationRequest, DebugControllerCreateDistributionRequestsAndFeesMutationResponse, DebugControllerCreatePaymentFromStripeMutationRequest, DebugControllerCreatePaymentFromStripeMutationResponse, DebugControllerUpdatePaymentStatusMutationRequest, DebugControllerUpdatePaymentStatusMutationResponse, DebugControllerRefreshInvoiceStatusMutationRequest, DebugControllerRefreshInvoiceStatusMutationResponse, DebugControllerBatchGenerateDocumentsMutationRequest, DebugControllerBatchGenerateDocumentsMutationResponse, DebugControllerBatchCreateUserRelationsMutationRequest, DebugControllerBatchCreateUserRelationsMutationResponse, DebugControllerCheckAllDocumentsMutationRequest, DebugControllerCheckAllDocumentsMutationResponse, DebugControllerRetriggerClaimDocumentFraudCheckMutationRequest, DebugControllerRetriggerClaimDocumentFraudCheckMutationResponse, DebugControllerSuperDeletePoliciesMutationResponse, DebugControllerSuperDeletePoliciesPathParams, DocumentsControllerValidateAndProcessDocumentQueryResponse, DocumentsControllerValidateAndProcessDocumentQueryParams, DocumentsControllerGetDocumentsQueryResponse, DocumentsControllerGetDocumentsQueryParams, DocumentsControllerGenerateDocumentUploadUrlsMutationRequest, DocumentsControllerGenerateDocumentUploadUrlsMutationResponse, DocumentsControllerDeleteDocumentsMutationResponse, DocumentsControllerDeleteDocumentsQueryParams, DocumentsControllerArchiveDocumentsMutationRequest, DocumentsControllerArchiveDocumentsMutationResponse, DocumentsControllerArchiveDocuments403, DocumentsControllerArchiveDocuments404, DocumentsControllerRestoreDocumentsMutationRequest, DocumentsControllerRestoreDocumentsMutationResponse, DocumentsControllerRestoreDocuments403, DocumentsControllerRestoreDocuments404, DocumentsControllerSetDocumentCategoryMutationRequest, DocumentsControllerSetDocumentCategoryMutationResponse, DocumentsControllerSetDocumentCategoryPathParams, DocumentsControllerSetDocumentCategory400, DocumentsControllerSetDocumentCategory403, DocumentsControllerSetDocumentCategory404, DocumentsControllerListDocumentsWithPresignedUrlMutationRequest, DocumentsControllerListDocumentsWithPresignedUrlMutationResponse, DocumentsControllerCreatePdfMutationRequest, DocumentsControllerCreatePdfMutationResponse, DocumentsControllerScheduleHandleMalwareProtectionScanResultMutationRequest, DocumentsControllerScheduleHandleMalwareProtectionScanResultMutationResponse, HealthControllerIndexQueryResponse, HealthControllerCheckQueryResponse, HealthControllerCheckPathParams, InvitationControllerInviteMutationRequest, InvitationControllerInviteMutationResponse, InvitationControllerInvite400, InvitationControllerAdminInviteMutationRequest, InvitationControllerAdminInviteMutationResponse, InvitationControllerAdminInvite400, InvitationControllerBrokerInviteMutationRequest, InvitationControllerBrokerInviteMutationResponse, InvitationControllerBrokerInvite400, InvitationControllerCreateAnonymousSessionMutationResponse, InvitationControllerCreateAnonymousSessionQueryParams, InvitationControllerHandoffAnonymousSessionMutationRequest, InvitationControllerHandoffAnonymousSessionMutationResponse, InvitationControllerResolveAnonymousSessionEntitiesQueryResponse, JobSchedulersControllerGetJobSchedulersQueryResponse, JobSchedulersControllerListMutationRequest, JobSchedulersControllerListMutationResponse, JobSchedulersControllerGetQueryResponse, JobSchedulersControllerGetPathParams, JobSchedulersControllerGet404, JobSchedulersControllerUpsertMutationRequest, JobSchedulersControllerUpsertMutationResponse, JobSchedulersControllerUpsertPathParams, JobSchedulersControllerUpdateMutationRequest, JobSchedulersControllerUpdateMutationResponse, JobSchedulersControllerUpdatePathParams, JobSchedulersControllerUpdate404, JobSchedulersControllerDeleteMutationResponse, JobSchedulersControllerDeletePathParams, JobSchedulersControllerDelete404, JobsControllerCreateJobMutationRequest, JobsControllerCreateJobMutationResponse, JobsControllerCreateJobsMutationRequest, JobsControllerCreateJobsMutationResponse, JobsControllerUpdateJobMutationRequest, JobsControllerUpdateJobMutationResponse, JobsControllerUpdateJobPathParams, JobsControllerGetJobQueryResponse, JobsControllerGetJobPathParams, JobsControllerCancelJobMutationResponse, JobsControllerCancelJobPathParams, JobsControllerCancelJobsMutationRequest, JobsControllerCancelJobsMutationResponse, JobsControllerRetryJobsMutationRequest, JobsControllerRetryJobsMutationResponse, JobsControllerListJobsMutationRequest, JobsControllerListJobsMutationResponse, JobsControllerCountJobsMutationRequest, JobsControllerCountJobsMutationResponse, JobsControllerClearJobsDataMutationResponse, JobsControllerClearWorkflowsDataMutationResponse, JobsControllerCancelPushProjectionJobsMutationResponse, QueueManagementControllerPauseMutationResponse, QueueManagementControllerResumeMutationResponse, QueueManagementControllerGetStatusQueryResponse, QueueManagementControllerPauseSingleMutationResponse, QueueManagementControllerPauseSinglePathParams, QueueManagementControllerResumeSingleMutationResponse, QueueManagementControllerResumeSinglePathParams, LegacyDocumentsControllerGenerateDocumentOnDemandMutationRequest, LegacyDocumentsControllerGenerateDocumentOnDemandMutationResponse, LegacyDocumentsControllerGenerateDocumentOnDemand400, LegacyDocumentsControllerGenerateDocumentOnDemand404, LegacyDocumentsControllerGetOnDemandDocumentsQueryResponse, LegacyDocumentsControllerGetOnDemandDocumentsQueryParams, LegacyDocumentsControllerGetOnDemandDocuments400, LegacyDocumentsControllerGetOnDemandDocuments404, LegacyDocumentsControllerGetExpectedGeneratedDocumentsQueryResponse, LegacyDocumentsControllerGetExpectedGeneratedDocumentsQueryParams, LegacyDocumentsControllerGetExpectedGeneratedDocuments400, LegacyDocumentsControllerGetExpectedGeneratedDocuments404, LegacyDocumentsControllerGetExpectedUploadedDocumentsQueryResponse, LegacyDocumentsControllerGetExpectedUploadedDocumentsQueryParams, LegacyDocumentsControllerGetExpectedUploadedDocuments400, LegacyDocumentsControllerGetExpectedUploadedDocuments404, LegacyDocumentsControllerGetExpectedUploadedDocuments501, LegacyDocumentsControllerGetGenerationPayloadMutationRequest, LegacyDocumentsControllerGetGenerationPayloadMutationResponse, LegacyDocumentsControllerGetGenerationPayloadQueryParams, LegacyDocumentsControllerGetGenerationPayload400, LegacyDocumentsControllerGetGenerationPayload404, LegacyDocumentsControllerRegenerateDocumentMutationRequest, LegacyDocumentsControllerRegenerateDocumentMutationResponse, LegacyDocumentsControllerRegenerateDocument404, LegacyDocumentsControllerRegenerateDocument500, LockControllerListLocksQueryResponse, LockControllerListLocksQueryParams, LockControllerGetLockQueryResponse, LockControllerGetLockPathParams, LockControllerDeleteLockMutationResponse, LockControllerDeleteLockPathParams, LockControllerCreateLockMutationRequest, LockControllerCreateLockMutationResponse, LockControllerCreateLockPathParams, LockControllerBatchCreateLocksMutationRequest, LockControllerBatchCreateLocksMutationResponse, LockControllerBatchGetLocksMutationRequest, LockControllerBatchGetLocksMutationResponse, LockControllerBatchDeleteLocksMutationRequest, LockControllerBatchDeleteLocksMutationResponse, NotificationControllerSendEmailMutationRequest, NotificationControllerSendEmailMutationResponse, NotificationControllerSendEmail400, NotificationControllerListEmailTemplatesQueryResponse, NotificationControllerListEmailTemplatesQueryParams, NotificationControllerRenderEmailTemplateMutationRequest, NotificationControllerRenderEmailTemplateMutationResponse, NotificationControllerRenderEmailTemplatePathParams, NotificationControllerRenderEmailTemplate404, NotificationControllerSendTestEmailMutationRequest, NotificationControllerSendTestEmailMutationResponse, NotificationControllerSendTestEmailPathParams, NotificationControllerSendTestEmail404, NotificationControllerListNotificationsQueryResponse, NotificationControllerListNotificationsQueryParams, NotificationControllerCreateNotificationMutationRequest, NotificationControllerCreateNotificationMutationResponse, NotificationControllerGetNotificationQueryResponse, NotificationControllerGetNotificationPathParams, NotificationControllerGetNotification404, NotificationControllerPatchNotificationMutationRequest, NotificationControllerPatchNotificationMutationResponse, NotificationControllerPatchNotificationPathParams, NotificationControllerDeleteNotificationMutationResponse, NotificationControllerDeleteNotificationPathParams, NotificationControllerSendNotificationMutationRequest, NotificationControllerSendNotificationMutationResponse, NotificationControllerSendNotification400, PaymentsControllerCreateCustomerMutationRequest, PaymentsControllerCreateCustomerMutationResponse, PaymentsControllerListCustomersMutationRequest, PaymentsControllerListCustomersMutationResponse, PaymentsControllerCreatePaymentMutationRequest, PaymentsControllerCreatePaymentMutationResponse, PaymentsControllerCreatePayment404, PaymentsControllerGetPaymentsQueryResponse, PaymentsControllerGetPaymentsQueryParams, PaymentsControllerSetupIntentMutationRequest, PaymentsControllerSetupIntentMutationResponse, PaymentsControllerSetupIntent404, PaymentsControllerGetCustomersPaymentMethodsQueryResponse, PaymentsControllerGetCustomersPaymentMethodsQueryParams, PaymentsControllerGetCustomerPaymentsQueryResponse, PaymentsControllerGetCustomerPaymentsPathParams, PaymentsControllerGetCustomerPaymentsQueryParams, PaymentsControllerCancelPaymentMutationRequest, PaymentsControllerCancelPaymentMutationResponse, PaymentsControllerCancelPaymentPathParams, PaymentsControllerSoftDeletePaymentMethodMutationResponse, PaymentsControllerSoftDeletePaymentMethodPathParams, PolicyControllerGetPolicyQueryResponse, PolicyControllerGetPolicyPathParams, PolicyControllerGetPolicyQueryParams, PolicyControllerGetPolicy403, PolicyControllerGetPolicy404, PolicyControllerEditPolicyMutationRequest, PolicyControllerEditPolicyMutationResponse, PolicyControllerEditPolicyPathParams, PolicyControllerEditPolicyQueryParams, PolicyControllerEditPolicy400, PolicyControllerEditPolicy403, PolicyControllerEditPolicy404, PolicyControllerEditPolicy409, PolicyControllerGenerateIncrementalIdMutationResponse, PolicyControllerGenerateIncrementalIdPathParams, PolicyControllerGenerateIncrementalId400, PolicyControllerGenerateDocumentUploadUrlMutationRequest, PolicyControllerGenerateDocumentUploadUrlMutationResponse, PolicyControllerGenerateDocumentUploadUrlPathParams, PolicyControllerGenerateDocumentUploadUrlQueryParams, PolicyControllerGenerateDocumentUploadUrl400, PolicyControllerGenerateDocumentUploadUrl403, PolicyControllerGenerateDocumentUploadUrl404, PolicyControllerListPolicyDocumentsQueryResponse, PolicyControllerListPolicyDocumentsPathParams, PolicyControllerListPolicyDocumentsQueryParams, PolicyControllerListPolicyDocuments403, PolicyControllerListPolicyDocuments404, PolicyControllerDeletePolicyDocumentsMutationResponse, PolicyControllerDeletePolicyDocumentsPathParams, PolicyControllerDeletePolicyDocumentsQueryParams, PolicyControllerDeletePolicyDocuments403, PolicyControllerDeletePolicyDocuments404, PolicyControllerEditPolicyExternalIdMutationRequest, PolicyControllerEditPolicyExternalIdMutationResponse, PolicyControllerEditPolicyExternalIdPathParams, PolicyControllerEditPolicyExternalId409, PolicyControllerConfirmPolicyMutationResponse, PolicyControllerConfirmPolicyPathParams, PolicyControllerConfirmPolicyQueryParams, PolicyControllerConfirmPolicy400, PolicyControllerConfirmPolicy403, PolicyControllerConfirmPolicy404, PolicyControllerConfirmPolicy409, PolicyControllerGeneratePolicySignatureRequestMutationRequest, PolicyControllerGeneratePolicySignatureRequestMutationResponse, PolicyControllerGeneratePolicySignatureRequestPathParams, PolicyControllerGeneratePolicySignatureRequestQueryParams, PolicyControllerGeneratePolicySignatureRequest400, PolicyControllerGeneratePolicySignatureRequest403, PolicyControllerGeneratePolicySignatureRequest404, PolicyControllerGeneratePolicySignatureRequest409, PolicyControllerGeneratePolicySignatureRequest425, PolicyControllerGetPremiumScheduleQueryResponse, PolicyControllerGetPremiumSchedulePathParams, PolicyControllerGetPremiumScheduleQueryParams, PolicyControllerGetPremiumSchedule403, PolicyControllerGetPremiumSchedule404, PolicyControllerListPolicyDocumentsAdminQueryResponse, PolicyControllerListPolicyDocumentsAdminPathParams, PolicyControllerListPolicyDocumentsAdminQueryParams, PolicyControllerListPolicyDocumentsAdmin403, PolicyControllerListPolicyDocumentsAdmin404, PolicyControllerListPolicyEventsQueryResponse, PolicyControllerListPolicyEventsPathParams, PolicyControllerListPolicyEvents404, PolicyControllerPushPolicyEventMutationRequest, PolicyControllerPushPolicyEventMutationResponse, PolicyControllerPushPolicyEventPathParams, PolicyControllerPushPolicyEventQueryParams, PolicyControllerPushPolicyEvent400, PolicyControllerPushPolicyEvent404, PolicyControllerPlanTasksQueryResponse, PolicyControllerPlanTasksPathParams, PolicyControllerPlanTasksQueryParams, PolicyControllerPlanTasks403, PolicyControllerPlanTasks404, PolicyControllerQuotePolicyMutationRequest, PolicyControllerQuotePolicyMutationResponse, PolicyControllerQuotePolicyPathParams, PolicyControllerQuotePolicyQueryParams, PolicyControllerQuotePolicy400, PolicyControllerQuotePolicy403, PolicyControllerQuotePolicy404, PolicyControllerQuotePolicy409, PolicyControllerGetAggregateQueryResponse, PolicyControllerGetAggregateQueryParams, PolicyControllerGetAggregate404, PolicyControllerCalculatePolicyQuoteMutationRequest, PolicyControllerCalculatePolicyQuoteMutationResponse, PolicyControllerCalculatePolicyQuotePathParams, PolicyControllerCalculatePolicyQuoteQueryParams, PolicyControllerCalculatePolicyQuote400, PolicyControllerCalculatePolicyQuote404, PolicyControllerCalculatePolicyQuote409, PolicyControllerStopPolicyMutationRequest, PolicyControllerStopPolicyMutationResponse, PolicyControllerStopPolicyPathParams, PolicyControllerStopPolicyQueryParams, PolicyControllerStopPolicy400, PolicyControllerStopPolicy403, PolicyControllerStopPolicy404, PolicyControllerStopPolicy409, PolicyControllerStopPolicy501, PolicyControllerRegisterAdditionalQuoteComponentsMutationRequest, PolicyControllerRegisterAdditionalQuoteComponentsMutationResponse, PolicyControllerRegisterAdditionalQuoteComponentsPathParams, PolicyControllerRegisterAdditionalQuoteComponentsQueryParams, PolicyControllerUpdatePolicyQuoteMutationRequest, PolicyControllerUpdatePolicyQuoteMutationResponse, PolicyControllerUpdatePolicyQuotePathParams, PolicyControllerUpdatePolicyQuoteQueryParams, PolicyControllerUpdatePolicyQuote404, PolicyControllerUpdatePolicyQuote409, PolicyControllerSuspendPolicyMutationResponse, PolicyControllerSuspendPolicyPathParams, PolicyControllerSuspendPolicyQueryParams, PolicyControllerSuspendPolicy404, PolicyControllerSuspendPolicy409, PolicyControllerActivatePolicyMutationRequest, PolicyControllerActivatePolicyMutationResponse, PolicyControllerActivatePolicyPathParams, PolicyControllerActivatePolicyQueryParams, PolicyControllerActivatePolicy400, PolicyControllerActivatePolicy404, PolicyControllerActivatePolicy409, PolicyControllerSetPolicyFeesMutationRequest, PolicyControllerSetPolicyFeesMutationResponse, PolicyControllerSetPolicyFeesPathParams, PolicyControllerSetPolicyFeesQueryParams, PolicyControllerSetPolicyFees400, PolicyControllerSetPolicyFees404, PolicyControllerManualQuotePolicyMutationRequest, PolicyControllerManualQuotePolicyMutationResponse, PolicyControllerManualQuotePolicyPathParams, PolicyControllerManualQuotePolicyQueryParams, PolicyControllerManualQuotePolicy400, PolicyControllerManualQuotePolicy404, PolicyControllerManualQuotePolicy409, PricingControllerComputePricingQueryResponse, PricingControllerComputePricingPathParams, PricingControllerComputePricingQueryParams, PricingControllerComputePricing400, PricingControllerComputePricing404, PricingControllerGetPriceQueryResponse, PricingControllerGetPricePathParams, PricingControllerGetPriceQueryParams, PricingControllerGetPrice404, PricingControllerSavePricingSelectionMutationRequest, PricingControllerSavePricingSelectionMutationResponse, PricingControllerSavePricingSelectionPathParams, PricingControllerSavePricingSelectionQueryParams, PricingControllerSavePricingSelection404, QuoteControllerGetQuoteMutationRequest, QuoteControllerGetQuoteMutationResponse, QuoteControllerGetQuotePathParams, QuoteControllerGetQuote400, QuoteControllerGetQuote404, QuoteControllerGetExternalQuoteQueryResponse, QuoteControllerGetExternalQuoteQueryParams, QuoteControllerGetExternalQuote404, RenewalControllerFinalizeRenewalBranchMutationResponse, RenewalControllerFinalizeRenewalBranchPathParams, RenewalControllerFinalizeRenewalBranchQueryParams, RenewalControllerFinalizeRenewalBranch404, RenewalControllerFinalizeRenewalBranch409, MonitoringControllerGetReportsQueryResponse, MonitoringControllerGetChecksQueryResponse, ReportingControllerGenerateReportMutationRequest, ReportingControllerGenerateReportMutationResponse, ReportingControllerGenerateReport400, ReportingControllerGetReportConfigQueryResponse, ReportingControllerGetReportConfigPathParams, ReportingControllerGetReportsMutationRequest, ReportingControllerGetReportsMutationResponse, ReportingControllerGenerateCustomReportMutationRequest, ReportingControllerGenerateCustomReportMutationResponse, RepricingControllerExecuteRepricingForPolicyMutationResponse, RepricingControllerExecuteRepricingForPolicyPathParams, RepricingControllerExecuteRepricingForPolicyQueryParams, SearchControllerSearchMutationRequest, SearchControllerSearchMutationResponse, SearchControllerSearchQueryParams, SearchControllerGenericSearchMutationRequest, SearchControllerGenericSearchMutationResponse, SearchControllerGenericSearchPathParams, SearchControllerGenericSearchQueryParams, SearchControllerGenericSearchSwaggerQueryResponse, SearchControllerGenericSearchSwaggerPathParams, SearchControllerGenericSearchSwaggerQueryParams, SearchControllerCountMutationRequest, SearchControllerCountMutationResponse, SearchControllerSuggestQueryResponse, SearchControllerSuggestQueryParams, SearchControllerReindexMutationRequest, SearchControllerReindexMutationResponse, SearchControllerReindexAllMutationRequest, SearchControllerReindexAllMutationResponse, SignatureControllerFakeMutationResponse, SignatureControllerFakePathParams, SignatureControllerYousignSecurityCheckQueryResponse, SignatureControllerGetSignatureRequestsByExternalIdQueryResponse, SignatureControllerGetSignatureRequestsByExternalIdPathParams, SignatureControllerGetSignerLinkQueryResponse, SignatureControllerGetSignerLinkPathParams, SignatureControllerResendSignatureReminderMutationResponse, SignatureControllerResendSignatureReminderPathParams, SirenControllerSearchSirenQueryResponse, SirenControllerSearchSirenQueryParams, SirenControllerSearchSiren400, SivControllerSearchSivQueryResponse, SivControllerSearchSivQueryParams, SivControllerSearchSiv404, SivControllerSearchSivAtLegacyPathQueryResponse, SivControllerSearchSivAtLegacyPathQueryParams, SivControllerSearchSivAtLegacyPath404, DerogationControllerCreateDerogationMutationResponse, DerogationControllerCreateDerogationPathParams, DerogationControllerCreateDerogationQueryParams, DerogationControllerCreateDerogation404, DerogationControllerCreateDerogation409, DerogationControllerApproveDerogationMutationResponse, DerogationControllerApproveDerogationPathParams, DerogationControllerApproveDerogation404, DerogationControllerDenyDerogationMutationRequest, DerogationControllerDenyDerogationMutationResponse, DerogationControllerDenyDerogationPathParams, DerogationControllerDenyDerogation404, DerogationControllerCheckDerogationRequirementMutationRequest, DerogationControllerCheckDerogationRequirementMutationResponse, DerogationControllerCheckDerogationRequirementPathParams, DerogationControllerCheckDerogationRequirementQueryParams, AiAdminControllerListConversationsQueryResponse, AiAdminControllerListConversationsQueryParams, AiAdminControllerGetConversationMessagesQueryResponse, AiAdminControllerGetConversationMessagesPathParams, CommentsControllerCreateCommentMutationRequest, CommentsControllerCreateCommentMutationResponse, CommentsControllerCreateCommentPathParams, CommentsControllerCreateCommentQueryParams, CommentsControllerCreateComment409, CommentsControllerUpdateCommentMutationRequest, CommentsControllerUpdateCommentMutationResponse, CommentsControllerUpdateCommentPathParams, CommentsControllerUpdateComment404, CommentsControllerDeleteCommentMutationResponse, CommentsControllerDeleteCommentPathParams, CommentsControllerDeleteComment404, CommentsControllerGetCommentQueryResponse, CommentsControllerGetCommentPathParams, CommentsControllerGetComment404, CommentsControllerListCommentsQueryResponse, CommentsControllerListCommentsPathParams, CommentsControllerListCommentsQueryParams, InternalNotesControllerCreateMutationRequest, InternalNotesControllerCreateMutationResponse, InternalNotesControllerCreatePathParams, InternalNotesControllerCreate400, InternalNotesControllerListQueryResponse, InternalNotesControllerListPathParams, InternalNotesControllerListQueryParams, InternalNotesControllerGetQueryResponse, InternalNotesControllerGetPathParams, InternalNotesControllerGet404, InternalNotesControllerUpdateMutationRequest, InternalNotesControllerUpdateMutationResponse, InternalNotesControllerUpdatePathParams, InternalNotesControllerUpdate403, InternalNotesControllerUpdate404, InternalNotesControllerDeleteMutationResponse, InternalNotesControllerDeletePathParams, InternalNotesControllerDeleteQueryParams, InternalNotesControllerDelete403, InternalNotesControllerDelete404, ClaimInternalNotesControllerCreateMutationRequest, ClaimInternalNotesControllerCreateMutationResponse, ClaimInternalNotesControllerCreatePathParams, ClaimInternalNotesControllerCreate400, ClaimInternalNotesControllerListQueryResponse, ClaimInternalNotesControllerListPathParams, ClaimInternalNotesControllerListQueryParams, ClaimInternalNotesControllerGetQueryResponse, ClaimInternalNotesControllerGetPathParams, ClaimInternalNotesControllerGet404, ClaimInternalNotesControllerUpdateMutationRequest, ClaimInternalNotesControllerUpdateMutationResponse, ClaimInternalNotesControllerUpdatePathParams, ClaimInternalNotesControllerUpdate403, ClaimInternalNotesControllerUpdate404, ClaimInternalNotesControllerDeleteMutationResponse, ClaimInternalNotesControllerDeletePathParams, ClaimInternalNotesControllerDeleteQueryParams, ClaimInternalNotesControllerDelete403, ClaimInternalNotesControllerDelete404, ConversationControllerCreateConversationMutationRequest, ConversationControllerCreateConversationMutationResponse, ConversationControllerListConversationsQueryResponse, ConversationControllerGetConversationQueryResponse, ConversationControllerGetConversationPathParams, ConversationControllerGetConversation404, ConversationControllerDeleteConversationMutationResponse, ConversationControllerDeleteConversationPathParams, ConversationControllerDeleteConversation404, ConversationControllerGetConversationMessagesQueryResponse, ConversationControllerGetConversationMessagesPathParams, ConversationControllerGetConversationMessages404, ConversationControllerSendConversationMessageMutationRequest, ConversationControllerSendConversationMessageMutationResponse, ConversationControllerSendConversationMessagePathParams, ConversationControllerSendConversationMessage404, ConversationControllerSendConversationMessageStreamMutationRequest, ConversationControllerSendConversationMessageStreamMutationResponse, ConversationControllerSendConversationMessageStreamPathParams, ConversationControllerSendConversationFeedbackMutationRequest, ConversationControllerSendConversationFeedbackMutationResponse, ConversationControllerSendConversationFeedbackPathParams, ConversationControllerSendConversationFeedback404, SraControllerGetFacetQueryResponse, SraControllerGetFacetQueryParams, SraControllerGetVehicleDetailsQueryResponse, SraControllerGetVehicleDetailsQueryParams, SraControllerGetVersionInformationFromBrandAndModelQueryResponse, SraControllerGetVersionInformationFromBrandAndModelQueryParams, HiscoxControllerGetActivitiesBySectorQueryResponse, HiscoxControllerGetActivitiesBySectorQueryParams, StripeWebhookControllerWebhookMutationResponse, StripeWebhookControllerWebhookHeaderParams, StripeWebhookControllerConnectWebhookMutationResponse, StripeWebhookControllerConnectWebhookHeaderParams, StripeWebhookControllerTestWebhookMutationResponse, StripeWebhookControllerTenantWebhookMutationResponse, StripeWebhookControllerTenantWebhookPathParams, StripeWebhookControllerTenantWebhookHeaderParams, StripeWebhookControllerTenantConnectWebhookMutationResponse, StripeWebhookControllerTenantConnectWebhookPathParams, StripeWebhookControllerTenantConnectWebhookHeaderParams, SydiaControllerListClaimsMutationRequest, SydiaControllerListClaimsMutationResponse, SydiaControllerGetClaimMutationRequest, SydiaControllerGetClaimMutationResponse, SydiaControllerUpsertPolicyClaimsMutationRequest, SydiaControllerUpsertPolicyClaimsMutationResponse, SydiaControllerGetCustomerMutationRequest, SydiaControllerGetCustomerMutationResponse, SydiaControllerListCustomersMutationRequest, SydiaControllerListCustomersMutationResponse, SydiaControllerListPoliciesMutationRequest, SydiaControllerListPoliciesMutationResponse, UserControllerGetMyUserWithDrivequantDataQueryResponse, UserControllerGetMyUserWithDrivequantDataQueryParams, UserControllerGetMyUserWithDrivequantData404, WorkflowsControllerStartWorkflowMutationRequest, WorkflowsControllerStartWorkflowMutationResponse, WorkflowsControllerListWorkflowRunsMutationRequest, WorkflowsControllerListWorkflowRunsMutationResponse, WorkflowsControllerGetWorkflowRunQueryResponse, WorkflowsControllerGetWorkflowRunPathParams, WorkflowsControllerListWorkflowRunNodesQueryResponse, WorkflowsControllerListWorkflowRunNodesPathParams, WorkflowsControllerListWorkflowRunNodesQueryParams, WorkflowsControllerCancelWorkflowRunsMutationRequest, WorkflowsControllerCancelWorkflowRunsMutationResponse, WorkflowsControllerRetryWorkflowRunMutationRequest, WorkflowsControllerRetryWorkflowRunMutationResponse, WorkflowsControllerRetryWorkflowRunPathParams, YeetControllerListDrivequantAverageScoresQueryResponse, YeetControllerListDrivequantAverageScoresPathParams, YeetControllerListDrivequantAverageScoresQueryParams, YeetControllerSurchargePolicyMutationRequest, YeetControllerSurchargePolicyMutationResponse, YeetControllerSurchargePolicyPathParams, YeetControllerSurchargePolicyQueryParams, YeetControllerListPossibleDrivequantUsersQueryResponse, YeetControllerListPossibleDrivequantUsersPathParams, YeetControllerListPossibleDrivequantUsersQueryParams, YeetControllerListDrivequantHistoricalUsersQueryResponse, YeetControllerListDrivequantHistoricalUsersPathParams, YeetControllerAttachDrivequantUserIdToCustomerMutationResponse, YeetControllerAttachDrivequantUserIdToCustomerPathParams, AxeceControllerListDrivequantAverageScoresQueryResponse, AxeceControllerListDrivequantAverageScoresPathParams, AxeceControllerListDrivequantAverageScoresQueryParams, AxeceControllerSurchargePolicyMutationRequest, AxeceControllerSurchargePolicyMutationResponse, AxeceControllerSurchargePolicyPathParams, AxeceControllerSurchargePolicyQueryParams, AxeceControllerListPossibleDrivequantUsersQueryResponse, AxeceControllerListPossibleDrivequantUsersPathParams, AxeceControllerListPossibleDrivequantUsersQueryParams, AxeceControllerListDrivequantHistoricalUsersQueryResponse, AxeceControllerListDrivequantHistoricalUsersPathParams, AxeceControllerAttachDrivequantUserIdToCustomerMutationResponse, AxeceControllerAttachDrivequantUserIdToCustomerPathParams, YousignControllerWebhookMutationResponse, YousignControllerTenantWebhookMutationResponse, YousignControllerTenantWebhookPathParams, EmailEngineWebhookControllerWebhookMutationResponse, Ar24ControllerRegisteredLetterMutationResponse, AdminAr24ControllerListUsersQueryResponse, AdminAr24ControllerCreateUserMutationRequest, AdminAr24ControllerCreateUserMutationResponse, AdminAr24ControllerRequestUserAccessMutationRequest, AdminAr24ControllerRequestUserAccessMutationResponse, AdminAr24ControllerGetUserQueryResponse, AdminAr24ControllerGetUserPathParams, AdminAr24ControllerUpdateUserMutationRequest, AdminAr24ControllerUpdateUserMutationResponse, AdminAr24ControllerUpdateUserPathParams, AdminAr24ControllerRequestUserEulaMutationResponse, AdminAr24ControllerRequestUserEulaPathParams, AdminAr24ControllerResendUserConfirmationMutationResponse, AdminAr24ControllerResendUserConfirmationPathParams, SesControllerSesEventMutationResponse, ViewSpecificControllerAccountingSummaryQueryResponse, ViewSpecificControllerAccountingSummaryQueryParams, ViewSpecificControllerListComplianceChecksOnPolicyQueryResponse, ViewSpecificControllerListComplianceChecksOnPolicyPathParams, ViewSpecificControllerListComplianceChecksOnPolicyQueryParams, ViewSpecificControllerAcknowledgeComplianceAlertMutationResponse, ViewSpecificControllerAcknowledgeComplianceAlertPathParams, ViewSpecificControllerListPolicyComplianceAlertsQueryResponse, ViewSpecificControllerListPolicyComplianceAlertsPathParams, ViewSpecificControllerListPolicyComplianceAlertsQueryParams, ViewSpecificControllerListChildBrokerageFirmsQueryResponse, ViewSpecificControllerListChildBrokerageFirmsPathParams, ViewSpecificControllerListChildBrokerageFirmsQueryParams, ViewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsQueryResponse, ViewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsPathParams, ViewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsQueryParams, ViewSpecificControllerListBrokerageFirmDistributionRequestsMutationResponse, ViewSpecificControllerListBrokerageFirmDistributionRequestsPathParams, ViewSpecificControllerListBrokerageFirmDistributionRequestsQueryParams, ViewSpecificControllerListPolicyAssetsQueryResponse, ViewSpecificControllerListPolicyAssetsPathParams, ViewSpecificControllerListPolicyAssetsQueryParams, ViewSpecificControllerListPolicyAssets403, ViewSpecificControllerListPolicyAssets404, ViewSpecificControllerGetAvailablePricingQueryResponse, ViewSpecificControllerGetAvailablePricingPathParams, ViewSpecificControllerGetAvailablePricingQueryParams, ViewSpecificControllerGetAvailablePricing400, ViewSpecificControllerGetAvailablePricing404, ViewSpecificControllerListPolicyCustomersQueryResponse, ViewSpecificControllerListPolicyCustomersPathParams, ViewSpecificControllerListPolicyCustomersQueryParams, ViewSpecificControllerListPolicyCustomers403, ViewSpecificControllerListPolicyCustomers404, ViewSpecificControllerListCustomerInvoicesQueryResponse, ViewSpecificControllerListCustomerInvoicesPathParams, ViewSpecificControllerListCustomerInvoicesQueryParams, ViewSpecificControllerListCustomerInvoices404, ViewSpecificControllerListCustomerPaymentsQueryResponse, ViewSpecificControllerListCustomerPaymentsPathParams, ViewSpecificControllerListCustomerPaymentsQueryParams, ViewSpecificControllerListCustomerPayments404, ViewSpecificControllerListCustomerPaymentMethodsQueryResponse, ViewSpecificControllerListCustomerPaymentMethodsPathParams, ViewSpecificControllerListCustomerPaymentMethodsQueryParams, ViewSpecificControllerListCustomerPaymentMethods404, ViewSpecificControllerListBrokerageFirmPaymentMethodsQueryResponse, ViewSpecificControllerListBrokerageFirmPaymentMethodsPathParams, ViewSpecificControllerListBrokerageFirmPaymentMethodsQueryParams, ViewSpecificControllerListBrokerageFirmPoliciesMutationRequest, ViewSpecificControllerListBrokerageFirmPoliciesMutationResponse, ViewSpecificControllerListBrokerageFirmPoliciesPathParams, ViewSpecificControllerGetAccountingSummaryForBrokerageFirmQueryResponse, ViewSpecificControllerGetAccountingSummaryForBrokerageFirmPathParams, ViewSpecificControllerGetAccountingSummaryForBrokerageFirmQueryParams, ViewSpecificControllerListCustomerRelationsQueryResponse, ViewSpecificControllerListCustomerRelationsPathParams, ViewSpecificControllerListCustomerRelationsQueryParams, ViewSpecificControllerListBrokerageFirmDerogationsMutationRequest, ViewSpecificControllerListBrokerageFirmDerogationsMutationResponse, ViewSpecificControllerListBrokerageFirmDerogationsPathParams, ViewSpecificControllerListBrokerageFirmDerogationsQueryParams, ViewSpecificControllerListProductCommonDocumentsQueryResponse, ViewSpecificControllerListProductCommonDocumentsPathParams, ViewSpecificControllerListProductCommonDocumentsQueryParams, ViewSpecificControllerCreateActiveTeamMutationRequest, ViewSpecificControllerCreateActiveTeamMutationResponse, ViewSpecificControllerCreateActiveTeamPathParams, BillingReadsControllerGetAccountingSummaryQueryResponse, BillingReadsControllerGetAccountingSummaryQueryParams, BillingReadsControllerGetBrokerageFirmAccountingSummaryQueryResponse, BillingReadsControllerGetBrokerageFirmAccountingSummaryPathParams, BillingReadsControllerGetBrokerageFirmAccountingSummaryQueryParams, BillingReadsControllerListCustomerInvoicesQueryResponse, BillingReadsControllerListCustomerInvoicesPathParams, BillingReadsControllerListCustomerInvoicesQueryParams, BillingReadsControllerListCustomerInvoices404, PaymentsReadsControllerListCustomerPaymentsQueryResponse, PaymentsReadsControllerListCustomerPaymentsPathParams, PaymentsReadsControllerListCustomerPaymentsQueryParams, PaymentsReadsControllerListCustomerPayments404, PaymentsReadsControllerListCustomerPaymentMethodsWithDocumentsQueryResponse, PaymentsReadsControllerListCustomerPaymentMethodsWithDocumentsPathParams, PaymentsReadsControllerListCustomerPaymentMethodsWithDocumentsQueryParams, PaymentsReadsControllerListCustomerPaymentMethodsWithDocuments404, PaymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocumentsQueryResponse, PaymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocumentsPathParams, PaymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocumentsQueryParams, CustomerReadsControllerListCustomerRelationsQueryResponse, CustomerReadsControllerListCustomerRelationsPathParams, CustomerReadsControllerListCustomerRelationsQueryParams, CustomerReadsControllerListPolicyCustomersQueryResponse, CustomerReadsControllerListPolicyCustomersPathParams, CustomerReadsControllerListPolicyCustomersQueryParams, CustomerReadsControllerListPolicyCustomers403, CustomerReadsControllerListPolicyCustomers404, AssetReadsControllerListPolicyAssetsQueryResponse, AssetReadsControllerListPolicyAssetsPathParams, AssetReadsControllerListPolicyAssetsQueryParams, AssetReadsControllerListPolicyAssets403, AssetReadsControllerListPolicyAssets404, PricingReadsControllerGetAvailablePricingQueryResponse, PricingReadsControllerGetAvailablePricingPathParams, PricingReadsControllerGetAvailablePricingQueryParams, PricingReadsControllerGetAvailablePricing400, PricingReadsControllerGetAvailablePricing404, DerogationsReadsControllerSearchBrokerageFirmDerogationsMutationRequest, DerogationsReadsControllerSearchBrokerageFirmDerogationsMutationResponse, DerogationsReadsControllerSearchBrokerageFirmDerogationsPathParams, DerogationsReadsControllerSearchBrokerageFirmDerogationsQueryParams, ComplianceReadsControllerListPolicyComplianceAlertsQueryResponse, ComplianceReadsControllerListPolicyComplianceAlertsPathParams, ComplianceReadsControllerListPolicyComplianceAlertsQueryParams, ComplianceReadsControllerListPolicyComplianceChecksQueryResponse, ComplianceReadsControllerListPolicyComplianceChecksPathParams, ComplianceReadsControllerListPolicyComplianceChecksQueryParams, ComplianceReadsControllerAcknowledgeComplianceAlertMutationResponse, ComplianceReadsControllerAcknowledgeComplianceAlertPathParams, BrokerageFirmsReadsControllerListChildBrokerageFirmsQueryResponse, BrokerageFirmsReadsControllerListChildBrokerageFirmsPathParams, BrokerageFirmsReadsControllerListChildBrokerageFirmsQueryParams, BrokerageFirmsReadsControllerCreateActiveTeamMutationRequest, BrokerageFirmsReadsControllerCreateActiveTeamMutationResponse, BrokerageFirmsReadsControllerCreateActiveTeamPathParams, PolicyReadsControllerSearchBrokerageFirmPoliciesMutationRequest, PolicyReadsControllerSearchBrokerageFirmPoliciesMutationResponse, PolicyReadsControllerSearchBrokerageFirmPoliciesPathParams, DistributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsMutationResponse, DistributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsPathParams, DistributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsQueryParams, DistributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsQueryResponse, DistributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsPathParams, DistributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsQueryParams, DocumentsReadsControllerListProductCommonDocumentsQueryResponse, DocumentsReadsControllerListProductCommonDocumentsPathParams, DocumentsReadsControllerListProductCommonDocumentsQueryParams, McpServerControllerHandleServerSentEventsQueryResponse, McpServerControllerHandleRequestMutationResponse, ComplianceControllerCreateCheckMutationRequest, ComplianceControllerCreateCheckMutationResponse, ComplianceControllerListChecksQueryResponse, ComplianceControllerListChecksQueryParams, ComplianceControllerUpdateCheckMutationRequest, ComplianceControllerUpdateCheckMutationResponse, ComplianceControllerUpdateCheckPathParams, ComplianceControllerUpdateCheck404, ComplianceControllerDeleteCheckMutationResponse, ComplianceControllerDeleteCheckPathParams, ComplianceControllerDeleteCheck404, ComplianceControllerGetCheckQueryResponse, ComplianceControllerGetCheckPathParams, ComplianceControllerGetCheck404, ComplianceControllerCreateAlertMutationRequest, ComplianceControllerCreateAlertMutationResponse, ComplianceControllerCreateAlert404, ComplianceControllerListAlertsQueryResponse, ComplianceControllerListAlertsQueryParams, ComplianceControllerAcknowledgeAlertsByEntityMutationResponse, ComplianceControllerAcknowledgeAlertsByEntityPathParams, ComplianceControllerAcknowledgeAlertsByCheckIdsMutationRequest, ComplianceControllerAcknowledgeAlertsByCheckIdsMutationResponse, ComplianceControllerUpdateAlertMutationRequest, ComplianceControllerUpdateAlertMutationResponse, ComplianceControllerUpdateAlertPathParams, ComplianceControllerUpdateAlert404, ComplianceControllerDeleteAlertMutationResponse, ComplianceControllerDeleteAlertPathParams, ComplianceControllerDeleteAlert404, ComplianceControllerGetAlertQueryResponse, ComplianceControllerGetAlertPathParams, ComplianceControllerGetAlert404, RelationsControllerCreateRelationMutationRequest, RelationsControllerCreateRelationMutationResponse, RelationsControllerGetPermissionRelationsForUserQueryResponse, RelationsControllerGetPermissionRelationsForUserQueryParams, RelationsControllerDeleteRelationMutationResponse, RelationsControllerDeleteRelationPathParams, RelationsControllerListTenantUsersQueryResponse, RelationsControllerListTenantUsersQueryParams, RelationsControllerListRelationsQueryResponse, RelationsControllerListRelationsQueryParams, LegacyPermissionsControllerAtMeQueryResponse, LegacyPermissionsControllerAtMe404, BrokerageFirmControllerCreateBrokerageFirmMutationRequest, BrokerageFirmControllerCreateBrokerageFirmMutationResponse, BrokerageFirmControllerCreateBrokerageFirm400, BrokerageFirmControllerCreateBrokerageFirm404, BrokerageFirmControllerListBrokerageFirmsQueryResponse, BrokerageFirmControllerListBrokerageFirmsQueryParams, BrokerageFirmControllerUpdateBrokerageFirmMutationRequest, BrokerageFirmControllerUpdateBrokerageFirmMutationResponse, BrokerageFirmControllerUpdateBrokerageFirmPathParams, BrokerageFirmControllerUpdateBrokerageFirm400, BrokerageFirmControllerUpdateBrokerageFirm404, BrokerageFirmControllerGetBrokerageFirmQueryResponse, BrokerageFirmControllerGetBrokerageFirmPathParams, BrokerageFirmControllerGetBrokerageFirm404, BrokerageFirmControllerGenerateUploadDocumentUrlMutationRequest, BrokerageFirmControllerGenerateUploadDocumentUrlMutationResponse, BrokerageFirmControllerGenerateUploadDocumentUrlPathParams, BrokerageFirmControllerGenerateUploadDocumentUrlQueryParams, BrokerageFirmControllerGenerateUploadDocumentUrl400, BrokerageFirmControllerGenerateUploadDocumentUrl403, BrokerageFirmControllerGenerateUploadDocumentUrl404, BrokerageFirmControllerListDocumentsQueryResponse, BrokerageFirmControllerListDocumentsPathParams, BrokerageFirmControllerListDocumentsQueryParams, BrokerageFirmControllerListDocuments400, BrokerageFirmControllerListDocuments403, BrokerageFirmControllerListDocuments404, BrokerageFirmControllerDeleteDocumentsMutationResponse, BrokerageFirmControllerDeleteDocumentsPathParams, BrokerageFirmControllerDeleteDocumentsQueryParams, BrokerageFirmControllerDeleteDocuments400, BrokerageFirmControllerDeleteDocuments403, BrokerageFirmControllerDeleteDocuments404, BrokerageFirmControllerGenerateReportMutationRequest, BrokerageFirmControllerGenerateReportMutationResponse, BrokerageFirmControllerGenerateReportPathParams, BrokerageFirmControllerListReportsQueryResponse, BrokerageFirmControllerListReportsPathParams, BrokerageFirmControllerListReportsQueryParams, BrokerageFirmControllerGetReportConfigQueryResponse, BrokerageFirmControllerGetReportConfigPathParams, BrokerageFirmControllerListCommissionStatementsQueryResponse, BrokerageFirmControllerListCommissionStatementsPathParams, BrokerageFirmControllerListCommissionStatementsQueryParams, BrokerageFirmControllerListCommissionStatements403, BrokerageFirmControllerListCommissionStatements404, BrokerageFirmControllerGetCommissionStatementDocumentMutationRequest, BrokerageFirmControllerGetCommissionStatementDocumentMutationResponse, BrokerageFirmControllerGetCommissionStatementDocumentPathParams, BrokerageFirmControllerGetCommissionStatementDocument400, BrokerageFirmControllerGetCommissionStatementDocument403, BrokerageFirmControllerGetCommissionStatementDocument404, BrokerageFirmControllerGetPaymentMethodSetupSecretQueryResponse, BrokerageFirmControllerGetPaymentMethodSetupSecretPathParams, BrokerageFirmControllerGetPaymentMethodSetupSecret404, BrokerageFirmControllerGetPaymentMethodsQueryResponse, BrokerageFirmControllerGetPaymentMethodsPathParams, BrokerageFirmControllerGetPaymentMethods404, BrokerageFirmControllerGenerateDocumentsForSignatureMutationResponse, BrokerageFirmControllerGenerateDocumentsForSignaturePathParams, BrokerageFirmControllerGenerateDocumentsForSignatureQueryParams, BrokerageFirmControllerGenerateDocumentsForSignature404, BrokerageFirmControllerGenerateSignatureRequestMutationRequest, BrokerageFirmControllerGenerateSignatureRequestMutationResponse, BrokerageFirmControllerGenerateSignatureRequestPathParams, BrokerageFirmControllerGenerateSignatureRequest404, BrokerageFirmControllerGenerateMandateSignatureRequestMutationRequest, BrokerageFirmControllerGenerateMandateSignatureRequestMutationResponse, BrokerageFirmControllerGenerateMandateSignatureRequestPathParams, BrokerageFirmControllerGenerateMandateSignatureRequest400, BrokerageFirmControllerGenerateMandateSignatureRequest404, BrokerageFirmControllerGenerateMandateSignatureRequest409, BrokerageFirmControllerGenerateMandateSignatureRequest425, BrokerageFirmControllerUpdatePreferredPaymentMethodMutationResponse, BrokerageFirmControllerUpdatePreferredPaymentMethodPathParams, BrokerageFirmControllerUpdatePreferredPaymentMethod400, BrokerageFirmControllerUpdatePreferredPaymentMethod404, BrokerageFirmControllerUpdatePreferredPaymentMethod409, BrokerageFirmControllerDeletePaymentMethodMutationResponse, BrokerageFirmControllerDeletePaymentMethodPathParams, BrokerageFirmControllerDeletePaymentMethod404, BrokerageFirmControllerDeletePaymentMethod409, BrokerageFirmControllerTransferPoliciesMutationRequest, BrokerageFirmControllerTransferPoliciesMutationResponse, BrokerageFirmControllerTransferPoliciesPathParams, BrokerageFirmControllerTransferPolicies404, DistributionRequestControllerCreateManyDistributionRequestsMutationRequest, DistributionRequestControllerCreateManyDistributionRequestsMutationResponse, DistributionRequestControllerCreateManyDistributionRequests409, DistributionRequestControllerApproveDistributionRequestMutationResponse, DistributionRequestControllerApproveDistributionRequestPathParams, DistributionRequestControllerApproveDistributionRequest404, DistributionRequestControllerApproveDistributionRequest409, DistributionRequestControllerWaitingForSignatureDistributionRequestMutationResponse, DistributionRequestControllerWaitingForSignatureDistributionRequestPathParams, DistributionRequestControllerDenyDistributionRequestMutationResponse, DistributionRequestControllerDenyDistributionRequestPathParams, DistributionRequestControllerDenyDistributionRequest404, DistributionRequestControllerDenyDistributionRequest409, DistributionRequestControllerRevokeDistributionRequestMutationResponse, DistributionRequestControllerRevokeDistributionRequestPathParams, DistributionRequestControllerRevokeDistributionRequest404, DistributionRequestControllerRevokeDistributionRequest409, DistributionRequestControllerGetDistributionRequestQueryResponse, DistributionRequestControllerGetDistributionRequestPathParams, DistributionRequestControllerGetDistributionRequest404, DistributionRequestControllerDeleteDistributionRequestMutationResponse, DistributionRequestControllerDeleteDistributionRequestPathParams, DistributionRequestControllerDeleteDistributionRequest404, DistributionRequestControllerListDistributionRequestsMutationRequest, DistributionRequestControllerListDistributionRequestsMutationResponse, DistributionRequestControllerListDistributionRequestsQueryParams, BrokerageFeeControllerCreateBrokerageFeeMutationRequest, BrokerageFeeControllerCreateBrokerageFeeMutationResponse, BrokerageFeeControllerCreateBrokerageFeePathParams, BrokerageFeeControllerCreateBrokerageFee404, BrokerageFeeControllerUpdateBrokerageFeeMutationRequest, BrokerageFeeControllerUpdateBrokerageFeeMutationResponse, BrokerageFeeControllerUpdateBrokerageFeePathParams, BrokerageFeeControllerUpdateBrokerageFee404, BrokerageFeeControllerDeleteBrokerageFeeMutationResponse, BrokerageFeeControllerDeleteBrokerageFeePathParams, BrokerageFeeControllerDeleteBrokerageFee404, BrokerageFeeControllerGetBrokerFeesQueryResponse, BrokerageFeeControllerGetBrokerFeesQueryParams, BrokerageFeeControllerGetBrokerFees404, TelematicsControllerUpsertExternalServiceUserIdMutationRequest, TelematicsControllerUpsertExternalServiceUserIdMutationResponse, TenantOnboardingControllerCreateAccountMutationRequest, TenantOnboardingControllerCreateAccountMutationResponse, TenantOnboardingControllerCreateAccountLinkMutationResponse, TenantOnboardingControllerCreateAccountLinkPathParams, PortfolioMigrationControllerStartMigrationWorkflowMutationRequest, PortfolioMigrationControllerStartMigrationWorkflowMutationResponse, PaymentMethodsMigrationControllerStartPaymentMethodsMigrationWorkflowMutationRequest, PaymentMethodsMigrationControllerStartPaymentMethodsMigrationWorkflowMutationResponse, EfficialeControllerCheckComplianceQueryResponse, EfficialeControllerCheckComplianceQueryParams, EfficialeControllerGetAlertsQueryResponse, EfficialeControllerGetAlertsQueryParams, EllisphereControllerOrderOnlineMutationRequest, EllisphereControllerOrderOnlineMutationResponse, SolvabilityControllerGetScoreMutationRequest, SolvabilityControllerGetScoreMutationResponse, MetabaseControllerGetIframeUrlQueryResponse, MetabaseControllerGetIframeUrlQueryParams, FvaControllerUploadFileMutationResponse, FvaControllerUploadFileQueryParams, FvaControllerRetrieveReportOutcomeQueryResponse, FvaControllerRetrieveReportOutcomeQueryParams, DocumentValidityControllerGetPolicyValidityQueryResponse, DocumentValidityControllerGetPolicyValidityPathParams, DocumentValidityControllerGetPolicyValidityQueryParams, DocumentValidityControllerGetPolicyValidity404, DocumentValidityControllerGetDocumentValidityQueryResponse, DocumentValidityControllerGetDocumentValidityPathParams, DocumentValidityControllerGetDocumentValidity500, DocumentValidityControllerOverrideDocumentValidityMutationRequest, DocumentValidityControllerOverrideDocumentValidityMutationResponse, DocumentValidityControllerOverrideDocumentValidityPathParams, DocumentValidityControllerOverrideDocumentValidity500, BrokerageFirmDocumentValidityControllerGetBrokerageFirmValidityQueryResponse, BrokerageFirmDocumentValidityControllerGetBrokerageFirmValidityPathParams, BrokerageFirmDocumentValidityControllerOverrideDocumentValidityMutationRequest, BrokerageFirmDocumentValidityControllerOverrideDocumentValidityMutationResponse, BrokerageFirmDocumentValidityControllerOverrideDocumentValidityPathParams, BrokerageFirmDocumentValidityControllerOverrideDocumentValidity500, DocumentCoherenceControllerGetDocumentCoherenceQueryResponse, DocumentCoherenceControllerGetDocumentCoherencePathParams, DocumentCoherenceControllerGetDocumentCoherenceQueryParams, DocumentCoherenceControllerGetDocumentCoherence400, DocumentCoherenceControllerGetDocumentCoherence404, PolicyDocumentControllerAcceptMutationRequest, PolicyDocumentControllerAcceptMutationResponse, PolicyDocumentControllerAcceptPathParams, PolicyDocumentControllerAccept404, PolicyDocumentControllerRejectMutationRequest, PolicyDocumentControllerRejectMutationResponse, PolicyDocumentControllerRejectPathParams, PolicyDocumentControllerReject404, PolicyDocumentControllerAcceptAllMutationRequest, PolicyDocumentControllerAcceptAllMutationResponse, PolicyDocumentControllerAcceptAllPathParams, PolicyDocumentControllerAcceptAll409, PolicyDocumentControllerCancelMutationResponse, PolicyDocumentControllerCancelPathParams, PolicyDocumentControllerCancel404, PolicyDocumentControllerGetPolicyDocumentConformityQueryResponse, PolicyDocumentControllerGetPolicyDocumentConformityPathParams, PolicyDocumentControllerGetPolicyDocumentConformityQueryParams, PolicyDocumentControllerGetPolicyDocumentVerdictsQueryResponse, PolicyDocumentControllerGetPolicyDocumentVerdictsPathParams, PolicyDocumentControllerGetPolicyDocumentVerdictsQueryParams, PolicyDocumentControllerGetPolicyDocumentFraudQueryResponse, PolicyDocumentControllerGetPolicyDocumentFraudPathParams, PolicyDocumentControllerGetPolicyDocumentFraudQueryParams, PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictMutationRequest, PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictMutationResponse, PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictPathParams, PolicyDocumentControllerCorrectPolicyDocumentFraudVerdict404, PolicyDocumentControllerCorrectPolicyDocumentFraudVerdict409, BrokerageFirmDocumentControllerAcceptBrokerageFirmDocumentMutationResponse, BrokerageFirmDocumentControllerAcceptBrokerageFirmDocumentPathParams, BrokerageFirmDocumentControllerAcceptBrokerageFirmDocument404, BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentMutationRequest, BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentMutationResponse, BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentPathParams, BrokerageFirmDocumentControllerRejectBrokerageFirmDocument404, BrokerageFirmDocumentControllerAcceptAllBrokerageFirmDocumentsMutationResponse, BrokerageFirmDocumentControllerAcceptAllBrokerageFirmDocumentsPathParams, BrokerageFirmDocumentControllerAcceptAllBrokerageFirmDocuments409, BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformityMutationResponse, BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformityPathParams, BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformity404, BrokerageFirmDocumentControllerGetBrokerageFirmDocumentConformityQueryResponse, BrokerageFirmDocumentControllerGetBrokerageFirmDocumentConformityPathParams, BrokerageFirmDocumentControllerGetBrokerageFirmDocumentFraudQueryResponse, BrokerageFirmDocumentControllerGetBrokerageFirmDocumentFraudPathParams, BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictMutationRequest, BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictMutationResponse, BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictPathParams, BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdict404, BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdict409, PolicyDocumentCollectionControllerGetCollectionStateQueryResponse, PolicyDocumentCollectionControllerGetCollectionStatePathParams, PolicyDocumentCollectionControllerGetCollectionStateQueryParams, PolicyDocumentExtractionControllerGetPolicyExtractionsQueryResponse, PolicyDocumentExtractionControllerGetPolicyExtractionsPathParams, PolicyDocumentExtractionControllerGetPolicyExtractionsQueryParams, PolicyDocumentExtractionControllerGetPolicyExtractions404, DocumentExtractionControllerGetDocumentExtractionQueryResponse, DocumentExtractionControllerGetDocumentExtractionPathParams, DocumentExtractionControllerGetDocumentExtraction404, DocumentExtractionControllerRetryDocumentExtractionMutationResponse, DocumentExtractionControllerRetryDocumentExtractionPathParams, DocumentExtractionControllerRetryDocumentExtraction404, DocumentExtractionControllerSubmitExtractionFeedbackMutationRequest, DocumentExtractionControllerSubmitExtractionFeedbackMutationResponse, DocumentExtractionControllerSubmitExtractionFeedbackPathParams, DocumentExtractionControllerGetExtractionFeedbackQueryResponse, DocumentExtractionControllerGetExtractionFeedbackPathParams, BrokerageFirmDocumentExtractionControllerGetBrokerageFirmExtractionsQueryResponse, BrokerageFirmDocumentExtractionControllerGetBrokerageFirmExtractionsPathParams, DocumentPrefillControllerRecordOutcomeMutationRequest, DocumentPrefillControllerRecordOutcomeMutationResponse, JwksControllerGetJwksQueryResponse, ImpersonationControllerCreateSessionMutationRequest, ImpersonationControllerCreateSessionMutationResponse, ImpersonationControllerListSessionsQueryResponse, ImpersonationControllerListSessionsQueryParams, ImpersonationControllerRevokeCurrentSessionMutationResponse, ImpersonationControllerRevokeSessionMutationResponse, ImpersonationControllerRevokeSessionPathParams, FederatedSessionControllerRevokeCurrentSessionMutationResponse, SpeechToTextControllerGetCredentialsMutationRequest, SpeechToTextControllerGetCredentialsMutationResponse, FcbWidgetControllerMintTokenQueryResponse, FcbWidgetControllerInitWhatsappConversationMutationRequest, FcbWidgetControllerInitWhatsappConversationMutationResponse } from "./kubb-types.ts";

function getAppControllerIndexUrl() {
  const res = { method: 'GET', url: `/` as const }
  return res
}

/**
 * {@link /}
 */
export async function appControllerIndex(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AppControllerIndexQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getAppControllerIndexUrl().url.toString(), ... requestConfig })
  return res.data
}

function getAuthControllerCheckEmailUrl() {
  const res = { method: 'POST', url: `/auth/check-email` as const }
  return res
}

/**
 * @summary Check email status for authentication
 * {@link /auth/check-email}
 */
export async function authControllerCheckEmail(data: AuthControllerCheckEmailMutationRequest, config: Partial<RequestConfig<AuthControllerCheckEmailMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<AuthControllerCheckEmailMutationResponse, ResponseErrorConfig<Error>, AuthControllerCheckEmailMutationRequest>({ method : "POST", url : getAuthControllerCheckEmailUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getAikanControllerGetAikanDocumentByIdUrl() {
  const res = { method: 'GET', url: `/aikan/documents` as const }
  return res
}

/**
 * @summary Endpoint for sydia to fetch documents
 * {@link /aikan/documents}
 */
export async function aikanControllerGetAikanDocumentById(params: AikanControllerGetAikanDocumentByIdQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AikanControllerGetAikanDocumentByIdQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getAikanControllerGetAikanDocumentByIdUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getAikanControllerGetAikanAssetsUrl() {
  const res = { method: 'GET', url: `/aikan/assets` as const }
  return res
}

/**
 * @summary Endpoint for sydia to fetch assets
 * {@link /aikan/assets}
 */
export async function aikanControllerGetAikanAssets(params: AikanControllerGetAikanAssetsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AikanControllerGetAikanAssetsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getAikanControllerGetAikanAssetsUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getAssetControllerBatchCreateAssetsUrl() {
  const res = { method: 'POST', url: `/assets/batch/create` as const }
  return res
}

/**
 * @summary Create several assets on the same policy
 * {@link /assets/batch/create}
 */
export async function assetControllerBatchCreateAssets(data: AssetControllerBatchCreateAssetsMutationRequest, params: AssetControllerBatchCreateAssetsQueryParams, config: Partial<RequestConfig<AssetControllerBatchCreateAssetsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<AssetControllerBatchCreateAssetsMutationResponse, ResponseErrorConfig<Error>, AssetControllerBatchCreateAssetsMutationRequest>({ method : "POST", url : getAssetControllerBatchCreateAssetsUrl().url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getAssetControllerBatchEditAssetsUrl() {
  const res = { method: 'PATCH', url: `/assets/batch/edit` as const }
  return res
}

/**
 * @summary Edit several assets of the same policy
 * {@link /assets/batch/edit}
 */
export async function assetControllerBatchEditAssets(data: AssetControllerBatchEditAssetsMutationRequest, params?: AssetControllerBatchEditAssetsQueryParams, config: Partial<RequestConfig<AssetControllerBatchEditAssetsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<AssetControllerBatchEditAssetsMutationResponse, ResponseErrorConfig<Error>, AssetControllerBatchEditAssetsMutationRequest>({ method : "PATCH", url : getAssetControllerBatchEditAssetsUrl().url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getAssetControllerBatchRemoveAssetsUrl() {
  const res = { method: 'POST', url: `/assets/batch/remove` as const }
  return res
}

/**
 * @summary Remove several assets from their policy
 * {@link /assets/batch/remove}
 */
export async function assetControllerBatchRemoveAssets(data: AssetControllerBatchRemoveAssetsMutationRequest, params: AssetControllerBatchRemoveAssetsQueryParams, config: Partial<RequestConfig<AssetControllerBatchRemoveAssetsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<AssetControllerBatchRemoveAssetsMutationResponse, ResponseErrorConfig<Error>, AssetControllerBatchRemoveAssetsMutationRequest>({ method : "POST", url : getAssetControllerBatchRemoveAssetsUrl().url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getAssetControllerCreateAssetUrl() {
  const res = { method: 'POST', url: `/assets` as const }
  return res
}

/**
 * @description `startedAt` must be the start of the day in `Europe/Paris`, expressed in UTC — `endedAt` is derived from it by snapping to that zone, so UTC midnight yields a contract two hours short with no error anywhere. Most products require it before the contract can be quoted.
 * @summary Create Asset
 * {@link /assets}
 */
export async function assetControllerCreateAsset(data: AssetControllerCreateAssetMutationRequest, params: AssetControllerCreateAssetQueryParams, config: Partial<RequestConfig<AssetControllerCreateAssetMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<AssetControllerCreateAssetMutationResponse, ResponseErrorConfig<AssetControllerCreateAsset400 | AssetControllerCreateAsset403 | AssetControllerCreateAsset404 | AssetControllerCreateAsset409>, AssetControllerCreateAssetMutationRequest>({ method : "POST", url : getAssetControllerCreateAssetUrl().url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getAssetControllerReplaceAssetUrl(originAssetId: AssetControllerReplaceAssetPathParams["originAssetId"]) {
  const res = { method: 'POST', url: `/assets/${originAssetId}/replace` as const }
  return res
}

/**
 * @summary Replace Asset
 * {@link /assets/:originAssetId/replace}
 */
export async function assetControllerReplaceAsset(originAssetId: AssetControllerReplaceAssetPathParams["originAssetId"], data: AssetControllerReplaceAssetMutationRequest, params: AssetControllerReplaceAssetQueryParams, config: Partial<RequestConfig<AssetControllerReplaceAssetMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<AssetControllerReplaceAssetMutationResponse, ResponseErrorConfig<AssetControllerReplaceAsset400 | AssetControllerReplaceAsset404 | AssetControllerReplaceAsset409>, AssetControllerReplaceAssetMutationRequest>({ method : "POST", url : getAssetControllerReplaceAssetUrl(originAssetId).url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getAssetControllerEditAssetUrl(assetId: AssetControllerEditAssetPathParams["assetId"]) {
  const res = { method: 'PATCH', url: `/assets/${assetId}` as const }
  return res
}

/**
 * @summary Edit an asset
 * {@link /assets/:assetId}
 */
export async function assetControllerEditAsset(assetId: AssetControllerEditAssetPathParams["assetId"], data: AssetControllerEditAssetMutationRequest, params?: AssetControllerEditAssetQueryParams, config: Partial<RequestConfig<AssetControllerEditAssetMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<AssetControllerEditAssetMutationResponse, ResponseErrorConfig<AssetControllerEditAsset400 | AssetControllerEditAsset403 | AssetControllerEditAsset404 | AssetControllerEditAsset409>, AssetControllerEditAssetMutationRequest>({ method : "PATCH", url : getAssetControllerEditAssetUrl(assetId).url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getAssetControllerGetAssetUrl(assetId: AssetControllerGetAssetPathParams["assetId"]) {
  const res = { method: 'GET', url: `/assets/${assetId}` as const }
  return res
}

/**
 * @summary Get Asset
 * {@link /assets/:assetId}
 */
export async function assetControllerGetAsset(assetId: AssetControllerGetAssetPathParams["assetId"], params?: AssetControllerGetAssetQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AssetControllerGetAssetQueryResponse, ResponseErrorConfig<AssetControllerGetAsset403 | AssetControllerGetAsset404>, unknown>({ method : "GET", url : getAssetControllerGetAssetUrl(assetId).url.toString(), params, ... requestConfig })
  return res.data
}

function getAssetControllerRemoveAssetUrl(assetId: AssetControllerRemoveAssetPathParams["assetId"]) {
  const res = { method: 'DELETE', url: `/assets/${assetId}` as const }
  return res
}

/**
 * @description Only possible when the asset was created on the same branch it is being removed on.
 * @summary Remove an asset from its policy
 * {@link /assets/:assetId}
 */
export async function assetControllerRemoveAsset(assetId: AssetControllerRemoveAssetPathParams["assetId"], params: AssetControllerRemoveAssetQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AssetControllerRemoveAssetMutationResponse, ResponseErrorConfig<AssetControllerRemoveAsset400 | AssetControllerRemoveAsset403 | AssetControllerRemoveAsset404 | AssetControllerRemoveAsset409>, unknown>({ method : "DELETE", url : getAssetControllerRemoveAssetUrl(assetId).url.toString(), params, ... requestConfig })
  return res.data
}

function getAssetControllerPushAssetEventUrl(assetId: AssetControllerPushAssetEventPathParams["assetId"]) {
  const res = { method: 'POST', url: `/assets/${assetId}/events` as const }
  return res
}

/**
 * @summary Push a custom event onto an asset
 * {@link /assets/:assetId/events}
 */
export async function assetControllerPushAssetEvent(assetId: AssetControllerPushAssetEventPathParams["assetId"], data: AssetControllerPushAssetEventMutationRequest, params: AssetControllerPushAssetEventQueryParams, config: Partial<RequestConfig<AssetControllerPushAssetEventMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<AssetControllerPushAssetEventMutationResponse, ResponseErrorConfig<AssetControllerPushAssetEvent400 | AssetControllerPushAssetEvent404>, AssetControllerPushAssetEventMutationRequest>({ method : "POST", url : getAssetControllerPushAssetEventUrl(assetId).url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getAssetControllerGetAssetExternalQuoteUrl(assetId: AssetControllerGetAssetExternalQuotePathParams["assetId"]) {
  const res = { method: 'GET', url: `/assets/${assetId}/external-quote` as const }
  return res
}

/**
 * @summary Get External Quote for this asset
 * {@link /assets/:assetId/external-quote}
 */
export async function assetControllerGetAssetExternalQuote(assetId: AssetControllerGetAssetExternalQuotePathParams["assetId"], params?: AssetControllerGetAssetExternalQuoteQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AssetControllerGetAssetExternalQuoteQueryResponse, ResponseErrorConfig<AssetControllerGetAssetExternalQuote404>, unknown>({ method : "GET", url : getAssetControllerGetAssetExternalQuoteUrl(assetId).url.toString(), params, ... requestConfig })
  return res.data
}

function getBillingControllerGetInvoicesUrl() {
  const res = { method: 'GET', url: `/billing` as const }
  return res
}

/**
 * @description Returns a paginated list of invoices specified by their IDs.
 * @summary Get invoices
 * {@link /billing}
 */
export async function billingControllerGetInvoices(params: BillingControllerGetInvoicesQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<BillingControllerGetInvoicesQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getBillingControllerGetInvoicesUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getBillingControllerListInvoiceEventsUrl(invoiceId: BillingControllerListInvoiceEventsPathParams["invoiceId"]) {
  const res = { method: 'GET', url: `/billing/debug/${invoiceId}/events` as const }
  return res
}

/**
 * @description Lists domain events related to a given invoice.
 * @summary TEST List invoice events
 * {@link /billing/debug/:invoiceId/events}
 */
export async function billingControllerListInvoiceEvents(invoiceId: BillingControllerListInvoiceEventsPathParams["invoiceId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<BillingControllerListInvoiceEventsQueryResponse, ResponseErrorConfig<BillingControllerListInvoiceEvents404>, unknown>({ method : "GET", url : getBillingControllerListInvoiceEventsUrl(invoiceId).url.toString(), ... requestConfig })
  return res.data
}

function getBillingControllerListInvoicesUrl() {
  const res = { method: 'POST', url: `/billing/debug/list-by-metadata` as const }
  return res
}

/**
 * @description Returns a paginated list of invoices filtered by issuance date range, statuses and failure flag. Accepts metadata filters as defined by the shared list filter DTO.
 * @summary DEBUG: List invoice by metadata
 * {@link /billing/debug/list-by-metadata}
 */
export async function billingControllerListInvoices(data: BillingControllerListInvoicesMutationRequest, config: Partial<RequestConfig<BillingControllerListInvoicesMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<BillingControllerListInvoicesMutationResponse, ResponseErrorConfig<Error>, BillingControllerListInvoicesMutationRequest>({ method : "POST", url : getBillingControllerListInvoicesUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getBillingControllerCreateManualInvoiceUrl() {
  const res = { method: 'POST', url: `/billing/debug/create-manual-invoice` as const }
  return res
}

/**
 * @summary DEBUG: Create manual invoice
 * {@link /billing/debug/create-manual-invoice}
 */
export async function billingControllerCreateManualInvoice(data: BillingControllerCreateManualInvoiceMutationRequest, config: Partial<RequestConfig<BillingControllerCreateManualInvoiceMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<BillingControllerCreateManualInvoiceMutationResponse, ResponseErrorConfig<Error>, BillingControllerCreateManualInvoiceMutationRequest>({ method : "POST", url : getBillingControllerCreateManualInvoiceUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getBillingControllerSetInvoiceCleanupUrl() {
  const res = { method: 'POST', url: `/billing/debug/set-invoice-cleanup` as const }
  return res
}

/**
 * @summary DEBUG: Set or unset the cleanup flag on an invoice and rebuild it
 * {@link /billing/debug/set-invoice-cleanup}
 */
export async function billingControllerSetInvoiceCleanup(data: BillingControllerSetInvoiceCleanupMutationRequest, config: Partial<RequestConfig<BillingControllerSetInvoiceCleanupMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<BillingControllerSetInvoiceCleanupMutationResponse, ResponseErrorConfig<Error>, BillingControllerSetInvoiceCleanupMutationRequest>({ method : "POST", url : getBillingControllerSetInvoiceCleanupUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getBillingControllerIssueInvoicesUrl() {
  const res = { method: 'POST', url: `/billing/debug/issue-invoices` as const }
  return res
}

/**
 * @summary DEBUG: Issue invoices
 * {@link /billing/debug/issue-invoices}
 */
export async function billingControllerIssueInvoices(data: BillingControllerIssueInvoicesMutationRequest, config: Partial<RequestConfig<BillingControllerIssueInvoicesMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<BillingControllerIssueInvoicesMutationResponse, ResponseErrorConfig<Error>, BillingControllerIssueInvoicesMutationRequest>({ method : "POST", url : getBillingControllerIssueInvoicesUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getBillingControllerDeleteInvoicesUrl() {
  const res = { method: 'POST', url: `/billing/debug/delete-invoices` as const }
  return res
}

/**
 * @summary DEBUG: Delete invoices
 * {@link /billing/debug/delete-invoices}
 */
export async function billingControllerDeleteInvoices(data: BillingControllerDeleteInvoicesMutationRequest, config: Partial<RequestConfig<BillingControllerDeleteInvoicesMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<BillingControllerDeleteInvoicesMutationResponse, ResponseErrorConfig<Error>, BillingControllerDeleteInvoicesMutationRequest>({ method : "POST", url : getBillingControllerDeleteInvoicesUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getBranchControllerEditBranchUrl(branchId: BranchControllerEditBranchPathParams["branchId"]) {
  const res = { method: 'PATCH', url: `/branches/${branchId}` as const }
  return res
}

/**
 * @description Edits only the name of an open MTA branch and requires the BRANCH_EDITOR role. Names are trimmed; blank names are rejected. An unchanged name succeeds without modification. Returns an empty object. Other branch and policy data remain unchanged.
 * @summary Edit an open MTA project
 * {@link /branches/:branchId}
 */
export async function branchControllerEditBranch(branchId: BranchControllerEditBranchPathParams["branchId"], data: BranchControllerEditBranchMutationRequest, config: Partial<RequestConfig<BranchControllerEditBranchMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<BranchControllerEditBranchMutationResponse, ResponseErrorConfig<BranchControllerEditBranch400 | BranchControllerEditBranch404 | BranchControllerEditBranch409>, BranchControllerEditBranchMutationRequest>({ method : "PATCH", url : getBranchControllerEditBranchUrl(branchId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getBranchControllerCreateBranchUrl(policyId: BranchControllerCreateBranchPathParams["policyId"]) {
  const res = { method: 'POST', url: `/policies/${policyId}/branches` as const }
  return res
}

/**
 * @description A mid-term adjustment needs the policy in `POLICY_CONFIRMED`, `POLICY_SIGNED` or `POLICY_STARTED`; other statuses are refused with `CONFLICTING_POLICY_STATUS`. Keep the returned branch id — every later call on that draft carries it, including the signature request.
 * @summary Create a branch
 * {@link /policies/:policyId/branches}
 */
export async function branchControllerCreateBranch(policyId: BranchControllerCreateBranchPathParams["policyId"], data: BranchControllerCreateBranchMutationRequest, params?: BranchControllerCreateBranchQueryParams, config: Partial<RequestConfig<BranchControllerCreateBranchMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<BranchControllerCreateBranchMutationResponse, ResponseErrorConfig<BranchControllerCreateBranch400 | BranchControllerCreateBranch404 | BranchControllerCreateBranch409>, BranchControllerCreateBranchMutationRequest>({ method : "POST", url : getBranchControllerCreateBranchUrl(policyId).url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getPolicyControllerListBranchesUrl(policyId: PolicyControllerListBranchesPathParams["policyId"]) {
  const res = { method: 'GET', url: `/policies/${policyId}/branches` as const }
  return res
}

/**
 * @description Returns merged and closed branches as well as open ones, and never paginates — filter on `branchStatus`, where `BRANCH_OPEN` is the draft in play.
 * @summary List branches on the policy
 * {@link /policies/:policyId/branches}
 */
export async function policyControllerListBranches(policyId: PolicyControllerListBranchesPathParams["policyId"], params?: PolicyControllerListBranchesQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PolicyControllerListBranchesQueryResponse, ResponseErrorConfig<PolicyControllerListBranches403 | PolicyControllerListBranches404>, unknown>({ method : "GET", url : getPolicyControllerListBranchesUrl(policyId).url.toString(), params, ... requestConfig })
  return res.data
}

function getBranchControllerGetBranchEffectiveDateUrl(policyId: BranchControllerGetBranchEffectiveDatePathParams["policyId"], branchId: BranchControllerGetBranchEffectiveDatePathParams["branchId"]) {
  const res = { method: 'GET', url: `/policies/${policyId}/branches/${branchId}/effective-date` as const }
  return res
}

/**
 * @description Answers only for branches that move a date. A mid-term adjustment that merely changes declared or priced fields has none and returns an empty object — that change takes effect on signature.
 * @summary Get the date at which a branch takes effect
 * {@link /policies/:policyId/branches/:branchId/effective-date}
 */
export async function branchControllerGetBranchEffectiveDate(policyId: BranchControllerGetBranchEffectiveDatePathParams["policyId"], branchId: BranchControllerGetBranchEffectiveDatePathParams["branchId"], params?: BranchControllerGetBranchEffectiveDateQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<BranchControllerGetBranchEffectiveDateQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getBranchControllerGetBranchEffectiveDateUrl(policyId, branchId).url.toString(), params, ... requestConfig })
  return res.data
}

function getBranchControllerForkBranchUrl(policyId: BranchControllerForkBranchPathParams["policyId"], branchId: BranchControllerForkBranchPathParams["branchId"]) {
  const res = { method: 'POST', url: `/policies/${policyId}/branches/${branchId}/fork` as const }
  return res
}

/**
 * @summary Fork a branch until its XXX_QUOTED events
 * {@link /policies/:policyId/branches/:branchId/fork}
 * @deprecated
 */
export async function branchControllerForkBranch(policyId: BranchControllerForkBranchPathParams["policyId"], branchId: BranchControllerForkBranchPathParams["branchId"], data: BranchControllerForkBranchMutationRequest, params?: BranchControllerForkBranchQueryParams, config: Partial<RequestConfig<BranchControllerForkBranchMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<BranchControllerForkBranchMutationResponse, ResponseErrorConfig<BranchControllerForkBranch400 | BranchControllerForkBranch404 | BranchControllerForkBranch409>, BranchControllerForkBranchMutationRequest>({ method : "POST", url : getBranchControllerForkBranchUrl(policyId, branchId).url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getBranchControllerForkBranchWithoutPolicyUrl(branchId: BranchControllerForkBranchWithoutPolicyPathParams["branchId"]) {
  const res = { method: 'POST', url: `/branches/${branchId}/fork` as const }
  return res
}

/**
 * @summary Fork a branch until its XXX_QUOTED events
 * {@link /branches/:branchId/fork}
 */
export async function branchControllerForkBranchWithoutPolicy(branchId: BranchControllerForkBranchWithoutPolicyPathParams["branchId"], data: BranchControllerForkBranchWithoutPolicyMutationRequest, params?: BranchControllerForkBranchWithoutPolicyQueryParams, config: Partial<RequestConfig<BranchControllerForkBranchWithoutPolicyMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<BranchControllerForkBranchWithoutPolicyMutationResponse, ResponseErrorConfig<BranchControllerForkBranchWithoutPolicy400 | BranchControllerForkBranchWithoutPolicy404 | BranchControllerForkBranchWithoutPolicy409>, BranchControllerForkBranchWithoutPolicyMutationRequest>({ method : "POST", url : getBranchControllerForkBranchWithoutPolicyUrl(branchId).url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getBranchControllerInvalidateBranchUrl(policyId: BranchControllerInvalidateBranchPathParams["policyId"], branchId: BranchControllerInvalidateBranchPathParams["branchId"]) {
  const res = { method: 'POST', url: `/policies/${policyId}/branches/${branchId}/invalidate` as const }
  return res
}

/**
 * @description Closes a draft without applying it; the live contract is untouched. Signing one draft closes the competing ones automatically, so this is only for drafts you abandon. On a termination branch this is also how a stop is called off, drafted or already scheduled: the policy stays in force with no coverage gap. Whoever may request that stop reason may call it off, and so may the brokers of the wholesale firm the policy is distributed for.
 * @summary Invalidate a branch
 * {@link /policies/:policyId/branches/:branchId/invalidate}
 */
export async function branchControllerInvalidateBranch(policyId: BranchControllerInvalidateBranchPathParams["policyId"], branchId: BranchControllerInvalidateBranchPathParams["branchId"], data: BranchControllerInvalidateBranchMutationRequest, params?: BranchControllerInvalidateBranchQueryParams, config: Partial<RequestConfig<BranchControllerInvalidateBranchMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<BranchControllerInvalidateBranchMutationResponse, ResponseErrorConfig<BranchControllerInvalidateBranch403 | BranchControllerInvalidateBranch404 | BranchControllerInvalidateBranch409>, BranchControllerInvalidateBranchMutationRequest>({ method : "POST", url : getBranchControllerInvalidateBranchUrl(policyId, branchId).url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getBrokerControllerAtMeUrl() {
  const res = { method: 'GET', url: `/brokerage-firms/@me` as const }
  return res
}

/**
 * @description Returns the brokerage information of the authenticated user, including profile and brokerage firm context, if available. This endpoint is deprecated and may be removed in a future version. Requires a valid session (401 if unauthenticated).
 * @summary Get current user's brokerage firm info
 * {@link /brokerage-firms/@me}
 * @deprecated
 */
export async function brokerControllerAtMe(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<BrokerControllerAtMeQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getBrokerControllerAtMeUrl().url.toString(), ... requestConfig })
  return res.data
}

function getBrokerControllerCreateBrokerUrl(brokerageFirmId: BrokerControllerCreateBrokerPathParams["brokerageFirmId"]) {
  const res = { method: 'POST', url: `/brokerage-firms/${brokerageFirmId}/brokers` as const }
  return res
}

/**
 * @description Creates a broker within the specified brokerage firm. You must provide the target brokerage firm id in the path and the broker details in the request body. The caller must have sufficient permissions within the brokerage firm.
 * @summary Create broker
 * {@link /brokerage-firms/:brokerageFirmId/brokers}
 */
export async function brokerControllerCreateBroker(brokerageFirmId: BrokerControllerCreateBrokerPathParams["brokerageFirmId"], data: BrokerControllerCreateBrokerMutationRequest, config: Partial<RequestConfig<BrokerControllerCreateBrokerMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<BrokerControllerCreateBrokerMutationResponse, ResponseErrorConfig<BrokerControllerCreateBroker404>, BrokerControllerCreateBrokerMutationRequest>({ method : "POST", url : getBrokerControllerCreateBrokerUrl(brokerageFirmId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getBrokerControllerListBrokersUrl(brokerageFirmId: BrokerControllerListBrokersPathParams["brokerageFirmId"]) {
  const res = { method: 'GET', url: `/brokerage-firms/${brokerageFirmId}/brokers` as const }
  return res
}

/**
 * @description Returns a paginated list of brokers for the specified brokerage firm. Supports pagination parameters (e.g., page cursors or limits) via query and may support optional role filters depending on configuration.
 * @summary List brokers in brokerage firm
 * {@link /brokerage-firms/:brokerageFirmId/brokers}
 */
export async function brokerControllerListBrokers(brokerageFirmId: BrokerControllerListBrokersPathParams["brokerageFirmId"], params?: BrokerControllerListBrokersQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<BrokerControllerListBrokersQueryResponse, ResponseErrorConfig<BrokerControllerListBrokers404>, unknown>({ method : "GET", url : getBrokerControllerListBrokersUrl(brokerageFirmId).url.toString(), params, ... requestConfig })
  return res.data
}

function getBrokerControllerUpdateBrokerUrl(brokerUserId: BrokerControllerUpdateBrokerPathParams["brokerUserId"], brokerageFirmId: BrokerControllerUpdateBrokerPathParams["brokerageFirmId"]) {
  const res = { method: 'PATCH', url: `/brokerage-firms/${brokerageFirmId}/brokers/${brokerUserId}` as const }
  return res
}

/**
 * @description Updates a broker profile inside a brokerage firm. Provide the brokerage firm id and the broker user id in the path and the fields to update in the request body. Only allowed for users with edit permissions.
 * @summary Update broker
 * {@link /brokerage-firms/:brokerageFirmId/brokers/:brokerUserId}
 */
export async function brokerControllerUpdateBroker(brokerUserId: BrokerControllerUpdateBrokerPathParams["brokerUserId"], brokerageFirmId: BrokerControllerUpdateBrokerPathParams["brokerageFirmId"], data: BrokerControllerUpdateBrokerMutationRequest, config: Partial<RequestConfig<BrokerControllerUpdateBrokerMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<BrokerControllerUpdateBrokerMutationResponse, ResponseErrorConfig<BrokerControllerUpdateBroker404>, BrokerControllerUpdateBrokerMutationRequest>({ method : "PATCH", url : getBrokerControllerUpdateBrokerUrl(brokerUserId, brokerageFirmId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getBrokerControllerDeleteBrokerUrl(brokerageFirmId: BrokerControllerDeleteBrokerPathParams["brokerageFirmId"], brokerUserId: BrokerControllerDeleteBrokerPathParams["brokerUserId"]) {
  const res = { method: 'DELETE', url: `/brokerage-firms/${brokerageFirmId}/brokers/${brokerUserId}` as const }
  return res
}

/**
 * @description Removes a broker from the given brokerage firm using the broker user id. Only users with delete permissions within the brokerage firm can perform this action.
 * @summary Delete broker from brokerage firm
 * {@link /brokerage-firms/:brokerageFirmId/brokers/:brokerUserId}
 */
export async function brokerControllerDeleteBroker(brokerageFirmId: BrokerControllerDeleteBrokerPathParams["brokerageFirmId"], brokerUserId: BrokerControllerDeleteBrokerPathParams["brokerUserId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<BrokerControllerDeleteBrokerMutationResponse, ResponseErrorConfig<BrokerControllerDeleteBroker404>, unknown>({ method : "DELETE", url : getBrokerControllerDeleteBrokerUrl(brokerageFirmId, brokerUserId).url.toString(), ... requestConfig })
  return res.data
}

function getBrokerControllerListDescendantBrokersUrl(brokerageFirmId: BrokerControllerListDescendantBrokersPathParams["brokerageFirmId"]) {
  const res = { method: 'GET', url: `/brokerage-firms/${brokerageFirmId}/brokers/descendants` as const }
  return res
}

/**
 * @description Returns a paginated list of brokers that belong to the given brokerage firm or any descendant in its hierarchy. Each entry is enriched with the brokerage firm id and display name so callers can group results by firm. Supports a queryString that matches broker firstName or lastName.
 * @summary List brokers of a firm and its descendants
 * {@link /brokerage-firms/:brokerageFirmId/brokers/descendants}
 */
export async function brokerControllerListDescendantBrokers(brokerageFirmId: BrokerControllerListDescendantBrokersPathParams["brokerageFirmId"], params?: BrokerControllerListDescendantBrokersQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<BrokerControllerListDescendantBrokersQueryResponse, ResponseErrorConfig<BrokerControllerListDescendantBrokers404>, unknown>({ method : "GET", url : getBrokerControllerListDescendantBrokersUrl(brokerageFirmId).url.toString(), params, ... requestConfig })
  return res.data
}

function getBrokerControllerGetBrokerUrl(brokerUserId: BrokerControllerGetBrokerPathParams["brokerUserId"]) {
  const res = { method: 'GET', url: `/brokerage-firms/brokers/${brokerUserId}` as const }
  return res
}

/**
 * @description Fetches a broker by the broker user id. This endpoint returns profile and brokerage context for the specified broker.
 * @summary Get a broker
 * {@link /brokerage-firms/brokers/:brokerUserId}
 */
export async function brokerControllerGetBroker(brokerUserId: BrokerControllerGetBrokerPathParams["brokerUserId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<BrokerControllerGetBrokerQueryResponse, ResponseErrorConfig<BrokerControllerGetBroker404>, unknown>({ method : "GET", url : getBrokerControllerGetBrokerUrl(brokerUserId).url.toString(), ... requestConfig })
  return res.data
}

function getEmailAccountControllerListMineUrl() {
  const res = { method: 'GET', url: `/email-accounts/@me` as const }
  return res
}

/**
 * @description Returns the connected email accounts owned by the authenticated broker plus every account shared within the broker's brokerage firm.
 * @summary List the logged-in broker's connected email accounts
 * {@link /email-accounts/@me}
 */
export async function emailAccountControllerListMine(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<EmailAccountControllerListMineQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getEmailAccountControllerListMineUrl().url.toString(), ... requestConfig })
  return res.data
}

function getEmailAccountControllerConnectUrl() {
  const res = { method: 'POST', url: `/email-accounts/connect` as const }
  return res
}

/**
 * @description Returns a single-use hosted consent URL. The browser must be redirected to it; the provider redirects back to the OAuth callback once consent completes. Connecting a shared mailbox requires the shared-account admin permission. Pass delegatedMailboxAddress to connect a Microsoft 365 shared mailbox through the signing-in user (Outlook only).
 * @summary Start the OAuth consent flow to connect an email account
 * {@link /email-accounts/connect}
 */
export async function emailAccountControllerConnect(data: EmailAccountControllerConnectMutationRequest, config: Partial<RequestConfig<EmailAccountControllerConnectMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<EmailAccountControllerConnectMutationResponse, ResponseErrorConfig<Error>, EmailAccountControllerConnectMutationRequest>({ method : "POST", url : getEmailAccountControllerConnectUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getEmailAccountControllerReconnectUrl(emailAccountId: EmailAccountControllerReconnectPathParams["emailAccountId"]) {
  const res = { method: 'POST', url: `/email-accounts/${emailAccountId}/reconnect` as const }
  return res
}

/**
 * @description Returns a single-use hosted consent URL that reauthorizes the existing vendor account. The browser must be redirected to it; the provider redirects back to the OAuth callback once consent completes.
 * @summary Restart the OAuth consent flow to reconnect an email account in error
 * {@link /email-accounts/:emailAccountId/reconnect}
 */
export async function emailAccountControllerReconnect(emailAccountId: EmailAccountControllerReconnectPathParams["emailAccountId"], data: EmailAccountControllerReconnectMutationRequest, config: Partial<RequestConfig<EmailAccountControllerReconnectMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<EmailAccountControllerReconnectMutationResponse, ResponseErrorConfig<Error>, EmailAccountControllerReconnectMutationRequest>({ method : "POST", url : getEmailAccountControllerReconnectUrl(emailAccountId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getEmailAccountControllerDisconnectUrl(emailAccountId: EmailAccountControllerDisconnectPathParams["emailAccountId"]) {
  const res = { method: 'DELETE', url: `/email-accounts/${emailAccountId}` as const }
  return res
}

/**
 * @description Revokes the upstream OAuth grant, removes the account from the email sync provider, and soft-deletes it. A broker may delete their personal accounts; a shared account may only be deleted by a firm admin.
 * @summary Disconnect and delete one of the logged-in broker's email accounts
 * {@link /email-accounts/:emailAccountId}
 */
export async function emailAccountControllerDisconnect(emailAccountId: EmailAccountControllerDisconnectPathParams["emailAccountId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<EmailAccountControllerDisconnectMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "DELETE", url : getEmailAccountControllerDisconnectUrl(emailAccountId).url.toString(), ... requestConfig })
  return res.data
}

function getEmailControllerAttachPoliciesUrl(emailId: EmailControllerAttachPoliciesPathParams["emailId"]) {
  const res = { method: 'POST', url: `/emails/${emailId}/policies` as const }
  return res
}

/**
 * @description Records manual links on this email and durably requests thread analysis. The caller must see the email and have access to every policy. Preserves the archive and read state. Returns after the decisions commit; automatic thread analysis is asynchronous.
 * @summary Attach an email to policies
 * {@link /emails/:emailId/policies}
 */
export async function emailControllerAttachPolicies(emailId: EmailControllerAttachPoliciesPathParams["emailId"], data: EmailControllerAttachPoliciesMutationRequest, config: Partial<RequestConfig<EmailControllerAttachPoliciesMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<EmailControllerAttachPoliciesMutationResponse, ResponseErrorConfig<EmailControllerAttachPolicies400 | EmailControllerAttachPolicies401 | EmailControllerAttachPolicies403>, EmailControllerAttachPoliciesMutationRequest>({ method : "POST", url : getEmailControllerAttachPoliciesUrl(emailId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getEmailControllerDetachPoliciesUrl() {
  const res = { method: 'POST', url: `/emails/policies/detach` as const }
  return res
}

/**
 * @description Records a manual exclusion for every email and policy pair in one transaction, then durably requests the analysis of each affected thread. Other policy links, archive state and read state are preserved. The caller must see every email and have access to every policy.
 * @summary Detach emails from policies
 * {@link /emails/policies/detach}
 */
export async function emailControllerDetachPolicies(data: EmailControllerDetachPoliciesMutationRequest, config: Partial<RequestConfig<EmailControllerDetachPoliciesMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<EmailControllerDetachPoliciesMutationResponse, ResponseErrorConfig<EmailControllerDetachPolicies400 | EmailControllerDetachPolicies401 | EmailControllerDetachPolicies403>, EmailControllerDetachPoliciesMutationRequest>({ method : "POST", url : getEmailControllerDetachPoliciesUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getEmailControllerDetachPolicyUrl(emailId: EmailControllerDetachPolicyPathParams["emailId"], policyId: EmailControllerDetachPolicyPathParams["policyId"]) {
  const res = { method: 'DELETE', url: `/emails/${emailId}/policies/${policyId}` as const }
  return res
}

/**
 * @description Records a manual exclusion for this email and durably requests thread analysis. Other policy links, archive state and read state are preserved. The caller must see the email and have access to the policy.
 * @summary Detach an email from a policy
 * {@link /emails/:emailId/policies/:policyId}
 */
export async function emailControllerDetachPolicy(emailId: EmailControllerDetachPolicyPathParams["emailId"], policyId: EmailControllerDetachPolicyPathParams["policyId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<EmailControllerDetachPolicyMutationResponse, ResponseErrorConfig<EmailControllerDetachPolicy400 | EmailControllerDetachPolicy401 | EmailControllerDetachPolicy403>, unknown>({ method : "DELETE", url : getEmailControllerDetachPolicyUrl(emailId, policyId).url.toString(), ... requestConfig })
  return res.data
}

function getEmailControllerMovePolicyUrl(emailId: EmailControllerMovePolicyPathParams["emailId"]) {
  const res = { method: 'POST', url: `/emails/${emailId}/policies/move` as const }
  return res
}

/**
 * @description Atomically detaches the currently linked source policy and attaches a different target policy, then durably requests thread analysis. The caller must see the email and have access to both policies. Preserves the archive and read state.
 * @summary Move an email link to another policy
 * {@link /emails/:emailId/policies/move}
 */
export async function emailControllerMovePolicy(emailId: EmailControllerMovePolicyPathParams["emailId"], data: EmailControllerMovePolicyMutationRequest, config: Partial<RequestConfig<EmailControllerMovePolicyMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<EmailControllerMovePolicyMutationResponse, ResponseErrorConfig<EmailControllerMovePolicy400 | EmailControllerMovePolicy401 | EmailControllerMovePolicy403>, EmailControllerMovePolicyMutationRequest>({ method : "POST", url : getEmailControllerMovePolicyUrl(emailId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getEmailControllerGetAttachmentDownloadUrlUrl(emailId: EmailControllerGetAttachmentDownloadUrlPathParams["emailId"], emailAttachmentId: EmailControllerGetAttachmentDownloadUrlPathParams["emailAttachmentId"]) {
  const res = { method: 'GET', url: `/emails/${emailId}/attachments/${emailAttachmentId}/download-url` as const }
  return res
}

/**
 * @description Returns a presigned URL serving the attachment under its original filename. The email must belong to one of the broker's accounts or to an account shared within their brokerage firm. Responds 409 while the attachment is not stored yet, or was skipped or failed.
 * @summary Get a short-lived download URL for an email attachment
 * {@link /emails/:emailId/attachments/:emailAttachmentId/download-url}
 */
export async function emailControllerGetAttachmentDownloadUrl(emailId: EmailControllerGetAttachmentDownloadUrlPathParams["emailId"], emailAttachmentId: EmailControllerGetAttachmentDownloadUrlPathParams["emailAttachmentId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<EmailControllerGetAttachmentDownloadUrlQueryResponse, ResponseErrorConfig<EmailControllerGetAttachmentDownloadUrl401 | EmailControllerGetAttachmentDownloadUrl409>, unknown>({ method : "GET", url : getEmailControllerGetAttachmentDownloadUrlUrl(emailId, emailAttachmentId).url.toString(), ... requestConfig })
  return res.data
}

function getEmailControllerGetEmailUrl(emailId: EmailControllerGetEmailPathParams["emailId"]) {
  const res = { method: 'GET', url: `/emails/${emailId}` as const }
  return res
}

/**
 * @description Returns the email with its stored web-safe HTML body, its attachments and their storage status. Opening an unread email marks it as read and schedules the Seen flag write to the mailbox. The email must belong to one of the broker's accounts or to an account shared within their brokerage firm; disconnected accounts keep their history readable.
 * @summary Read an email: metadata, stored body and attachments
 * {@link /emails/:emailId}
 */
export async function emailControllerGetEmail(emailId: EmailControllerGetEmailPathParams["emailId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<EmailControllerGetEmailQueryResponse, ResponseErrorConfig<EmailControllerGetEmail400 | EmailControllerGetEmail401>, unknown>({ method : "GET", url : getEmailControllerGetEmailUrl(emailId).url.toString(), ... requestConfig })
  return res.data
}

function getEmailThreadControllerListThreadsUrl() {
  const res = { method: 'GET', url: `/email-threads` as const }
  return res
}

/**
 * @description Threads to process or processed, newest latest email first, cursor-paginated. With policyId, returns whole threads containing an active link to that policy, with their emails oldest first, including archived emails. Requires policy access and covers personal and firm-shared accounts for every broker. Without policyId, shared accounts require shared-account admin permission. Disconnected accounts retain their history. Listing never marks an email as read.
 * @summary List the email threads
 * {@link /email-threads}
 */
export async function emailThreadControllerListThreads(params?: EmailThreadControllerListThreadsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<EmailThreadControllerListThreadsQueryResponse, ResponseErrorConfig<EmailThreadControllerListThreads400 | EmailThreadControllerListThreads401>, unknown>({ method : "GET", url : getEmailThreadControllerListThreadsUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getEmailThreadControllerSetThreadsArchivedUrl() {
  const res = { method: 'PATCH', url: `/email-threads` as const }
  return res
}

/**
 * @description Sets the archive state of every email of the threads, or only of `emailIds`, in one write. Archiving an archived email keeps its first archive date; links are untouched. Returns the emails whose state changed, which an undo sends back with the opposite value. Every thread must belong to one of the broker's personal accounts, or to a firm shared account for shared-account admins; one malformed, unknown or invisible thread rejects the whole request.
 * @summary Archive or unarchive email threads
 * {@link /email-threads}
 */
export async function emailThreadControllerSetThreadsArchived(data: EmailThreadControllerSetThreadsArchivedMutationRequest, config: Partial<RequestConfig<EmailThreadControllerSetThreadsArchivedMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<EmailThreadControllerSetThreadsArchivedMutationResponse, ResponseErrorConfig<EmailThreadControllerSetThreadsArchived400 | EmailThreadControllerSetThreadsArchived401>, EmailThreadControllerSetThreadsArchivedMutationRequest>({ method : "PATCH", url : getEmailThreadControllerSetThreadsArchivedUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getEmailThreadControllerGetThreadUrl(threadId: EmailThreadControllerGetThreadPathParams["threadId"]) {
  const res = { method: 'GET', url: `/email-threads/${threadId}` as const }
  return res
}

/**
 * @description Every email of the thread, oldest first, with its linked policies; bodies are read through GET /emails/{emailId}. Opening the thread marks each unread email as read and schedules the Seen flag write to the mailbox. The thread must belong to one of the broker's accounts or to an account shared within their brokerage firm.
 * @summary Open an email thread
 * {@link /email-threads/:threadId}
 */
export async function emailThreadControllerGetThread(threadId: EmailThreadControllerGetThreadPathParams["threadId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<EmailThreadControllerGetThreadQueryResponse, ResponseErrorConfig<EmailThreadControllerGetThread400 | EmailThreadControllerGetThread401>, unknown>({ method : "GET", url : getEmailThreadControllerGetThreadUrl(threadId).url.toString(), ... requestConfig })
  return res.data
}

function getEmailThreadControllerAttachThreadsPoliciesUrl() {
  const res = { method: 'POST', url: `/email-threads/policies` as const }
  return res
}

/**
 * @description Records manual links to the policies on every email of the threads still to attach (not archived, no active link), including emails with a manual exclusion, in one transaction, then durably requests the analysis of each thread. Never marks an email as read. Returns the emails now linked, which an undo sends to POST /emails/policies/detach. The caller must see every thread's account and have access to every policy.
 * @summary Attach email threads to policies
 * {@link /email-threads/policies}
 */
export async function emailThreadControllerAttachThreadsPolicies(data: EmailThreadControllerAttachThreadsPoliciesMutationRequest, config: Partial<RequestConfig<EmailThreadControllerAttachThreadsPoliciesMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<EmailThreadControllerAttachThreadsPoliciesMutationResponse, ResponseErrorConfig<EmailThreadControllerAttachThreadsPolicies400 | EmailThreadControllerAttachThreadsPolicies401 | EmailThreadControllerAttachThreadsPolicies403>, EmailThreadControllerAttachThreadsPoliciesMutationRequest>({ method : "POST", url : getEmailThreadControllerAttachThreadsPoliciesUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getGeneralInboxControllerGetSummaryUrl() {
  const res = { method: 'GET', url: `/general-inbox/summary` as const }
  return res
}

/**
 * @description Counters for the sidebar and the mailbox filter: unread threads to process, in total and per mailbox. Covers the broker's personal accounts, plus the firm's shared accounts for shared-account admins.
 * @summary Summary counters of the general inbox
 * {@link /general-inbox/summary}
 */
export async function generalInboxControllerGetSummary(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GeneralInboxControllerGetSummaryQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGeneralInboxControllerGetSummaryUrl().url.toString(), ... requestConfig })
  return res.data
}

function getClaimManagementControllerLookupCustomerUrl() {
  const res = { method: 'POST', url: `/claim-management/lookup-customer` as const }
  return res
}

/**
 * @description Optional `reference` is forwarded to the partner as a secondary identifier (e.g. CB: `IDENT_2`). When present it also propagates to `/check-coverage` and `/claims` (bootstrap); omitted or empty leaves those calls unchanged.
 * @summary Look up a customer in the partner system (FNOL screen 1)
 * {@link /claim-management/lookup-customer}
 */
export async function claimManagementControllerLookupCustomer(data: ClaimManagementControllerLookupCustomerMutationRequest, config: Partial<RequestConfig<ClaimManagementControllerLookupCustomerMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ClaimManagementControllerLookupCustomerMutationResponse, ResponseErrorConfig<ClaimManagementControllerLookupCustomer400 | ClaimManagementControllerLookupCustomer404>, ClaimManagementControllerLookupCustomerMutationRequest>({ method : "POST", url : getClaimManagementControllerLookupCustomerUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getClaimManagementControllerCheckCoverageUrl() {
  const res = { method: 'POST', url: `/claim-management/check-coverage` as const }
  return res
}

/**
 * @description Optional `reference` (CB: `IDENT_2`) — pass the value the customer typed on screen 1. Forwarded to the partner alongside `externalCustomerId` (IDENT_1) on every partner sub-call. Omitted or empty = same payload as before.
 * @summary Check coverage for a claim type (FNOL screen 2)
 * {@link /claim-management/check-coverage}
 */
export async function claimManagementControllerCheckCoverage(data: ClaimManagementControllerCheckCoverageMutationRequest, config: Partial<RequestConfig<ClaimManagementControllerCheckCoverageMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ClaimManagementControllerCheckCoverageMutationResponse, ResponseErrorConfig<ClaimManagementControllerCheckCoverage400 | ClaimManagementControllerCheckCoverage422>, ClaimManagementControllerCheckCoverageMutationRequest>({ method : "POST", url : getClaimManagementControllerCheckCoverageUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getClaimManagementControllerGenerateFnolUploadUrlUrl() {
  const res = { method: 'POST', url: `/claim-management/documents/upload-url` as const }
  return res
}

/**
 * @summary Generate a presigned upload URL for an FNOL document (authenticated)
 * {@link /claim-management/documents/upload-url}
 */
export async function claimManagementControllerGenerateFnolUploadUrl(data: ClaimManagementControllerGenerateFnolUploadUrlMutationRequest, config: Partial<RequestConfig<ClaimManagementControllerGenerateFnolUploadUrlMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ClaimManagementControllerGenerateFnolUploadUrlMutationResponse, ResponseErrorConfig<ClaimManagementControllerGenerateFnolUploadUrl400 | ClaimManagementControllerGenerateFnolUploadUrl413>, ClaimManagementControllerGenerateFnolUploadUrlMutationRequest>({ method : "POST", url : getClaimManagementControllerGenerateFnolUploadUrlUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getClaimManagementControllerBootstrapUrl() {
  const res = { method: 'POST', url: `/claim-management/claims` as const }
  return res
}

/**
 * @description Optional `reference` (CB: `IDENT_2`) is persisted onto the claim aggregate and forwarded to the partner at SUBMIT (CB `/creation`). Pass the value collected on screen 1; omitted or empty = no `IDENT_2` is emitted at SUBMIT.
 * @summary Create a new claim (FNOL bootstrap)
 * {@link /claim-management/claims}
 */
export async function claimManagementControllerBootstrap(data: ClaimManagementControllerBootstrapMutationRequest, config: Partial<RequestConfig<ClaimManagementControllerBootstrapMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ClaimManagementControllerBootstrapMutationResponse, ResponseErrorConfig<ClaimManagementControllerBootstrap400 | ClaimManagementControllerBootstrap422>, ClaimManagementControllerBootstrapMutationRequest>({ method : "POST", url : getClaimManagementControllerBootstrapUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getClaimManagementControllerListUrl() {
  const res = { method: 'GET', url: `/claim-management/claims` as const }
  return res
}

/**
 * @summary List claims (internal — claim managers only)
 * {@link /claim-management/claims}
 */
export async function claimManagementControllerList(params?: ClaimManagementControllerListQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ClaimManagementControllerListQueryResponse, ResponseErrorConfig<ClaimManagementControllerList400>, unknown>({ method : "GET", url : getClaimManagementControllerListUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getClaimManagementControllerListMyClaimsUrl() {
  const res = { method: 'GET', url: `/claim-management/my-claims` as const }
  return res
}

/**
 * @summary List the caller's own claims (self-service)
 * {@link /claim-management/my-claims}
 */
export async function claimManagementControllerListMyClaims(params?: ClaimManagementControllerListMyClaimsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ClaimManagementControllerListMyClaimsQueryResponse, ResponseErrorConfig<ClaimManagementControllerListMyClaims400>, unknown>({ method : "GET", url : getClaimManagementControllerListMyClaimsUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getClaimManagementControllerUpdateDraftUrl(id: ClaimManagementControllerUpdateDraftPathParams["id"]) {
  const res = { method: 'PATCH', url: `/claim-management/claims/${id}` as const }
  return res
}

/**
 * @summary Update incident fields / assetId / metadata
 * {@link /claim-management/claims/:id}
 */
export async function claimManagementControllerUpdateDraft(id: ClaimManagementControllerUpdateDraftPathParams["id"], data: ClaimManagementControllerUpdateDraftMutationRequest, config: Partial<RequestConfig<ClaimManagementControllerUpdateDraftMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ClaimManagementControllerUpdateDraftMutationResponse, ResponseErrorConfig<ClaimManagementControllerUpdateDraft400 | ClaimManagementControllerUpdateDraft404 | ClaimManagementControllerUpdateDraft409>, ClaimManagementControllerUpdateDraftMutationRequest>({ method : "PATCH", url : getClaimManagementControllerUpdateDraftUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getClaimManagementControllerGetUrl(id: ClaimManagementControllerGetPathParams["id"]) {
  const res = { method: 'GET', url: `/claim-management/claims/${id}` as const }
  return res
}

/**
 * @summary Get a claim by ID (the claimant for their own claim, or a claims manager for any)
 * {@link /claim-management/claims/:id}
 */
export async function claimManagementControllerGet(id: ClaimManagementControllerGetPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ClaimManagementControllerGetQueryResponse, ResponseErrorConfig<ClaimManagementControllerGet400 | ClaimManagementControllerGet404>, unknown>({ method : "GET", url : getClaimManagementControllerGetUrl(id).url.toString(), ... requestConfig })
  return res.data
}

function getClaimManagementControllerUpdateCustomFieldsUrl(id: ClaimManagementControllerUpdateCustomFieldsPathParams["id"]) {
  const res = { method: 'PUT', url: `/claim-management/claims/${id}/custom-fields` as const }
  return res
}

/**
 * @summary Update custom fields (patch, merged + validated)
 * {@link /claim-management/claims/:id/custom-fields}
 */
export async function claimManagementControllerUpdateCustomFields(id: ClaimManagementControllerUpdateCustomFieldsPathParams["id"], data: ClaimManagementControllerUpdateCustomFieldsMutationRequest, config: Partial<RequestConfig<ClaimManagementControllerUpdateCustomFieldsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ClaimManagementControllerUpdateCustomFieldsMutationResponse, ResponseErrorConfig<ClaimManagementControllerUpdateCustomFields400 | ClaimManagementControllerUpdateCustomFields404 | ClaimManagementControllerUpdateCustomFields409>, ClaimManagementControllerUpdateCustomFieldsMutationRequest>({ method : "PUT", url : getClaimManagementControllerUpdateCustomFieldsUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getClaimManagementControllerAttachDocumentUrl(id: ClaimManagementControllerAttachDocumentPathParams["id"]) {
  const res = { method: 'POST', url: `/claim-management/claims/${id}/documents` as const }
  return res
}

/**
 * @summary Attach a document to a claim
 * {@link /claim-management/claims/:id/documents}
 */
export async function claimManagementControllerAttachDocument(id: ClaimManagementControllerAttachDocumentPathParams["id"], data: ClaimManagementControllerAttachDocumentMutationRequest, config: Partial<RequestConfig<ClaimManagementControllerAttachDocumentMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ClaimManagementControllerAttachDocumentMutationResponse, ResponseErrorConfig<ClaimManagementControllerAttachDocument400 | ClaimManagementControllerAttachDocument404 | ClaimManagementControllerAttachDocument409>, ClaimManagementControllerAttachDocumentMutationRequest>({ method : "POST", url : getClaimManagementControllerAttachDocumentUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getClaimManagementControllerGenerateDocumentUrl(id: ClaimManagementControllerGenerateDocumentPathParams["id"]) {
  const res = { method: 'POST', url: `/claim-management/claims/${id}/documents/generate` as const }
  return res
}

/**
 * @summary Generate a Korint-rendered document for a slot and attach it
 * {@link /claim-management/claims/:id/documents/generate}
 */
export async function claimManagementControllerGenerateDocument(id: ClaimManagementControllerGenerateDocumentPathParams["id"], data: ClaimManagementControllerGenerateDocumentMutationRequest, config: Partial<RequestConfig<ClaimManagementControllerGenerateDocumentMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ClaimManagementControllerGenerateDocumentMutationResponse, ResponseErrorConfig<ClaimManagementControllerGenerateDocument400 | ClaimManagementControllerGenerateDocument404 | ClaimManagementControllerGenerateDocument409>, ClaimManagementControllerGenerateDocumentMutationRequest>({ method : "POST", url : getClaimManagementControllerGenerateDocumentUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getClaimManagementControllerGetDocumentGenerationPayloadUrl() {
  const res = { method: 'POST', url: `/claim-management/debug/generate-document-payload` as const }
  return res
}

/**
 * @summary Debug: build the Carbone payload for a claim document slot without rendering
 * {@link /claim-management/debug/generate-document-payload}
 */
export async function claimManagementControllerGetDocumentGenerationPayload(data: ClaimManagementControllerGetDocumentGenerationPayloadMutationRequest, config: Partial<RequestConfig<ClaimManagementControllerGetDocumentGenerationPayloadMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ClaimManagementControllerGetDocumentGenerationPayloadMutationResponse, ResponseErrorConfig<ClaimManagementControllerGetDocumentGenerationPayload400 | ClaimManagementControllerGetDocumentGenerationPayload404 | ClaimManagementControllerGetDocumentGenerationPayload409>, ClaimManagementControllerGetDocumentGenerationPayloadMutationRequest>({ method : "POST", url : getClaimManagementControllerGetDocumentGenerationPayloadUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getClaimManagementControllerDetachDocumentUrl(id: ClaimManagementControllerDetachDocumentPathParams["id"], documentId: ClaimManagementControllerDetachDocumentPathParams["documentId"]) {
  const res = { method: 'DELETE', url: `/claim-management/claims/${id}/documents/${documentId}` as const }
  return res
}

/**
 * @summary Detach a document from a claim
 * {@link /claim-management/claims/:id/documents/:documentId}
 */
export async function claimManagementControllerDetachDocument(id: ClaimManagementControllerDetachDocumentPathParams["id"], documentId: ClaimManagementControllerDetachDocumentPathParams["documentId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ClaimManagementControllerDetachDocumentMutationResponse, ResponseErrorConfig<ClaimManagementControllerDetachDocument400 | ClaimManagementControllerDetachDocument404 | ClaimManagementControllerDetachDocument409>, unknown>({ method : "DELETE", url : getClaimManagementControllerDetachDocumentUrl(id, documentId).url.toString(), ... requestConfig })
  return res.data
}

function getClaimManagementControllerTransitionUrl(id: ClaimManagementControllerTransitionPathParams["id"]) {
  const res = { method: 'POST', url: `/claim-management/claims/${id}/transition` as const }
  return res
}

/**
 * @summary Apply a claim state-machine transition (SUBMIT / DISCARD / FORWARD_EXTERNAL / FLAG_PIECES / SETTLE / CLOSE / REOPEN_*). Partner-facing side effects (forward, re-upload flag) run asynchronously.
 * {@link /claim-management/claims/:id/transition}
 */
export async function claimManagementControllerTransition(id: ClaimManagementControllerTransitionPathParams["id"], data: ClaimManagementControllerTransitionMutationRequest, config: Partial<RequestConfig<ClaimManagementControllerTransitionMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ClaimManagementControllerTransitionMutationResponse, ResponseErrorConfig<ClaimManagementControllerTransition400 | ClaimManagementControllerTransition404 | ClaimManagementControllerTransition409>, ClaimManagementControllerTransitionMutationRequest>({ method : "POST", url : getClaimManagementControllerTransitionUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getClaimManagementControllerRetryForwardUrl(id: ClaimManagementControllerRetryForwardPathParams["id"]) {
  const res = { method: 'POST', url: `/claim-management/claims/${id}/retry-forward` as const }
  return res
}

/**
 * @summary Retry the partner-API forward for a submitted claim whose forward failed. Super-admin only; the forward itself is asynchronous.
 * {@link /claim-management/claims/:id/retry-forward}
 */
export async function claimManagementControllerRetryForward(id: ClaimManagementControllerRetryForwardPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ClaimManagementControllerRetryForwardMutationResponse, ResponseErrorConfig<ClaimManagementControllerRetryForward400 | ClaimManagementControllerRetryForward404>, unknown>({ method : "POST", url : getClaimManagementControllerRetryForwardUrl(id).url.toString(), ... requestConfig })
  return res.data
}

function getClaimManagementControllerAddNoteUrl(id: ClaimManagementControllerAddNotePathParams["id"]) {
  const res = { method: 'POST', url: `/claim-management/claims/${id}/notes` as const }
  return res
}

/**
 * @summary Append a note to a claim (any state, append-only)
 * {@link /claim-management/claims/:id/notes}
 */
export async function claimManagementControllerAddNote(id: ClaimManagementControllerAddNotePathParams["id"], data: ClaimManagementControllerAddNoteMutationRequest, config: Partial<RequestConfig<ClaimManagementControllerAddNoteMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ClaimManagementControllerAddNoteMutationResponse, ResponseErrorConfig<ClaimManagementControllerAddNote400 | ClaimManagementControllerAddNote404>, ClaimManagementControllerAddNoteMutationRequest>({ method : "POST", url : getClaimManagementControllerAddNoteUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getClaimManagementControllerStartClaimsExportUrl() {
  const res = { method: 'POST', url: `/claim-management/claims/export` as const }
  return res
}

/**
 * @description Takes the same filters as `GET /claim-management/claims` but ignores pagination: the CSV covers every claim the filters select. Building it is asynchronous — this enqueues a job and returns its id; poll `GET /claim-management/claims/export/{jobId}` for the presigned URL. The CSV is semicolon-delimited with a UTF-8 BOM (Excel fr-FR opens a comma-delimited one as a single column) and the link expires after an hour.
 * @summary Start a CSV export of the filtered claims list (internal — claim managers only)
 * {@link /claim-management/claims/export}
 */
export async function claimManagementControllerStartClaimsExport(params?: ClaimManagementControllerStartClaimsExportQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ClaimManagementControllerStartClaimsExportMutationResponse, ResponseErrorConfig<ClaimManagementControllerStartClaimsExport400>, unknown>({ method : "POST", url : getClaimManagementControllerStartClaimsExportUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getClaimManagementControllerGetClaimsExportStatusUrl(jobId: ClaimManagementControllerGetClaimsExportStatusPathParams["jobId"]) {
  const res = { method: 'GET', url: `/claim-management/claims/export/${jobId}` as const }
  return res
}

/**
 * @description `downloadUrl` is present only once `status` is SUCCEEDED. Terminal states are SUCCEEDED, ERROR and CANCELLED.
 * @summary Poll a claims CSV export job (internal — claim managers only)
 * {@link /claim-management/claims/export/:jobId}
 */
export async function claimManagementControllerGetClaimsExportStatus(jobId: ClaimManagementControllerGetClaimsExportStatusPathParams["jobId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ClaimManagementControllerGetClaimsExportStatusQueryResponse, ResponseErrorConfig<ClaimManagementControllerGetClaimsExportStatus400>, unknown>({ method : "GET", url : getClaimManagementControllerGetClaimsExportStatusUrl(jobId).url.toString(), ... requestConfig })
  return res.data
}

function getClaimManagementControllerAvailableTransitionsUrl(id: ClaimManagementControllerAvailableTransitionsPathParams["id"]) {
  const res = { method: 'GET', url: `/claim-management/claims/${id}/available-transitions` as const }
  return res
}

/**
 * @summary Get valid next state-machine events from the current state
 * {@link /claim-management/claims/:id/available-transitions}
 */
export async function claimManagementControllerAvailableTransitions(id: ClaimManagementControllerAvailableTransitionsPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ClaimManagementControllerAvailableTransitionsQueryResponse, ResponseErrorConfig<ClaimManagementControllerAvailableTransitions400 | ClaimManagementControllerAvailableTransitions404>, unknown>({ method : "GET", url : getClaimManagementControllerAvailableTransitionsUrl(id).url.toString(), ... requestConfig })
  return res.data
}

function getClaimManagementControllerGetClaimExtractionsUrl(id: ClaimManagementControllerGetClaimExtractionsPathParams["id"]) {
  const res = { method: 'GET', url: `/claim-management/claims/${id}/document-extractions` as const }
  return res
}

/**
 * @summary List AI document extractions for a claim (FNOL prefill candidates)
 * {@link /claim-management/claims/:id/document-extractions}
 */
export async function claimManagementControllerGetClaimExtractions(id: ClaimManagementControllerGetClaimExtractionsPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ClaimManagementControllerGetClaimExtractionsQueryResponse, ResponseErrorConfig<ClaimManagementControllerGetClaimExtractions400 | ClaimManagementControllerGetClaimExtractions404>, unknown>({ method : "GET", url : getClaimManagementControllerGetClaimExtractionsUrl(id).url.toString(), ... requestConfig })
  return res.data
}

function getClaimManagementControllerStatusHistoryUrl(id: ClaimManagementControllerStatusHistoryPathParams["id"]) {
  const res = { method: 'GET', url: `/claim-management/claims/${id}/status-history` as const }
  return res
}

/**
 * @summary Get a claim's status-change history (owner)
 * {@link /claim-management/claims/:id/status-history}
 */
export async function claimManagementControllerStatusHistory(id: ClaimManagementControllerStatusHistoryPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ClaimManagementControllerStatusHistoryQueryResponse, ResponseErrorConfig<ClaimManagementControllerStatusHistory400 | ClaimManagementControllerStatusHistory404>, unknown>({ method : "GET", url : getClaimManagementControllerStatusHistoryUrl(id).url.toString(), ... requestConfig })
  return res.data
}

function getClaimManagementControllerDocumentFraudScoresUrl(id: ClaimManagementControllerDocumentFraudScoresPathParams["id"]) {
  const res = { method: 'GET', url: `/claim-management/claims/${id}/fraud-scores` as const }
  return res
}

/**
 * @summary Get per-document fraud scores for a claim (internal — claim managers only)
 * {@link /claim-management/claims/:id/fraud-scores}
 */
export async function claimManagementControllerDocumentFraudScores(id: ClaimManagementControllerDocumentFraudScoresPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ClaimManagementControllerDocumentFraudScoresQueryResponse, ResponseErrorConfig<ClaimManagementControllerDocumentFraudScores400>, unknown>({ method : "GET", url : getClaimManagementControllerDocumentFraudScoresUrl(id).url.toString(), ... requestConfig })
  return res.data
}

function getClaimManagementControllerFraudNarrativeUrl(id: ClaimManagementControllerFraudNarrativePathParams["id"]) {
  const res = { method: 'GET', url: `/claim-management/claims/${id}/fraud-narrative` as const }
  return res
}

/**
 * @description Short AI-generated summary of the per-document fraud findings. Lazily generated and cached server-side; the first call after a verdict change may take a few seconds. `narrative` is null when the claim has no verdicts yet or generation is unavailable.
 * @summary Get the AI-generated claim fraud narrative (internal — claim managers only)
 * {@link /claim-management/claims/:id/fraud-narrative}
 */
export async function claimManagementControllerFraudNarrative(id: ClaimManagementControllerFraudNarrativePathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ClaimManagementControllerFraudNarrativeQueryResponse, ResponseErrorConfig<ClaimManagementControllerFraudNarrative400>, unknown>({ method : "GET", url : getClaimManagementControllerFraudNarrativeUrl(id).url.toString(), ... requestConfig })
  return res.data
}

function getClaimManagementControllerCorrectDocumentFraudVerdictUrl(id: ClaimManagementControllerCorrectDocumentFraudVerdictPathParams["id"], documentId: ClaimManagementControllerCorrectDocumentFraudVerdictPathParams["documentId"]) {
  const res = { method: 'POST', url: `/claim-management/claims/${id}/documents/${documentId}/fraud-verdict` as const }
  return res
}

/**
 * @description A claims manager overrides the vendor fraud verdict for a document. Persists the correction, emits a Dash0 feedback event, and records a side-event on the claim stream. Not re-forwarded to the partner.
 * @summary Correct a per-document fraud verdict (internal — claim managers only)
 * {@link /claim-management/claims/:id/documents/:documentId/fraud-verdict}
 */
export async function claimManagementControllerCorrectDocumentFraudVerdict(id: ClaimManagementControllerCorrectDocumentFraudVerdictPathParams["id"], documentId: ClaimManagementControllerCorrectDocumentFraudVerdictPathParams["documentId"], data: ClaimManagementControllerCorrectDocumentFraudVerdictMutationRequest, config: Partial<RequestConfig<ClaimManagementControllerCorrectDocumentFraudVerdictMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ClaimManagementControllerCorrectDocumentFraudVerdictMutationResponse, ResponseErrorConfig<ClaimManagementControllerCorrectDocumentFraudVerdict400>, ClaimManagementControllerCorrectDocumentFraudVerdictMutationRequest>({ method : "POST", url : getClaimManagementControllerCorrectDocumentFraudVerdictUrl(id, documentId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getClaimManagementControllerTimelineUrl(id: ClaimManagementControllerTimelinePathParams["id"]) {
  const res = { method: 'GET', url: `/claim-management/claims/${id}/timeline` as const }
  return res
}

/**
 * @summary Get claim event timeline (internal — claim managers only)
 * {@link /claim-management/claims/:id/timeline}
 */
export async function claimManagementControllerTimeline(id: ClaimManagementControllerTimelinePathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ClaimManagementControllerTimelineQueryResponse, ResponseErrorConfig<ClaimManagementControllerTimeline400 | ClaimManagementControllerTimeline404>, unknown>({ method : "GET", url : getClaimManagementControllerTimelineUrl(id).url.toString(), ... requestConfig })
  return res.data
}

function getExternalClaimsControllerCreateUrl() {
  const res = { method: 'POST', url: `/external-claims` as const }
  return res
}

/**
 * @summary Declare a claim from an external system
 * {@link /external-claims}
 */
export async function externalClaimsControllerCreate(data: ExternalClaimsControllerCreateMutationRequest, config: Partial<RequestConfig<ExternalClaimsControllerCreateMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ExternalClaimsControllerCreateMutationResponse, ResponseErrorConfig<Error>, ExternalClaimsControllerCreateMutationRequest>({ method : "POST", url : getExternalClaimsControllerCreateUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getExternalClaimsControllerResyncUrl(claimId: ExternalClaimsControllerResyncPathParams["claimId"]) {
  const res = { method: 'POST', url: `/external-claims/${claimId}/resync` as const }
  return res
}

/**
 * {@link /external-claims/:claimId/resync}
 */
export async function externalClaimsControllerResync(claimId: ExternalClaimsControllerResyncPathParams["claimId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ExternalClaimsControllerResyncMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getExternalClaimsControllerResyncUrl(claimId).url.toString(), ... requestConfig })
  return res.data
}

function getClaimsControllerCreateUrl() {
  const res = { method: 'POST', url: `/claims` as const }
  return res
}

/**
 * @summary Create claim
 * {@link /claims}
 */
export async function claimsControllerCreate(data: ClaimsControllerCreateMutationRequest, config: Partial<RequestConfig<ClaimsControllerCreateMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ClaimsControllerCreateMutationResponse, ResponseErrorConfig<ClaimsControllerCreate400 | ClaimsControllerCreate409>, ClaimsControllerCreateMutationRequest>({ method : "POST", url : getClaimsControllerCreateUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getClaimsControllerListUrl() {
  const res = { method: 'GET', url: `/claims` as const }
  return res
}

/**
 * @summary List claims
 * {@link /claims}
 */
export async function claimsControllerList(params: ClaimsControllerListQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ClaimsControllerListQueryResponse, ResponseErrorConfig<ClaimsControllerList400>, unknown>({ method : "GET", url : getClaimsControllerListUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getClaimsControllerUpdateUrl(id: ClaimsControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/claims/${id}` as const }
  return res
}

/**
 * @summary Update claim
 * {@link /claims/:id}
 */
export async function claimsControllerUpdate(id: ClaimsControllerUpdatePathParams["id"], data: ClaimsControllerUpdateMutationRequest, config: Partial<RequestConfig<ClaimsControllerUpdateMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ClaimsControllerUpdateMutationResponse, ResponseErrorConfig<ClaimsControllerUpdate400 | ClaimsControllerUpdate404 | ClaimsControllerUpdate409>, ClaimsControllerUpdateMutationRequest>({ method : "PATCH", url : getClaimsControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getClaimsControllerDeleteUrl(id: ClaimsControllerDeletePathParams["id"]) {
  const res = { method: 'DELETE', url: `/claims/${id}` as const }
  return res
}

/**
 * @summary Delete claim
 * {@link /claims/:id}
 */
export async function claimsControllerDelete(id: ClaimsControllerDeletePathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ClaimsControllerDeleteMutationResponse, ResponseErrorConfig<ClaimsControllerDelete400 | ClaimsControllerDelete404>, unknown>({ method : "DELETE", url : getClaimsControllerDeleteUrl(id).url.toString(), ... requestConfig })
  return res.data
}

function getClaimsControllerGetUrl(id: ClaimsControllerGetPathParams["id"]) {
  const res = { method: 'GET', url: `/claims/${id}` as const }
  return res
}

/**
 * @summary Get claim
 * {@link /claims/:id}
 */
export async function claimsControllerGet(id: ClaimsControllerGetPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ClaimsControllerGetQueryResponse, ResponseErrorConfig<ClaimsControllerGet400 | ClaimsControllerGet404>, unknown>({ method : "GET", url : getClaimsControllerGetUrl(id).url.toString(), ... requestConfig })
  return res.data
}

function getConfigControllerListTenantsUrl() {
  const res = { method: 'GET', url: `/admin/tenants` as const }
  return res
}

/**
 * @summary Admin only: list every configured tenant id
 * {@link /admin/tenants}
 */
export async function configControllerListTenants(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ConfigControllerListTenantsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getConfigControllerListTenantsUrl().url.toString(), ... requestConfig })
  return res.data
}

function getConfigControllerGetTenantConfigUrl() {
  const res = { method: 'GET', url: `/admin/config` as const }
  return res
}

/**
 * @summary Admin only: Get tenant config
 * {@link /admin/config}
 */
export async function configControllerGetTenantConfig(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ConfigControllerGetTenantConfigQueryResponse, ResponseErrorConfig<ConfigControllerGetTenantConfig400>, unknown>({ method : "GET", url : getConfigControllerGetTenantConfigUrl().url.toString(), ... requestConfig })
  return res.data
}

function getConfigControllerGetProductConfigUrl(productId: ConfigControllerGetProductConfigPathParams["productId"]) {
  const res = { method: 'GET', url: `/admin/config/${productId}` as const }
  return res
}

/**
 * @summary Admin only: Get product config
 * {@link /admin/config/:productId}
 */
export async function configControllerGetProductConfig(productId: ConfigControllerGetProductConfigPathParams["productId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ConfigControllerGetProductConfigQueryResponse, ResponseErrorConfig<ConfigControllerGetProductConfig400>, unknown>({ method : "GET", url : getConfigControllerGetProductConfigUrl(productId).url.toString(), ... requestConfig })
  return res.data
}

function getConfigControllerGetPublicTenantConfigByDomainUrl() {
  const res = { method: 'GET', url: `/config/by-domain` as const }
  return res
}

/**
 * @description Matches a bare domain (no scheme, path or port) case-insensitively. Only domains explicitly registered against a tenant resolve, which is a small set used by white-label frontends — any other domain returns INVALID_TENANT, including one that looks like a Korint hostname.
 * @summary Get a tenant's public config by domain
 * {@link /config/by-domain}
 */
export async function configControllerGetPublicTenantConfigByDomain(params: ConfigControllerGetPublicTenantConfigByDomainQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ConfigControllerGetPublicTenantConfigByDomainQueryResponse, ResponseErrorConfig<ConfigControllerGetPublicTenantConfigByDomain400>, unknown>({ method : "GET", url : getConfigControllerGetPublicTenantConfigByDomainUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getConfigControllerGetPublicProductConfigUrl(productId: ConfigControllerGetPublicProductConfigPathParams["productId"]) {
  const res = { method: 'GET', url: `/config/${productId}` as const }
  return res
}

/**
 * @description Read this at runtime before every journey — products gain fields, and a transcribed list silently stops matching. Fields from the `*AggregateFields` lists are top-level properties of their entity; the rest go in its `customFields` array.
 * @summary Get public product config
 * {@link /config/:productId}
 */
export async function configControllerGetPublicProductConfig(productId: ConfigControllerGetPublicProductConfigPathParams["productId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ConfigControllerGetPublicProductConfigQueryResponse, ResponseErrorConfig<ConfigControllerGetPublicProductConfig400>, unknown>({ method : "GET", url : getConfigControllerGetPublicProductConfigUrl(productId).url.toString(), ... requestConfig })
  return res.data
}

function getConfigControllerGetPublicTenantConfigUrl() {
  const res = { method: 'GET', url: `/config` as const }
  return res
}

/**
 * @description Carries `availableProductIds`; fetch each product's own configuration separately. Needs no credentials.
 * @summary Get public tenant config
 * {@link /config}
 */
export async function configControllerGetPublicTenantConfig(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ConfigControllerGetPublicTenantConfigQueryResponse, ResponseErrorConfig<ConfigControllerGetPublicTenantConfig400>, unknown>({ method : "GET", url : getConfigControllerGetPublicTenantConfigUrl().url.toString(), ... requestConfig })
  return res.data
}

function getConfigControllerGetProductsForTenantUrl() {
  const res = { method: 'GET', url: `/products` as const }
  return res
}

/**
 * @summary Admin only: Get products for a given tenant
 * {@link /products}
 */
export async function configControllerGetProductsForTenant(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ConfigControllerGetProductsForTenantQueryResponse, ResponseErrorConfig<ConfigControllerGetProductsForTenant400>, unknown>({ method : "GET", url : getConfigControllerGetProductsForTenantUrl().url.toString(), ... requestConfig })
  return res.data
}

function getConfigControllerGetBusinessRolePermissionsUrl() {
  const res = { method: 'GET', url: `/business-role-permissions` as const }
  return res
}

/**
 * @summary List the permissions granted by a business role
 * {@link /business-role-permissions}
 */
export async function configControllerGetBusinessRolePermissions(params: ConfigControllerGetBusinessRolePermissionsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ConfigControllerGetBusinessRolePermissionsQueryResponse, ResponseErrorConfig<ConfigControllerGetBusinessRolePermissions400>, unknown>({ method : "GET", url : getConfigControllerGetBusinessRolePermissionsUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getFeatureFlagControllerAtMeUrl() {
  const res = { method: 'GET', url: `/feature-flags/@me` as const }
  return res
}

/**
 * @summary Get evaluated feature flags for the current user and tenant
 * {@link /feature-flags/@me}
 */
export async function featureFlagControllerAtMe(params: FeatureFlagControllerAtMeQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<FeatureFlagControllerAtMeQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getFeatureFlagControllerAtMeUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getFeatureFlagControllerFindAllUrl() {
  const res = { method: 'GET', url: `/feature-flags` as const }
  return res
}

/**
 * @summary List all feature flags with their state
 * {@link /feature-flags}
 */
export async function featureFlagControllerFindAll(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<FeatureFlagControllerFindAllQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getFeatureFlagControllerFindAllUrl().url.toString(), ... requestConfig })
  return res.data
}

function getFeatureFlagControllerUpdateUrl() {
  const res = { method: 'PATCH', url: `/feature-flags` as const }
  return res
}

/**
 * @summary Update a dynamic feature flag
 * {@link /feature-flags}
 */
export async function featureFlagControllerUpdate(data: FeatureFlagControllerUpdateMutationRequest, config: Partial<RequestConfig<FeatureFlagControllerUpdateMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<FeatureFlagControllerUpdateMutationResponse, ResponseErrorConfig<Error>, FeatureFlagControllerUpdateMutationRequest>({ method : "PATCH", url : getFeatureFlagControllerUpdateUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getCustomerControllerGetCustomerUrl(customerId: CustomerControllerGetCustomerPathParams["customerId"]) {
  const res = { method: 'GET', url: `/customers/${customerId}` as const }
  return res
}

/**
 * @description Read the customer back after any step that enriches it — a registry lookup or a document extraction — rather than trusting your local copy.
 * @summary Get Customer
 * {@link /customers/:customerId}
 */
export async function customerControllerGetCustomer(customerId: CustomerControllerGetCustomerPathParams["customerId"], params?: CustomerControllerGetCustomerQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<CustomerControllerGetCustomerQueryResponse, ResponseErrorConfig<CustomerControllerGetCustomer404>, unknown>({ method : "GET", url : getCustomerControllerGetCustomerUrl(customerId).url.toString(), params, ... requestConfig })
  return res.data
}

function getCustomerControllerEditCustomerUrl(customerId: CustomerControllerEditCustomerPathParams["customerId"]) {
  const res = { method: 'PATCH', url: `/customers/${customerId}` as const }
  return res
}

/**
 * @description Company identity is not yours to set: supplying the SIRET triggers a registry lookup that overwrites the other company fields, nulls legal statuses the registry omits, and fails the whole request with `COMPANY_NOT_FOUND` on an unknown SIRET.
 * @summary Edit Customer
 * {@link /customers/:customerId}
 */
export async function customerControllerEditCustomer(customerId: CustomerControllerEditCustomerPathParams["customerId"], data: CustomerControllerEditCustomerMutationRequest, params?: CustomerControllerEditCustomerQueryParams, config: Partial<RequestConfig<CustomerControllerEditCustomerMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<CustomerControllerEditCustomerMutationResponse, ResponseErrorConfig<CustomerControllerEditCustomer400 | CustomerControllerEditCustomer404 | CustomerControllerEditCustomer409>, CustomerControllerEditCustomerMutationRequest>({ method : "PATCH", url : getCustomerControllerEditCustomerUrl(customerId).url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getCustomerControllerGetCustomerPaymentMethodsUrl(customerId: CustomerControllerGetCustomerPaymentMethodsPathParams["customerId"]) {
  const res = { method: 'GET', url: `/customers/${customerId}/payment-methods` as const }
  return res
}

/**
 * @description `WAITING_MANDATE_SIGNATURE` is accepted for new business, which is what lets a customer sign the contract and the SEPA mandate in one session.
 * @summary Get Customer Payment Methods
 * {@link /customers/:customerId/payment-methods}
 */
export async function customerControllerGetCustomerPaymentMethods(customerId: CustomerControllerGetCustomerPaymentMethodsPathParams["customerId"], params?: CustomerControllerGetCustomerPaymentMethodsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<CustomerControllerGetCustomerPaymentMethodsQueryResponse, ResponseErrorConfig<CustomerControllerGetCustomerPaymentMethods404>, unknown>({ method : "GET", url : getCustomerControllerGetCustomerPaymentMethodsUrl(customerId).url.toString(), params, ... requestConfig })
  return res.data
}

function getCustomerControllerGetPaymentMethodSetupSecretUrl(customerId: CustomerControllerGetPaymentMethodSetupSecretPathParams["customerId"]) {
  const res = { method: 'GET', url: `/customers/${customerId}/payment-methods/secret` as const }
  return res
}

/**
 * @description Quote the policy first: the payment-side customer is created by quoting, so asking earlier returns `PAYMENT_CUSTOMER_NOT_FOUND`. Needs `DIRECT_DEBIT` in the product's `allowedPaymentModes`, or it refuses with `CONFLICTING_CONFIG`. Initialise Stripe.js with the publishable key of Korint's Stripe account for your tenant and environment — ask your Korint contact; a key from another account fails in the browser as `No such setupintent`, which reads as a bad secret but is not.
 * @summary Get Payment Method Setup Secret
 * {@link /customers/:customerId/payment-methods/secret}
 */
export async function customerControllerGetPaymentMethodSetupSecret(customerId: CustomerControllerGetPaymentMethodSetupSecretPathParams["customerId"], params?: CustomerControllerGetPaymentMethodSetupSecretQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<CustomerControllerGetPaymentMethodSetupSecretQueryResponse, ResponseErrorConfig<CustomerControllerGetPaymentMethodSetupSecret400 | CustomerControllerGetPaymentMethodSetupSecret404 | CustomerControllerGetPaymentMethodSetupSecret409>, unknown>({ method : "GET", url : getCustomerControllerGetPaymentMethodSetupSecretUrl(customerId).url.toString(), params, ... requestConfig })
  return res.data
}

function getCustomerControllerListCustomersUrl() {
  const res = { method: 'GET', url: `/customers` as const }
  return res
}

/**
 * @description Use it to find an existing policyholder before initialising a new one, so a returning customer is not duplicated.
 * @summary List Customers
 * {@link /customers}
 */
export async function customerControllerListCustomers(params?: CustomerControllerListCustomersQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<CustomerControllerListCustomersQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getCustomerControllerListCustomersUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getCustomerControllerInitializeCustomerUrl() {
  const res = { method: 'POST', url: `/customers` as const }
  return res
}

/**
 * @description Creates the policyholder, a policy and the branch to work on, all three. Keep `initializedWith.branch`: every later call on that draft carries it.
 * @summary Initialize customer
 * {@link /customers}
 */
export async function customerControllerInitializeCustomer(data: CustomerControllerInitializeCustomerMutationRequest, params: CustomerControllerInitializeCustomerQueryParams, config: Partial<RequestConfig<CustomerControllerInitializeCustomerMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<CustomerControllerInitializeCustomerMutationResponse, ResponseErrorConfig<CustomerControllerInitializeCustomer400 | CustomerControllerInitializeCustomer404 | CustomerControllerInitializeCustomer409>, CustomerControllerInitializeCustomerMutationRequest>({ method : "POST", url : getCustomerControllerInitializeCustomerUrl().url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getCustomerControllerPushCustomerEventUrl(customerId: CustomerControllerPushCustomerEventPathParams["customerId"]) {
  const res = { method: 'POST', url: `/customers/${customerId}/events` as const }
  return res
}

/**
 * @summary Push a custom event onto a customer
 * {@link /customers/:customerId/events}
 */
export async function customerControllerPushCustomerEvent(customerId: CustomerControllerPushCustomerEventPathParams["customerId"], data: CustomerControllerPushCustomerEventMutationRequest, params?: CustomerControllerPushCustomerEventQueryParams, config: Partial<RequestConfig<CustomerControllerPushCustomerEventMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<CustomerControllerPushCustomerEventMutationResponse, ResponseErrorConfig<CustomerControllerPushCustomerEvent400 | CustomerControllerPushCustomerEvent404>, CustomerControllerPushCustomerEventMutationRequest>({ method : "POST", url : getCustomerControllerPushCustomerEventUrl(customerId).url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getCustomerControllerGetInvoicingScheduleUrl(customerId: CustomerControllerGetInvoicingSchedulePathParams["customerId"]) {
  const res = { method: 'GET', url: `/customers/${customerId}/invoicing-schedule` as const }
  return res
}

/**
 * @summary Get invoicing schedule
 * {@link /customers/:customerId/invoicing-schedule}
 */
export async function customerControllerGetInvoicingSchedule(customerId: CustomerControllerGetInvoicingSchedulePathParams["customerId"], params?: CustomerControllerGetInvoicingScheduleQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<CustomerControllerGetInvoicingScheduleQueryResponse, ResponseErrorConfig<CustomerControllerGetInvoicingSchedule400 | CustomerControllerGetInvoicingSchedule404>, unknown>({ method : "GET", url : getCustomerControllerGetInvoicingScheduleUrl(customerId).url.toString(), params, ... requestConfig })
  return res.data
}

function getCustomerControllerGenerateMandateSignatureRequestUrl(customerId: CustomerControllerGenerateMandateSignatureRequestPathParams["customerId"], paymentMethodId: CustomerControllerGenerateMandateSignatureRequestPathParams["paymentMethodId"]) {
  const res = { method: 'POST', url: `/customers/${customerId}/payment-methods/${paymentMethodId}/signature` as const }
  return res
}

/**
 * @description The customer must already have a first name, last name and email address, since they identify the signer. If any of the three is missing, the request fails with MISSING_CUSTOMER_CONTACT_FIELDS.
 * @summary Generate mandate signature request
 * {@link /customers/:customerId/payment-methods/:paymentMethodId/signature}
 */
export async function customerControllerGenerateMandateSignatureRequest(customerId: CustomerControllerGenerateMandateSignatureRequestPathParams["customerId"], paymentMethodId: CustomerControllerGenerateMandateSignatureRequestPathParams["paymentMethodId"], data: CustomerControllerGenerateMandateSignatureRequestMutationRequest, params?: CustomerControllerGenerateMandateSignatureRequestQueryParams, config: Partial<RequestConfig<CustomerControllerGenerateMandateSignatureRequestMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<CustomerControllerGenerateMandateSignatureRequestMutationResponse, ResponseErrorConfig<CustomerControllerGenerateMandateSignatureRequest400 | CustomerControllerGenerateMandateSignatureRequest404 | CustomerControllerGenerateMandateSignatureRequest409 | CustomerControllerGenerateMandateSignatureRequest425>, CustomerControllerGenerateMandateSignatureRequestMutationRequest>({ method : "POST", url : getCustomerControllerGenerateMandateSignatureRequestUrl(customerId, paymentMethodId).url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getCustomerControllerUpdatePreferredPaymentMethodUrl(customerId: CustomerControllerUpdatePreferredPaymentMethodPathParams["customerId"], paymentMethodId: CustomerControllerUpdatePreferredPaymentMethodPathParams["paymentMethodId"]) {
  const res = { method: 'PUT', url: `/customers/${customerId}/payment-methods/${paymentMethodId}/preferred` as const }
  return res
}

/**
 * @summary Update customer preferred payment method
 * {@link /customers/:customerId/payment-methods/:paymentMethodId/preferred}
 */
export async function customerControllerUpdatePreferredPaymentMethod(customerId: CustomerControllerUpdatePreferredPaymentMethodPathParams["customerId"], paymentMethodId: CustomerControllerUpdatePreferredPaymentMethodPathParams["paymentMethodId"], params?: CustomerControllerUpdatePreferredPaymentMethodQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<CustomerControllerUpdatePreferredPaymentMethodMutationResponse, ResponseErrorConfig<CustomerControllerUpdatePreferredPaymentMethod400 | CustomerControllerUpdatePreferredPaymentMethod404 | CustomerControllerUpdatePreferredPaymentMethod409>, unknown>({ method : "PUT", url : getCustomerControllerUpdatePreferredPaymentMethodUrl(customerId, paymentMethodId).url.toString(), params, ... requestConfig })
  return res.data
}

function getCustomerControllerDeletePaymentMethodUrl(customerId: CustomerControllerDeletePaymentMethodPathParams["customerId"], paymentMethodId: CustomerControllerDeletePaymentMethodPathParams["paymentMethodId"]) {
  const res = { method: 'DELETE', url: `/customers/${customerId}/payment-methods/${paymentMethodId}` as const }
  return res
}

/**
 * @summary Remove a customer payment method (excludes it from billing)
 * {@link /customers/:customerId/payment-methods/:paymentMethodId}
 */
export async function customerControllerDeletePaymentMethod(customerId: CustomerControllerDeletePaymentMethodPathParams["customerId"], paymentMethodId: CustomerControllerDeletePaymentMethodPathParams["paymentMethodId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<CustomerControllerDeletePaymentMethodMutationResponse, ResponseErrorConfig<CustomerControllerDeletePaymentMethod404 | CustomerControllerDeletePaymentMethod409>, unknown>({ method : "DELETE", url : getCustomerControllerDeletePaymentMethodUrl(customerId, paymentMethodId).url.toString(), ... requestConfig })
  return res.data
}

function getCustomerControllerUpdatePaymentModeUrl(customerId: CustomerControllerUpdatePaymentModePathParams["customerId"]) {
  const res = { method: 'PUT', url: `/customers/${customerId}/payment-mode` as const }
  return res
}

/**
 * @description A new customer defaults to the first automatic mode of the product's `allowedPaymentModes` — `OFFLINE` is only a default when it is the only allowed mode, and is only accepted on single-payer policies. Switching to `OFFLINE` stops automatic collection — an in-flight payment still settles through its webhook. Switching back to `DIRECT_DEBIT` requires a usable payment method, and already-issued invoices are not charged retroactively.
 * @summary Update customer payment mode
 * {@link /customers/:customerId/payment-mode}
 */
export async function customerControllerUpdatePaymentMode(customerId: CustomerControllerUpdatePaymentModePathParams["customerId"], data: CustomerControllerUpdatePaymentModeMutationRequest, params?: CustomerControllerUpdatePaymentModeQueryParams, config: Partial<RequestConfig<CustomerControllerUpdatePaymentModeMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<CustomerControllerUpdatePaymentModeMutationResponse, ResponseErrorConfig<CustomerControllerUpdatePaymentMode400 | CustomerControllerUpdatePaymentMode404 | CustomerControllerUpdatePaymentMode409>, CustomerControllerUpdatePaymentModeMutationRequest>({ method : "PUT", url : getCustomerControllerUpdatePaymentModeUrl(customerId).url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getCustomerControllerGetBankTransferAccountUrl(customerId: CustomerControllerGetBankTransferAccountPathParams["customerId"]) {
  const res = { method: 'GET', url: `/customers/${customerId}/bank-transfer-account` as const }
  return res
}

/**
 * @summary Get bank transfer account
 * {@link /customers/:customerId/bank-transfer-account}
 */
export async function customerControllerGetBankTransferAccount(customerId: CustomerControllerGetBankTransferAccountPathParams["customerId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<CustomerControllerGetBankTransferAccountQueryResponse, ResponseErrorConfig<CustomerControllerGetBankTransferAccount400 | CustomerControllerGetBankTransferAccount404 | CustomerControllerGetBankTransferAccount409>, unknown>({ method : "GET", url : getCustomerControllerGetBankTransferAccountUrl(customerId).url.toString(), ... requestConfig })
  return res.data
}

function getCustomerControllerChargeUrl(customerId: CustomerControllerChargePathParams["customerId"]) {
  const res = { method: 'POST', url: `/customers/${customerId}/retry-charge` as const }
  return res
}

/**
 * @summary Attempt a charge for an invoice
 * {@link /customers/:customerId/retry-charge}
 */
export async function customerControllerCharge(customerId: CustomerControllerChargePathParams["customerId"], data: CustomerControllerChargeMutationRequest, params?: CustomerControllerChargeQueryParams, config: Partial<RequestConfig<CustomerControllerChargeMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<CustomerControllerChargeMutationResponse, ResponseErrorConfig<CustomerControllerCharge400 | CustomerControllerCharge404>, CustomerControllerChargeMutationRequest>({ method : "POST", url : getCustomerControllerChargeUrl(customerId).url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getCustomerControllerManuallyMarkInvoiceUrl(customerId: CustomerControllerManuallyMarkInvoicePathParams["customerId"]) {
  const res = { method: 'POST', url: `/customers/${customerId}/manually-mark-invoice` as const }
  return res
}

/**
 * @summary Mark an invoice as settled outside the platform
 * {@link /customers/:customerId/manually-mark-invoice}
 */
export async function customerControllerManuallyMarkInvoice(customerId: CustomerControllerManuallyMarkInvoicePathParams["customerId"], data: CustomerControllerManuallyMarkInvoiceMutationRequest, config: Partial<RequestConfig<CustomerControllerManuallyMarkInvoiceMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<CustomerControllerManuallyMarkInvoiceMutationResponse, ResponseErrorConfig<CustomerControllerManuallyMarkInvoice400 | CustomerControllerManuallyMarkInvoice404 | CustomerControllerManuallyMarkInvoice409 | CustomerControllerManuallyMarkInvoice500>, CustomerControllerManuallyMarkInvoiceMutationRequest>({ method : "POST", url : getCustomerControllerManuallyMarkInvoiceUrl(customerId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getCustomerControllerGetCustomerBalanceUrl(customerId: CustomerControllerGetCustomerBalancePathParams["customerId"]) {
  const res = { method: 'GET', url: `/customers/${customerId}/balance` as const }
  return res
}

/**
 * @summary Get Customer Balance
 * {@link /customers/:customerId/balance}
 */
export async function customerControllerGetCustomerBalance(customerId: CustomerControllerGetCustomerBalancePathParams["customerId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<CustomerControllerGetCustomerBalanceQueryResponse, ResponseErrorConfig<CustomerControllerGetCustomerBalance404>, unknown>({ method : "GET", url : getCustomerControllerGetCustomerBalanceUrl(customerId).url.toString(), ... requestConfig })
  return res.data
}

function getCustomerControllerGetMigratedBillingTakeoverUrl(customerId: CustomerControllerGetMigratedBillingTakeoverPathParams["customerId"]) {
  const res = { method: 'GET', url: `/customers/${customerId}/migrated-billing-takeover` as const }
  return res
}

/**
 * @description One entry per policy the customer pays for. `migrated` tells a customer that was never imported apart from one whose rows are missing.
 * @summary Get the migrated billing takeover dates of a customer
 * {@link /customers/:customerId/migrated-billing-takeover}
 */
export async function customerControllerGetMigratedBillingTakeover(customerId: CustomerControllerGetMigratedBillingTakeoverPathParams["customerId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<CustomerControllerGetMigratedBillingTakeoverQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getCustomerControllerGetMigratedBillingTakeoverUrl(customerId).url.toString(), ... requestConfig })
  return res.data
}

function getCustomerControllerSetMigratedBillingTakeoverUrl(customerId: CustomerControllerSetMigratedBillingTakeoverPathParams["customerId"], policyId: CustomerControllerSetMigratedBillingTakeoverPathParams["policyId"]) {
  const res = { method: 'PUT', url: `/customers/${customerId}/migrated-billing-takeover/${policyId}` as const }
  return res
}

/**
 * @description Changes which invoices the platform bills. The row is frozen against the recomputing projection until it is unlocked.
 * @summary Override and freeze a migrated billing takeover date
 * {@link /customers/:customerId/migrated-billing-takeover/:policyId}
 */
export async function customerControllerSetMigratedBillingTakeover(customerId: CustomerControllerSetMigratedBillingTakeoverPathParams["customerId"], policyId: CustomerControllerSetMigratedBillingTakeoverPathParams["policyId"], data: CustomerControllerSetMigratedBillingTakeoverMutationRequest, config: Partial<RequestConfig<CustomerControllerSetMigratedBillingTakeoverMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<CustomerControllerSetMigratedBillingTakeoverMutationResponse, ResponseErrorConfig<Error>, CustomerControllerSetMigratedBillingTakeoverMutationRequest>({ method : "PUT", url : getCustomerControllerSetMigratedBillingTakeoverUrl(customerId, policyId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getCustomerControllerUnlockMigratedBillingTakeoverUrl(customerId: CustomerControllerUnlockMigratedBillingTakeoverPathParams["customerId"], policyId: CustomerControllerUnlockMigratedBillingTakeoverPathParams["policyId"]) {
  const res = { method: 'DELETE', url: `/customers/${customerId}/migrated-billing-takeover/${policyId}` as const }
  return res
}

/**
 * @description Clears the freeze and recomputes the date immediately.
 * @summary Hand a migrated billing takeover date back to the projection
 * {@link /customers/:customerId/migrated-billing-takeover/:policyId}
 */
export async function customerControllerUnlockMigratedBillingTakeover(customerId: CustomerControllerUnlockMigratedBillingTakeoverPathParams["customerId"], policyId: CustomerControllerUnlockMigratedBillingTakeoverPathParams["policyId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<CustomerControllerUnlockMigratedBillingTakeoverMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "DELETE", url : getCustomerControllerUnlockMigratedBillingTakeoverUrl(customerId, policyId).url.toString(), ... requestConfig })
  return res.data
}

function getCustomerControllerCreateCustomerForPolicyUrl(policyId: CustomerControllerCreateCustomerForPolicyPathParams["policyId"]) {
  const res = { method: 'POST', url: `/customers/policies/${policyId}` as const }
  return res
}

/**
 * @summary Create a customer on an existing policy
 * {@link /customers/policies/:policyId}
 */
export async function customerControllerCreateCustomerForPolicy(policyId: CustomerControllerCreateCustomerForPolicyPathParams["policyId"], data: CustomerControllerCreateCustomerForPolicyMutationRequest, params?: CustomerControllerCreateCustomerForPolicyQueryParams, config: Partial<RequestConfig<CustomerControllerCreateCustomerForPolicyMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<CustomerControllerCreateCustomerForPolicyMutationResponse, ResponseErrorConfig<CustomerControllerCreateCustomerForPolicy404>, CustomerControllerCreateCustomerForPolicyMutationRequest>({ method : "POST", url : getCustomerControllerCreateCustomerForPolicyUrl(policyId).url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getCustomerControllerDeleteCustomerFromPolicyUrl(policyId: CustomerControllerDeleteCustomerFromPolicyPathParams["policyId"], customerId: CustomerControllerDeleteCustomerFromPolicyPathParams["customerId"]) {
  const res = { method: 'DELETE', url: `/customers/${customerId}/policies/${policyId}` as const }
  return res
}

/**
 * @summary Delete customer from policy
 * {@link /customers/:customerId/policies/:policyId}
 */
export async function customerControllerDeleteCustomerFromPolicy(policyId: CustomerControllerDeleteCustomerFromPolicyPathParams["policyId"], customerId: CustomerControllerDeleteCustomerFromPolicyPathParams["customerId"], params?: CustomerControllerDeleteCustomerFromPolicyQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<CustomerControllerDeleteCustomerFromPolicyMutationResponse, ResponseErrorConfig<CustomerControllerDeleteCustomerFromPolicy403 | CustomerControllerDeleteCustomerFromPolicy404 | CustomerControllerDeleteCustomerFromPolicy409>, unknown>({ method : "DELETE", url : getCustomerControllerDeleteCustomerFromPolicyUrl(policyId, customerId).url.toString(), params, ... requestConfig })
  return res.data
}

function getDebugControllerClearTestDataUrl() {
  const res = { method: 'POST', url: `/debug/clear-test-data` as const }
  return res
}

/**
 * {@link /debug/clear-test-data}
 */
export async function debugControllerClearTestData(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DebugControllerClearTestDataMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getDebugControllerClearTestDataUrl().url.toString(), ... requestConfig })
  return res.data
}

function getDebugControllerClearProjectionsDataUrl() {
  const res = { method: 'POST', url: `/debug/clear-projections-data` as const }
  return res
}

/**
 * {@link /debug/clear-projections-data}
 */
export async function debugControllerClearProjectionsData(params?: DebugControllerClearProjectionsDataQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DebugControllerClearProjectionsDataMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getDebugControllerClearProjectionsDataUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getDebugControllerClearLegacyCacheUrl() {
  const res = { method: 'POST', url: `/debug/clear-cache` as const }
  return res
}

/**
 * {@link /debug/clear-cache}
 */
export async function debugControllerClearLegacyCache(params?: DebugControllerClearLegacyCacheQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DebugControllerClearLegacyCacheMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getDebugControllerClearLegacyCacheUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getDebugControllerGetProjectionsUrl(projectionTable: DebugControllerGetProjectionsPathParams["projectionTable"]) {
  const res = { method: 'GET', url: `/debug/projections/${projectionTable}` as const }
  return res
}

/**
 * {@link /debug/projections/:projectionTable}
 */
export async function debugControllerGetProjections(projectionTable: DebugControllerGetProjectionsPathParams["projectionTable"], params: DebugControllerGetProjectionsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DebugControllerGetProjectionsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getDebugControllerGetProjectionsUrl(projectionTable).url.toString(), params, ... requestConfig })
  return res.data
}

function getDebugControllerCountCoreEventsUrl(aggregateId: DebugControllerCountCoreEventsPathParams["aggregateId"]) {
  const res = { method: 'GET', url: `/debug/core/${aggregateId}/events/count` as const }
  return res
}

/**
 * {@link /debug/core/:aggregateId/events/count}
 */
export async function debugControllerCountCoreEvents(aggregateId: DebugControllerCountCoreEventsPathParams["aggregateId"], params?: DebugControllerCountCoreEventsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DebugControllerCountCoreEventsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getDebugControllerCountCoreEventsUrl(aggregateId).url.toString(), params, ... requestConfig })
  return res.data
}

function getDebugControllerToggleIgnoreCoreEventsUrl() {
  const res = { method: 'POST', url: `/debug/core/events/toggle-ignore` as const }
  return res
}

/**
 * {@link /debug/core/events/toggle-ignore}
 */
export async function debugControllerToggleIgnoreCoreEvents(data: DebugControllerToggleIgnoreCoreEventsMutationRequest, config: Partial<RequestConfig<DebugControllerToggleIgnoreCoreEventsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<DebugControllerToggleIgnoreCoreEventsMutationResponse, ResponseErrorConfig<Error>, DebugControllerToggleIgnoreCoreEventsMutationRequest>({ method : "POST", url : getDebugControllerToggleIgnoreCoreEventsUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getDebugControllerBillCustomerUrl(customerId: DebugControllerBillCustomerPathParams["customerId"]) {
  const res = { method: 'POST', url: `/debug/customers/${customerId}/bill` as const }
  return res
}

/**
 * {@link /debug/customers/:customerId/bill}
 */
export async function debugControllerBillCustomer(customerId: DebugControllerBillCustomerPathParams["customerId"], params?: DebugControllerBillCustomerQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DebugControllerBillCustomerMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getDebugControllerBillCustomerUrl(customerId).url.toString(), params, ... requestConfig })
  return res.data
}

function getDebugControllerBatchBillCustomersUrl() {
  const res = { method: 'POST', url: `/debug/customers/batch-bill` as const }
  return res
}

/**
 * {@link /debug/customers/batch-bill}
 */
export async function debugControllerBatchBillCustomers(data: DebugControllerBatchBillCustomersMutationRequest, params?: DebugControllerBatchBillCustomersQueryParams, config: Partial<RequestConfig<DebugControllerBatchBillCustomersMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<DebugControllerBatchBillCustomersMutationResponse, ResponseErrorConfig<Error>, DebugControllerBatchBillCustomersMutationRequest>({ method : "POST", url : getDebugControllerBatchBillCustomersUrl().url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getDebugControllerBatchChargeInvoicesUrl() {
  const res = { method: 'POST', url: `/debug/invoices/batch-charge` as const }
  return res
}

/**
 * {@link /debug/invoices/batch-charge}
 */
export async function debugControllerBatchChargeInvoices(data: DebugControllerBatchChargeInvoicesMutationRequest, config: Partial<RequestConfig<DebugControllerBatchChargeInvoicesMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<DebugControllerBatchChargeInvoicesMutationResponse, ResponseErrorConfig<Error>, DebugControllerBatchChargeInvoicesMutationRequest>({ method : "POST", url : getDebugControllerBatchChargeInvoicesUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getDebugControllerStartDailyStagingCleanupUrl() {
  const res = { method: 'POST', url: `/debug/start-daily-staging-cleanup` as const }
  return res
}

/**
 * {@link /debug/start-daily-staging-cleanup}
 */
export async function debugControllerStartDailyStagingCleanup(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DebugControllerStartDailyStagingCleanupMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getDebugControllerStartDailyStagingCleanupUrl().url.toString(), ... requestConfig })
  return res.data
}

function getDebugControllerCreateDistributionRequestsAndFeesUrl() {
  const res = { method: 'POST', url: `/debug/add-new-product-to-distribution-requests` as const }
  return res
}

/**
 * {@link /debug/add-new-product-to-distribution-requests}
 */
export async function debugControllerCreateDistributionRequestsAndFees(data: DebugControllerCreateDistributionRequestsAndFeesMutationRequest, config: Partial<RequestConfig<DebugControllerCreateDistributionRequestsAndFeesMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<DebugControllerCreateDistributionRequestsAndFeesMutationResponse, ResponseErrorConfig<Error>, DebugControllerCreateDistributionRequestsAndFeesMutationRequest>({ method : "POST", url : getDebugControllerCreateDistributionRequestsAndFeesUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getDebugControllerCreatePaymentFromStripeUrl() {
  const res = { method: 'POST', url: `/debug/create-payment-from-stripe` as const }
  return res
}

/**
 * {@link /debug/create-payment-from-stripe}
 */
export async function debugControllerCreatePaymentFromStripe(data: DebugControllerCreatePaymentFromStripeMutationRequest, config: Partial<RequestConfig<DebugControllerCreatePaymentFromStripeMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<DebugControllerCreatePaymentFromStripeMutationResponse, ResponseErrorConfig<Error>, DebugControllerCreatePaymentFromStripeMutationRequest>({ method : "POST", url : getDebugControllerCreatePaymentFromStripeUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getDebugControllerUpdatePaymentStatusUrl() {
  const res = { method: 'POST', url: `/debug/update-payment-status` as const }
  return res
}

/**
 * {@link /debug/update-payment-status}
 */
export async function debugControllerUpdatePaymentStatus(data: DebugControllerUpdatePaymentStatusMutationRequest, config: Partial<RequestConfig<DebugControllerUpdatePaymentStatusMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<DebugControllerUpdatePaymentStatusMutationResponse, ResponseErrorConfig<Error>, DebugControllerUpdatePaymentStatusMutationRequest>({ method : "POST", url : getDebugControllerUpdatePaymentStatusUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getDebugControllerRefreshInvoiceStatusUrl() {
  const res = { method: 'POST', url: `/debug/refresh-invoice-status` as const }
  return res
}

/**
 * {@link /debug/refresh-invoice-status}
 */
export async function debugControllerRefreshInvoiceStatus(data: DebugControllerRefreshInvoiceStatusMutationRequest, config: Partial<RequestConfig<DebugControllerRefreshInvoiceStatusMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<DebugControllerRefreshInvoiceStatusMutationResponse, ResponseErrorConfig<Error>, DebugControllerRefreshInvoiceStatusMutationRequest>({ method : "POST", url : getDebugControllerRefreshInvoiceStatusUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getDebugControllerBatchGenerateDocumentsUrl() {
  const res = { method: 'POST', url: `/debug/batch-generate-documents` as const }
  return res
}

/**
 * {@link /debug/batch-generate-documents}
 */
export async function debugControllerBatchGenerateDocuments(data: DebugControllerBatchGenerateDocumentsMutationRequest, config: Partial<RequestConfig<DebugControllerBatchGenerateDocumentsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<DebugControllerBatchGenerateDocumentsMutationResponse, ResponseErrorConfig<Error>, DebugControllerBatchGenerateDocumentsMutationRequest>({ method : "POST", url : getDebugControllerBatchGenerateDocumentsUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getDebugControllerBatchCreateUserRelationsUrl() {
  const res = { method: 'POST', url: `/debug/batch-create-user-relations` as const }
  return res
}

/**
 * {@link /debug/batch-create-user-relations}
 */
export async function debugControllerBatchCreateUserRelations(data: DebugControllerBatchCreateUserRelationsMutationRequest, config: Partial<RequestConfig<DebugControllerBatchCreateUserRelationsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<DebugControllerBatchCreateUserRelationsMutationResponse, ResponseErrorConfig<Error>, DebugControllerBatchCreateUserRelationsMutationRequest>({ method : "POST", url : getDebugControllerBatchCreateUserRelationsUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getDebugControllerCheckAllDocumentsUrl() {
  const res = { method: 'POST', url: `/debug/check-all-documents` as const }
  return res
}

/**
 * {@link /debug/check-all-documents}
 */
export async function debugControllerCheckAllDocuments(data: DebugControllerCheckAllDocumentsMutationRequest, config: Partial<RequestConfig<DebugControllerCheckAllDocumentsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<DebugControllerCheckAllDocumentsMutationResponse, ResponseErrorConfig<Error>, DebugControllerCheckAllDocumentsMutationRequest>({ method : "POST", url : getDebugControllerCheckAllDocumentsUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getDebugControllerRetriggerClaimDocumentFraudCheckUrl() {
  const res = { method: 'POST', url: `/debug/retrigger-claim-document-fraud-check` as const }
  return res
}

/**
 * {@link /debug/retrigger-claim-document-fraud-check}
 */
export async function debugControllerRetriggerClaimDocumentFraudCheck(data: DebugControllerRetriggerClaimDocumentFraudCheckMutationRequest, config: Partial<RequestConfig<DebugControllerRetriggerClaimDocumentFraudCheckMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<DebugControllerRetriggerClaimDocumentFraudCheckMutationResponse, ResponseErrorConfig<Error>, DebugControllerRetriggerClaimDocumentFraudCheckMutationRequest>({ method : "POST", url : getDebugControllerRetriggerClaimDocumentFraudCheckUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getDebugControllerSuperDeletePoliciesUrl(policyId: DebugControllerSuperDeletePoliciesPathParams["policyId"]) {
  const res = { method: 'DELETE', url: `/debug/policies/${policyId}` as const }
  return res
}

/**
 * {@link /debug/policies/:policyId}
 */
export async function debugControllerSuperDeletePolicies(policyId: DebugControllerSuperDeletePoliciesPathParams["policyId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DebugControllerSuperDeletePoliciesMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "DELETE", url : getDebugControllerSuperDeletePoliciesUrl(policyId).url.toString(), ... requestConfig })
  return res.data
}

function getDocumentsControllerValidateAndProcessDocumentUrl() {
  const res = { method: 'GET', url: `/documents/validate` as const }
  return res
}

/**
 * @description Validates a document upload, waits for malware scan, classifies with AI, and extracts data. Streams progress updates via Server-Sent Events.
 * @summary Validate, scan, classify, and extract document (SSE)
 * {@link /documents/validate}
 */
export async function documentsControllerValidateAndProcessDocument(params: DocumentsControllerValidateAndProcessDocumentQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DocumentsControllerValidateAndProcessDocumentQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getDocumentsControllerValidateAndProcessDocumentUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getDocumentsControllerGetDocumentsUrl() {
  const res = { method: 'GET', url: `/documents` as const }
  return res
}

/**
 * @summary Get documents by ID with a signed URL
 * {@link /documents}
 */
export async function documentsControllerGetDocuments(params: DocumentsControllerGetDocumentsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DocumentsControllerGetDocumentsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getDocumentsControllerGetDocumentsUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getDocumentsControllerGenerateDocumentUploadUrlsUrl() {
  const res = { method: 'POST', url: `/documents` as const }
  return res
}

/**
 * @summary Generate upload URL
 * {@link /documents}
 */
export async function documentsControllerGenerateDocumentUploadUrls(data: DocumentsControllerGenerateDocumentUploadUrlsMutationRequest, config: Partial<RequestConfig<DocumentsControllerGenerateDocumentUploadUrlsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<DocumentsControllerGenerateDocumentUploadUrlsMutationResponse, ResponseErrorConfig<Error>, DocumentsControllerGenerateDocumentUploadUrlsMutationRequest>({ method : "POST", url : getDocumentsControllerGenerateDocumentUploadUrlsUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getDocumentsControllerDeleteDocumentsUrl() {
  const res = { method: 'DELETE', url: `/documents` as const }
  return res
}

/**
 * @summary Delete documents by IDs
 * {@link /documents}
 */
export async function documentsControllerDeleteDocuments(params: DocumentsControllerDeleteDocumentsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DocumentsControllerDeleteDocumentsMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "DELETE", url : getDocumentsControllerDeleteDocumentsUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getDocumentsControllerArchiveDocumentsUrl() {
  const res = { method: 'POST', url: `/documents/archive` as const }
  return res
}

/**
 * @summary Archive documents (Super admin only)
 * {@link /documents/archive}
 */
export async function documentsControllerArchiveDocuments(data: DocumentsControllerArchiveDocumentsMutationRequest, config: Partial<RequestConfig<DocumentsControllerArchiveDocumentsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<DocumentsControllerArchiveDocumentsMutationResponse, ResponseErrorConfig<DocumentsControllerArchiveDocuments403 | DocumentsControllerArchiveDocuments404>, DocumentsControllerArchiveDocumentsMutationRequest>({ method : "POST", url : getDocumentsControllerArchiveDocumentsUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getDocumentsControllerRestoreDocumentsUrl() {
  const res = { method: 'POST', url: `/documents/restore` as const }
  return res
}

/**
 * @summary Restore documents (Super admin only)
 * {@link /documents/restore}
 */
export async function documentsControllerRestoreDocuments(data: DocumentsControllerRestoreDocumentsMutationRequest, config: Partial<RequestConfig<DocumentsControllerRestoreDocumentsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<DocumentsControllerRestoreDocumentsMutationResponse, ResponseErrorConfig<DocumentsControllerRestoreDocuments403 | DocumentsControllerRestoreDocuments404>, DocumentsControllerRestoreDocumentsMutationRequest>({ method : "POST", url : getDocumentsControllerRestoreDocumentsUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getDocumentsControllerSetDocumentCategoryUrl(documentId: DocumentsControllerSetDocumentCategoryPathParams["documentId"]) {
  const res = { method: 'PATCH', url: `/documents/${documentId}` as const }
  return res
}

/**
 * @description Updates the category metadata of a document. Requires SET_DOCUMENT_CATEGORY permission.
 * @summary Set document category
 * {@link /documents/:documentId}
 */
export async function documentsControllerSetDocumentCategory(documentId: DocumentsControllerSetDocumentCategoryPathParams["documentId"], data: DocumentsControllerSetDocumentCategoryMutationRequest, config: Partial<RequestConfig<DocumentsControllerSetDocumentCategoryMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<DocumentsControllerSetDocumentCategoryMutationResponse, ResponseErrorConfig<DocumentsControllerSetDocumentCategory400 | DocumentsControllerSetDocumentCategory403 | DocumentsControllerSetDocumentCategory404>, DocumentsControllerSetDocumentCategoryMutationRequest>({ method : "PATCH", url : getDocumentsControllerSetDocumentCategoryUrl(documentId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getDocumentsControllerListDocumentsWithPresignedUrlUrl() {
  const res = { method: 'POST', url: `/documents/debug/list-by-metadata` as const }
  return res
}

/**
 * @summary DEBUG: List documents by metadata
 * {@link /documents/debug/list-by-metadata}
 */
export async function documentsControllerListDocumentsWithPresignedUrl(data: DocumentsControllerListDocumentsWithPresignedUrlMutationRequest, config: Partial<RequestConfig<DocumentsControllerListDocumentsWithPresignedUrlMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<DocumentsControllerListDocumentsWithPresignedUrlMutationResponse, ResponseErrorConfig<Error>, DocumentsControllerListDocumentsWithPresignedUrlMutationRequest>({ method : "POST", url : getDocumentsControllerListDocumentsWithPresignedUrlUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getDocumentsControllerCreatePdfUrl() {
  const res = { method: 'POST', url: `/documents/debug/generate-pdf` as const }
  return res
}

/**
 * @summary DEBUG: Create pdf
 * {@link /documents/debug/generate-pdf}
 */
export async function documentsControllerCreatePdf(data: DocumentsControllerCreatePdfMutationRequest, config: Partial<RequestConfig<DocumentsControllerCreatePdfMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<DocumentsControllerCreatePdfMutationResponse, ResponseErrorConfig<Error>, DocumentsControllerCreatePdfMutationRequest>({ method : "POST", url : getDocumentsControllerCreatePdfUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getDocumentsControllerScheduleHandleMalwareProtectionScanResultUrl() {
  const res = { method: 'POST', url: `/documents/schedule-handle-malware-protection-scan-result` as const }
  return res
}

/**
 * {@link /documents/schedule-handle-malware-protection-scan-result}
 */
export async function documentsControllerScheduleHandleMalwareProtectionScanResult(data: DocumentsControllerScheduleHandleMalwareProtectionScanResultMutationRequest, config: Partial<RequestConfig<DocumentsControllerScheduleHandleMalwareProtectionScanResultMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<DocumentsControllerScheduleHandleMalwareProtectionScanResultMutationResponse, ResponseErrorConfig<Error>, DocumentsControllerScheduleHandleMalwareProtectionScanResultMutationRequest>({ method : "POST", url : getDocumentsControllerScheduleHandleMalwareProtectionScanResultUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getHealthControllerIndexUrl() {
  const res = { method: 'GET', url: `/health` as const }
  return res
}

/**
 * {@link /health}
 */
export async function healthControllerIndex(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<HealthControllerIndexQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getHealthControllerIndexUrl().url.toString(), ... requestConfig })
  return res.data
}

function getHealthControllerCheckUrl(service: HealthControllerCheckPathParams["service"]) {
  const res = { method: 'GET', url: `/health/${service}` as const }
  return res
}

/**
 * {@link /health/:service}
 */
export async function healthControllerCheck(service: HealthControllerCheckPathParams["service"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<HealthControllerCheckQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getHealthControllerCheckUrl(service).url.toString(), ... requestConfig })
  return res.data
}

function getInvitationControllerInviteUrl() {
  const res = { method: 'POST', url: `/invite` as const }
  return res
}

/**
 * @description Sends the customer an email inviting them to create their account.
 * @summary Invite a customer
 * {@link /invite}
 */
export async function invitationControllerInvite(data: InvitationControllerInviteMutationRequest, config: Partial<RequestConfig<InvitationControllerInviteMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<InvitationControllerInviteMutationResponse, ResponseErrorConfig<InvitationControllerInvite400>, InvitationControllerInviteMutationRequest>({ method : "POST", url : getInvitationControllerInviteUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getInvitationControllerAdminInviteUrl() {
  const res = { method: 'POST', url: `/debug/admin-invite` as const }
  return res
}

/**
 * {@link /debug/admin-invite}
 */
export async function invitationControllerAdminInvite(data: InvitationControllerAdminInviteMutationRequest, config: Partial<RequestConfig<InvitationControllerAdminInviteMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<InvitationControllerAdminInviteMutationResponse, ResponseErrorConfig<InvitationControllerAdminInvite400>, InvitationControllerAdminInviteMutationRequest>({ method : "POST", url : getInvitationControllerAdminInviteUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getInvitationControllerBrokerInviteUrl() {
  const res = { method: 'POST', url: `/broker-invite` as const }
  return res
}

/**
 * @description Sends the broker an email inviting them to join the brokerage firm.
 * @summary Invite a broker
 * {@link /broker-invite}
 */
export async function invitationControllerBrokerInvite(data: InvitationControllerBrokerInviteMutationRequest, config: Partial<RequestConfig<InvitationControllerBrokerInviteMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<InvitationControllerBrokerInviteMutationResponse, ResponseErrorConfig<InvitationControllerBrokerInvite400>, InvitationControllerBrokerInviteMutationRequest>({ method : "POST", url : getInvitationControllerBrokerInviteUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getInvitationControllerCreateAnonymousSessionUrl() {
  const res = { method: 'POST', url: `/anonymous-session` as const }
  return res
}

/**
 * @description Issues a temporary session so a visitor can quote without an account. Rate limited to 100 sessions per hour.
 * @summary Start an anonymous session
 * {@link /anonymous-session}
 */
export async function invitationControllerCreateAnonymousSession(params?: InvitationControllerCreateAnonymousSessionQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<InvitationControllerCreateAnonymousSessionMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getInvitationControllerCreateAnonymousSessionUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getInvitationControllerHandoffAnonymousSessionUrl() {
  const res = { method: 'POST', url: `/anonymous-session/handoff` as const }
  return res
}

/**
 * @description Transfers everything captured during the anonymous session to the signed-in user.
 * @summary Hand an anonymous session over to an account
 * {@link /anonymous-session/handoff}
 */
export async function invitationControllerHandoffAnonymousSession(data: InvitationControllerHandoffAnonymousSessionMutationRequest, config: Partial<RequestConfig<InvitationControllerHandoffAnonymousSessionMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<InvitationControllerHandoffAnonymousSessionMutationResponse, ResponseErrorConfig<Error>, InvitationControllerHandoffAnonymousSessionMutationRequest>({ method : "POST", url : getInvitationControllerHandoffAnonymousSessionUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getInvitationControllerResolveAnonymousSessionEntitiesUrl() {
  const res = { method: 'GET', url: `/anonymous-session/entities` as const }
  return res
}

/**
 * @summary List the entities created during an anonymous session
 * {@link /anonymous-session/entities}
 */
export async function invitationControllerResolveAnonymousSessionEntities(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<InvitationControllerResolveAnonymousSessionEntitiesQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getInvitationControllerResolveAnonymousSessionEntitiesUrl().url.toString(), ... requestConfig })
  return res.data
}

function getJobSchedulersControllerGetJobSchedulersUrl() {
  const res = { method: 'GET', url: `/job-schedulers/bull-mq` as const }
  return res
}

/**
 * @summary Get current job schedulers using bullmq api
 * {@link /job-schedulers/bull-mq}
 */
export async function jobSchedulersControllerGetJobSchedulers(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<JobSchedulersControllerGetJobSchedulersQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getJobSchedulersControllerGetJobSchedulersUrl().url.toString(), ... requestConfig })
  return res.data
}

function getJobSchedulersControllerListUrl() {
  const res = { method: 'POST', url: `/job-schedulers/list` as const }
  return res
}

/**
 * @summary List current job schedulers
 * {@link /job-schedulers/list}
 */
export async function jobSchedulersControllerList(data: JobSchedulersControllerListMutationRequest, config: Partial<RequestConfig<JobSchedulersControllerListMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<JobSchedulersControllerListMutationResponse, ResponseErrorConfig<Error>, JobSchedulersControllerListMutationRequest>({ method : "POST", url : getJobSchedulersControllerListUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getJobSchedulersControllerGetUrl(id: JobSchedulersControllerGetPathParams["id"]) {
  const res = { method: 'GET', url: `/job-schedulers/${id}` as const }
  return res
}

/**
 * @summary Get a job scheduler
 * {@link /job-schedulers/:id}
 */
export async function jobSchedulersControllerGet(id: JobSchedulersControllerGetPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<JobSchedulersControllerGetQueryResponse, ResponseErrorConfig<JobSchedulersControllerGet404>, unknown>({ method : "GET", url : getJobSchedulersControllerGetUrl(id).url.toString(), ... requestConfig })
  return res.data
}

function getJobSchedulersControllerUpsertUrl(id: JobSchedulersControllerUpsertPathParams["id"]) {
  const res = { method: 'POST', url: `/job-schedulers/${id}` as const }
  return res
}

/**
 * @summary Upsert a job scheduler
 * {@link /job-schedulers/:id}
 */
export async function jobSchedulersControllerUpsert(id: JobSchedulersControllerUpsertPathParams["id"], data: JobSchedulersControllerUpsertMutationRequest, config: Partial<RequestConfig<JobSchedulersControllerUpsertMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<JobSchedulersControllerUpsertMutationResponse, ResponseErrorConfig<Error>, JobSchedulersControllerUpsertMutationRequest>({ method : "POST", url : getJobSchedulersControllerUpsertUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getJobSchedulersControllerUpdateUrl(id: JobSchedulersControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/job-schedulers/${id}` as const }
  return res
}

/**
 * @summary Update a job scheduler
 * {@link /job-schedulers/:id}
 */
export async function jobSchedulersControllerUpdate(id: JobSchedulersControllerUpdatePathParams["id"], data: JobSchedulersControllerUpdateMutationRequest, config: Partial<RequestConfig<JobSchedulersControllerUpdateMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<JobSchedulersControllerUpdateMutationResponse, ResponseErrorConfig<JobSchedulersControllerUpdate404>, JobSchedulersControllerUpdateMutationRequest>({ method : "PATCH", url : getJobSchedulersControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getJobSchedulersControllerDeleteUrl(id: JobSchedulersControllerDeletePathParams["id"]) {
  const res = { method: 'DELETE', url: `/job-schedulers/${id}` as const }
  return res
}

/**
 * @summary Delete a job scheduler
 * {@link /job-schedulers/:id}
 */
export async function jobSchedulersControllerDelete(id: JobSchedulersControllerDeletePathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<JobSchedulersControllerDeleteMutationResponse, ResponseErrorConfig<JobSchedulersControllerDelete404>, unknown>({ method : "DELETE", url : getJobSchedulersControllerDeleteUrl(id).url.toString(), ... requestConfig })
  return res.data
}

function getJobsControllerCreateJobUrl() {
  const res = { method: 'POST', url: `/jobs` as const }
  return res
}

/**
 * @summary Create new job
 * {@link /jobs}
 */
export async function jobsControllerCreateJob(data: JobsControllerCreateJobMutationRequest, config: Partial<RequestConfig<JobsControllerCreateJobMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<JobsControllerCreateJobMutationResponse, ResponseErrorConfig<Error>, JobsControllerCreateJobMutationRequest>({ method : "POST", url : getJobsControllerCreateJobUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getJobsControllerCreateJobsUrl() {
  const res = { method: 'POST', url: `/jobs/batch` as const }
  return res
}

/**
 * @summary Batch create jobs sharing the same service, command and options
 * {@link /jobs/batch}
 */
export async function jobsControllerCreateJobs(data: JobsControllerCreateJobsMutationRequest, config: Partial<RequestConfig<JobsControllerCreateJobsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<JobsControllerCreateJobsMutationResponse, ResponseErrorConfig<Error>, JobsControllerCreateJobsMutationRequest>({ method : "POST", url : getJobsControllerCreateJobsUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getJobsControllerUpdateJobUrl(id: JobsControllerUpdateJobPathParams["id"]) {
  const res = { method: 'PATCH', url: `/jobs/${id}` as const }
  return res
}

/**
 * @summary Update job
 * {@link /jobs/:id}
 */
export async function jobsControllerUpdateJob(id: JobsControllerUpdateJobPathParams["id"], data: JobsControllerUpdateJobMutationRequest, config: Partial<RequestConfig<JobsControllerUpdateJobMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<JobsControllerUpdateJobMutationResponse, ResponseErrorConfig<Error>, JobsControllerUpdateJobMutationRequest>({ method : "PATCH", url : getJobsControllerUpdateJobUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getJobsControllerGetJobUrl(id: JobsControllerGetJobPathParams["id"]) {
  const res = { method: 'GET', url: `/jobs/${id}` as const }
  return res
}

/**
 * @summary Get job
 * {@link /jobs/:id}
 */
export async function jobsControllerGetJob(id: JobsControllerGetJobPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<JobsControllerGetJobQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getJobsControllerGetJobUrl(id).url.toString(), ... requestConfig })
  return res.data
}

function getJobsControllerCancelJobUrl(id: JobsControllerCancelJobPathParams["id"]) {
  const res = { method: 'DELETE', url: `/jobs/${id}` as const }
  return res
}

/**
 * @summary Cancel job
 * {@link /jobs/:id}
 */
export async function jobsControllerCancelJob(id: JobsControllerCancelJobPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<JobsControllerCancelJobMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "DELETE", url : getJobsControllerCancelJobUrl(id).url.toString(), ... requestConfig })
  return res.data
}

function getJobsControllerCancelJobsUrl() {
  const res = { method: 'POST', url: `/jobs/cancel` as const }
  return res
}

/**
 * @summary Cancel multiple jobs
 * {@link /jobs/cancel}
 */
export async function jobsControllerCancelJobs(data: JobsControllerCancelJobsMutationRequest, config: Partial<RequestConfig<JobsControllerCancelJobsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<JobsControllerCancelJobsMutationResponse, ResponseErrorConfig<Error>, JobsControllerCancelJobsMutationRequest>({ method : "POST", url : getJobsControllerCancelJobsUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getJobsControllerRetryJobsUrl() {
  const res = { method: 'POST', url: `/jobs/retry` as const }
  return res
}

/**
 * @summary Retry jobs
 * {@link /jobs/retry}
 */
export async function jobsControllerRetryJobs(data: JobsControllerRetryJobsMutationRequest, config: Partial<RequestConfig<JobsControllerRetryJobsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<JobsControllerRetryJobsMutationResponse, ResponseErrorConfig<Error>, JobsControllerRetryJobsMutationRequest>({ method : "POST", url : getJobsControllerRetryJobsUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getJobsControllerListJobsUrl() {
  const res = { method: 'POST', url: `/jobs/list-by-metadata` as const }
  return res
}

/**
 * @summary List jobs by metadata
 * {@link /jobs/list-by-metadata}
 */
export async function jobsControllerListJobs(data: JobsControllerListJobsMutationRequest, config: Partial<RequestConfig<JobsControllerListJobsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<JobsControllerListJobsMutationResponse, ResponseErrorConfig<Error>, JobsControllerListJobsMutationRequest>({ method : "POST", url : getJobsControllerListJobsUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getJobsControllerCountJobsUrl() {
  const res = { method: 'POST', url: `/jobs/count-by-metadata` as const }
  return res
}

/**
 * @summary Count jobs matching filters, grouped by status
 * {@link /jobs/count-by-metadata}
 */
export async function jobsControllerCountJobs(data: JobsControllerCountJobsMutationRequest, config: Partial<RequestConfig<JobsControllerCountJobsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<JobsControllerCountJobsMutationResponse, ResponseErrorConfig<Error>, JobsControllerCountJobsMutationRequest>({ method : "POST", url : getJobsControllerCountJobsUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getJobsControllerClearJobsDataUrl() {
  const res = { method: 'POST', url: `/jobs/clear-jobs-data` as const }
  return res
}

/**
 * @summary Clear jobs data
 * {@link /jobs/clear-jobs-data}
 */
export async function jobsControllerClearJobsData(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<JobsControllerClearJobsDataMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getJobsControllerClearJobsDataUrl().url.toString(), ... requestConfig })
  return res.data
}

function getJobsControllerClearWorkflowsDataUrl() {
  const res = { method: 'POST', url: `/jobs/clear-workflows-data` as const }
  return res
}

/**
 * @summary Clear workflows data
 * {@link /jobs/clear-workflows-data}
 */
export async function jobsControllerClearWorkflowsData(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<JobsControllerClearWorkflowsDataMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getJobsControllerClearWorkflowsDataUrl().url.toString(), ... requestConfig })
  return res.data
}

function getJobsControllerCancelPushProjectionJobsUrl() {
  const res = { method: 'POST', url: `/jobs/cancel-push-projection-jobs` as const }
  return res
}

/**
 * @summary Hotfix: cancel all projection jobs
 * {@link /jobs/cancel-push-projection-jobs}
 */
export async function jobsControllerCancelPushProjectionJobs(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<JobsControllerCancelPushProjectionJobsMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getJobsControllerCancelPushProjectionJobsUrl().url.toString(), ... requestConfig })
  return res.data
}

function getQueueManagementControllerPauseUrl() {
  const res = { method: 'POST', url: `/queues/pause` as const }
  return res
}

/**
 * @summary Pause all BullMQ queues
 * {@link /queues/pause}
 */
export async function queueManagementControllerPause(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<QueueManagementControllerPauseMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getQueueManagementControllerPauseUrl().url.toString(), ... requestConfig })
  return res.data
}

function getQueueManagementControllerResumeUrl() {
  const res = { method: 'POST', url: `/queues/resume` as const }
  return res
}

/**
 * @summary Resume all BullMQ queues
 * {@link /queues/resume}
 */
export async function queueManagementControllerResume(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<QueueManagementControllerResumeMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getQueueManagementControllerResumeUrl().url.toString(), ... requestConfig })
  return res.data
}

function getQueueManagementControllerGetStatusUrl() {
  const res = { method: 'GET', url: `/queues/status` as const }
  return res
}

/**
 * @summary Get pause/running status of all BullMQ queues
 * {@link /queues/status}
 */
export async function queueManagementControllerGetStatus(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<QueueManagementControllerGetStatusQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getQueueManagementControllerGetStatusUrl().url.toString(), ... requestConfig })
  return res.data
}

function getQueueManagementControllerPauseSingleUrl(queueName: QueueManagementControllerPauseSinglePathParams["queueName"]) {
  const res = { method: 'POST', url: `/queues/${queueName}/pause` as const }
  return res
}

/**
 * @summary Pause a single BullMQ queue by name
 * {@link /queues/:queueName/pause}
 */
export async function queueManagementControllerPauseSingle(queueName: QueueManagementControllerPauseSinglePathParams["queueName"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<QueueManagementControllerPauseSingleMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getQueueManagementControllerPauseSingleUrl(queueName).url.toString(), ... requestConfig })
  return res.data
}

function getQueueManagementControllerResumeSingleUrl(queueName: QueueManagementControllerResumeSinglePathParams["queueName"]) {
  const res = { method: 'POST', url: `/queues/${queueName}/resume` as const }
  return res
}

/**
 * @summary Resume a single BullMQ queue by name
 * {@link /queues/:queueName/resume}
 */
export async function queueManagementControllerResumeSingle(queueName: QueueManagementControllerResumeSinglePathParams["queueName"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<QueueManagementControllerResumeSingleMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getQueueManagementControllerResumeSingleUrl(queueName).url.toString(), ... requestConfig })
  return res.data
}

function getLegacyDocumentsControllerGenerateDocumentOnDemandUrl() {
  const res = { method: 'POST', url: `/generate-document-on-demand` as const }
  return res
}

/**
 * @description A policyholder reaches only the configs flagged `generateOnDemandByPolicyholder`. The audience follows the role the caller was authorized on, never the body.
 * @summary Generate an on-demand document
 * {@link /generate-document-on-demand}
 */
export async function legacyDocumentsControllerGenerateDocumentOnDemand(data: LegacyDocumentsControllerGenerateDocumentOnDemandMutationRequest, config: Partial<RequestConfig<LegacyDocumentsControllerGenerateDocumentOnDemandMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<LegacyDocumentsControllerGenerateDocumentOnDemandMutationResponse, ResponseErrorConfig<LegacyDocumentsControllerGenerateDocumentOnDemand400 | LegacyDocumentsControllerGenerateDocumentOnDemand404>, LegacyDocumentsControllerGenerateDocumentOnDemandMutationRequest>({ method : "POST", url : getLegacyDocumentsControllerGenerateDocumentOnDemandUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getLegacyDocumentsControllerGetOnDemandDocumentsUrl() {
  const res = { method: 'GET', url: `/on-demand-documents` as const }
  return res
}

/**
 * @description Narrowed to the configs flagged `generateOnDemandByPolicyholder` when the caller is a policyholder.
 * @summary List on-demand documents eligible for a target
 * {@link /on-demand-documents}
 */
export async function legacyDocumentsControllerGetOnDemandDocuments(params: LegacyDocumentsControllerGetOnDemandDocumentsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<LegacyDocumentsControllerGetOnDemandDocumentsQueryResponse, ResponseErrorConfig<LegacyDocumentsControllerGetOnDemandDocuments400 | LegacyDocumentsControllerGetOnDemandDocuments404>, unknown>({ method : "GET", url : getLegacyDocumentsControllerGetOnDemandDocumentsUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getLegacyDocumentsControllerGetExpectedGeneratedDocumentsUrl() {
  const res = { method: 'GET', url: `/expected-generated-documents` as const }
  return res
}

/**
 * @description The minimum: the product's common documents, plus generated documents whose trigger fired and whose filters pass. On-demand documents are excluded, so a policy legitimately holds more than this list. `whenAt` defaults to now; a past one dates the events and the policy but not the assets (ENG-4476).
 * @summary List the generated document types a policy is expected to have on a branch
 * {@link /expected-generated-documents}
 */
export async function legacyDocumentsControllerGetExpectedGeneratedDocuments(params: LegacyDocumentsControllerGetExpectedGeneratedDocumentsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<LegacyDocumentsControllerGetExpectedGeneratedDocumentsQueryResponse, ResponseErrorConfig<LegacyDocumentsControllerGetExpectedGeneratedDocuments400 | LegacyDocumentsControllerGetExpectedGeneratedDocuments404>, unknown>({ method : "GET", url : getLegacyDocumentsControllerGetExpectedGeneratedDocumentsUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getLegacyDocumentsControllerGetExpectedUploadedDocumentsUrl() {
  const res = { method: 'GET', url: `/expected-uploaded-documents` as const }
  return res
}

/**
 * @description The entity is read from the `targetId` prefix: a policy id returns the product's policyholderDocuments, a brokerage firm id the tenant's brokerageFirmDocumentsList — minus the entries whose filters do not pass on that entity's payload. Entries without filters are always expected. `required` says whether a missing document blocks conformity.
 * @summary List the document categories an entity is expected to upload
 * {@link /expected-uploaded-documents}
 */
export async function legacyDocumentsControllerGetExpectedUploadedDocuments(params: LegacyDocumentsControllerGetExpectedUploadedDocumentsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<LegacyDocumentsControllerGetExpectedUploadedDocumentsQueryResponse, ResponseErrorConfig<LegacyDocumentsControllerGetExpectedUploadedDocuments400 | LegacyDocumentsControllerGetExpectedUploadedDocuments404 | LegacyDocumentsControllerGetExpectedUploadedDocuments501>, unknown>({ method : "GET", url : getLegacyDocumentsControllerGetExpectedUploadedDocumentsUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getLegacyDocumentsControllerGetGenerationPayloadUrl() {
  const res = { method: 'POST', url: `/debug/generate-document-payload` as const }
  return res
}

/**
 * {@link /debug/generate-document-payload}
 */
export async function legacyDocumentsControllerGetGenerationPayload(data: LegacyDocumentsControllerGetGenerationPayloadMutationRequest, params: LegacyDocumentsControllerGetGenerationPayloadQueryParams, config: Partial<RequestConfig<LegacyDocumentsControllerGetGenerationPayloadMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<LegacyDocumentsControllerGetGenerationPayloadMutationResponse, ResponseErrorConfig<LegacyDocumentsControllerGetGenerationPayload400 | LegacyDocumentsControllerGetGenerationPayload404>, LegacyDocumentsControllerGetGenerationPayloadMutationRequest>({ method : "POST", url : getLegacyDocumentsControllerGetGenerationPayloadUrl().url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getLegacyDocumentsControllerRegenerateDocumentUrl() {
  const res = { method: 'POST', url: `/admin/regenerate-document` as const }
  return res
}

/**
 * @summary Regenerate a corrupted document (Super admin only)
 * {@link /admin/regenerate-document}
 */
export async function legacyDocumentsControllerRegenerateDocument(data: LegacyDocumentsControllerRegenerateDocumentMutationRequest, config: Partial<RequestConfig<LegacyDocumentsControllerRegenerateDocumentMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<LegacyDocumentsControllerRegenerateDocumentMutationResponse, ResponseErrorConfig<LegacyDocumentsControllerRegenerateDocument404 | LegacyDocumentsControllerRegenerateDocument500>, LegacyDocumentsControllerRegenerateDocumentMutationRequest>({ method : "POST", url : getLegacyDocumentsControllerRegenerateDocumentUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getLockControllerListLocksUrl() {
  const res = { method: 'GET', url: `/locks` as const }
  return res
}

/**
 * @description Super-admin-only, cross-tenant listing of currently held locks.
 * @summary List locks currently held
 * {@link /locks}
 */
export async function lockControllerListLocks(params?: LockControllerListLocksQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<LockControllerListLocksQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getLockControllerListLocksUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getLockControllerGetLockUrl(id: LockControllerGetLockPathParams["id"]) {
  const res = { method: 'GET', url: `/locks/${id}` as const }
  return res
}

/**
 * {@link /locks/:id}
 */
export async function lockControllerGetLock(id: LockControllerGetLockPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<LockControllerGetLockQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getLockControllerGetLockUrl(id).url.toString(), ... requestConfig })
  return res.data
}

function getLockControllerDeleteLockUrl(id: LockControllerDeleteLockPathParams["id"]) {
  const res = { method: 'DELETE', url: `/locks/${id}` as const }
  return res
}

/**
 * {@link /locks/:id}
 */
export async function lockControllerDeleteLock(id: LockControllerDeleteLockPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<LockControllerDeleteLockMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "DELETE", url : getLockControllerDeleteLockUrl(id).url.toString(), ... requestConfig })
  return res.data
}

function getLockControllerCreateLockUrl(id: LockControllerCreateLockPathParams["id"]) {
  const res = { method: 'POST', url: `/locks/${id}` as const }
  return res
}

/**
 * {@link /locks/:id}
 */
export async function lockControllerCreateLock(id: LockControllerCreateLockPathParams["id"], data?: LockControllerCreateLockMutationRequest, config: Partial<RequestConfig<LockControllerCreateLockMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<LockControllerCreateLockMutationResponse, ResponseErrorConfig<Error>, LockControllerCreateLockMutationRequest>({ method : "POST", url : getLockControllerCreateLockUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getLockControllerBatchCreateLocksUrl() {
  const res = { method: 'POST', url: `/locks/batch` as const }
  return res
}

/**
 * @description Generic over what is held: the caller composes each `<entityId>:BILLING` or `<entityId>:PAYMENT` id, exactly as for the single-lock route. Every lock records the same reason. An id already held is reported as `ALREADY_LOCKED` and left untouched rather than failing the batch.
 * @summary Take several locks at once
 * {@link /locks/batch}
 */
export async function lockControllerBatchCreateLocks(data: LockControllerBatchCreateLocksMutationRequest, config: Partial<RequestConfig<LockControllerBatchCreateLocksMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<LockControllerBatchCreateLocksMutationResponse, ResponseErrorConfig<Error>, LockControllerBatchCreateLocksMutationRequest>({ method : "POST", url : getLockControllerBatchCreateLocksUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getLockControllerBatchGetLocksUrl() {
  const res = { method: 'POST', url: `/locks/batch/get` as const }
  return res
}

/**
 * @description What is holding each id, so a caller can show an operator the reasons before releasing them. Only held ids come back: anything absent from the response is free.
 * @summary Read several locks by id
 * {@link /locks/batch/get}
 */
export async function lockControllerBatchGetLocks(data: LockControllerBatchGetLocksMutationRequest, config: Partial<RequestConfig<LockControllerBatchGetLocksMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<LockControllerBatchGetLocksMutationResponse, ResponseErrorConfig<Error>, LockControllerBatchGetLocksMutationRequest>({ method : "POST", url : getLockControllerBatchGetLocksUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getLockControllerBatchDeleteLocksUrl() {
  const res = { method: 'POST', url: `/locks/batch/delete` as const }
  return res
}

/**
 * @description The mirror of the batch-lock route. Each entry names the hold to release and when it was taken, from the batch-get that preceded it, so a hold released and retaken meanwhile comes back `STALE` rather than being released out from under whoever took it. An id nothing is holding is `NOT_LOCKED` and left alone rather than failing the batch.
 * @summary Release several locks at once
 * {@link /locks/batch/delete}
 */
export async function lockControllerBatchDeleteLocks(data: LockControllerBatchDeleteLocksMutationRequest, config: Partial<RequestConfig<LockControllerBatchDeleteLocksMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<LockControllerBatchDeleteLocksMutationResponse, ResponseErrorConfig<Error>, LockControllerBatchDeleteLocksMutationRequest>({ method : "POST", url : getLockControllerBatchDeleteLocksUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getNotificationControllerSendEmailUrl() {
  const res = { method: 'POST', url: `/notifications/emails/send` as const }
  return res
}

/**
 * @summary Send transactional email
 * {@link /notifications/emails/send}
 */
export async function notificationControllerSendEmail(data: NotificationControllerSendEmailMutationRequest, config: Partial<RequestConfig<NotificationControllerSendEmailMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<NotificationControllerSendEmailMutationResponse, ResponseErrorConfig<NotificationControllerSendEmail400>, NotificationControllerSendEmailMutationRequest>({ method : "POST", url : getNotificationControllerSendEmailUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getNotificationControllerListEmailTemplatesUrl() {
  const res = { method: 'GET', url: `/notifications/email-templates` as const }
  return res
}

/**
 * @summary List in-repo email templates
 * {@link /notifications/email-templates}
 */
export async function notificationControllerListEmailTemplates(params?: NotificationControllerListEmailTemplatesQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<NotificationControllerListEmailTemplatesQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getNotificationControllerListEmailTemplatesUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getNotificationControllerRenderEmailTemplateUrl(key: NotificationControllerRenderEmailTemplatePathParams["key"]) {
  const res = { method: 'POST', url: `/notifications/email-templates/${key}/render` as const }
  return res
}

/**
 * @summary Render an in-repo email template
 * {@link /notifications/email-templates/:key/render}
 */
export async function notificationControllerRenderEmailTemplate(key: NotificationControllerRenderEmailTemplatePathParams["key"], data: NotificationControllerRenderEmailTemplateMutationRequest, config: Partial<RequestConfig<NotificationControllerRenderEmailTemplateMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<NotificationControllerRenderEmailTemplateMutationResponse, ResponseErrorConfig<NotificationControllerRenderEmailTemplate404>, NotificationControllerRenderEmailTemplateMutationRequest>({ method : "POST", url : getNotificationControllerRenderEmailTemplateUrl(key).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getNotificationControllerSendTestEmailUrl(key: NotificationControllerSendTestEmailPathParams["key"]) {
  const res = { method: 'POST', url: `/notifications/email-templates/${key}/send-test` as const }
  return res
}

/**
 * @description Renders the template and delivers it to the caller's own address, resolved from the request principal — the recipient is never taken from the body.
 * @summary Send an in-repo email template to yourself
 * {@link /notifications/email-templates/:key/send-test}
 */
export async function notificationControllerSendTestEmail(key: NotificationControllerSendTestEmailPathParams["key"], data: NotificationControllerSendTestEmailMutationRequest, config: Partial<RequestConfig<NotificationControllerSendTestEmailMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<NotificationControllerSendTestEmailMutationResponse, ResponseErrorConfig<NotificationControllerSendTestEmail404>, NotificationControllerSendTestEmailMutationRequest>({ method : "POST", url : getNotificationControllerSendTestEmailUrl(key).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getNotificationControllerListNotificationsUrl() {
  const res = { method: 'GET', url: `/notifications` as const }
  return res
}

/**
 * @summary List notifications
 * {@link /notifications}
 */
export async function notificationControllerListNotifications(params?: NotificationControllerListNotificationsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<NotificationControllerListNotificationsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getNotificationControllerListNotificationsUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getNotificationControllerCreateNotificationUrl() {
  const res = { method: 'POST', url: `/notifications` as const }
  return res
}

/**
 * {@link /notifications}
 */
export async function notificationControllerCreateNotification(data: NotificationControllerCreateNotificationMutationRequest, config: Partial<RequestConfig<NotificationControllerCreateNotificationMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<NotificationControllerCreateNotificationMutationResponse, ResponseErrorConfig<Error>, NotificationControllerCreateNotificationMutationRequest>({ method : "POST", url : getNotificationControllerCreateNotificationUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getNotificationControllerGetNotificationUrl(id: NotificationControllerGetNotificationPathParams["id"]) {
  const res = { method: 'GET', url: `/notifications/${id}` as const }
  return res
}

/**
 * @summary Get a notification
 * {@link /notifications/:id}
 */
export async function notificationControllerGetNotification(id: NotificationControllerGetNotificationPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<NotificationControllerGetNotificationQueryResponse, ResponseErrorConfig<NotificationControllerGetNotification404>, unknown>({ method : "GET", url : getNotificationControllerGetNotificationUrl(id).url.toString(), ... requestConfig })
  return res.data
}

function getNotificationControllerPatchNotificationUrl(id: NotificationControllerPatchNotificationPathParams["id"]) {
  const res = { method: 'PATCH', url: `/notifications/${id}` as const }
  return res
}

/**
 * {@link /notifications/:id}
 */
export async function notificationControllerPatchNotification(id: NotificationControllerPatchNotificationPathParams["id"], data: NotificationControllerPatchNotificationMutationRequest, config: Partial<RequestConfig<NotificationControllerPatchNotificationMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<NotificationControllerPatchNotificationMutationResponse, ResponseErrorConfig<Error>, NotificationControllerPatchNotificationMutationRequest>({ method : "PATCH", url : getNotificationControllerPatchNotificationUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getNotificationControllerDeleteNotificationUrl(id: NotificationControllerDeleteNotificationPathParams["id"]) {
  const res = { method: 'DELETE', url: `/notifications/${id}` as const }
  return res
}

/**
 * {@link /notifications/:id}
 */
export async function notificationControllerDeleteNotification(id: NotificationControllerDeleteNotificationPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<NotificationControllerDeleteNotificationMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "DELETE", url : getNotificationControllerDeleteNotificationUrl(id).url.toString(), ... requestConfig })
  return res.data
}

function getNotificationControllerSendNotificationUrl() {
  const res = { method: 'POST', url: `/notifications/send` as const }
  return res
}

/**
 * @description Sends an electronic registered letter (ERE) about a policy, to the policy's customer or an explicit recipient. To resend one, call it again with the same reason and a corrected recipient. Asynchronous: the notification appears once the letter is sent.
 * @summary Send a notification
 * {@link /notifications/send}
 */
export async function notificationControllerSendNotification(data: NotificationControllerSendNotificationMutationRequest, config: Partial<RequestConfig<NotificationControllerSendNotificationMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<NotificationControllerSendNotificationMutationResponse, ResponseErrorConfig<NotificationControllerSendNotification400>, NotificationControllerSendNotificationMutationRequest>({ method : "POST", url : getNotificationControllerSendNotificationUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getPaymentsControllerCreateCustomerUrl() {
  const res = { method: 'POST', url: `/payments/customers` as const }
  return res
}

/**
 * {@link /payments/customers}
 */
export async function paymentsControllerCreateCustomer(data: PaymentsControllerCreateCustomerMutationRequest, config: Partial<RequestConfig<PaymentsControllerCreateCustomerMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PaymentsControllerCreateCustomerMutationResponse, ResponseErrorConfig<Error>, PaymentsControllerCreateCustomerMutationRequest>({ method : "POST", url : getPaymentsControllerCreateCustomerUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getPaymentsControllerListCustomersUrl() {
  const res = { method: 'POST', url: `/payments/customers/list-by-metadata` as const }
  return res
}

/**
 * @summary List payment customers
 * {@link /payments/customers/list-by-metadata}
 */
export async function paymentsControllerListCustomers(data: PaymentsControllerListCustomersMutationRequest, config: Partial<RequestConfig<PaymentsControllerListCustomersMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PaymentsControllerListCustomersMutationResponse, ResponseErrorConfig<Error>, PaymentsControllerListCustomersMutationRequest>({ method : "POST", url : getPaymentsControllerListCustomersUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getPaymentsControllerCreatePaymentUrl() {
  const res = { method: 'POST', url: `/payments` as const }
  return res
}

/**
 * {@link /payments}
 */
export async function paymentsControllerCreatePayment(data: PaymentsControllerCreatePaymentMutationRequest, config: Partial<RequestConfig<PaymentsControllerCreatePaymentMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PaymentsControllerCreatePaymentMutationResponse, ResponseErrorConfig<PaymentsControllerCreatePayment404>, PaymentsControllerCreatePaymentMutationRequest>({ method : "POST", url : getPaymentsControllerCreatePaymentUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getPaymentsControllerGetPaymentsUrl() {
  const res = { method: 'GET', url: `/payments` as const }
  return res
}

/**
 * @summary Get payments by ids
 * {@link /payments}
 */
export async function paymentsControllerGetPayments(params: PaymentsControllerGetPaymentsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PaymentsControllerGetPaymentsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getPaymentsControllerGetPaymentsUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getPaymentsControllerSetupIntentUrl() {
  const res = { method: 'POST', url: `/payments/setup-payment-method` as const }
  return res
}

/**
 * {@link /payments/setup-payment-method}
 */
export async function paymentsControllerSetupIntent(data: PaymentsControllerSetupIntentMutationRequest, config: Partial<RequestConfig<PaymentsControllerSetupIntentMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PaymentsControllerSetupIntentMutationResponse, ResponseErrorConfig<PaymentsControllerSetupIntent404>, PaymentsControllerSetupIntentMutationRequest>({ method : "POST", url : getPaymentsControllerSetupIntentUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getPaymentsControllerGetCustomersPaymentMethodsUrl() {
  const res = { method: 'GET', url: `/payments/payment-methods` as const }
  return res
}

/**
 * @summary Get payment methods associated to a customer
 * {@link /payments/payment-methods}
 */
export async function paymentsControllerGetCustomersPaymentMethods(params: PaymentsControllerGetCustomersPaymentMethodsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PaymentsControllerGetCustomersPaymentMethodsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getPaymentsControllerGetCustomersPaymentMethodsUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getPaymentsControllerGetCustomerPaymentsUrl(customerId: PaymentsControllerGetCustomerPaymentsPathParams["customerId"]) {
  const res = { method: 'GET', url: `/payments/${customerId}/payments` as const }
  return res
}

/**
 * @summary Get payments by customerId
 * {@link /payments/:customerId/payments}
 */
export async function paymentsControllerGetCustomerPayments(customerId: PaymentsControllerGetCustomerPaymentsPathParams["customerId"], params?: PaymentsControllerGetCustomerPaymentsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PaymentsControllerGetCustomerPaymentsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getPaymentsControllerGetCustomerPaymentsUrl(customerId).url.toString(), params, ... requestConfig })
  return res.data
}

function getPaymentsControllerCancelPaymentUrl(paymentId: PaymentsControllerCancelPaymentPathParams["paymentId"]) {
  const res = { method: 'POST', url: `/payments/${paymentId}/cancel` as const }
  return res
}

/**
 * @summary Cancel a payment
 * {@link /payments/:paymentId/cancel}
 */
export async function paymentsControllerCancelPayment(paymentId: PaymentsControllerCancelPaymentPathParams["paymentId"], data: PaymentsControllerCancelPaymentMutationRequest, config: Partial<RequestConfig<PaymentsControllerCancelPaymentMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PaymentsControllerCancelPaymentMutationResponse, ResponseErrorConfig<Error>, PaymentsControllerCancelPaymentMutationRequest>({ method : "POST", url : getPaymentsControllerCancelPaymentUrl(paymentId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getPaymentsControllerSoftDeletePaymentMethodUrl(paymentMethodId: PaymentsControllerSoftDeletePaymentMethodPathParams["paymentMethodId"]) {
  const res = { method: 'DELETE', url: `/payments/payment-methods/${paymentMethodId}` as const }
  return res
}

/**
 * @summary Soft-delete a payment method (excludes it from billing)
 * {@link /payments/payment-methods/:paymentMethodId}
 */
export async function paymentsControllerSoftDeletePaymentMethod(paymentMethodId: PaymentsControllerSoftDeletePaymentMethodPathParams["paymentMethodId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PaymentsControllerSoftDeletePaymentMethodMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "DELETE", url : getPaymentsControllerSoftDeletePaymentMethodUrl(paymentMethodId).url.toString(), ... requestConfig })
  return res.data
}

function getPolicyControllerGetPolicyUrl(policyId: PolicyControllerGetPolicyPathParams["policyId"]) {
  const res = { method: 'GET', url: `/policies/${policyId}` as const }
  return res
}

/**
 * @description Poll this for anything that completes outside your request: a signature finishing, a first premium arriving, cover starting. Reads are branch-scoped, so pass the branch the work was done on.
 * @summary Get Policy
 * {@link /policies/:policyId}
 */
export async function policyControllerGetPolicy(policyId: PolicyControllerGetPolicyPathParams["policyId"], params?: PolicyControllerGetPolicyQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PolicyControllerGetPolicyQueryResponse, ResponseErrorConfig<PolicyControllerGetPolicy403 | PolicyControllerGetPolicy404>, unknown>({ method : "GET", url : getPolicyControllerGetPolicyUrl(policyId).url.toString(), params, ... requestConfig })
  return res.data
}

function getPolicyControllerEditPolicyUrl(policyId: PolicyControllerEditPolicyPathParams["policyId"]) {
  const res = { method: 'PATCH', url: `/policies/${policyId}` as const }
  return res
}

/**
 * @description `invoicingConfig` comes from the product's `billing.defaultConfig` rather than being invented. These are terms you decide, not customer input, and a product may require them before quoting or confirming.
 * @summary Edit Policy
 * {@link /policies/:policyId}
 */
export async function policyControllerEditPolicy(policyId: PolicyControllerEditPolicyPathParams["policyId"], data: PolicyControllerEditPolicyMutationRequest, params?: PolicyControllerEditPolicyQueryParams, config: Partial<RequestConfig<PolicyControllerEditPolicyMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PolicyControllerEditPolicyMutationResponse, ResponseErrorConfig<PolicyControllerEditPolicy400 | PolicyControllerEditPolicy403 | PolicyControllerEditPolicy404 | PolicyControllerEditPolicy409>, PolicyControllerEditPolicyMutationRequest>({ method : "PATCH", url : getPolicyControllerEditPolicyUrl(policyId).url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getPolicyControllerGenerateIncrementalIdUrl(policyId: PolicyControllerGenerateIncrementalIdPathParams["policyId"]) {
  const res = { method: 'POST', url: `/policies/${policyId}/generate-incremental-id` as const }
  return res
}

/**
 * @summary TEST Calculate invoices
 * {@link /policies/:policyId/generate-incremental-id}
 */
export async function policyControllerGenerateIncrementalId(policyId: PolicyControllerGenerateIncrementalIdPathParams["policyId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PolicyControllerGenerateIncrementalIdMutationResponse, ResponseErrorConfig<PolicyControllerGenerateIncrementalId400>, unknown>({ method : "POST", url : getPolicyControllerGenerateIncrementalIdUrl(policyId).url.toString(), ... requestConfig })
  return res.data
}

function getPolicyControllerGenerateDocumentUploadUrlUrl(policyId: PolicyControllerGenerateDocumentUploadUrlPathParams["policyId"]) {
  const res = { method: 'POST', url: `/policies/${policyId}/documents` as const }
  return res
}

/**
 * @summary Generate Upload Document Url
 * {@link /policies/:policyId/documents}
 */
export async function policyControllerGenerateDocumentUploadUrl(policyId: PolicyControllerGenerateDocumentUploadUrlPathParams["policyId"], data: PolicyControllerGenerateDocumentUploadUrlMutationRequest, params?: PolicyControllerGenerateDocumentUploadUrlQueryParams, config: Partial<RequestConfig<PolicyControllerGenerateDocumentUploadUrlMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PolicyControllerGenerateDocumentUploadUrlMutationResponse, ResponseErrorConfig<PolicyControllerGenerateDocumentUploadUrl400 | PolicyControllerGenerateDocumentUploadUrl403 | PolicyControllerGenerateDocumentUploadUrl404>, PolicyControllerGenerateDocumentUploadUrlMutationRequest>({ method : "POST", url : getPolicyControllerGenerateDocumentUploadUrlUrl(policyId).url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getPolicyControllerListPolicyDocumentsUrl(policyId: PolicyControllerListPolicyDocumentsPathParams["policyId"]) {
  const res = { method: 'GET', url: `/policies/${policyId}/documents` as const }
  return res
}

/**
 * @summary List a policy's documents
 * {@link /policies/:policyId/documents}
 */
export async function policyControllerListPolicyDocuments(policyId: PolicyControllerListPolicyDocumentsPathParams["policyId"], params?: PolicyControllerListPolicyDocumentsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PolicyControllerListPolicyDocumentsQueryResponse, ResponseErrorConfig<PolicyControllerListPolicyDocuments403 | PolicyControllerListPolicyDocuments404>, unknown>({ method : "GET", url : getPolicyControllerListPolicyDocumentsUrl(policyId).url.toString(), params, ... requestConfig })
  return res.data
}

function getPolicyControllerDeletePolicyDocumentsUrl(policyId: PolicyControllerDeletePolicyDocumentsPathParams["policyId"]) {
  const res = { method: 'DELETE', url: `/policies/${policyId}/documents` as const }
  return res
}

/**
 * @summary Delete policy documents by id
 * {@link /policies/:policyId/documents}
 */
export async function policyControllerDeletePolicyDocuments(policyId: PolicyControllerDeletePolicyDocumentsPathParams["policyId"], params: PolicyControllerDeletePolicyDocumentsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PolicyControllerDeletePolicyDocumentsMutationResponse, ResponseErrorConfig<PolicyControllerDeletePolicyDocuments403 | PolicyControllerDeletePolicyDocuments404>, unknown>({ method : "DELETE", url : getPolicyControllerDeletePolicyDocumentsUrl(policyId).url.toString(), params, ... requestConfig })
  return res.data
}

function getPolicyControllerEditPolicyExternalIdUrl(policyId: PolicyControllerEditPolicyExternalIdPathParams["policyId"]) {
  const res = { method: 'POST', url: `/policies/${policyId}/external-id` as const }
  return res
}

/**
 * @summary Edit Policy external ID
 * {@link /policies/:policyId/external-id}
 */
export async function policyControllerEditPolicyExternalId(policyId: PolicyControllerEditPolicyExternalIdPathParams["policyId"], data: PolicyControllerEditPolicyExternalIdMutationRequest, config: Partial<RequestConfig<PolicyControllerEditPolicyExternalIdMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PolicyControllerEditPolicyExternalIdMutationResponse, ResponseErrorConfig<PolicyControllerEditPolicyExternalId409>, PolicyControllerEditPolicyExternalIdMutationRequest>({ method : "POST", url : getPolicyControllerEditPolicyExternalIdUrl(policyId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getPolicyControllerConfirmPolicyUrl(policyId: PolicyControllerConfirmPolicyPathParams["policyId"]) {
  const res = { method: 'POST', url: `/policies/${policyId}/confirm` as const }
  return res
}

/**
 * @description The policy and its assets all become [CONFIRMED](/concepts/core-lifecycle/core-entities/policies#policy-statuses) and can no longer be modified in the New Business flow.
 * @summary Confirm a policy
 * {@link /policies/:policyId/confirm}
 */
export async function policyControllerConfirmPolicy(policyId: PolicyControllerConfirmPolicyPathParams["policyId"], params: PolicyControllerConfirmPolicyQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PolicyControllerConfirmPolicyMutationResponse, ResponseErrorConfig<PolicyControllerConfirmPolicy400 | PolicyControllerConfirmPolicy403 | PolicyControllerConfirmPolicy404 | PolicyControllerConfirmPolicy409>, unknown>({ method : "POST", url : getPolicyControllerConfirmPolicyUrl(policyId).url.toString(), params, ... requestConfig })
  return res.data
}

function getPolicyControllerGeneratePolicySignatureRequestUrl(policyId: PolicyControllerGeneratePolicySignatureRequestPathParams["policyId"]) {
  const res = { method: 'POST', url: `/policies/${policyId}/signature` as const }
  return res
}

/**
 * @description Pass `branchId`: the documents offered are the unsigned ones on that branch, so omitting it looks at the base contract and fails with `NO_UNIQUE_DOCUMENT_TYPE_READY_TO_BE_SIGNED` and `documentNumber: 0`. Signing is a human action you then observe by polling — never by re-issuing this call, which creates a second request. On direct debit it is also refused with `NO_VALID_PAYMENT_METHODS` until a usable payment method exists.
 * @summary Generate a signature request for a policy
 * {@link /policies/:policyId/signature}
 */
export async function policyControllerGeneratePolicySignatureRequest(policyId: PolicyControllerGeneratePolicySignatureRequestPathParams["policyId"], data: PolicyControllerGeneratePolicySignatureRequestMutationRequest, params?: PolicyControllerGeneratePolicySignatureRequestQueryParams, config: Partial<RequestConfig<PolicyControllerGeneratePolicySignatureRequestMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PolicyControllerGeneratePolicySignatureRequestMutationResponse, ResponseErrorConfig<PolicyControllerGeneratePolicySignatureRequest400 | PolicyControllerGeneratePolicySignatureRequest403 | PolicyControllerGeneratePolicySignatureRequest404 | PolicyControllerGeneratePolicySignatureRequest409 | PolicyControllerGeneratePolicySignatureRequest425>, PolicyControllerGeneratePolicySignatureRequestMutationRequest>({ method : "POST", url : getPolicyControllerGeneratePolicySignatureRequestUrl(policyId).url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getPolicyControllerGetPremiumScheduleUrl(policyId: PolicyControllerGetPremiumSchedulePathParams["policyId"]) {
  const res = { method: 'GET', url: `/policies/${policyId}/premium-schedule` as const }
  return res
}

/**
 * @description The quote's premium is the contract total, not the first charge. Use this to show what will be paid and when instead of deriving a schedule from `invoicingConfig`.
 * @summary Get the premium schedule
 * {@link /policies/:policyId/premium-schedule}
 */
export async function policyControllerGetPremiumSchedule(policyId: PolicyControllerGetPremiumSchedulePathParams["policyId"], params: PolicyControllerGetPremiumScheduleQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PolicyControllerGetPremiumScheduleQueryResponse, ResponseErrorConfig<PolicyControllerGetPremiumSchedule403 | PolicyControllerGetPremiumSchedule404>, unknown>({ method : "GET", url : getPolicyControllerGetPremiumScheduleUrl(policyId).url.toString(), params, ... requestConfig })
  return res.data
}

function getPolicyControllerListPolicyDocumentsAdminUrl(policyId: PolicyControllerListPolicyDocumentsAdminPathParams["policyId"]) {
  const res = { method: 'GET', url: `/policies/${policyId}/admin/documents` as const }
  return res
}

/**
 * @summary List policy documents (Admin only - includes deleted)
 * {@link /policies/:policyId/admin/documents}
 */
export async function policyControllerListPolicyDocumentsAdmin(policyId: PolicyControllerListPolicyDocumentsAdminPathParams["policyId"], params?: PolicyControllerListPolicyDocumentsAdminQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PolicyControllerListPolicyDocumentsAdminQueryResponse, ResponseErrorConfig<PolicyControllerListPolicyDocumentsAdmin403 | PolicyControllerListPolicyDocumentsAdmin404>, unknown>({ method : "GET", url : getPolicyControllerListPolicyDocumentsAdminUrl(policyId).url.toString(), params, ... requestConfig })
  return res.data
}

function getPolicyControllerListPolicyEventsUrl(policyId: PolicyControllerListPolicyEventsPathParams["policyId"]) {
  const res = { method: 'GET', url: `/policies/${policyId}/events` as const }
  return res
}

/**
 * @summary List policy, asset or customer events.
 * {@link /policies/:policyId/events}
 */
export async function policyControllerListPolicyEvents(policyId: PolicyControllerListPolicyEventsPathParams["policyId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PolicyControllerListPolicyEventsQueryResponse, ResponseErrorConfig<PolicyControllerListPolicyEvents404>, unknown>({ method : "GET", url : getPolicyControllerListPolicyEventsUrl(policyId).url.toString(), ... requestConfig })
  return res.data
}

function getPolicyControllerPushPolicyEventUrl(policyId: PolicyControllerPushPolicyEventPathParams["policyId"]) {
  const res = { method: 'POST', url: `/policies/${policyId}/events` as const }
  return res
}

/**
 * @summary Push a custom event onto a policy
 * {@link /policies/:policyId/events}
 */
export async function policyControllerPushPolicyEvent(policyId: PolicyControllerPushPolicyEventPathParams["policyId"], data: PolicyControllerPushPolicyEventMutationRequest, params?: PolicyControllerPushPolicyEventQueryParams, config: Partial<RequestConfig<PolicyControllerPushPolicyEventMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PolicyControllerPushPolicyEventMutationResponse, ResponseErrorConfig<PolicyControllerPushPolicyEvent400 | PolicyControllerPushPolicyEvent404>, PolicyControllerPushPolicyEventMutationRequest>({ method : "POST", url : getPolicyControllerPushPolicyEventUrl(policyId).url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getPolicyControllerPlanTasksUrl(policyId: PolicyControllerPlanTasksPathParams["policyId"]) {
  const res = { method: 'GET', url: `/policies/${policyId}/recurring-tasks` as const }
  return res
}

/**
 * @description Returns recurring tasks for the requested date range. Execution history is not checked. Requires permission to plan tasks for the policy.
 * @summary List planned policy tasks
 * {@link /policies/:policyId/recurring-tasks}
 */
export async function policyControllerPlanTasks(policyId: PolicyControllerPlanTasksPathParams["policyId"], params?: PolicyControllerPlanTasksQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PolicyControllerPlanTasksQueryResponse, ResponseErrorConfig<PolicyControllerPlanTasks403 | PolicyControllerPlanTasks404>, unknown>({ method : "GET", url : getPolicyControllerPlanTasksUrl(policyId).url.toString(), params, ... requestConfig })
  return res.data
}

function getPolicyControllerQuotePolicyUrl(policyId: PolicyControllerQuotePolicyPathParams["policyId"]) {
  const res = { method: 'POST', url: `/policies/${policyId}/quote` as const }
  return res
}

/**
 * @description Persists the price and moves the policy to `POLICY_QUOTED`, the status confirmation requires; `calculate-quote` persists nothing. Permitted tiers, excesses and perils come from the config's `quote` object, not from `publicQuoteConfig`. On a mid-term adjustment the branch must contain at least one change that affects pricing, or it is refused with `NO_CHANGES_TO_QUOTE`. The response body is empty — read the quote back from the policy.
 * @summary Quote the policy
 * {@link /policies/:policyId/quote}
 */
export async function policyControllerQuotePolicy(policyId: PolicyControllerQuotePolicyPathParams["policyId"], data: PolicyControllerQuotePolicyMutationRequest, params: PolicyControllerQuotePolicyQueryParams, config: Partial<RequestConfig<PolicyControllerQuotePolicyMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PolicyControllerQuotePolicyMutationResponse, ResponseErrorConfig<PolicyControllerQuotePolicy400 | PolicyControllerQuotePolicy403 | PolicyControllerQuotePolicy404 | PolicyControllerQuotePolicy409>, PolicyControllerQuotePolicyMutationRequest>({ method : "POST", url : getPolicyControllerQuotePolicyUrl(policyId).url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getPolicyControllerGetAggregateUrl() {
  const res = { method: 'GET', url: `/policies/debug/aggregate` as const }
  return res
}

/**
 * @summary Get Aggregate
 * {@link /policies/debug/aggregate}
 */
export async function policyControllerGetAggregate(params: PolicyControllerGetAggregateQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PolicyControllerGetAggregateQueryResponse, ResponseErrorConfig<PolicyControllerGetAggregate404>, unknown>({ method : "GET", url : getPolicyControllerGetAggregateUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getPolicyControllerCalculatePolicyQuoteUrl(policyId: PolicyControllerCalculatePolicyQuotePathParams["policyId"]) {
  const res = { method: 'POST', url: `/policies/${policyId}/calculate-quote` as const }
  return res
}

/**
 * @description Calculate quote information for a policy without actually quoting it. The quote contains the full pricing details, i.e. base prices for assets or policy, the multipliers applied, peril breakdown, etc.
 * @summary Calculate policy quote
 * {@link /policies/:policyId/calculate-quote}
 */
export async function policyControllerCalculatePolicyQuote(policyId: PolicyControllerCalculatePolicyQuotePathParams["policyId"], data: PolicyControllerCalculatePolicyQuoteMutationRequest, params?: PolicyControllerCalculatePolicyQuoteQueryParams, config: Partial<RequestConfig<PolicyControllerCalculatePolicyQuoteMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PolicyControllerCalculatePolicyQuoteMutationResponse, ResponseErrorConfig<PolicyControllerCalculatePolicyQuote400 | PolicyControllerCalculatePolicyQuote404 | PolicyControllerCalculatePolicyQuote409>, PolicyControllerCalculatePolicyQuoteMutationRequest>({ method : "POST", url : getPolicyControllerCalculatePolicyQuoteUrl(policyId).url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getPolicyControllerStopPolicyUrl(policyId: PolicyControllerStopPolicyPathParams["policyId"]) {
  const res = { method: 'POST', url: `/policies/${policyId}/stop` as const }
  return res
}

/**
 * @description The policy becomes [STOPPED](/concepts/core-lifecycle/core-entities/policies#policy-statuses) and can no longer be modified; assets that had started stop, and assets that never started are cancelled. On a tenant running the scheduled stop model the request is instead recorded on its own branch and takes effect on its effective date, so the policy keeps its status, its coverage and its billing until then. Pass `draft=true` to save a request the user has started but not committed to: nothing is scheduled and nothing reaches the policy, so it can be resumed from any device while everything carries on untouched. Either way, call the request off by invalidating that branch.
 * @summary Stop a policy
 * {@link /policies/:policyId/stop}
 */
export async function policyControllerStopPolicy(policyId: PolicyControllerStopPolicyPathParams["policyId"], data: PolicyControllerStopPolicyMutationRequest, params?: PolicyControllerStopPolicyQueryParams, config: Partial<RequestConfig<PolicyControllerStopPolicyMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PolicyControllerStopPolicyMutationResponse, ResponseErrorConfig<PolicyControllerStopPolicy400 | PolicyControllerStopPolicy403 | PolicyControllerStopPolicy404 | PolicyControllerStopPolicy409 | PolicyControllerStopPolicy501>, PolicyControllerStopPolicyMutationRequest>({ method : "POST", url : getPolicyControllerStopPolicyUrl(policyId).url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getPolicyControllerRegisterAdditionalQuoteComponentsUrl(policyId: PolicyControllerRegisterAdditionalQuoteComponentsPathParams["policyId"]) {
  const res = { method: 'POST', url: `/policies/debug/${policyId}/register-additional-quote-components` as const }
  return res
}

/**
 * @summary Register additional quote components for a policy
 * {@link /policies/debug/:policyId/register-additional-quote-components}
 */
export async function policyControllerRegisterAdditionalQuoteComponents(policyId: PolicyControllerRegisterAdditionalQuoteComponentsPathParams["policyId"], data: PolicyControllerRegisterAdditionalQuoteComponentsMutationRequest, params?: PolicyControllerRegisterAdditionalQuoteComponentsQueryParams, config: Partial<RequestConfig<PolicyControllerRegisterAdditionalQuoteComponentsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PolicyControllerRegisterAdditionalQuoteComponentsMutationResponse, ResponseErrorConfig<Error>, PolicyControllerRegisterAdditionalQuoteComponentsMutationRequest>({ method : "POST", url : getPolicyControllerRegisterAdditionalQuoteComponentsUrl(policyId).url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getPolicyControllerUpdatePolicyQuoteUrl(policyId: PolicyControllerUpdatePolicyQuotePathParams["policyId"]) {
  const res = { method: 'POST', url: `/policies/${policyId}/update-policy-quote` as const }
  return res
}

/**
 * @summary Update policy quote components
 * {@link /policies/:policyId/update-policy-quote}
 */
export async function policyControllerUpdatePolicyQuote(policyId: PolicyControllerUpdatePolicyQuotePathParams["policyId"], data: PolicyControllerUpdatePolicyQuoteMutationRequest, params: PolicyControllerUpdatePolicyQuoteQueryParams, config: Partial<RequestConfig<PolicyControllerUpdatePolicyQuoteMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PolicyControllerUpdatePolicyQuoteMutationResponse, ResponseErrorConfig<PolicyControllerUpdatePolicyQuote404 | PolicyControllerUpdatePolicyQuote409>, PolicyControllerUpdatePolicyQuoteMutationRequest>({ method : "POST", url : getPolicyControllerUpdatePolicyQuoteUrl(policyId).url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getPolicyControllerSuspendPolicyUrl(policyId: PolicyControllerSuspendPolicyPathParams["policyId"]) {
  const res = { method: 'POST', url: `/policies/${policyId}/suspend` as const }
  return res
}

/**
 * @summary Suspend the policy
 * {@link /policies/:policyId/suspend}
 */
export async function policyControllerSuspendPolicy(policyId: PolicyControllerSuspendPolicyPathParams["policyId"], params?: PolicyControllerSuspendPolicyQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PolicyControllerSuspendPolicyMutationResponse, ResponseErrorConfig<PolicyControllerSuspendPolicy404 | PolicyControllerSuspendPolicy409>, unknown>({ method : "POST", url : getPolicyControllerSuspendPolicyUrl(policyId).url.toString(), params, ... requestConfig })
  return res.data
}

function getPolicyControllerActivatePolicyUrl(policyId: PolicyControllerActivatePolicyPathParams["policyId"]) {
  const res = { method: 'POST', url: `/policies/${policyId}/activate` as const }
  return res
}

/**
 * @description Brings a **suspended** contract back into force, and nothing else — any other status is refused with `CONFLICTING_POLICY_STATUS`. It is not how a new contract starts: a signed one comes into force on its own at its start date, and on products setting `requireFirstPaymentToActivate`, once the first premium is collected. `appliedAt` is when activation takes effect and must not precede `whenAt`; the call schedules the change for that date rather than applying it immediately.
 * @summary Activate the policy
 * {@link /policies/:policyId/activate}
 */
export async function policyControllerActivatePolicy(policyId: PolicyControllerActivatePolicyPathParams["policyId"], data: PolicyControllerActivatePolicyMutationRequest, params?: PolicyControllerActivatePolicyQueryParams, config: Partial<RequestConfig<PolicyControllerActivatePolicyMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PolicyControllerActivatePolicyMutationResponse, ResponseErrorConfig<PolicyControllerActivatePolicy400 | PolicyControllerActivatePolicy404 | PolicyControllerActivatePolicy409>, PolicyControllerActivatePolicyMutationRequest>({ method : "POST", url : getPolicyControllerActivatePolicyUrl(policyId).url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getPolicyControllerSetPolicyFeesUrl(policyId: PolicyControllerSetPolicyFeesPathParams["policyId"]) {
  const res = { method: 'POST', url: `/policies/${policyId}/fees` as const }
  return res
}

/**
 * @summary Set policy brokerage fees
 * {@link /policies/:policyId/fees}
 */
export async function policyControllerSetPolicyFees(policyId: PolicyControllerSetPolicyFeesPathParams["policyId"], data: PolicyControllerSetPolicyFeesMutationRequest, params?: PolicyControllerSetPolicyFeesQueryParams, config: Partial<RequestConfig<PolicyControllerSetPolicyFeesMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PolicyControllerSetPolicyFeesMutationResponse, ResponseErrorConfig<PolicyControllerSetPolicyFees400 | PolicyControllerSetPolicyFees404>, PolicyControllerSetPolicyFeesMutationRequest>({ method : "POST", url : getPolicyControllerSetPolicyFeesUrl(policyId).url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getPolicyControllerManualQuotePolicyUrl(policyId: PolicyControllerManualQuotePolicyPathParams["policyId"]) {
  const res = { method: 'POST', url: `/policies/${policyId}/manual-quote` as const }
  return res
}

/**
 * @summary Manual quote policy
 * {@link /policies/:policyId/manual-quote}
 * @deprecated
 */
export async function policyControllerManualQuotePolicy(policyId: PolicyControllerManualQuotePolicyPathParams["policyId"], data: PolicyControllerManualQuotePolicyMutationRequest, params: PolicyControllerManualQuotePolicyQueryParams, config: Partial<RequestConfig<PolicyControllerManualQuotePolicyMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PolicyControllerManualQuotePolicyMutationResponse, ResponseErrorConfig<PolicyControllerManualQuotePolicy400 | PolicyControllerManualQuotePolicy404 | PolicyControllerManualQuotePolicy409>, PolicyControllerManualQuotePolicyMutationRequest>({ method : "POST", url : getPolicyControllerManualQuotePolicyUrl(policyId).url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getPricingControllerComputePricingUrl(policyId: PricingControllerComputePricingPathParams["policyId"]) {
  const res = { method: 'GET', url: `/pricing/${policyId}` as const }
  return res
}

/**
 * @summary Compute pricing for selected tier and perils
 * {@link /pricing/:policyId}
 */
export async function pricingControllerComputePricing(policyId: PricingControllerComputePricingPathParams["policyId"], params: PricingControllerComputePricingQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PricingControllerComputePricingQueryResponse, ResponseErrorConfig<PricingControllerComputePricing400 | PricingControllerComputePricing404>, unknown>({ method : "GET", url : getPricingControllerComputePricingUrl(policyId).url.toString(), params, ... requestConfig })
  return res.data
}

function getPricingControllerGetPriceUrl(policyId: PricingControllerGetPricePathParams["policyId"]) {
  const res = { method: 'GET', url: `/pricing/${policyId}/price` as const }
  return res
}

/**
 * @summary Get price lines for display
 * {@link /pricing/:policyId/price}
 */
export async function pricingControllerGetPrice(policyId: PricingControllerGetPricePathParams["policyId"], params?: PricingControllerGetPriceQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PricingControllerGetPriceQueryResponse, ResponseErrorConfig<PricingControllerGetPrice404>, unknown>({ method : "GET", url : getPricingControllerGetPriceUrl(policyId).url.toString(), params, ... requestConfig })
  return res.data
}

function getPricingControllerSavePricingSelectionUrl(policyId: PricingControllerSavePricingSelectionPathParams["policyId"]) {
  const res = { method: 'PUT', url: `/pricing/${policyId}/selection` as const }
  return res
}

/**
 * @summary Save pricing tier and peril selection
 * {@link /pricing/:policyId/selection}
 */
export async function pricingControllerSavePricingSelection(policyId: PricingControllerSavePricingSelectionPathParams["policyId"], data: PricingControllerSavePricingSelectionMutationRequest, params?: PricingControllerSavePricingSelectionQueryParams, config: Partial<RequestConfig<PricingControllerSavePricingSelectionMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PricingControllerSavePricingSelectionMutationResponse, ResponseErrorConfig<PricingControllerSavePricingSelection404>, PricingControllerSavePricingSelectionMutationRequest>({ method : "PUT", url : getPricingControllerSavePricingSelectionUrl(policyId).url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getQuoteControllerGetQuoteUrl(productId: QuoteControllerGetQuotePathParams["productId"]) {
  const res = { method: 'POST', url: `/quote/debug/${productId}` as const }
  return res
}

/**
 * @description Computes a quote for the given `productId` using the provided customer, policy, branch, assets and options. The endpoint aggregates pricing and returns a policy-and-assets quote. Intended for internal/debug usage.
 * @summary DEBUG: Get quote for a product
 * {@link /quote/debug/:productId}
 */
export async function quoteControllerGetQuote(productId: QuoteControllerGetQuotePathParams["productId"], data: QuoteControllerGetQuoteMutationRequest, config: Partial<RequestConfig<QuoteControllerGetQuoteMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<QuoteControllerGetQuoteMutationResponse, ResponseErrorConfig<QuoteControllerGetQuote400 | QuoteControllerGetQuote404>, QuoteControllerGetQuoteMutationRequest>({ method : "POST", url : getQuoteControllerGetQuoteUrl(productId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getQuoteControllerGetExternalQuoteUrl() {
  const res = { method: 'GET', url: `/quote/external-quote` as const }
  return res
}

/**
 * @description Retrieves an external quote representation associated with a Korint internal quote `quoteId`. Returns external identifiers and raw external data if found.
 * @summary Get external quote by internal quote id
 * {@link /quote/external-quote}
 */
export async function quoteControllerGetExternalQuote(params: QuoteControllerGetExternalQuoteQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<QuoteControllerGetExternalQuoteQueryResponse, ResponseErrorConfig<QuoteControllerGetExternalQuote404>, unknown>({ method : "GET", url : getQuoteControllerGetExternalQuoteUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getRenewalControllerFinalizeRenewalBranchUrl(policyId: RenewalControllerFinalizeRenewalBranchPathParams["policyId"], branchId: RenewalControllerFinalizeRenewalBranchPathParams["branchId"]) {
  const res = { method: 'POST', url: `/renewal/policies/${policyId}/branches/${branchId}/finalize-renewal` as const }
  return res
}

/**
 * @summary Finalize the renewal proposition : accept or refuse it
 * {@link /renewal/policies/:policyId/branches/:branchId/finalize-renewal}
 */
export async function renewalControllerFinalizeRenewalBranch(policyId: RenewalControllerFinalizeRenewalBranchPathParams["policyId"], branchId: RenewalControllerFinalizeRenewalBranchPathParams["branchId"], params: RenewalControllerFinalizeRenewalBranchQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<RenewalControllerFinalizeRenewalBranchMutationResponse, ResponseErrorConfig<RenewalControllerFinalizeRenewalBranch404 | RenewalControllerFinalizeRenewalBranch409>, unknown>({ method : "POST", url : getRenewalControllerFinalizeRenewalBranchUrl(policyId, branchId).url.toString(), params, ... requestConfig })
  return res.data
}

function getMonitoringControllerGetReportsUrl() {
  const res = { method: 'GET', url: `/monitoring/reports` as const }
  return res
}

/**
 * @summary Get daily monitoring reports
 * {@link /monitoring/reports}
 */
export async function monitoringControllerGetReports(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<MonitoringControllerGetReportsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getMonitoringControllerGetReportsUrl().url.toString(), ... requestConfig })
  return res.data
}

function getMonitoringControllerGetChecksUrl() {
  const res = { method: 'GET', url: `/monitoring/checks` as const }
  return res
}

/**
 * @summary List the available monitoring checks
 * {@link /monitoring/checks}
 */
export async function monitoringControllerGetChecks(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<MonitoringControllerGetChecksQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getMonitoringControllerGetChecksUrl().url.toString(), ... requestConfig })
  return res.data
}

function getReportingControllerGenerateReportUrl() {
  const res = { method: 'POST', url: `/reporting` as const }
  return res
}

/**
 * @summary Generate a report
 * {@link /reporting}
 */
export async function reportingControllerGenerateReport(data: ReportingControllerGenerateReportMutationRequest, config: Partial<RequestConfig<ReportingControllerGenerateReportMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ReportingControllerGenerateReportMutationResponse, ResponseErrorConfig<ReportingControllerGenerateReport400>, ReportingControllerGenerateReportMutationRequest>({ method : "POST", url : getReportingControllerGenerateReportUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getReportingControllerGetReportConfigUrl(type: ReportingControllerGetReportConfigPathParams["type"]) {
  const res = { method: 'GET', url: `/reporting/${type}/config` as const }
  return res
}

/**
 * @summary Get report config
 * {@link /reporting/:type/config}
 */
export async function reportingControllerGetReportConfig(type: ReportingControllerGetReportConfigPathParams["type"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ReportingControllerGetReportConfigQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getReportingControllerGetReportConfigUrl(type).url.toString(), ... requestConfig })
  return res.data
}

function getReportingControllerGetReportsUrl() {
  const res = { method: 'POST', url: `/reporting/retrieve` as const }
  return res
}

/**
 * @summary Get reports
 * {@link /reporting/retrieve}
 */
export async function reportingControllerGetReports(data: ReportingControllerGetReportsMutationRequest, config: Partial<RequestConfig<ReportingControllerGetReportsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ReportingControllerGetReportsMutationResponse, ResponseErrorConfig<Error>, ReportingControllerGetReportsMutationRequest>({ method : "POST", url : getReportingControllerGetReportsUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getReportingControllerGenerateCustomReportUrl() {
  const res = { method: 'POST', url: `/reporting/custom` as const }
  return res
}

/**
 * @summary Export a search query as CSV
 * {@link /reporting/custom}
 */
export async function reportingControllerGenerateCustomReport(data: ReportingControllerGenerateCustomReportMutationRequest, config: Partial<RequestConfig<ReportingControllerGenerateCustomReportMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ReportingControllerGenerateCustomReportMutationResponse, ResponseErrorConfig<Error>, ReportingControllerGenerateCustomReportMutationRequest>({ method : "POST", url : getReportingControllerGenerateCustomReportUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getRepricingControllerExecuteRepricingForPolicyUrl(policyId: RepricingControllerExecuteRepricingForPolicyPathParams["policyId"]) {
  const res = { method: 'POST', url: `/repricing/${policyId}` as const }
  return res
}

/**
 * {@link /repricing/:policyId}
 */
export async function repricingControllerExecuteRepricingForPolicy(policyId: RepricingControllerExecuteRepricingForPolicyPathParams["policyId"], params?: RepricingControllerExecuteRepricingForPolicyQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<RepricingControllerExecuteRepricingForPolicyMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getRepricingControllerExecuteRepricingForPolicyUrl(policyId).url.toString(), params, ... requestConfig })
  return res.data
}

function getSearchControllerSearchUrl() {
  const res = { method: 'POST', url: `/search` as const }
  return res
}

/**
 * @summary Search
 * {@link /search}
 */
export async function searchControllerSearch(data: SearchControllerSearchMutationRequest, params?: SearchControllerSearchQueryParams, config: Partial<RequestConfig<SearchControllerSearchMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<SearchControllerSearchMutationResponse, ResponseErrorConfig<Error>, SearchControllerSearchMutationRequest>({ method : "POST", url : getSearchControllerSearchUrl().url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getSearchControllerGenericSearchUrl(name: SearchControllerGenericSearchPathParams["name"]) {
  const res = { method: 'POST', url: `/search/${name}/find` as const }
  return res
}

/**
 * @summary Generic Search
 * {@link /search/:name/find}
 */
export async function searchControllerGenericSearch(name: SearchControllerGenericSearchPathParams["name"], data: SearchControllerGenericSearchMutationRequest, params: SearchControllerGenericSearchQueryParams, config: Partial<RequestConfig<SearchControllerGenericSearchMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<SearchControllerGenericSearchMutationResponse, ResponseErrorConfig<Error>, SearchControllerGenericSearchMutationRequest>({ method : "POST", url : getSearchControllerGenericSearchUrl(name).url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getSearchControllerGenericSearchSwaggerUrl(name: SearchControllerGenericSearchSwaggerPathParams["name"]) {
  const res = { method: 'GET', url: `/search/${name}/find/swagger` as const }
  return res
}

/**
 * @summary Generic Search Swagger
 * {@link /search/:name/find/swagger}
 */
export async function searchControllerGenericSearchSwagger(name: SearchControllerGenericSearchSwaggerPathParams["name"], params: SearchControllerGenericSearchSwaggerQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SearchControllerGenericSearchSwaggerQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getSearchControllerGenericSearchSwaggerUrl(name).url.toString(), params, ... requestConfig })
  return res.data
}

function getSearchControllerCountUrl() {
  const res = { method: 'POST', url: `/search/count` as const }
  return res
}

/**
 * @summary Count
 * {@link /search/count}
 */
export async function searchControllerCount(data: SearchControllerCountMutationRequest, config: Partial<RequestConfig<SearchControllerCountMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<SearchControllerCountMutationResponse, ResponseErrorConfig<Error>, SearchControllerCountMutationRequest>({ method : "POST", url : getSearchControllerCountUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getSearchControllerSuggestUrl() {
  const res = { method: 'GET', url: `/search/suggest` as const }
  return res
}

/**
 * @summary Suggest
 * {@link /search/suggest}
 */
export async function searchControllerSuggest(params: SearchControllerSuggestQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SearchControllerSuggestQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getSearchControllerSuggestUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getSearchControllerReindexUrl() {
  const res = { method: 'POST', url: `/search/reindex` as const }
  return res
}

/**
 * @summary Reindex collections
 * {@link /search/reindex}
 */
export async function searchControllerReindex(data: SearchControllerReindexMutationRequest, config: Partial<RequestConfig<SearchControllerReindexMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<SearchControllerReindexMutationResponse, ResponseErrorConfig<Error>, SearchControllerReindexMutationRequest>({ method : "POST", url : getSearchControllerReindexUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getSearchControllerReindexAllUrl() {
  const res = { method: 'POST', url: `/search/reindex-all` as const }
  return res
}

/**
 * @summary Reindex all collections (tenant agnostic)
 * {@link /search/reindex-all}
 */
export async function searchControllerReindexAll(data: SearchControllerReindexAllMutationRequest, config: Partial<RequestConfig<SearchControllerReindexAllMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<SearchControllerReindexAllMutationResponse, ResponseErrorConfig<Error>, SearchControllerReindexAllMutationRequest>({ method : "POST", url : getSearchControllerReindexAllUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getSignatureControllerFakeUrl(signature_id: SignatureControllerFakePathParams["signature_id"]) {
  const res = { method: 'PUT', url: `/signature/fake/${signature_id}` as const }
  return res
}

/**
 * @description Requires M2M_{app_name}_TOKEN
 * @summary Fake a signature done event
 * {@link /signature/fake/:signature_id}
 */
export async function signatureControllerFake(signature_id: SignatureControllerFakePathParams["signature_id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SignatureControllerFakeMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "PUT", url : getSignatureControllerFakeUrl(signature_id).url.toString(), ... requestConfig })
  return res.data
}

function getSignatureControllerYousignSecurityCheckUrl() {
  const res = { method: 'GET', url: `/signature/yousign/security-check` as const }
  return res
}

/**
 * {@link /signature/yousign/security-check}
 */
export async function signatureControllerYousignSecurityCheck(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SignatureControllerYousignSecurityCheckQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getSignatureControllerYousignSecurityCheckUrl().url.toString(), ... requestConfig })
  return res.data
}

function getSignatureControllerGetSignatureRequestsByExternalIdUrl(externalId: SignatureControllerGetSignatureRequestsByExternalIdPathParams["externalId"]) {
  const res = { method: 'GET', url: `/signature/by-external-id/${externalId}` as const }
  return res
}

/**
 * @description Pass the policy id as `externalId`. A policy with no requests returns `200` and an empty `signatureRequests` array rather than a 404, so an empty result does not distinguish "not requested yet" from a wrong id.
 * @summary List signature requests for a policy
 * {@link /signature/by-external-id/:externalId}
 */
export async function signatureControllerGetSignatureRequestsByExternalId(externalId: SignatureControllerGetSignatureRequestsByExternalIdPathParams["externalId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SignatureControllerGetSignatureRequestsByExternalIdQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getSignatureControllerGetSignatureRequestsByExternalIdUrl(externalId).url.toString(), ... requestConfig })
  return res.data
}

function getSignatureControllerGetSignerLinkUrl(policyId: SignatureControllerGetSignerLinkPathParams["policyId"], signatureId: SignatureControllerGetSignerLinkPathParams["signatureId"], signerCustomerId: SignatureControllerGetSignerLinkPathParams["signerCustomerId"]) {
  const res = { method: 'GET', url: `/signature/${signatureId}/policy/${policyId}/signers/${signerCustomerId}/link` as const }
  return res
}

/**
 * @summary Get signature link for a specific signer
 * {@link /signature/:signatureId/policy/:policyId/signers/:signerCustomerId/link}
 */
export async function signatureControllerGetSignerLink(policyId: SignatureControllerGetSignerLinkPathParams["policyId"], signatureId: SignatureControllerGetSignerLinkPathParams["signatureId"], signerCustomerId: SignatureControllerGetSignerLinkPathParams["signerCustomerId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SignatureControllerGetSignerLinkQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getSignatureControllerGetSignerLinkUrl(policyId, signatureId, signerCustomerId).url.toString(), ... requestConfig })
  return res.data
}

function getSignatureControllerResendSignatureReminderUrl(policyId: SignatureControllerResendSignatureReminderPathParams["policyId"], signatureId: SignatureControllerResendSignatureReminderPathParams["signatureId"], signerCustomerId: SignatureControllerResendSignatureReminderPathParams["signerCustomerId"]) {
  const res = { method: 'POST', url: `/signature/${signatureId}/policy/${policyId}/signers/${signerCustomerId}/resend` as const }
  return res
}

/**
 * @summary Resend signature reminder to a specific signer
 * {@link /signature/:signatureId/policy/:policyId/signers/:signerCustomerId/resend}
 */
export async function signatureControllerResendSignatureReminder(policyId: SignatureControllerResendSignatureReminderPathParams["policyId"], signatureId: SignatureControllerResendSignatureReminderPathParams["signatureId"], signerCustomerId: SignatureControllerResendSignatureReminderPathParams["signerCustomerId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SignatureControllerResendSignatureReminderMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getSignatureControllerResendSignatureReminderUrl(policyId, signatureId, signerCustomerId).url.toString(), ... requestConfig })
  return res.data
}

function getSirenControllerSearchSirenUrl() {
  const res = { method: 'GET', url: `/siren` as const }
  return res
}

/**
 * @description Fetch company data from a SIREN API, from a SIRET, SIREN or a name
 * @summary Search SIREN
 * {@link /siren}
 */
export async function sirenControllerSearchSiren(params?: SirenControllerSearchSirenQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SirenControllerSearchSirenQueryResponse, ResponseErrorConfig<SirenControllerSearchSiren400>, unknown>({ method : "GET", url : getSirenControllerSearchSirenUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getAddressAutocompleteControllerSuggestUrl() {
  const res = { method: 'GET', url: `/address-autocomplete/suggest` as const }
  return res
}

/**
 * @description Autocomplete addresses from a partial query
 * @summary Suggest addresses
 * {@link /address-autocomplete/suggest}
 */
export async function addressAutocompleteControllerSuggest(params: AddressAutocompleteControllerSuggestQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AddressAutocompleteControllerSuggestQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getAddressAutocompleteControllerSuggestUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getSivControllerSearchSivUrl() {
  const res = { method: 'GET', url: `/vehicle-information/registration` as const }
  return res
}

/**
 * @description Returns the vehicle registered under the given French registration number (plaque).
 * @summary Look up a vehicle by registration number
 * {@link /vehicle-information/registration}
 */
export async function sivControllerSearchSiv(params: SivControllerSearchSivQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SivControllerSearchSivQueryResponse, ResponseErrorConfig<SivControllerSearchSiv404>, unknown>({ method : "GET", url : getSivControllerSearchSivUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getSivControllerSearchSivAtLegacyPathUrl() {
  const res = { method: 'GET', url: `/siv` as const }
  return res
}

/**
 * @summary Look up a vehicle by registration number
 * {@link /siv}
 * @deprecated
 */
export async function sivControllerSearchSivAtLegacyPath(params: SivControllerSearchSivAtLegacyPathQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SivControllerSearchSivAtLegacyPathQueryResponse, ResponseErrorConfig<SivControllerSearchSivAtLegacyPath404>, unknown>({ method : "GET", url : getSivControllerSearchSivAtLegacyPathUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getDerogationControllerCreateDerogationUrl(branchId: DerogationControllerCreateDerogationPathParams["branchId"]) {
  const res = { method: 'POST', url: `/derogations/branches/${branchId}` as const }
  return res
}

/**
 * @summary Create derogation
 * {@link /derogations/branches/:branchId}
 */
export async function derogationControllerCreateDerogation(branchId: DerogationControllerCreateDerogationPathParams["branchId"], params: DerogationControllerCreateDerogationQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DerogationControllerCreateDerogationMutationResponse, ResponseErrorConfig<DerogationControllerCreateDerogation404 | DerogationControllerCreateDerogation409>, unknown>({ method : "POST", url : getDerogationControllerCreateDerogationUrl(branchId).url.toString(), params, ... requestConfig })
  return res.data
}

function getDerogationControllerApproveDerogationUrl(branchId: DerogationControllerApproveDerogationPathParams["branchId"], derogationId: DerogationControllerApproveDerogationPathParams["derogationId"]) {
  const res = { method: 'POST', url: `/derogations/${derogationId}/branches/${branchId}/approve` as const }
  return res
}

/**
 * @summary Approve derogation
 * {@link /derogations/:derogationId/branches/:branchId/approve}
 */
export async function derogationControllerApproveDerogation(branchId: DerogationControllerApproveDerogationPathParams["branchId"], derogationId: DerogationControllerApproveDerogationPathParams["derogationId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DerogationControllerApproveDerogationMutationResponse, ResponseErrorConfig<DerogationControllerApproveDerogation404>, unknown>({ method : "POST", url : getDerogationControllerApproveDerogationUrl(branchId, derogationId).url.toString(), ... requestConfig })
  return res.data
}

function getDerogationControllerDenyDerogationUrl(derogationId: DerogationControllerDenyDerogationPathParams["derogationId"], branchId: DerogationControllerDenyDerogationPathParams["branchId"]) {
  const res = { method: 'POST', url: `/derogations/${derogationId}/branches/${branchId}/deny` as const }
  return res
}

/**
 * @summary Deny derogation
 * {@link /derogations/:derogationId/branches/:branchId/deny}
 */
export async function derogationControllerDenyDerogation(derogationId: DerogationControllerDenyDerogationPathParams["derogationId"], branchId: DerogationControllerDenyDerogationPathParams["branchId"], data: DerogationControllerDenyDerogationMutationRequest, config: Partial<RequestConfig<DerogationControllerDenyDerogationMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<DerogationControllerDenyDerogationMutationResponse, ResponseErrorConfig<DerogationControllerDenyDerogation404>, DerogationControllerDenyDerogationMutationRequest>({ method : "POST", url : getDerogationControllerDenyDerogationUrl(derogationId, branchId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getDerogationControllerCheckDerogationRequirementUrl(branchId: DerogationControllerCheckDerogationRequirementPathParams["branchId"]) {
  const res = { method: 'POST', url: `/derogations/branches/${branchId}/check` as const }
  return res
}

/**
 * @summary Check if a derogation is required for a branch/action
 * {@link /derogations/branches/:branchId/check}
 */
export async function derogationControllerCheckDerogationRequirement(branchId: DerogationControllerCheckDerogationRequirementPathParams["branchId"], data: DerogationControllerCheckDerogationRequirementMutationRequest, params: DerogationControllerCheckDerogationRequirementQueryParams, config: Partial<RequestConfig<DerogationControllerCheckDerogationRequirementMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<DerogationControllerCheckDerogationRequirementMutationResponse, ResponseErrorConfig<Error>, DerogationControllerCheckDerogationRequirementMutationRequest>({ method : "POST", url : getDerogationControllerCheckDerogationRequirementUrl(branchId).url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getAiAdminControllerListConversationsUrl() {
  const res = { method: 'GET', url: `/ai-admin/conversations` as const }
  return res
}

/**
 * @summary List all conversations (admin)
 * {@link /ai-admin/conversations}
 */
export async function aiAdminControllerListConversations(params?: AiAdminControllerListConversationsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AiAdminControllerListConversationsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getAiAdminControllerListConversationsUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getAiAdminControllerGetConversationMessagesUrl(conversationId: AiAdminControllerGetConversationMessagesPathParams["conversationId"]) {
  const res = { method: 'GET', url: `/ai-admin/conversations/${conversationId}/messages` as const }
  return res
}

/**
 * @summary Get conversation messages (admin)
 * {@link /ai-admin/conversations/:conversationId/messages}
 */
export async function aiAdminControllerGetConversationMessages(conversationId: AiAdminControllerGetConversationMessagesPathParams["conversationId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AiAdminControllerGetConversationMessagesQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getAiAdminControllerGetConversationMessagesUrl(conversationId).url.toString(), ... requestConfig })
  return res.data
}

function getCommentsControllerCreateCommentUrl(entityId: CommentsControllerCreateCommentPathParams["entityId"]) {
  const res = { method: 'POST', url: `/comments/${entityId}` as const }
  return res
}

/**
 * @summary Create a comment for an entity and branch
 * {@link /comments/:entityId}
 */
export async function commentsControllerCreateComment(entityId: CommentsControllerCreateCommentPathParams["entityId"], data: CommentsControllerCreateCommentMutationRequest, params?: CommentsControllerCreateCommentQueryParams, config: Partial<RequestConfig<CommentsControllerCreateCommentMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<CommentsControllerCreateCommentMutationResponse, ResponseErrorConfig<CommentsControllerCreateComment409>, CommentsControllerCreateCommentMutationRequest>({ method : "POST", url : getCommentsControllerCreateCommentUrl(entityId).url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getCommentsControllerUpdateCommentUrl(commentId: CommentsControllerUpdateCommentPathParams["commentId"]) {
  const res = { method: 'PATCH', url: `/comments/${commentId}` as const }
  return res
}

/**
 * @summary Update a comment for an entity and branch
 * {@link /comments/:commentId}
 */
export async function commentsControllerUpdateComment(commentId: CommentsControllerUpdateCommentPathParams["commentId"], data: CommentsControllerUpdateCommentMutationRequest, config: Partial<RequestConfig<CommentsControllerUpdateCommentMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<CommentsControllerUpdateCommentMutationResponse, ResponseErrorConfig<CommentsControllerUpdateComment404>, CommentsControllerUpdateCommentMutationRequest>({ method : "PATCH", url : getCommentsControllerUpdateCommentUrl(commentId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getCommentsControllerDeleteCommentUrl(commentId: CommentsControllerDeleteCommentPathParams["commentId"]) {
  const res = { method: 'DELETE', url: `/comments/${commentId}` as const }
  return res
}

/**
 * @summary Delete a comment for an entity and branch
 * {@link /comments/:commentId}
 */
export async function commentsControllerDeleteComment(commentId: CommentsControllerDeleteCommentPathParams["commentId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<CommentsControllerDeleteCommentMutationResponse, ResponseErrorConfig<CommentsControllerDeleteComment404>, unknown>({ method : "DELETE", url : getCommentsControllerDeleteCommentUrl(commentId).url.toString(), ... requestConfig })
  return res.data
}

function getCommentsControllerGetCommentUrl(commentId: CommentsControllerGetCommentPathParams["commentId"]) {
  const res = { method: 'GET', url: `/comments/${commentId}` as const }
  return res
}

/**
 * @summary Get a comment for an entity and branch
 * {@link /comments/:commentId}
 */
export async function commentsControllerGetComment(commentId: CommentsControllerGetCommentPathParams["commentId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<CommentsControllerGetCommentQueryResponse, ResponseErrorConfig<CommentsControllerGetComment404>, unknown>({ method : "GET", url : getCommentsControllerGetCommentUrl(commentId).url.toString(), ... requestConfig })
  return res.data
}

function getCommentsControllerListCommentsUrl(entityId: CommentsControllerListCommentsPathParams["entityId"]) {
  const res = { method: 'GET', url: `/comments/${entityId}/list` as const }
  return res
}

/**
 * @summary List comments for an entity and branch
 * {@link /comments/:entityId/list}
 */
export async function commentsControllerListComments(entityId: CommentsControllerListCommentsPathParams["entityId"], params?: CommentsControllerListCommentsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<CommentsControllerListCommentsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getCommentsControllerListCommentsUrl(entityId).url.toString(), params, ... requestConfig })
  return res.data
}

function getInternalNotesControllerCreateUrl(policyId: InternalNotesControllerCreatePathParams["policyId"]) {
  const res = { method: 'POST', url: `/policies/${policyId}/internal-notes` as const }
  return res
}

/**
 * @summary Create an internal note on a policy
 * {@link /policies/:policyId/internal-notes}
 */
export async function internalNotesControllerCreate(policyId: InternalNotesControllerCreatePathParams["policyId"], data: InternalNotesControllerCreateMutationRequest, config: Partial<RequestConfig<InternalNotesControllerCreateMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<InternalNotesControllerCreateMutationResponse, ResponseErrorConfig<InternalNotesControllerCreate400>, InternalNotesControllerCreateMutationRequest>({ method : "POST", url : getInternalNotesControllerCreateUrl(policyId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getInternalNotesControllerListUrl(policyId: InternalNotesControllerListPathParams["policyId"]) {
  const res = { method: 'GET', url: `/policies/${policyId}/internal-notes` as const }
  return res
}

/**
 * @summary List internal notes on a policy
 * {@link /policies/:policyId/internal-notes}
 */
export async function internalNotesControllerList(policyId: InternalNotesControllerListPathParams["policyId"], params?: InternalNotesControllerListQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<InternalNotesControllerListQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getInternalNotesControllerListUrl(policyId).url.toString(), params, ... requestConfig })
  return res.data
}

function getInternalNotesControllerGetUrl(policyId: InternalNotesControllerGetPathParams["policyId"], noteId: InternalNotesControllerGetPathParams["noteId"]) {
  const res = { method: 'GET', url: `/policies/${policyId}/internal-notes/${noteId}` as const }
  return res
}

/**
 * @summary Get an internal note by id
 * {@link /policies/:policyId/internal-notes/:noteId}
 */
export async function internalNotesControllerGet(policyId: InternalNotesControllerGetPathParams["policyId"], noteId: InternalNotesControllerGetPathParams["noteId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<InternalNotesControllerGetQueryResponse, ResponseErrorConfig<InternalNotesControllerGet404>, unknown>({ method : "GET", url : getInternalNotesControllerGetUrl(policyId, noteId).url.toString(), ... requestConfig })
  return res.data
}

function getInternalNotesControllerUpdateUrl(policyId: InternalNotesControllerUpdatePathParams["policyId"], noteId: InternalNotesControllerUpdatePathParams["noteId"]) {
  const res = { method: 'PATCH', url: `/policies/${policyId}/internal-notes/${noteId}` as const }
  return res
}

/**
 * @summary Update an internal note (author only)
 * {@link /policies/:policyId/internal-notes/:noteId}
 */
export async function internalNotesControllerUpdate(policyId: InternalNotesControllerUpdatePathParams["policyId"], noteId: InternalNotesControllerUpdatePathParams["noteId"], data: InternalNotesControllerUpdateMutationRequest, config: Partial<RequestConfig<InternalNotesControllerUpdateMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<InternalNotesControllerUpdateMutationResponse, ResponseErrorConfig<InternalNotesControllerUpdate403 | InternalNotesControllerUpdate404>, InternalNotesControllerUpdateMutationRequest>({ method : "PATCH", url : getInternalNotesControllerUpdateUrl(policyId, noteId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getInternalNotesControllerDeleteUrl(policyId: InternalNotesControllerDeletePathParams["policyId"], noteId: InternalNotesControllerDeletePathParams["noteId"]) {
  const res = { method: 'DELETE', url: `/policies/${policyId}/internal-notes/${noteId}` as const }
  return res
}

/**
 * @description Soft-deletes the note by default. Super admins can delete it permanently with `?hard=true`.
 * @summary Delete an internal note
 * {@link /policies/:policyId/internal-notes/:noteId}
 */
export async function internalNotesControllerDelete(policyId: InternalNotesControllerDeletePathParams["policyId"], noteId: InternalNotesControllerDeletePathParams["noteId"], params: InternalNotesControllerDeleteQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<InternalNotesControllerDeleteMutationResponse, ResponseErrorConfig<InternalNotesControllerDelete403 | InternalNotesControllerDelete404>, unknown>({ method : "DELETE", url : getInternalNotesControllerDeleteUrl(policyId, noteId).url.toString(), params, ... requestConfig })
  return res.data
}

function getClaimInternalNotesControllerCreateUrl(claimId: ClaimInternalNotesControllerCreatePathParams["claimId"]) {
  const res = { method: 'POST', url: `/claim-management/claims/${claimId}/internal-notes` as const }
  return res
}

/**
 * @summary Create an internal note on a claim
 * {@link /claim-management/claims/:claimId/internal-notes}
 */
export async function claimInternalNotesControllerCreate(claimId: ClaimInternalNotesControllerCreatePathParams["claimId"], data: ClaimInternalNotesControllerCreateMutationRequest, config: Partial<RequestConfig<ClaimInternalNotesControllerCreateMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ClaimInternalNotesControllerCreateMutationResponse, ResponseErrorConfig<ClaimInternalNotesControllerCreate400>, ClaimInternalNotesControllerCreateMutationRequest>({ method : "POST", url : getClaimInternalNotesControllerCreateUrl(claimId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getClaimInternalNotesControllerListUrl(claimId: ClaimInternalNotesControllerListPathParams["claimId"]) {
  const res = { method: 'GET', url: `/claim-management/claims/${claimId}/internal-notes` as const }
  return res
}

/**
 * @summary List internal notes on a claim
 * {@link /claim-management/claims/:claimId/internal-notes}
 */
export async function claimInternalNotesControllerList(claimId: ClaimInternalNotesControllerListPathParams["claimId"], params?: ClaimInternalNotesControllerListQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ClaimInternalNotesControllerListQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getClaimInternalNotesControllerListUrl(claimId).url.toString(), params, ... requestConfig })
  return res.data
}

function getClaimInternalNotesControllerGetUrl(claimId: ClaimInternalNotesControllerGetPathParams["claimId"], noteId: ClaimInternalNotesControllerGetPathParams["noteId"]) {
  const res = { method: 'GET', url: `/claim-management/claims/${claimId}/internal-notes/${noteId}` as const }
  return res
}

/**
 * @summary Get an internal note on a claim
 * {@link /claim-management/claims/:claimId/internal-notes/:noteId}
 */
export async function claimInternalNotesControllerGet(claimId: ClaimInternalNotesControllerGetPathParams["claimId"], noteId: ClaimInternalNotesControllerGetPathParams["noteId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ClaimInternalNotesControllerGetQueryResponse, ResponseErrorConfig<ClaimInternalNotesControllerGet404>, unknown>({ method : "GET", url : getClaimInternalNotesControllerGetUrl(claimId, noteId).url.toString(), ... requestConfig })
  return res.data
}

function getClaimInternalNotesControllerUpdateUrl(claimId: ClaimInternalNotesControllerUpdatePathParams["claimId"], noteId: ClaimInternalNotesControllerUpdatePathParams["noteId"]) {
  const res = { method: 'PATCH', url: `/claim-management/claims/${claimId}/internal-notes/${noteId}` as const }
  return res
}

/**
 * @summary Update an internal note on a claim (author only)
 * {@link /claim-management/claims/:claimId/internal-notes/:noteId}
 */
export async function claimInternalNotesControllerUpdate(claimId: ClaimInternalNotesControllerUpdatePathParams["claimId"], noteId: ClaimInternalNotesControllerUpdatePathParams["noteId"], data: ClaimInternalNotesControllerUpdateMutationRequest, config: Partial<RequestConfig<ClaimInternalNotesControllerUpdateMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ClaimInternalNotesControllerUpdateMutationResponse, ResponseErrorConfig<ClaimInternalNotesControllerUpdate403 | ClaimInternalNotesControllerUpdate404>, ClaimInternalNotesControllerUpdateMutationRequest>({ method : "PATCH", url : getClaimInternalNotesControllerUpdateUrl(claimId, noteId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getClaimInternalNotesControllerDeleteUrl(claimId: ClaimInternalNotesControllerDeletePathParams["claimId"], noteId: ClaimInternalNotesControllerDeletePathParams["noteId"]) {
  const res = { method: 'DELETE', url: `/claim-management/claims/${claimId}/internal-notes/${noteId}` as const }
  return res
}

/**
 * @description Soft-deletes the note by default. Super admins can delete it permanently with `?hard=true`.
 * @summary Delete an internal note on a claim
 * {@link /claim-management/claims/:claimId/internal-notes/:noteId}
 */
export async function claimInternalNotesControllerDelete(claimId: ClaimInternalNotesControllerDeletePathParams["claimId"], noteId: ClaimInternalNotesControllerDeletePathParams["noteId"], params: ClaimInternalNotesControllerDeleteQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ClaimInternalNotesControllerDeleteMutationResponse, ResponseErrorConfig<ClaimInternalNotesControllerDelete403 | ClaimInternalNotesControllerDelete404>, unknown>({ method : "DELETE", url : getClaimInternalNotesControllerDeleteUrl(claimId, noteId).url.toString(), params, ... requestConfig })
  return res.data
}

function getConversationControllerCreateConversationUrl() {
  const res = { method: 'POST', url: `/conversations` as const }
  return res
}

/**
 * @summary Create a new conversation
 * {@link /conversations}
 */
export async function conversationControllerCreateConversation(data: ConversationControllerCreateConversationMutationRequest, config: Partial<RequestConfig<ConversationControllerCreateConversationMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ConversationControllerCreateConversationMutationResponse, ResponseErrorConfig<Error>, ConversationControllerCreateConversationMutationRequest>({ method : "POST", url : getConversationControllerCreateConversationUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getConversationControllerListConversationsUrl() {
  const res = { method: 'GET', url: `/conversations` as const }
  return res
}

/**
 * @summary List conversations for the current user
 * {@link /conversations}
 */
export async function conversationControllerListConversations(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ConversationControllerListConversationsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getConversationControllerListConversationsUrl().url.toString(), ... requestConfig })
  return res.data
}

function getConversationControllerGetConversationUrl(conversationId: ConversationControllerGetConversationPathParams["conversationId"]) {
  const res = { method: 'GET', url: `/conversations/${conversationId}` as const }
  return res
}

/**
 * @summary Get a conversation
 * {@link /conversations/:conversationId}
 */
export async function conversationControllerGetConversation(conversationId: ConversationControllerGetConversationPathParams["conversationId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ConversationControllerGetConversationQueryResponse, ResponseErrorConfig<ConversationControllerGetConversation404>, unknown>({ method : "GET", url : getConversationControllerGetConversationUrl(conversationId).url.toString(), ... requestConfig })
  return res.data
}

function getConversationControllerDeleteConversationUrl(conversationId: ConversationControllerDeleteConversationPathParams["conversationId"]) {
  const res = { method: 'DELETE', url: `/conversations/${conversationId}` as const }
  return res
}

/**
 * @summary Soft delete a conversation
 * {@link /conversations/:conversationId}
 */
export async function conversationControllerDeleteConversation(conversationId: ConversationControllerDeleteConversationPathParams["conversationId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ConversationControllerDeleteConversationMutationResponse, ResponseErrorConfig<ConversationControllerDeleteConversation404>, unknown>({ method : "DELETE", url : getConversationControllerDeleteConversationUrl(conversationId).url.toString(), ... requestConfig })
  return res.data
}

function getConversationControllerGetConversationMessagesUrl(conversationId: ConversationControllerGetConversationMessagesPathParams["conversationId"]) {
  const res = { method: 'GET', url: `/conversations/${conversationId}/messages` as const }
  return res
}

/**
 * @summary Get messages for a conversation
 * {@link /conversations/:conversationId/messages}
 */
export async function conversationControllerGetConversationMessages(conversationId: ConversationControllerGetConversationMessagesPathParams["conversationId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ConversationControllerGetConversationMessagesQueryResponse, ResponseErrorConfig<ConversationControllerGetConversationMessages404>, unknown>({ method : "GET", url : getConversationControllerGetConversationMessagesUrl(conversationId).url.toString(), ... requestConfig })
  return res.data
}

function getConversationControllerSendConversationMessageUrl(conversationId: ConversationControllerSendConversationMessagePathParams["conversationId"]) {
  const res = { method: 'POST', url: `/conversations/${conversationId}/messages` as const }
  return res
}

/**
 * @summary Send a message in a conversation
 * {@link /conversations/:conversationId/messages}
 */
export async function conversationControllerSendConversationMessage(conversationId: ConversationControllerSendConversationMessagePathParams["conversationId"], data: ConversationControllerSendConversationMessageMutationRequest, config: Partial<RequestConfig<ConversationControllerSendConversationMessageMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ConversationControllerSendConversationMessageMutationResponse, ResponseErrorConfig<ConversationControllerSendConversationMessage404>, ConversationControllerSendConversationMessageMutationRequest>({ method : "POST", url : getConversationControllerSendConversationMessageUrl(conversationId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getConversationControllerSendConversationMessageStreamUrl(conversationId: ConversationControllerSendConversationMessageStreamPathParams["conversationId"]) {
  const res = { method: 'POST', url: `/conversations/${conversationId}/messages/stream` as const }
  return res
}

/**
 * @summary Stream a message response in a conversation via SSE
 * {@link /conversations/:conversationId/messages/stream}
 */
export async function conversationControllerSendConversationMessageStream(conversationId: ConversationControllerSendConversationMessageStreamPathParams["conversationId"], data: ConversationControllerSendConversationMessageStreamMutationRequest, config: Partial<RequestConfig<ConversationControllerSendConversationMessageStreamMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ConversationControllerSendConversationMessageStreamMutationResponse, ResponseErrorConfig<Error>, ConversationControllerSendConversationMessageStreamMutationRequest>({ method : "POST", url : getConversationControllerSendConversationMessageStreamUrl(conversationId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getConversationControllerSendConversationFeedbackUrl(conversationId: ConversationControllerSendConversationFeedbackPathParams["conversationId"], messageId: ConversationControllerSendConversationFeedbackPathParams["messageId"]) {
  const res = { method: 'POST', url: `/conversations/${conversationId}/messages/${messageId}/feedback` as const }
  return res
}

/**
 * @summary Send feedback on a conversation message
 * {@link /conversations/:conversationId/messages/:messageId/feedback}
 */
export async function conversationControllerSendConversationFeedback(conversationId: ConversationControllerSendConversationFeedbackPathParams["conversationId"], messageId: ConversationControllerSendConversationFeedbackPathParams["messageId"], data: ConversationControllerSendConversationFeedbackMutationRequest, config: Partial<RequestConfig<ConversationControllerSendConversationFeedbackMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ConversationControllerSendConversationFeedbackMutationResponse, ResponseErrorConfig<ConversationControllerSendConversationFeedback404>, ConversationControllerSendConversationFeedbackMutationRequest>({ method : "POST", url : getConversationControllerSendConversationFeedbackUrl(conversationId, messageId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getSraControllerGetFacetUrl() {
  const res = { method: 'GET', url: `/vehicle-information/facet` as const }
  return res
}

/**
 * @description Returns the available values for one facet, such as brand or model.
 * @summary List the values of a vehicle facet
 * {@link /vehicle-information/facet}
 */
export async function sraControllerGetFacet(params: SraControllerGetFacetQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SraControllerGetFacetQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getSraControllerGetFacetUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getSraControllerGetVehicleDetailsUrl() {
  const res = { method: 'GET', url: `/vehicle-information/details` as const }
  return res
}

/**
 * @summary Get vehicle details
 * {@link /vehicle-information/details}
 */
export async function sraControllerGetVehicleDetails(params: SraControllerGetVehicleDetailsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SraControllerGetVehicleDetailsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getSraControllerGetVehicleDetailsUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getSraControllerGetVersionInformationFromBrandAndModelUrl() {
  const res = { method: 'GET', url: `/vehicle-information/versions` as const }
  return res
}

/**
 * @description Each version comes with its fiscal power and number of seats.
 * @summary List the versions of a brand and model
 * {@link /vehicle-information/versions}
 */
export async function sraControllerGetVersionInformationFromBrandAndModel(params: SraControllerGetVersionInformationFromBrandAndModelQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SraControllerGetVersionInformationFromBrandAndModelQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getSraControllerGetVersionInformationFromBrandAndModelUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getHiscoxControllerGetActivitiesBySectorUrl() {
  const res = { method: 'GET', url: `/hiscox/activities-by-sector` as const }
  return res
}

/**
 * @summary Get activities from the same sector as the given activity
 * {@link /hiscox/activities-by-sector}
 */
export async function hiscoxControllerGetActivitiesBySector(params: HiscoxControllerGetActivitiesBySectorQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<HiscoxControllerGetActivitiesBySectorQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getHiscoxControllerGetActivitiesBySectorUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getStripeWebhookControllerWebhookUrl() {
  const res = { method: 'POST', url: `/stripe/webhook` as const }
  return res
}

/**
 * {@link /stripe/webhook}
 */
export async function stripeWebhookControllerWebhook(headers: StripeWebhookControllerWebhookHeaderParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<StripeWebhookControllerWebhookMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getStripeWebhookControllerWebhookUrl().url.toString(), ... requestConfig, headers : { ...headers, ...requestConfig.headers } })
  return res.data
}

function getStripeWebhookControllerConnectWebhookUrl() {
  const res = { method: 'POST', url: `/stripe/webhook/connect` as const }
  return res
}

/**
 * {@link /stripe/webhook/connect}
 */
export async function stripeWebhookControllerConnectWebhook(headers: StripeWebhookControllerConnectWebhookHeaderParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<StripeWebhookControllerConnectWebhookMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getStripeWebhookControllerConnectWebhookUrl().url.toString(), ... requestConfig, headers : { ...headers, ...requestConfig.headers } })
  return res.data
}

function getStripeWebhookControllerTestWebhookUrl() {
  const res = { method: 'POST', url: `/stripe/webhook/test` as const }
  return res
}

/**
 * {@link /stripe/webhook/test}
 */
export async function stripeWebhookControllerTestWebhook(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<StripeWebhookControllerTestWebhookMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getStripeWebhookControllerTestWebhookUrl().url.toString(), ... requestConfig })
  return res.data
}

function getStripeWebhookControllerTenantWebhookUrl(tenant: StripeWebhookControllerTenantWebhookPathParams["tenant"]) {
  const res = { method: 'POST', url: `/stripe/webhook/${tenant}` as const }
  return res
}

/**
 * {@link /stripe/webhook/:tenant}
 */
export async function stripeWebhookControllerTenantWebhook(tenant: StripeWebhookControllerTenantWebhookPathParams["tenant"], headers: StripeWebhookControllerTenantWebhookHeaderParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<StripeWebhookControllerTenantWebhookMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getStripeWebhookControllerTenantWebhookUrl(tenant).url.toString(), ... requestConfig, headers : { ...headers, ...requestConfig.headers } })
  return res.data
}

function getStripeWebhookControllerTenantConnectWebhookUrl(tenant: StripeWebhookControllerTenantConnectWebhookPathParams["tenant"]) {
  const res = { method: 'POST', url: `/stripe/webhook/connect/${tenant}` as const }
  return res
}

/**
 * {@link /stripe/webhook/connect/:tenant}
 */
export async function stripeWebhookControllerTenantConnectWebhook(tenant: StripeWebhookControllerTenantConnectWebhookPathParams["tenant"], headers: StripeWebhookControllerTenantConnectWebhookHeaderParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<StripeWebhookControllerTenantConnectWebhookMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getStripeWebhookControllerTenantConnectWebhookUrl(tenant).url.toString(), ... requestConfig, headers : { ...headers, ...requestConfig.headers } })
  return res.data
}

function getSydiaControllerListClaimsUrl() {
  const res = { method: 'POST', url: `/sydia/claims/list` as const }
  return res
}

/**
 * @summary Fetch list of claims
 * {@link /sydia/claims/list}
 */
export async function sydiaControllerListClaims(data: SydiaControllerListClaimsMutationRequest, config: Partial<RequestConfig<SydiaControllerListClaimsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<SydiaControllerListClaimsMutationResponse, ResponseErrorConfig<Error>, SydiaControllerListClaimsMutationRequest>({ method : "POST", url : getSydiaControllerListClaimsUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getSydiaControllerGetClaimUrl() {
  const res = { method: 'POST', url: `/sydia/claims` as const }
  return res
}

/**
 * @summary Fetch a claim with claimId
 * {@link /sydia/claims}
 */
export async function sydiaControllerGetClaim(data: SydiaControllerGetClaimMutationRequest, config: Partial<RequestConfig<SydiaControllerGetClaimMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<SydiaControllerGetClaimMutationResponse, ResponseErrorConfig<Error>, SydiaControllerGetClaimMutationRequest>({ method : "POST", url : getSydiaControllerGetClaimUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getSydiaControllerUpsertPolicyClaimsUrl() {
  const res = { method: 'PUT', url: `/sydia/claims` as const }
  return res
}

/**
 * @summary Upsert Sydia claim in our database
 * {@link /sydia/claims}
 */
export async function sydiaControllerUpsertPolicyClaims(data: SydiaControllerUpsertPolicyClaimsMutationRequest, config: Partial<RequestConfig<SydiaControllerUpsertPolicyClaimsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<SydiaControllerUpsertPolicyClaimsMutationResponse, ResponseErrorConfig<Error>, SydiaControllerUpsertPolicyClaimsMutationRequest>({ method : "PUT", url : getSydiaControllerUpsertPolicyClaimsUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getSydiaControllerGetCustomerUrl() {
  const res = { method: 'POST', url: `/sydia/customers` as const }
  return res
}

/**
 * @summary Fetch a customer with policyId and claimId
 * {@link /sydia/customers}
 */
export async function sydiaControllerGetCustomer(data: SydiaControllerGetCustomerMutationRequest, config: Partial<RequestConfig<SydiaControllerGetCustomerMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<SydiaControllerGetCustomerMutationResponse, ResponseErrorConfig<Error>, SydiaControllerGetCustomerMutationRequest>({ method : "POST", url : getSydiaControllerGetCustomerUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getSydiaControllerListCustomersUrl() {
  const res = { method: 'POST', url: `/sydia/customers/list` as const }
  return res
}

/**
 * @summary Fetch list of customers
 * {@link /sydia/customers/list}
 */
export async function sydiaControllerListCustomers(data: SydiaControllerListCustomersMutationRequest, config: Partial<RequestConfig<SydiaControllerListCustomersMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<SydiaControllerListCustomersMutationResponse, ResponseErrorConfig<Error>, SydiaControllerListCustomersMutationRequest>({ method : "POST", url : getSydiaControllerListCustomersUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getSydiaControllerListPoliciesUrl() {
  const res = { method: 'POST', url: `/sydia/policy/list` as const }
  return res
}

/**
 * @summary Fetch list of sydia policies
 * {@link /sydia/policy/list}
 */
export async function sydiaControllerListPolicies(data: SydiaControllerListPoliciesMutationRequest, config: Partial<RequestConfig<SydiaControllerListPoliciesMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<SydiaControllerListPoliciesMutationResponse, ResponseErrorConfig<Error>, SydiaControllerListPoliciesMutationRequest>({ method : "POST", url : getSydiaControllerListPoliciesUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getUserControllerGetMyUserWithDrivequantDataUrl() {
  const res = { method: 'GET', url: `/user/@me/drivequant` as const }
  return res
}

/**
 * @summary Retrieve user data with Drivequant unique ID
 * {@link /user/@me/drivequant}
 */
export async function userControllerGetMyUserWithDrivequantData(params?: UserControllerGetMyUserWithDrivequantDataQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<UserControllerGetMyUserWithDrivequantDataQueryResponse, ResponseErrorConfig<UserControllerGetMyUserWithDrivequantData404>, unknown>({ method : "GET", url : getUserControllerGetMyUserWithDrivequantDataUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getWorkflowsControllerStartWorkflowUrl() {
  const res = { method: 'POST', url: `/workflows` as const }
  return res
}

/**
 * @summary Schedule workflow execution
 * {@link /workflows}
 */
export async function workflowsControllerStartWorkflow(data: WorkflowsControllerStartWorkflowMutationRequest, config: Partial<RequestConfig<WorkflowsControllerStartWorkflowMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<WorkflowsControllerStartWorkflowMutationResponse, ResponseErrorConfig<Error>, WorkflowsControllerStartWorkflowMutationRequest>({ method : "POST", url : getWorkflowsControllerStartWorkflowUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getWorkflowsControllerListWorkflowRunsUrl() {
  const res = { method: 'POST', url: `/workflows/list-by-metadata` as const }
  return res
}

/**
 * @summary List workflow runs
 * {@link /workflows/list-by-metadata}
 */
export async function workflowsControllerListWorkflowRuns(data: WorkflowsControllerListWorkflowRunsMutationRequest, config: Partial<RequestConfig<WorkflowsControllerListWorkflowRunsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<WorkflowsControllerListWorkflowRunsMutationResponse, ResponseErrorConfig<Error>, WorkflowsControllerListWorkflowRunsMutationRequest>({ method : "POST", url : getWorkflowsControllerListWorkflowRunsUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getWorkflowsControllerGetWorkflowRunUrl(id: WorkflowsControllerGetWorkflowRunPathParams["id"]) {
  const res = { method: 'GET', url: `/workflows/${id}` as const }
  return res
}

/**
 * @summary Get workflow run
 * {@link /workflows/:id}
 */
export async function workflowsControllerGetWorkflowRun(id: WorkflowsControllerGetWorkflowRunPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<WorkflowsControllerGetWorkflowRunQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getWorkflowsControllerGetWorkflowRunUrl(id).url.toString(), ... requestConfig })
  return res.data
}

function getWorkflowsControllerListWorkflowRunNodesUrl(id: WorkflowsControllerListWorkflowRunNodesPathParams["id"]) {
  const res = { method: 'GET', url: `/workflows/${id}/nodes` as const }
  return res
}

/**
 * @summary List workflow run nodes
 * {@link /workflows/:id/nodes}
 */
export async function workflowsControllerListWorkflowRunNodes(id: WorkflowsControllerListWorkflowRunNodesPathParams["id"], params?: WorkflowsControllerListWorkflowRunNodesQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<WorkflowsControllerListWorkflowRunNodesQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getWorkflowsControllerListWorkflowRunNodesUrl(id).url.toString(), params, ... requestConfig })
  return res.data
}

function getWorkflowsControllerCancelWorkflowRunsUrl() {
  const res = { method: 'POST', url: `/workflows/cancel` as const }
  return res
}

/**
 * @summary Cancel multiple workflow runs
 * {@link /workflows/cancel}
 */
export async function workflowsControllerCancelWorkflowRuns(data: WorkflowsControllerCancelWorkflowRunsMutationRequest, config: Partial<RequestConfig<WorkflowsControllerCancelWorkflowRunsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<WorkflowsControllerCancelWorkflowRunsMutationResponse, ResponseErrorConfig<Error>, WorkflowsControllerCancelWorkflowRunsMutationRequest>({ method : "POST", url : getWorkflowsControllerCancelWorkflowRunsUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getWorkflowsControllerRetryWorkflowRunUrl(id: WorkflowsControllerRetryWorkflowRunPathParams["id"]) {
  const res = { method: 'POST', url: `/workflows/${id}/retry` as const }
  return res
}

/**
 * @summary Retry workflow run
 * {@link /workflows/:id/retry}
 */
export async function workflowsControllerRetryWorkflowRun(id: WorkflowsControllerRetryWorkflowRunPathParams["id"], data: WorkflowsControllerRetryWorkflowRunMutationRequest, config: Partial<RequestConfig<WorkflowsControllerRetryWorkflowRunMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<WorkflowsControllerRetryWorkflowRunMutationResponse, ResponseErrorConfig<Error>, WorkflowsControllerRetryWorkflowRunMutationRequest>({ method : "POST", url : getWorkflowsControllerRetryWorkflowRunUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getYeetControllerListDrivequantAverageScoresUrl(policyId: YeetControllerListDrivequantAverageScoresPathParams["policyId"]) {
  const res = { method: 'GET', url: `/yeet/drivequant-scores/${policyId}/average` as const }
  return res
}

/**
 * @summary List averages scores on the policy
 * {@link /yeet/drivequant-scores/:policyId/average}
 */
export async function yeetControllerListDrivequantAverageScores(policyId: YeetControllerListDrivequantAverageScoresPathParams["policyId"], params?: YeetControllerListDrivequantAverageScoresQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<YeetControllerListDrivequantAverageScoresQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getYeetControllerListDrivequantAverageScoresUrl(policyId).url.toString(), params, ... requestConfig })
  return res.data
}

function getYeetControllerSurchargePolicyUrl(policyId: YeetControllerSurchargePolicyPathParams["policyId"]) {
  const res = { method: 'POST', url: `/yeet/surcharge/${policyId}` as const }
  return res
}

/**
 * @summary Surcharge the policy
 * {@link /yeet/surcharge/:policyId}
 */
export async function yeetControllerSurchargePolicy(policyId: YeetControllerSurchargePolicyPathParams["policyId"], data: YeetControllerSurchargePolicyMutationRequest, params?: YeetControllerSurchargePolicyQueryParams, config: Partial<RequestConfig<YeetControllerSurchargePolicyMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<YeetControllerSurchargePolicyMutationResponse, ResponseErrorConfig<Error>, YeetControllerSurchargePolicyMutationRequest>({ method : "POST", url : getYeetControllerSurchargePolicyUrl(policyId).url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getYeetControllerListPossibleDrivequantUsersUrl(customerId: YeetControllerListPossibleDrivequantUsersPathParams["customerId"]) {
  const res = { method: 'GET', url: `/yeet/${customerId}/possible-drivequant-ids` as const }
  return res
}

/**
 * @summary Get customer possible external service ids
 * {@link /yeet/:customerId/possible-drivequant-ids}
 */
export async function yeetControllerListPossibleDrivequantUsers(customerId: YeetControllerListPossibleDrivequantUsersPathParams["customerId"], params?: YeetControllerListPossibleDrivequantUsersQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<YeetControllerListPossibleDrivequantUsersQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getYeetControllerListPossibleDrivequantUsersUrl(customerId).url.toString(), params, ... requestConfig })
  return res.data
}

function getYeetControllerListDrivequantHistoricalUsersUrl(customerId: YeetControllerListDrivequantHistoricalUsersPathParams["customerId"]) {
  const res = { method: 'GET', url: `/yeet/${customerId}/drivequant-users` as const }
  return res
}

/**
 * @summary List historical Drivequant users attached to the customer
 * {@link /yeet/:customerId/drivequant-users}
 */
export async function yeetControllerListDrivequantHistoricalUsers(customerId: YeetControllerListDrivequantHistoricalUsersPathParams["customerId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<YeetControllerListDrivequantHistoricalUsersQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getYeetControllerListDrivequantHistoricalUsersUrl(customerId).url.toString(), ... requestConfig })
  return res.data
}

function getYeetControllerAttachDrivequantUserIdToCustomerUrl(customerId: YeetControllerAttachDrivequantUserIdToCustomerPathParams["customerId"], drivequantUserId: YeetControllerAttachDrivequantUserIdToCustomerPathParams["drivequantUserId"]) {
  const res = { method: 'POST', url: `/yeet/${customerId}/attach-drivequant-user-id/${drivequantUserId}` as const }
  return res
}

/**
 * @summary Attach Drivequant user id to customer
 * {@link /yeet/:customerId/attach-drivequant-user-id/:drivequantUserId}
 */
export async function yeetControllerAttachDrivequantUserIdToCustomer(customerId: YeetControllerAttachDrivequantUserIdToCustomerPathParams["customerId"], drivequantUserId: YeetControllerAttachDrivequantUserIdToCustomerPathParams["drivequantUserId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<YeetControllerAttachDrivequantUserIdToCustomerMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getYeetControllerAttachDrivequantUserIdToCustomerUrl(customerId, drivequantUserId).url.toString(), ... requestConfig })
  return res.data
}

function getAxeceControllerListDrivequantAverageScoresUrl(policyId: AxeceControllerListDrivequantAverageScoresPathParams["policyId"]) {
  const res = { method: 'GET', url: `/axece/drivequant-scores/${policyId}/average` as const }
  return res
}

/**
 * @summary List averages scores on the policy
 * {@link /axece/drivequant-scores/:policyId/average}
 */
export async function axeceControllerListDrivequantAverageScores(policyId: AxeceControllerListDrivequantAverageScoresPathParams["policyId"], params?: AxeceControllerListDrivequantAverageScoresQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AxeceControllerListDrivequantAverageScoresQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getAxeceControllerListDrivequantAverageScoresUrl(policyId).url.toString(), params, ... requestConfig })
  return res.data
}

function getAxeceControllerSurchargePolicyUrl(policyId: AxeceControllerSurchargePolicyPathParams["policyId"]) {
  const res = { method: 'POST', url: `/axece/surcharge/${policyId}` as const }
  return res
}

/**
 * @summary Surcharge the policy
 * {@link /axece/surcharge/:policyId}
 */
export async function axeceControllerSurchargePolicy(policyId: AxeceControllerSurchargePolicyPathParams["policyId"], data: AxeceControllerSurchargePolicyMutationRequest, params?: AxeceControllerSurchargePolicyQueryParams, config: Partial<RequestConfig<AxeceControllerSurchargePolicyMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<AxeceControllerSurchargePolicyMutationResponse, ResponseErrorConfig<Error>, AxeceControllerSurchargePolicyMutationRequest>({ method : "POST", url : getAxeceControllerSurchargePolicyUrl(policyId).url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getAxeceControllerListPossibleDrivequantUsersUrl(customerId: AxeceControllerListPossibleDrivequantUsersPathParams["customerId"]) {
  const res = { method: 'GET', url: `/axece/${customerId}/possible-drivequant-ids` as const }
  return res
}

/**
 * @summary Get customer possible external service ids
 * {@link /axece/:customerId/possible-drivequant-ids}
 */
export async function axeceControllerListPossibleDrivequantUsers(customerId: AxeceControllerListPossibleDrivequantUsersPathParams["customerId"], params?: AxeceControllerListPossibleDrivequantUsersQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AxeceControllerListPossibleDrivequantUsersQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getAxeceControllerListPossibleDrivequantUsersUrl(customerId).url.toString(), params, ... requestConfig })
  return res.data
}

function getAxeceControllerListDrivequantHistoricalUsersUrl(customerId: AxeceControllerListDrivequantHistoricalUsersPathParams["customerId"]) {
  const res = { method: 'GET', url: `/axece/${customerId}/drivequant-users` as const }
  return res
}

/**
 * @summary List historical Drivequant users attached to the customer
 * {@link /axece/:customerId/drivequant-users}
 */
export async function axeceControllerListDrivequantHistoricalUsers(customerId: AxeceControllerListDrivequantHistoricalUsersPathParams["customerId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AxeceControllerListDrivequantHistoricalUsersQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getAxeceControllerListDrivequantHistoricalUsersUrl(customerId).url.toString(), ... requestConfig })
  return res.data
}

function getAxeceControllerAttachDrivequantUserIdToCustomerUrl(customerId: AxeceControllerAttachDrivequantUserIdToCustomerPathParams["customerId"], drivequantUserId: AxeceControllerAttachDrivequantUserIdToCustomerPathParams["drivequantUserId"]) {
  const res = { method: 'POST', url: `/axece/${customerId}/attach-drivequant-user-id/${drivequantUserId}` as const }
  return res
}

/**
 * @summary Attach Drivequant user id to customer
 * {@link /axece/:customerId/attach-drivequant-user-id/:drivequantUserId}
 */
export async function axeceControllerAttachDrivequantUserIdToCustomer(customerId: AxeceControllerAttachDrivequantUserIdToCustomerPathParams["customerId"], drivequantUserId: AxeceControllerAttachDrivequantUserIdToCustomerPathParams["drivequantUserId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AxeceControllerAttachDrivequantUserIdToCustomerMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getAxeceControllerAttachDrivequantUserIdToCustomerUrl(customerId, drivequantUserId).url.toString(), ... requestConfig })
  return res.data
}

function getYousignControllerWebhookUrl() {
  const res = { method: 'POST', url: `/yousign/webhook` as const }
  return res
}

/**
 * {@link /yousign/webhook}
 */
export async function yousignControllerWebhook(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<YousignControllerWebhookMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getYousignControllerWebhookUrl().url.toString(), ... requestConfig })
  return res.data
}

function getYousignControllerTenantWebhookUrl(tenant: YousignControllerTenantWebhookPathParams["tenant"]) {
  const res = { method: 'POST', url: `/yousign/webhook/${tenant}` as const }
  return res
}

/**
 * {@link /yousign/webhook/:tenant}
 */
export async function yousignControllerTenantWebhook(tenant: YousignControllerTenantWebhookPathParams["tenant"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<YousignControllerTenantWebhookMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getYousignControllerTenantWebhookUrl(tenant).url.toString(), ... requestConfig })
  return res.data
}

function getEmailEngineWebhookControllerWebhookUrl() {
  const res = { method: 'POST', url: `/emailengine/webhook` as const }
  return res
}

/**
 * {@link /emailengine/webhook}
 */
export async function emailEngineWebhookControllerWebhook(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<EmailEngineWebhookControllerWebhookMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getEmailEngineWebhookControllerWebhookUrl().url.toString(), ... requestConfig })
  return res.data
}

function getAr24ControllerRegisteredLetterUrl() {
  const res = { method: 'POST', url: `/ar24/webhook` as const }
  return res
}

/**
 * @summary Receive AR24 webhook for registered letter
 * {@link /ar24/webhook}
 */
export async function ar24ControllerRegisteredLetter(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<Ar24ControllerRegisteredLetterMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getAr24ControllerRegisteredLetterUrl().url.toString(), ... requestConfig })
  return res.data
}

function getAdminAr24ControllerListUsersUrl() {
  const res = { method: 'GET', url: `/ar24/users` as const }
  return res
}

/**
 * @summary List the AR24 accounts registered letters are sent from
 * {@link /ar24/users}
 */
export async function adminAr24ControllerListUsers(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AdminAr24ControllerListUsersQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getAdminAr24ControllerListUsersUrl().url.toString(), ... requestConfig })
  return res.data
}

function getAdminAr24ControllerCreateUserUrl() {
  const res = { method: 'POST', url: `/ar24/users` as const }
  return res
}

/**
 * @summary Create an AR24 account
 * {@link /ar24/users}
 */
export async function adminAr24ControllerCreateUser(data: AdminAr24ControllerCreateUserMutationRequest, config: Partial<RequestConfig<AdminAr24ControllerCreateUserMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<AdminAr24ControllerCreateUserMutationResponse, ResponseErrorConfig<Error>, AdminAr24ControllerCreateUserMutationRequest>({ method : "POST", url : getAdminAr24ControllerCreateUserUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getAdminAr24ControllerRequestUserAccessUrl() {
  const res = { method: 'POST', url: `/ar24/users/request-access` as const }
  return res
}

/**
 * @summary Invite an existing AR24 account to attach itself to our API account
 * {@link /ar24/users/request-access}
 */
export async function adminAr24ControllerRequestUserAccess(data: AdminAr24ControllerRequestUserAccessMutationRequest, config: Partial<RequestConfig<AdminAr24ControllerRequestUserAccessMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<AdminAr24ControllerRequestUserAccessMutationResponse, ResponseErrorConfig<Error>, AdminAr24ControllerRequestUserAccessMutationRequest>({ method : "POST", url : getAdminAr24ControllerRequestUserAccessUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getAdminAr24ControllerGetUserUrl(userId: AdminAr24ControllerGetUserPathParams["userId"]) {
  const res = { method: 'GET', url: `/ar24/users/${userId}` as const }
  return res
}

/**
 * @summary Get one AR24 account
 * {@link /ar24/users/:userId}
 */
export async function adminAr24ControllerGetUser(userId: AdminAr24ControllerGetUserPathParams["userId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AdminAr24ControllerGetUserQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getAdminAr24ControllerGetUserUrl(userId).url.toString(), ... requestConfig })
  return res.data
}

function getAdminAr24ControllerUpdateUserUrl(userId: AdminAr24ControllerUpdateUserPathParams["userId"]) {
  const res = { method: 'PATCH', url: `/ar24/users/${userId}` as const }
  return res
}

/**
 * @summary Update an AR24 account
 * {@link /ar24/users/:userId}
 */
export async function adminAr24ControllerUpdateUser(userId: AdminAr24ControllerUpdateUserPathParams["userId"], data: AdminAr24ControllerUpdateUserMutationRequest, config: Partial<RequestConfig<AdminAr24ControllerUpdateUserMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<AdminAr24ControllerUpdateUserMutationResponse, ResponseErrorConfig<Error>, AdminAr24ControllerUpdateUserMutationRequest>({ method : "PATCH", url : getAdminAr24ControllerUpdateUserUrl(userId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getAdminAr24ControllerRequestUserEulaUrl(userId: AdminAr24ControllerRequestUserEulaPathParams["userId"]) {
  const res = { method: 'POST', url: `/ar24/users/${userId}/request-eula` as const }
  return res
}

/**
 * @summary Ask an AR24 account to accept the EULA
 * {@link /ar24/users/:userId/request-eula}
 */
export async function adminAr24ControllerRequestUserEula(userId: AdminAr24ControllerRequestUserEulaPathParams["userId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AdminAr24ControllerRequestUserEulaMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getAdminAr24ControllerRequestUserEulaUrl(userId).url.toString(), ... requestConfig })
  return res.data
}

function getAdminAr24ControllerResendUserConfirmationUrl(userId: AdminAr24ControllerResendUserConfirmationPathParams["userId"]) {
  const res = { method: 'POST', url: `/ar24/users/${userId}/resend-confirmation` as const }
  return res
}

/**
 * @summary Resend the address-confirmation email to an AR24 account
 * {@link /ar24/users/:userId/resend-confirmation}
 */
export async function adminAr24ControllerResendUserConfirmation(userId: AdminAr24ControllerResendUserConfirmationPathParams["userId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AdminAr24ControllerResendUserConfirmationMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getAdminAr24ControllerResendUserConfirmationUrl(userId).url.toString(), ... requestConfig })
  return res.data
}

function getSesControllerSesEventUrl() {
  const res = { method: 'POST', url: `/ses/webhook` as const }
  return res
}

/**
 * @summary Receive SES delivery, bounce and complaint events via SNS
 * {@link /ses/webhook}
 */
export async function sesControllerSesEvent(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SesControllerSesEventMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getSesControllerSesEventUrl().url.toString(), ... requestConfig })
  return res.data
}

function getViewSpecificControllerAccountingSummaryUrl() {
  const res = { method: 'GET', url: `/view-specific/accounting-summary` as const }
  return res
}

/**
 * @summary Accounting summary
 * {@link /view-specific/accounting-summary}
 */
export async function viewSpecificControllerAccountingSummary(params?: ViewSpecificControllerAccountingSummaryQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ViewSpecificControllerAccountingSummaryQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getViewSpecificControllerAccountingSummaryUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getViewSpecificControllerListComplianceChecksOnPolicyUrl(policyId: ViewSpecificControllerListComplianceChecksOnPolicyPathParams["policyId"]) {
  const res = { method: 'GET', url: `/view-specific/compliance/${policyId}/checks` as const }
  return res
}

/**
 * @summary List compliance checks on policy
 * {@link /view-specific/compliance/:policyId/checks}
 */
export async function viewSpecificControllerListComplianceChecksOnPolicy(policyId: ViewSpecificControllerListComplianceChecksOnPolicyPathParams["policyId"], params?: ViewSpecificControllerListComplianceChecksOnPolicyQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ViewSpecificControllerListComplianceChecksOnPolicyQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getViewSpecificControllerListComplianceChecksOnPolicyUrl(policyId).url.toString(), params, ... requestConfig })
  return res.data
}

function getViewSpecificControllerAcknowledgeComplianceAlertUrl(alertId: ViewSpecificControllerAcknowledgeComplianceAlertPathParams["alertId"]) {
  const res = { method: 'PATCH', url: `/view-specific/compliance/${alertId}/acknowledge` as const }
  return res
}

/**
 * @summary Acknowledge compliance alert
 * {@link /view-specific/compliance/:alertId/acknowledge}
 */
export async function viewSpecificControllerAcknowledgeComplianceAlert(alertId: ViewSpecificControllerAcknowledgeComplianceAlertPathParams["alertId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ViewSpecificControllerAcknowledgeComplianceAlertMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "PATCH", url : getViewSpecificControllerAcknowledgeComplianceAlertUrl(alertId).url.toString(), ... requestConfig })
  return res.data
}

function getViewSpecificControllerListPolicyComplianceAlertsUrl(policyId: ViewSpecificControllerListPolicyComplianceAlertsPathParams["policyId"]) {
  const res = { method: 'GET', url: `/view-specific/compliance/${policyId}/alerts` as const }
  return res
}

/**
 * @summary List compliance alerts on policy
 * {@link /view-specific/compliance/:policyId/alerts}
 */
export async function viewSpecificControllerListPolicyComplianceAlerts(policyId: ViewSpecificControllerListPolicyComplianceAlertsPathParams["policyId"], params?: ViewSpecificControllerListPolicyComplianceAlertsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ViewSpecificControllerListPolicyComplianceAlertsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getViewSpecificControllerListPolicyComplianceAlertsUrl(policyId).url.toString(), params, ... requestConfig })
  return res.data
}

function getViewSpecificControllerListChildBrokerageFirmsUrl(brokerageFirmId: ViewSpecificControllerListChildBrokerageFirmsPathParams["brokerageFirmId"]) {
  const res = { method: 'GET', url: `/view-specific/${brokerageFirmId}/child-brokerage-firms` as const }
  return res
}

/**
 * @summary List child brokerage firms
 * {@link /view-specific/:brokerageFirmId/child-brokerage-firms}
 */
export async function viewSpecificControllerListChildBrokerageFirms(brokerageFirmId: ViewSpecificControllerListChildBrokerageFirmsPathParams["brokerageFirmId"], params?: ViewSpecificControllerListChildBrokerageFirmsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ViewSpecificControllerListChildBrokerageFirmsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getViewSpecificControllerListChildBrokerageFirmsUrl(brokerageFirmId).url.toString(), params, ... requestConfig })
  return res.data
}

function getViewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsUrl(brokerageFirmId: ViewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsPathParams["brokerageFirmId"]) {
  const res = { method: 'GET', url: `/view-specific/${brokerageFirmId}/wholesale-distribution-requests` as const }
  return res
}

/**
 * @summary List distribution requested to the brokerage firm given in the path
 * {@link /view-specific/:brokerageFirmId/wholesale-distribution-requests}
 */
export async function viewSpecificControllerListWholesaleBrokerageFirmDistributionRequests(brokerageFirmId: ViewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsPathParams["brokerageFirmId"], params?: ViewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ViewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getViewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsUrl(brokerageFirmId).url.toString(), params, ... requestConfig })
  return res.data
}

function getViewSpecificControllerListBrokerageFirmDistributionRequestsUrl(brokerageFirmId: ViewSpecificControllerListBrokerageFirmDistributionRequestsPathParams["brokerageFirmId"]) {
  const res = { method: 'POST', url: `/view-specific/${brokerageFirmId}/distribution-requests` as const }
  return res
}

/**
 * @summary List distribution requested by the brokerage firm given in the path
 * {@link /view-specific/:brokerageFirmId/distribution-requests}
 */
export async function viewSpecificControllerListBrokerageFirmDistributionRequests(brokerageFirmId: ViewSpecificControllerListBrokerageFirmDistributionRequestsPathParams["brokerageFirmId"], params?: ViewSpecificControllerListBrokerageFirmDistributionRequestsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ViewSpecificControllerListBrokerageFirmDistributionRequestsMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getViewSpecificControllerListBrokerageFirmDistributionRequestsUrl(brokerageFirmId).url.toString(), params, ... requestConfig })
  return res.data
}

function getViewSpecificControllerListPolicyAssetsUrl(policyId: ViewSpecificControllerListPolicyAssetsPathParams["policyId"]) {
  const res = { method: 'GET', url: `/view-specific/${policyId}/assets` as const }
  return res
}

/**
 * @summary List Assets On Policy
 * {@link /view-specific/:policyId/assets}
 */
export async function viewSpecificControllerListPolicyAssets(policyId: ViewSpecificControllerListPolicyAssetsPathParams["policyId"], params?: ViewSpecificControllerListPolicyAssetsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ViewSpecificControllerListPolicyAssetsQueryResponse, ResponseErrorConfig<ViewSpecificControllerListPolicyAssets403 | ViewSpecificControllerListPolicyAssets404>, unknown>({ method : "GET", url : getViewSpecificControllerListPolicyAssetsUrl(policyId).url.toString(), params, ... requestConfig })
  return res.data
}

function getViewSpecificControllerGetAvailablePricingUrl(policyId: ViewSpecificControllerGetAvailablePricingPathParams["policyId"]) {
  const res = { method: 'GET', url: `/view-specific/${policyId}/available-pricing` as const }
  return res
}

/**
 * @summary Get available pricing tiers for policy
 * {@link /view-specific/:policyId/available-pricing}
 */
export async function viewSpecificControllerGetAvailablePricing(policyId: ViewSpecificControllerGetAvailablePricingPathParams["policyId"], params?: ViewSpecificControllerGetAvailablePricingQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ViewSpecificControllerGetAvailablePricingQueryResponse, ResponseErrorConfig<ViewSpecificControllerGetAvailablePricing400 | ViewSpecificControllerGetAvailablePricing404>, unknown>({ method : "GET", url : getViewSpecificControllerGetAvailablePricingUrl(policyId).url.toString(), params, ... requestConfig })
  return res.data
}

function getViewSpecificControllerListPolicyCustomersUrl(policyId: ViewSpecificControllerListPolicyCustomersPathParams["policyId"]) {
  const res = { method: 'GET', url: `/view-specific/${policyId}/customers` as const }
  return res
}

/**
 * @summary List Customers On Policy
 * {@link /view-specific/:policyId/customers}
 */
export async function viewSpecificControllerListPolicyCustomers(policyId: ViewSpecificControllerListPolicyCustomersPathParams["policyId"], params?: ViewSpecificControllerListPolicyCustomersQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ViewSpecificControllerListPolicyCustomersQueryResponse, ResponseErrorConfig<ViewSpecificControllerListPolicyCustomers403 | ViewSpecificControllerListPolicyCustomers404>, unknown>({ method : "GET", url : getViewSpecificControllerListPolicyCustomersUrl(policyId).url.toString(), params, ... requestConfig })
  return res.data
}

function getViewSpecificControllerListCustomerInvoicesUrl(customerId: ViewSpecificControllerListCustomerInvoicesPathParams["customerId"]) {
  const res = { method: 'GET', url: `/view-specific/${customerId}/invoices` as const }
  return res
}

/**
 * @summary List invoices on customer
 * {@link /view-specific/:customerId/invoices}
 */
export async function viewSpecificControllerListCustomerInvoices(customerId: ViewSpecificControllerListCustomerInvoicesPathParams["customerId"], params?: ViewSpecificControllerListCustomerInvoicesQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ViewSpecificControllerListCustomerInvoicesQueryResponse, ResponseErrorConfig<ViewSpecificControllerListCustomerInvoices404>, unknown>({ method : "GET", url : getViewSpecificControllerListCustomerInvoicesUrl(customerId).url.toString(), params, ... requestConfig })
  return res.data
}

function getViewSpecificControllerListCustomerPaymentsUrl(customerId: ViewSpecificControllerListCustomerPaymentsPathParams["customerId"]) {
  const res = { method: 'GET', url: `/view-specific/${customerId}/payments` as const }
  return res
}

/**
 * @summary List Customer Payments
 * {@link /view-specific/:customerId/payments}
 */
export async function viewSpecificControllerListCustomerPayments(customerId: ViewSpecificControllerListCustomerPaymentsPathParams["customerId"], params?: ViewSpecificControllerListCustomerPaymentsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ViewSpecificControllerListCustomerPaymentsQueryResponse, ResponseErrorConfig<ViewSpecificControllerListCustomerPayments404>, unknown>({ method : "GET", url : getViewSpecificControllerListCustomerPaymentsUrl(customerId).url.toString(), params, ... requestConfig })
  return res.data
}

function getViewSpecificControllerListCustomerPaymentMethodsUrl(customerId: ViewSpecificControllerListCustomerPaymentMethodsPathParams["customerId"]) {
  const res = { method: 'GET', url: `/view-specific/${customerId}/payment-methods` as const }
  return res
}

/**
 * @summary List customer payment methods with documents
 * {@link /view-specific/:customerId/payment-methods}
 */
export async function viewSpecificControllerListCustomerPaymentMethods(customerId: ViewSpecificControllerListCustomerPaymentMethodsPathParams["customerId"], params?: ViewSpecificControllerListCustomerPaymentMethodsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ViewSpecificControllerListCustomerPaymentMethodsQueryResponse, ResponseErrorConfig<ViewSpecificControllerListCustomerPaymentMethods404>, unknown>({ method : "GET", url : getViewSpecificControllerListCustomerPaymentMethodsUrl(customerId).url.toString(), params, ... requestConfig })
  return res.data
}

function getViewSpecificControllerListBrokerageFirmPaymentMethodsUrl(brokerageFirmId: ViewSpecificControllerListBrokerageFirmPaymentMethodsPathParams["brokerageFirmId"]) {
  const res = { method: 'GET', url: `/view-specific/brokerage-firms/${brokerageFirmId}/payment-methods` as const }
  return res
}

/**
 * @summary List brokerage firm payment methods with documents
 * {@link /view-specific/brokerage-firms/:brokerageFirmId/payment-methods}
 */
export async function viewSpecificControllerListBrokerageFirmPaymentMethods(brokerageFirmId: ViewSpecificControllerListBrokerageFirmPaymentMethodsPathParams["brokerageFirmId"], params?: ViewSpecificControllerListBrokerageFirmPaymentMethodsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ViewSpecificControllerListBrokerageFirmPaymentMethodsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getViewSpecificControllerListBrokerageFirmPaymentMethodsUrl(brokerageFirmId).url.toString(), params, ... requestConfig })
  return res.data
}

function getViewSpecificControllerListBrokerageFirmPoliciesUrl(brokerageFirmId: ViewSpecificControllerListBrokerageFirmPoliciesPathParams["brokerageFirmId"]) {
  const res = { method: 'POST', url: `/view-specific/${brokerageFirmId}/policies` as const }
  return res
}

/**
 * @description `LIST_LIVE_POLICIES_FROM_BROKERAGE_FIRM` lists `viewType: live` only; `newBusiness`, `archivedNewBusiness` and `derogation` need `LIST_ALL_POLICIES_FROM_BROKERAGE_FIRM` (403 otherwise).
 * @summary List brokerage firm policies
 * {@link /view-specific/:brokerageFirmId/policies}
 */
export async function viewSpecificControllerListBrokerageFirmPolicies(brokerageFirmId: ViewSpecificControllerListBrokerageFirmPoliciesPathParams["brokerageFirmId"], data: ViewSpecificControllerListBrokerageFirmPoliciesMutationRequest, config: Partial<RequestConfig<ViewSpecificControllerListBrokerageFirmPoliciesMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ViewSpecificControllerListBrokerageFirmPoliciesMutationResponse, ResponseErrorConfig<Error>, ViewSpecificControllerListBrokerageFirmPoliciesMutationRequest>({ method : "POST", url : getViewSpecificControllerListBrokerageFirmPoliciesUrl(brokerageFirmId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getViewSpecificControllerGetAccountingSummaryForBrokerageFirmUrl(brokerageFirmId: ViewSpecificControllerGetAccountingSummaryForBrokerageFirmPathParams["brokerageFirmId"]) {
  const res = { method: 'GET', url: `/view-specific/${brokerageFirmId}/accounting-summary` as const }
  return res
}

/**
 * @summary Accounting summary for a brokerage firm
 * {@link /view-specific/:brokerageFirmId/accounting-summary}
 */
export async function viewSpecificControllerGetAccountingSummaryForBrokerageFirm(brokerageFirmId: ViewSpecificControllerGetAccountingSummaryForBrokerageFirmPathParams["brokerageFirmId"], params?: ViewSpecificControllerGetAccountingSummaryForBrokerageFirmQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ViewSpecificControllerGetAccountingSummaryForBrokerageFirmQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getViewSpecificControllerGetAccountingSummaryForBrokerageFirmUrl(brokerageFirmId).url.toString(), params, ... requestConfig })
  return res.data
}

function getViewSpecificControllerListCustomerRelationsUrl(customerId: ViewSpecificControllerListCustomerRelationsPathParams["customerId"]) {
  const res = { method: 'GET', url: `/view-specific/${customerId}/relations` as const }
  return res
}

/**
 * @summary List customer relations
 * {@link /view-specific/:customerId/relations}
 */
export async function viewSpecificControllerListCustomerRelations(customerId: ViewSpecificControllerListCustomerRelationsPathParams["customerId"], params?: ViewSpecificControllerListCustomerRelationsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ViewSpecificControllerListCustomerRelationsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getViewSpecificControllerListCustomerRelationsUrl(customerId).url.toString(), params, ... requestConfig })
  return res.data
}

function getViewSpecificControllerListBrokerageFirmDerogationsUrl(brokerageFirmId: ViewSpecificControllerListBrokerageFirmDerogationsPathParams["brokerageFirmId"]) {
  const res = { method: 'POST', url: `/view-specific/${brokerageFirmId}/derogations` as const }
  return res
}

/**
 * @summary List brokerage firm derogations
 * {@link /view-specific/:brokerageFirmId/derogations}
 */
export async function viewSpecificControllerListBrokerageFirmDerogations(brokerageFirmId: ViewSpecificControllerListBrokerageFirmDerogationsPathParams["brokerageFirmId"], data: ViewSpecificControllerListBrokerageFirmDerogationsMutationRequest, params?: ViewSpecificControllerListBrokerageFirmDerogationsQueryParams, config: Partial<RequestConfig<ViewSpecificControllerListBrokerageFirmDerogationsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ViewSpecificControllerListBrokerageFirmDerogationsMutationResponse, ResponseErrorConfig<Error>, ViewSpecificControllerListBrokerageFirmDerogationsMutationRequest>({ method : "POST", url : getViewSpecificControllerListBrokerageFirmDerogationsUrl(brokerageFirmId).url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getViewSpecificControllerListProductCommonDocumentsUrl(productId: ViewSpecificControllerListProductCommonDocumentsPathParams["productId"]) {
  const res = { method: 'GET', url: `/view-specific/${productId}/common-documents` as const }
  return res
}

/**
 * @summary List product general documents
 * {@link /view-specific/:productId/common-documents}
 */
export async function viewSpecificControllerListProductCommonDocuments(productId: ViewSpecificControllerListProductCommonDocumentsPathParams["productId"], params?: ViewSpecificControllerListProductCommonDocumentsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ViewSpecificControllerListProductCommonDocumentsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getViewSpecificControllerListProductCommonDocumentsUrl(productId).url.toString(), params, ... requestConfig })
  return res.data
}

function getViewSpecificControllerCreateActiveTeamUrl(brokerageFirmId: ViewSpecificControllerCreateActiveTeamPathParams["brokerageFirmId"]) {
  const res = { method: 'POST', url: `/view-specific/${brokerageFirmId}/create-active-team` as const }
  return res
}

/**
 * @summary Create a new active team (brokerage firm with approved distribution requests)
 * {@link /view-specific/:brokerageFirmId/create-active-team}
 */
export async function viewSpecificControllerCreateActiveTeam(brokerageFirmId: ViewSpecificControllerCreateActiveTeamPathParams["brokerageFirmId"], data: ViewSpecificControllerCreateActiveTeamMutationRequest, config: Partial<RequestConfig<ViewSpecificControllerCreateActiveTeamMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ViewSpecificControllerCreateActiveTeamMutationResponse, ResponseErrorConfig<Error>, ViewSpecificControllerCreateActiveTeamMutationRequest>({ method : "POST", url : getViewSpecificControllerCreateActiveTeamUrl(brokerageFirmId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getBillingReadsControllerGetAccountingSummaryUrl() {
  const res = { method: 'GET', url: `/accounting-summary` as const }
  return res
}

/**
 * @summary Get the accounting summary
 * {@link /accounting-summary}
 */
export async function billingReadsControllerGetAccountingSummary(params?: BillingReadsControllerGetAccountingSummaryQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<BillingReadsControllerGetAccountingSummaryQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getBillingReadsControllerGetAccountingSummaryUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getBillingReadsControllerGetBrokerageFirmAccountingSummaryUrl(brokerageFirmId: BillingReadsControllerGetBrokerageFirmAccountingSummaryPathParams["brokerageFirmId"]) {
  const res = { method: 'GET', url: `/brokerage-firms/${brokerageFirmId}/accounting-summary` as const }
  return res
}

/**
 * @summary Get a brokerage firm's accounting summary
 * {@link /brokerage-firms/:brokerageFirmId/accounting-summary}
 */
export async function billingReadsControllerGetBrokerageFirmAccountingSummary(brokerageFirmId: BillingReadsControllerGetBrokerageFirmAccountingSummaryPathParams["brokerageFirmId"], params?: BillingReadsControllerGetBrokerageFirmAccountingSummaryQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<BillingReadsControllerGetBrokerageFirmAccountingSummaryQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getBillingReadsControllerGetBrokerageFirmAccountingSummaryUrl(brokerageFirmId).url.toString(), params, ... requestConfig })
  return res.data
}

function getBillingReadsControllerListCustomerInvoicesUrl(customerId: BillingReadsControllerListCustomerInvoicesPathParams["customerId"]) {
  const res = { method: 'GET', url: `/customers/${customerId}/invoices` as const }
  return res
}

/**
 * @summary List a customer's invoices
 * {@link /customers/:customerId/invoices}
 */
export async function billingReadsControllerListCustomerInvoices(customerId: BillingReadsControllerListCustomerInvoicesPathParams["customerId"], params?: BillingReadsControllerListCustomerInvoicesQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<BillingReadsControllerListCustomerInvoicesQueryResponse, ResponseErrorConfig<BillingReadsControllerListCustomerInvoices404>, unknown>({ method : "GET", url : getBillingReadsControllerListCustomerInvoicesUrl(customerId).url.toString(), params, ... requestConfig })
  return res.data
}

function getPaymentsReadsControllerListCustomerPaymentsUrl(customerId: PaymentsReadsControllerListCustomerPaymentsPathParams["customerId"]) {
  const res = { method: 'GET', url: `/customers/${customerId}/payments` as const }
  return res
}

/**
 * @summary List a customer's payments
 * {@link /customers/:customerId/payments}
 */
export async function paymentsReadsControllerListCustomerPayments(customerId: PaymentsReadsControllerListCustomerPaymentsPathParams["customerId"], params?: PaymentsReadsControllerListCustomerPaymentsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PaymentsReadsControllerListCustomerPaymentsQueryResponse, ResponseErrorConfig<PaymentsReadsControllerListCustomerPayments404>, unknown>({ method : "GET", url : getPaymentsReadsControllerListCustomerPaymentsUrl(customerId).url.toString(), params, ... requestConfig })
  return res.data
}

function getPaymentsReadsControllerListCustomerPaymentMethodsWithDocumentsUrl(customerId: PaymentsReadsControllerListCustomerPaymentMethodsWithDocumentsPathParams["customerId"]) {
  const res = { method: 'GET', url: `/customers/${customerId}/payment-methods/with-documents` as const }
  return res
}

/**
 * @description Same payment methods as `GET /customers/{customerId}/payment-methods`, each with the documents attached to it.
 * @summary List a customer's payment methods with their documents
 * {@link /customers/:customerId/payment-methods/with-documents}
 */
export async function paymentsReadsControllerListCustomerPaymentMethodsWithDocuments(customerId: PaymentsReadsControllerListCustomerPaymentMethodsWithDocumentsPathParams["customerId"], params?: PaymentsReadsControllerListCustomerPaymentMethodsWithDocumentsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PaymentsReadsControllerListCustomerPaymentMethodsWithDocumentsQueryResponse, ResponseErrorConfig<PaymentsReadsControllerListCustomerPaymentMethodsWithDocuments404>, unknown>({ method : "GET", url : getPaymentsReadsControllerListCustomerPaymentMethodsWithDocumentsUrl(customerId).url.toString(), params, ... requestConfig })
  return res.data
}

function getPaymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocumentsUrl(brokerageFirmId: PaymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocumentsPathParams["brokerageFirmId"]) {
  const res = { method: 'GET', url: `/brokerage-firms/${brokerageFirmId}/payment-methods/with-documents` as const }
  return res
}

/**
 * @description Same payment methods as `GET /brokerage-firms/{brokerageFirmId}/payment-methods`, each with the documents attached to it.
 * @summary List a brokerage firm's payment methods with their documents
 * {@link /brokerage-firms/:brokerageFirmId/payment-methods/with-documents}
 */
export async function paymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocuments(brokerageFirmId: PaymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocumentsPathParams["brokerageFirmId"], params?: PaymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocumentsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PaymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocumentsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getPaymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocumentsUrl(brokerageFirmId).url.toString(), params, ... requestConfig })
  return res.data
}

function getCustomerReadsControllerListCustomerRelationsUrl(customerId: CustomerReadsControllerListCustomerRelationsPathParams["customerId"]) {
  const res = { method: 'GET', url: `/customers/${customerId}/relations` as const }
  return res
}

/**
 * @summary List a customer's relations
 * {@link /customers/:customerId/relations}
 */
export async function customerReadsControllerListCustomerRelations(customerId: CustomerReadsControllerListCustomerRelationsPathParams["customerId"], params?: CustomerReadsControllerListCustomerRelationsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<CustomerReadsControllerListCustomerRelationsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getCustomerReadsControllerListCustomerRelationsUrl(customerId).url.toString(), params, ... requestConfig })
  return res.data
}

function getCustomerReadsControllerListPolicyCustomersUrl(policyId: CustomerReadsControllerListPolicyCustomersPathParams["policyId"]) {
  const res = { method: 'GET', url: `/policies/${policyId}/customers` as const }
  return res
}

/**
 * @description Lists everyone on the contract with their role — use it to find the payer whose payment method gates a signature request.
 * @summary List a policy's customers
 * {@link /policies/:policyId/customers}
 */
export async function customerReadsControllerListPolicyCustomers(policyId: CustomerReadsControllerListPolicyCustomersPathParams["policyId"], params?: CustomerReadsControllerListPolicyCustomersQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<CustomerReadsControllerListPolicyCustomersQueryResponse, ResponseErrorConfig<CustomerReadsControllerListPolicyCustomers403 | CustomerReadsControllerListPolicyCustomers404>, unknown>({ method : "GET", url : getCustomerReadsControllerListPolicyCustomersUrl(policyId).url.toString(), params, ... requestConfig })
  return res.data
}

function getAssetReadsControllerListPolicyAssetsUrl(policyId: AssetReadsControllerListPolicyAssetsPathParams["policyId"]) {
  const res = { method: 'GET', url: `/policies/${policyId}/assets` as const }
  return res
}

/**
 * @description Branch-scoped: pass the branch the assets were created on, or the result comes back empty as though they never existed.
 * @summary List a policy's assets
 * {@link /policies/:policyId/assets}
 */
export async function assetReadsControllerListPolicyAssets(policyId: AssetReadsControllerListPolicyAssetsPathParams["policyId"], params?: AssetReadsControllerListPolicyAssetsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AssetReadsControllerListPolicyAssetsQueryResponse, ResponseErrorConfig<AssetReadsControllerListPolicyAssets403 | AssetReadsControllerListPolicyAssets404>, unknown>({ method : "GET", url : getAssetReadsControllerListPolicyAssetsUrl(policyId).url.toString(), params, ... requestConfig })
  return res.data
}

function getPricingReadsControllerGetAvailablePricingUrl(policyId: PricingReadsControllerGetAvailablePricingPathParams["policyId"]) {
  const res = { method: 'GET', url: `/policies/${policyId}/available-pricing` as const }
  return res
}

/**
 * @summary Get the pricing tiers available for a policy
 * {@link /policies/:policyId/available-pricing}
 */
export async function pricingReadsControllerGetAvailablePricing(policyId: PricingReadsControllerGetAvailablePricingPathParams["policyId"], params?: PricingReadsControllerGetAvailablePricingQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PricingReadsControllerGetAvailablePricingQueryResponse, ResponseErrorConfig<PricingReadsControllerGetAvailablePricing400 | PricingReadsControllerGetAvailablePricing404>, unknown>({ method : "GET", url : getPricingReadsControllerGetAvailablePricingUrl(policyId).url.toString(), params, ... requestConfig })
  return res.data
}

function getDerogationsReadsControllerSearchBrokerageFirmDerogationsUrl(brokerageFirmId: DerogationsReadsControllerSearchBrokerageFirmDerogationsPathParams["brokerageFirmId"]) {
  const res = { method: 'POST', url: `/brokerage-firms/${brokerageFirmId}/derogations/search` as const }
  return res
}

/**
 * @description Filters are sent in the request body, which is why this is a POST.
 * @summary Search a brokerage firm's derogations
 * {@link /brokerage-firms/:brokerageFirmId/derogations/search}
 */
export async function derogationsReadsControllerSearchBrokerageFirmDerogations(brokerageFirmId: DerogationsReadsControllerSearchBrokerageFirmDerogationsPathParams["brokerageFirmId"], data: DerogationsReadsControllerSearchBrokerageFirmDerogationsMutationRequest, params?: DerogationsReadsControllerSearchBrokerageFirmDerogationsQueryParams, config: Partial<RequestConfig<DerogationsReadsControllerSearchBrokerageFirmDerogationsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<DerogationsReadsControllerSearchBrokerageFirmDerogationsMutationResponse, ResponseErrorConfig<Error>, DerogationsReadsControllerSearchBrokerageFirmDerogationsMutationRequest>({ method : "POST", url : getDerogationsReadsControllerSearchBrokerageFirmDerogationsUrl(brokerageFirmId).url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getComplianceReadsControllerListPolicyComplianceAlertsUrl(policyId: ComplianceReadsControllerListPolicyComplianceAlertsPathParams["policyId"]) {
  const res = { method: 'GET', url: `/policies/${policyId}/compliance/alerts` as const }
  return res
}

/**
 * @summary List a policy's compliance alerts
 * {@link /policies/:policyId/compliance/alerts}
 */
export async function complianceReadsControllerListPolicyComplianceAlerts(policyId: ComplianceReadsControllerListPolicyComplianceAlertsPathParams["policyId"], params?: ComplianceReadsControllerListPolicyComplianceAlertsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ComplianceReadsControllerListPolicyComplianceAlertsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getComplianceReadsControllerListPolicyComplianceAlertsUrl(policyId).url.toString(), params, ... requestConfig })
  return res.data
}

function getComplianceReadsControllerListPolicyComplianceChecksUrl(policyId: ComplianceReadsControllerListPolicyComplianceChecksPathParams["policyId"]) {
  const res = { method: 'GET', url: `/policies/${policyId}/compliance/checks` as const }
  return res
}

/**
 * @summary List a policy's compliance checks
 * {@link /policies/:policyId/compliance/checks}
 */
export async function complianceReadsControllerListPolicyComplianceChecks(policyId: ComplianceReadsControllerListPolicyComplianceChecksPathParams["policyId"], params?: ComplianceReadsControllerListPolicyComplianceChecksQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ComplianceReadsControllerListPolicyComplianceChecksQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getComplianceReadsControllerListPolicyComplianceChecksUrl(policyId).url.toString(), params, ... requestConfig })
  return res.data
}

function getComplianceReadsControllerAcknowledgeComplianceAlertUrl(alertId: ComplianceReadsControllerAcknowledgeComplianceAlertPathParams["alertId"]) {
  const res = { method: 'PATCH', url: `/compliance/alerts/${alertId}/acknowledge` as const }
  return res
}

/**
 * @summary Acknowledge a compliance alert
 * {@link /compliance/alerts/:alertId/acknowledge}
 */
export async function complianceReadsControllerAcknowledgeComplianceAlert(alertId: ComplianceReadsControllerAcknowledgeComplianceAlertPathParams["alertId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ComplianceReadsControllerAcknowledgeComplianceAlertMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "PATCH", url : getComplianceReadsControllerAcknowledgeComplianceAlertUrl(alertId).url.toString(), ... requestConfig })
  return res.data
}

function getBrokerageFirmsReadsControllerListChildBrokerageFirmsUrl(brokerageFirmId: BrokerageFirmsReadsControllerListChildBrokerageFirmsPathParams["brokerageFirmId"]) {
  const res = { method: 'GET', url: `/brokerage-firms/${brokerageFirmId}/children` as const }
  return res
}

/**
 * @summary List a brokerage firm's children
 * {@link /brokerage-firms/:brokerageFirmId/children}
 */
export async function brokerageFirmsReadsControllerListChildBrokerageFirms(brokerageFirmId: BrokerageFirmsReadsControllerListChildBrokerageFirmsPathParams["brokerageFirmId"], params?: BrokerageFirmsReadsControllerListChildBrokerageFirmsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<BrokerageFirmsReadsControllerListChildBrokerageFirmsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getBrokerageFirmsReadsControllerListChildBrokerageFirmsUrl(brokerageFirmId).url.toString(), params, ... requestConfig })
  return res.data
}

function getBrokerageFirmsReadsControllerCreateActiveTeamUrl(brokerageFirmId: BrokerageFirmsReadsControllerCreateActiveTeamPathParams["brokerageFirmId"]) {
  const res = { method: 'POST', url: `/brokerage-firms/${brokerageFirmId}/active-teams` as const }
  return res
}

/**
 * @description Creates a brokerage firm together with approved distribution requests.
 * @summary Create an active team
 * {@link /brokerage-firms/:brokerageFirmId/active-teams}
 */
export async function brokerageFirmsReadsControllerCreateActiveTeam(brokerageFirmId: BrokerageFirmsReadsControllerCreateActiveTeamPathParams["brokerageFirmId"], data: BrokerageFirmsReadsControllerCreateActiveTeamMutationRequest, config: Partial<RequestConfig<BrokerageFirmsReadsControllerCreateActiveTeamMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<BrokerageFirmsReadsControllerCreateActiveTeamMutationResponse, ResponseErrorConfig<Error>, BrokerageFirmsReadsControllerCreateActiveTeamMutationRequest>({ method : "POST", url : getBrokerageFirmsReadsControllerCreateActiveTeamUrl(brokerageFirmId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getPolicyReadsControllerSearchBrokerageFirmPoliciesUrl(brokerageFirmId: PolicyReadsControllerSearchBrokerageFirmPoliciesPathParams["brokerageFirmId"]) {
  const res = { method: 'POST', url: `/brokerage-firms/${brokerageFirmId}/policies/search` as const }
  return res
}

/**
 * @description Filters go in the body, which is why this is a POST. `viewType: live` means issued rather than currently in force — it includes stopped contracts, so read each row's status before offering an action that needs a running one. `pageInfo` takes `{ count, page }`. `LIST_LIVE_POLICIES_FROM_BROKERAGE_FIRM` lists `viewType: live` only; `newBusiness`, `archivedNewBusiness` and `derogation` need `LIST_ALL_POLICIES_FROM_BROKERAGE_FIRM` (403 otherwise).
 * @summary Search a brokerage firm's policies
 * {@link /brokerage-firms/:brokerageFirmId/policies/search}
 */
export async function policyReadsControllerSearchBrokerageFirmPolicies(brokerageFirmId: PolicyReadsControllerSearchBrokerageFirmPoliciesPathParams["brokerageFirmId"], data: PolicyReadsControllerSearchBrokerageFirmPoliciesMutationRequest, config: Partial<RequestConfig<PolicyReadsControllerSearchBrokerageFirmPoliciesMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PolicyReadsControllerSearchBrokerageFirmPoliciesMutationResponse, ResponseErrorConfig<Error>, PolicyReadsControllerSearchBrokerageFirmPoliciesMutationRequest>({ method : "POST", url : getPolicyReadsControllerSearchBrokerageFirmPoliciesUrl(brokerageFirmId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getDistributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsUrl(brokerageFirmId: DistributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsPathParams["brokerageFirmId"]) {
  const res = { method: 'POST', url: `/brokerage-firms/${brokerageFirmId}/distribution-requests/search` as const }
  return res
}

/**
 * @description Filters are sent as query parameters. Kept a POST for symmetry with the other searches.
 * @summary Search the distribution requests a brokerage firm has made
 * {@link /brokerage-firms/:brokerageFirmId/distribution-requests/search}
 */
export async function distributionRequestsReadsControllerSearchBrokerageFirmDistributionRequests(brokerageFirmId: DistributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsPathParams["brokerageFirmId"], params?: DistributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DistributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getDistributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsUrl(brokerageFirmId).url.toString(), params, ... requestConfig })
  return res.data
}

function getDistributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsUrl(brokerageFirmId: DistributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsPathParams["brokerageFirmId"]) {
  const res = { method: 'GET', url: `/brokerage-firms/${brokerageFirmId}/wholesale-distribution-requests` as const }
  return res
}

/**
 * @summary List the distribution requests made to a brokerage firm
 * {@link /brokerage-firms/:brokerageFirmId/wholesale-distribution-requests}
 */
export async function distributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequests(brokerageFirmId: DistributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsPathParams["brokerageFirmId"], params?: DistributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DistributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getDistributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsUrl(brokerageFirmId).url.toString(), params, ... requestConfig })
  return res.data
}

function getDocumentsReadsControllerListProductCommonDocumentsUrl(productId: DocumentsReadsControllerListProductCommonDocumentsPathParams["productId"]) {
  const res = { method: 'GET', url: `/products/${productId}/documents` as const }
  return res
}

/**
 * @summary List a product's general documents
 * {@link /products/:productId/documents}
 */
export async function documentsReadsControllerListProductCommonDocuments(productId: DocumentsReadsControllerListProductCommonDocumentsPathParams["productId"], params?: DocumentsReadsControllerListProductCommonDocumentsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DocumentsReadsControllerListProductCommonDocumentsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getDocumentsReadsControllerListProductCommonDocumentsUrl(productId).url.toString(), params, ... requestConfig })
  return res.data
}

function getMcpServerControllerHandleServerSentEventsUrl() {
  const res = { method: 'GET', url: `/mcp` as const }
  return res
}

/**
 * @summary MCP: SSE stream for server-to-client notifications
 * {@link /mcp}
 */
export async function mcpServerControllerHandleServerSentEvents(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<McpServerControllerHandleServerSentEventsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getMcpServerControllerHandleServerSentEventsUrl().url.toString(), ... requestConfig })
  return res.data
}

function getMcpServerControllerHandleRequestUrl() {
  const res = { method: 'POST', url: `/mcp` as const }
  return res
}

/**
 * @summary MCP: Handle Streamable HTTP request
 * {@link /mcp}
 */
export async function mcpServerControllerHandleRequest(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<McpServerControllerHandleRequestMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getMcpServerControllerHandleRequestUrl().url.toString(), ... requestConfig })
  return res.data
}

function getComplianceControllerCreateCheckUrl() {
  const res = { method: 'POST', url: `/compliance/checks` as const }
  return res
}

/**
 * @summary Create compliance check
 * {@link /compliance/checks}
 */
export async function complianceControllerCreateCheck(data: ComplianceControllerCreateCheckMutationRequest, config: Partial<RequestConfig<ComplianceControllerCreateCheckMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ComplianceControllerCreateCheckMutationResponse, ResponseErrorConfig<Error>, ComplianceControllerCreateCheckMutationRequest>({ method : "POST", url : getComplianceControllerCreateCheckUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getComplianceControllerListChecksUrl() {
  const res = { method: 'GET', url: `/compliance/checks` as const }
  return res
}

/**
 * @summary List compliance checks
 * {@link /compliance/checks}
 */
export async function complianceControllerListChecks(params?: ComplianceControllerListChecksQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ComplianceControllerListChecksQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getComplianceControllerListChecksUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getComplianceControllerUpdateCheckUrl(checkId: ComplianceControllerUpdateCheckPathParams["checkId"]) {
  const res = { method: 'PATCH', url: `/compliance/checks/${checkId}` as const }
  return res
}

/**
 * @summary Update compliance check
 * {@link /compliance/checks/:checkId}
 */
export async function complianceControllerUpdateCheck(checkId: ComplianceControllerUpdateCheckPathParams["checkId"], data: ComplianceControllerUpdateCheckMutationRequest, config: Partial<RequestConfig<ComplianceControllerUpdateCheckMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ComplianceControllerUpdateCheckMutationResponse, ResponseErrorConfig<ComplianceControllerUpdateCheck404>, ComplianceControllerUpdateCheckMutationRequest>({ method : "PATCH", url : getComplianceControllerUpdateCheckUrl(checkId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getComplianceControllerDeleteCheckUrl(checkId: ComplianceControllerDeleteCheckPathParams["checkId"]) {
  const res = { method: 'DELETE', url: `/compliance/checks/${checkId}` as const }
  return res
}

/**
 * @summary Delete compliance check
 * {@link /compliance/checks/:checkId}
 */
export async function complianceControllerDeleteCheck(checkId: ComplianceControllerDeleteCheckPathParams["checkId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ComplianceControllerDeleteCheckMutationResponse, ResponseErrorConfig<ComplianceControllerDeleteCheck404>, unknown>({ method : "DELETE", url : getComplianceControllerDeleteCheckUrl(checkId).url.toString(), ... requestConfig })
  return res.data
}

function getComplianceControllerGetCheckUrl(checkId: ComplianceControllerGetCheckPathParams["checkId"]) {
  const res = { method: 'GET', url: `/compliance/checks/${checkId}` as const }
  return res
}

/**
 * @summary Get compliance check
 * {@link /compliance/checks/:checkId}
 */
export async function complianceControllerGetCheck(checkId: ComplianceControllerGetCheckPathParams["checkId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ComplianceControllerGetCheckQueryResponse, ResponseErrorConfig<ComplianceControllerGetCheck404>, unknown>({ method : "GET", url : getComplianceControllerGetCheckUrl(checkId).url.toString(), ... requestConfig })
  return res.data
}

function getComplianceControllerCreateAlertUrl() {
  const res = { method: 'POST', url: `/compliance/alerts` as const }
  return res
}

/**
 * @summary Create compliance alert
 * {@link /compliance/alerts}
 */
export async function complianceControllerCreateAlert(data: ComplianceControllerCreateAlertMutationRequest, config: Partial<RequestConfig<ComplianceControllerCreateAlertMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ComplianceControllerCreateAlertMutationResponse, ResponseErrorConfig<ComplianceControllerCreateAlert404>, ComplianceControllerCreateAlertMutationRequest>({ method : "POST", url : getComplianceControllerCreateAlertUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getComplianceControllerListAlertsUrl() {
  const res = { method: 'GET', url: `/compliance/alerts` as const }
  return res
}

/**
 * @summary List compliance alerts
 * {@link /compliance/alerts}
 */
export async function complianceControllerListAlerts(params?: ComplianceControllerListAlertsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ComplianceControllerListAlertsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getComplianceControllerListAlertsUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getComplianceControllerAcknowledgeAlertsByEntityUrl(entityId: ComplianceControllerAcknowledgeAlertsByEntityPathParams["entityId"]) {
  const res = { method: 'PATCH', url: `/compliance/alerts/acknowledge/${entityId}` as const }
  return res
}

/**
 * @summary Acknowledge all alerts for an entity
 * {@link /compliance/alerts/acknowledge/:entityId}
 */
export async function complianceControllerAcknowledgeAlertsByEntity(entityId: ComplianceControllerAcknowledgeAlertsByEntityPathParams["entityId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ComplianceControllerAcknowledgeAlertsByEntityMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "PATCH", url : getComplianceControllerAcknowledgeAlertsByEntityUrl(entityId).url.toString(), ... requestConfig })
  return res.data
}

function getComplianceControllerAcknowledgeAlertsByCheckIdsUrl() {
  const res = { method: 'PATCH', url: `/compliance/alerts/acknowledge-by-check-ids` as const }
  return res
}

/**
 * @summary Acknowledge all alerts for given check IDs
 * {@link /compliance/alerts/acknowledge-by-check-ids}
 */
export async function complianceControllerAcknowledgeAlertsByCheckIds(data: ComplianceControllerAcknowledgeAlertsByCheckIdsMutationRequest, config: Partial<RequestConfig<ComplianceControllerAcknowledgeAlertsByCheckIdsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ComplianceControllerAcknowledgeAlertsByCheckIdsMutationResponse, ResponseErrorConfig<Error>, ComplianceControllerAcknowledgeAlertsByCheckIdsMutationRequest>({ method : "PATCH", url : getComplianceControllerAcknowledgeAlertsByCheckIdsUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getComplianceControllerUpdateAlertUrl(alertId: ComplianceControllerUpdateAlertPathParams["alertId"]) {
  const res = { method: 'PATCH', url: `/compliance/alerts/${alertId}` as const }
  return res
}

/**
 * @summary Update compliance alert
 * {@link /compliance/alerts/:alertId}
 */
export async function complianceControllerUpdateAlert(alertId: ComplianceControllerUpdateAlertPathParams["alertId"], data: ComplianceControllerUpdateAlertMutationRequest, config: Partial<RequestConfig<ComplianceControllerUpdateAlertMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ComplianceControllerUpdateAlertMutationResponse, ResponseErrorConfig<ComplianceControllerUpdateAlert404>, ComplianceControllerUpdateAlertMutationRequest>({ method : "PATCH", url : getComplianceControllerUpdateAlertUrl(alertId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getComplianceControllerDeleteAlertUrl(alertId: ComplianceControllerDeleteAlertPathParams["alertId"]) {
  const res = { method: 'DELETE', url: `/compliance/alerts/${alertId}` as const }
  return res
}

/**
 * @summary Delete compliance alert
 * {@link /compliance/alerts/:alertId}
 */
export async function complianceControllerDeleteAlert(alertId: ComplianceControllerDeleteAlertPathParams["alertId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ComplianceControllerDeleteAlertMutationResponse, ResponseErrorConfig<ComplianceControllerDeleteAlert404>, unknown>({ method : "DELETE", url : getComplianceControllerDeleteAlertUrl(alertId).url.toString(), ... requestConfig })
  return res.data
}

function getComplianceControllerGetAlertUrl(alertId: ComplianceControllerGetAlertPathParams["alertId"]) {
  const res = { method: 'GET', url: `/compliance/alerts/${alertId}` as const }
  return res
}

/**
 * @summary Get compliance alert
 * {@link /compliance/alerts/:alertId}
 */
export async function complianceControllerGetAlert(alertId: ComplianceControllerGetAlertPathParams["alertId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ComplianceControllerGetAlertQueryResponse, ResponseErrorConfig<ComplianceControllerGetAlert404>, unknown>({ method : "GET", url : getComplianceControllerGetAlertUrl(alertId).url.toString(), ... requestConfig })
  return res.data
}

function getRelationsControllerCreateRelationUrl() {
  const res = { method: 'POST', url: `/relations` as const }
  return res
}

/**
 * @summary Create a relation
 * {@link /relations}
 */
export async function relationsControllerCreateRelation(data: RelationsControllerCreateRelationMutationRequest, config: Partial<RequestConfig<RelationsControllerCreateRelationMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<RelationsControllerCreateRelationMutationResponse, ResponseErrorConfig<Error>, RelationsControllerCreateRelationMutationRequest>({ method : "POST", url : getRelationsControllerCreateRelationUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getRelationsControllerGetPermissionRelationsForUserUrl() {
  const res = { method: 'GET', url: `/relations/permission-relations` as const }
  return res
}

/**
 * @summary Get all permission relations for a user
 * {@link /relations/permission-relations}
 */
export async function relationsControllerGetPermissionRelationsForUser(params: RelationsControllerGetPermissionRelationsForUserQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<RelationsControllerGetPermissionRelationsForUserQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getRelationsControllerGetPermissionRelationsForUserUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getRelationsControllerDeleteRelationUrl(relationId: RelationsControllerDeleteRelationPathParams["relationId"]) {
  const res = { method: 'DELETE', url: `/relations/${relationId}` as const }
  return res
}

/**
 * @summary Delete a relation
 * {@link /relations/:relationId}
 */
export async function relationsControllerDeleteRelation(relationId: RelationsControllerDeleteRelationPathParams["relationId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<RelationsControllerDeleteRelationMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "DELETE", url : getRelationsControllerDeleteRelationUrl(relationId).url.toString(), ... requestConfig })
  return res.data
}

function getRelationsControllerListTenantUsersUrl() {
  const res = { method: 'GET', url: `/relations/users` as const }
  return res
}

/**
 * @summary List the users holding relations, one row per user
 * {@link /relations/users}
 */
export async function relationsControllerListTenantUsers(params?: RelationsControllerListTenantUsersQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<RelationsControllerListTenantUsersQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getRelationsControllerListTenantUsersUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getRelationsControllerListRelationsUrl() {
  const res = { method: 'GET', url: `/relations/list` as const }
  return res
}

/**
 * @summary List all relations for a resource and/or a user or none
 * {@link /relations/list}
 */
export async function relationsControllerListRelations(params?: RelationsControllerListRelationsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<RelationsControllerListRelationsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getRelationsControllerListRelationsUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getLegacyPermissionsControllerAtMeUrl() {
  const res = { method: 'GET', url: `/users/permissions/@me` as const }
  return res
}

/**
 * @description Do not use the status code as a signed-in test: an anonymous session gets `200` with an empty identity rather than an error, so branch on a field in the body. On this route a request with no token is `401`, as is a malformed, expired or wrong-tenant token.
 * @summary Get the current user's roles and relations
 * {@link /users/permissions/@me}
 */
export async function legacyPermissionsControllerAtMe(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<LegacyPermissionsControllerAtMeQueryResponse, ResponseErrorConfig<LegacyPermissionsControllerAtMe404>, unknown>({ method : "GET", url : getLegacyPermissionsControllerAtMeUrl().url.toString(), ... requestConfig })
  return res.data
}

function getBrokerageFirmControllerCreateBrokerageFirmUrl() {
  const res = { method: 'POST', url: `/brokerage-firms` as const }
  return res
}

/**
 * @description Creates a brokerage firm for the tenant using the provided configuration. Requires a valid authenticated user. The body contains company, product, and commission configuration.
 * @summary Create brokerage firm
 * {@link /brokerage-firms}
 */
export async function brokerageFirmControllerCreateBrokerageFirm(data: BrokerageFirmControllerCreateBrokerageFirmMutationRequest, config: Partial<RequestConfig<BrokerageFirmControllerCreateBrokerageFirmMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<BrokerageFirmControllerCreateBrokerageFirmMutationResponse, ResponseErrorConfig<BrokerageFirmControllerCreateBrokerageFirm400 | BrokerageFirmControllerCreateBrokerageFirm404>, BrokerageFirmControllerCreateBrokerageFirmMutationRequest>({ method : "POST", url : getBrokerageFirmControllerCreateBrokerageFirmUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getBrokerageFirmControllerListBrokerageFirmsUrl() {
  const res = { method: 'GET', url: `/brokerage-firms` as const }
  return res
}

/**
 * @description Returns a paginated list of brokerage firms in the current tenant. Results may vary by user permissions.
 * @summary List brokerage firms on tenant
 * {@link /brokerage-firms}
 */
export async function brokerageFirmControllerListBrokerageFirms(params?: BrokerageFirmControllerListBrokerageFirmsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<BrokerageFirmControllerListBrokerageFirmsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getBrokerageFirmControllerListBrokerageFirmsUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getBrokerageFirmControllerUpdateBrokerageFirmUrl(brokerageFirmId: BrokerageFirmControllerUpdateBrokerageFirmPathParams["brokerageFirmId"]) {
  const res = { method: 'PATCH', url: `/brokerage-firms/${brokerageFirmId}` as const }
  return res
}

/**
 * @description Updates a brokerage firm identified by brokerageFirmId. Provide only the fields that should be changed in the body. Requires edit permissions on the brokerage firm.
 * @summary Update brokerage firm
 * {@link /brokerage-firms/:brokerageFirmId}
 */
export async function brokerageFirmControllerUpdateBrokerageFirm(brokerageFirmId: BrokerageFirmControllerUpdateBrokerageFirmPathParams["brokerageFirmId"], data: BrokerageFirmControllerUpdateBrokerageFirmMutationRequest, config: Partial<RequestConfig<BrokerageFirmControllerUpdateBrokerageFirmMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<BrokerageFirmControllerUpdateBrokerageFirmMutationResponse, ResponseErrorConfig<BrokerageFirmControllerUpdateBrokerageFirm400 | BrokerageFirmControllerUpdateBrokerageFirm404>, BrokerageFirmControllerUpdateBrokerageFirmMutationRequest>({ method : "PATCH", url : getBrokerageFirmControllerUpdateBrokerageFirmUrl(brokerageFirmId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getBrokerageFirmControllerGetBrokerageFirmUrl(brokerageFirmId: BrokerageFirmControllerGetBrokerageFirmPathParams["brokerageFirmId"]) {
  const res = { method: 'GET', url: `/brokerage-firms/${brokerageFirmId}` as const }
  return res
}

/**
 * @description Retrieves a brokerage firm by id including configuration and metadata.
 * @summary Get brokerage firm
 * {@link /brokerage-firms/:brokerageFirmId}
 */
export async function brokerageFirmControllerGetBrokerageFirm(brokerageFirmId: BrokerageFirmControllerGetBrokerageFirmPathParams["brokerageFirmId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<BrokerageFirmControllerGetBrokerageFirmQueryResponse, ResponseErrorConfig<BrokerageFirmControllerGetBrokerageFirm404>, unknown>({ method : "GET", url : getBrokerageFirmControllerGetBrokerageFirmUrl(brokerageFirmId).url.toString(), ... requestConfig })
  return res.data
}

function getBrokerageFirmControllerGenerateUploadDocumentUrlUrl(brokerageFirmId: BrokerageFirmControllerGenerateUploadDocumentUrlPathParams["brokerageFirmId"]) {
  const res = { method: 'POST', url: `/brokerage-firms/${brokerageFirmId}/documents` as const }
  return res
}

/**
 * @description Generates a presigned URL to upload a document to the brokerage firm. Provide document metadata in the body and any additional parameters in the query.
 * @summary Generate Upload Document Url
 * {@link /brokerage-firms/:brokerageFirmId/documents}
 */
export async function brokerageFirmControllerGenerateUploadDocumentUrl(brokerageFirmId: BrokerageFirmControllerGenerateUploadDocumentUrlPathParams["brokerageFirmId"], data: BrokerageFirmControllerGenerateUploadDocumentUrlMutationRequest, params?: BrokerageFirmControllerGenerateUploadDocumentUrlQueryParams, config: Partial<RequestConfig<BrokerageFirmControllerGenerateUploadDocumentUrlMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<BrokerageFirmControllerGenerateUploadDocumentUrlMutationResponse, ResponseErrorConfig<BrokerageFirmControllerGenerateUploadDocumentUrl400 | BrokerageFirmControllerGenerateUploadDocumentUrl403 | BrokerageFirmControllerGenerateUploadDocumentUrl404>, BrokerageFirmControllerGenerateUploadDocumentUrlMutationRequest>({ method : "POST", url : getBrokerageFirmControllerGenerateUploadDocumentUrlUrl(brokerageFirmId).url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getBrokerageFirmControllerListDocumentsUrl(brokerageFirmId: BrokerageFirmControllerListDocumentsPathParams["brokerageFirmId"]) {
  const res = { method: 'GET', url: `/brokerage-firms/${brokerageFirmId}/documents` as const }
  return res
}

/**
 * @description Lists documents that belong to the brokerage firm. Supports pagination and filters via query params.
 * @summary List documents on brokerage firm
 * {@link /brokerage-firms/:brokerageFirmId/documents}
 */
export async function brokerageFirmControllerListDocuments(brokerageFirmId: BrokerageFirmControllerListDocumentsPathParams["brokerageFirmId"], params?: BrokerageFirmControllerListDocumentsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<BrokerageFirmControllerListDocumentsQueryResponse, ResponseErrorConfig<BrokerageFirmControllerListDocuments400 | BrokerageFirmControllerListDocuments403 | BrokerageFirmControllerListDocuments404>, unknown>({ method : "GET", url : getBrokerageFirmControllerListDocumentsUrl(brokerageFirmId).url.toString(), params, ... requestConfig })
  return res.data
}

function getBrokerageFirmControllerDeleteDocumentsUrl(brokerageFirmId: BrokerageFirmControllerDeleteDocumentsPathParams["brokerageFirmId"]) {
  const res = { method: 'DELETE', url: `/brokerage-firms/${brokerageFirmId}/documents` as const }
  return res
}

/**
 * @description Deletes documents belonging to the brokerage firm matching the provided query filter.
 * @summary Delete documents on brokerage firm
 * {@link /brokerage-firms/:brokerageFirmId/documents}
 */
export async function brokerageFirmControllerDeleteDocuments(brokerageFirmId: BrokerageFirmControllerDeleteDocumentsPathParams["brokerageFirmId"], params: BrokerageFirmControllerDeleteDocumentsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<BrokerageFirmControllerDeleteDocumentsMutationResponse, ResponseErrorConfig<BrokerageFirmControllerDeleteDocuments400 | BrokerageFirmControllerDeleteDocuments403 | BrokerageFirmControllerDeleteDocuments404>, unknown>({ method : "DELETE", url : getBrokerageFirmControllerDeleteDocumentsUrl(brokerageFirmId).url.toString(), params, ... requestConfig })
  return res.data
}

function getBrokerageFirmControllerGenerateReportUrl(brokerageFirmId: BrokerageFirmControllerGenerateReportPathParams["brokerageFirmId"]) {
  const res = { method: 'POST', url: `/brokerage-firms/${brokerageFirmId}/reports` as const }
  return res
}

/**
 * @description Generates a report for the specified brokerage firm using the parameters provided in the body.
 * @summary Generate report for brokerage firm
 * {@link /brokerage-firms/:brokerageFirmId/reports}
 */
export async function brokerageFirmControllerGenerateReport(brokerageFirmId: BrokerageFirmControllerGenerateReportPathParams["brokerageFirmId"], data: BrokerageFirmControllerGenerateReportMutationRequest, config: Partial<RequestConfig<BrokerageFirmControllerGenerateReportMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<BrokerageFirmControllerGenerateReportMutationResponse, ResponseErrorConfig<Error>, BrokerageFirmControllerGenerateReportMutationRequest>({ method : "POST", url : getBrokerageFirmControllerGenerateReportUrl(brokerageFirmId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getBrokerageFirmControllerListReportsUrl(brokerageFirmId: BrokerageFirmControllerListReportsPathParams["brokerageFirmId"]) {
  const res = { method: 'GET', url: `/brokerage-firms/${brokerageFirmId}/reports` as const }
  return res
}

/**
 * @description Returns a paginated list of generated reports for the brokerage firm.
 * @summary List reports for brokerage firm
 * {@link /brokerage-firms/:brokerageFirmId/reports}
 */
export async function brokerageFirmControllerListReports(brokerageFirmId: BrokerageFirmControllerListReportsPathParams["brokerageFirmId"], params?: BrokerageFirmControllerListReportsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<BrokerageFirmControllerListReportsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getBrokerageFirmControllerListReportsUrl(brokerageFirmId).url.toString(), params, ... requestConfig })
  return res.data
}

function getBrokerageFirmControllerGetReportConfigUrl(brokerageFirmId: BrokerageFirmControllerGetReportConfigPathParams["brokerageFirmId"], type: BrokerageFirmControllerGetReportConfigPathParams["type"]) {
  const res = { method: 'GET', url: `/brokerage-firms/${brokerageFirmId}/reports/${type}/config` as const }
  return res
}

/**
 * @description Retrieves the report configuration for the specified brokerage firm.
 * @summary Get report config for brokerage firm
 * {@link /brokerage-firms/:brokerageFirmId/reports/:type/config}
 */
export async function brokerageFirmControllerGetReportConfig(brokerageFirmId: BrokerageFirmControllerGetReportConfigPathParams["brokerageFirmId"], type: BrokerageFirmControllerGetReportConfigPathParams["type"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<BrokerageFirmControllerGetReportConfigQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getBrokerageFirmControllerGetReportConfigUrl(brokerageFirmId, type).url.toString(), ... requestConfig })
  return res.data
}

function getBrokerageFirmControllerListCommissionStatementsUrl(brokerageFirmId: BrokerageFirmControllerListCommissionStatementsPathParams["brokerageFirmId"]) {
  const res = { method: 'GET', url: `/brokerage-firms/${brokerageFirmId}/commission-statements` as const }
  return res
}

/**
 * @description Returns the monthly commission statements of one exercise with their downloadable reports: what a wholesale firm paid its retail firms, or what a retail firm received.
 * @summary List commission statements for brokerage firm
 * {@link /brokerage-firms/:brokerageFirmId/commission-statements}
 */
export async function brokerageFirmControllerListCommissionStatements(brokerageFirmId: BrokerageFirmControllerListCommissionStatementsPathParams["brokerageFirmId"], params?: BrokerageFirmControllerListCommissionStatementsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<BrokerageFirmControllerListCommissionStatementsQueryResponse, ResponseErrorConfig<BrokerageFirmControllerListCommissionStatements403 | BrokerageFirmControllerListCommissionStatements404>, unknown>({ method : "GET", url : getBrokerageFirmControllerListCommissionStatementsUrl(brokerageFirmId).url.toString(), params, ... requestConfig })
  return res.data
}

function getBrokerageFirmControllerGetCommissionStatementDocumentUrl(brokerageFirmId: BrokerageFirmControllerGetCommissionStatementDocumentPathParams["brokerageFirmId"]) {
  const res = { method: 'POST', url: `/brokerage-firms/${brokerageFirmId}/commission-statements/documents` as const }
  return res
}

/**
 * @description Renders the document of the given type and period the first time it is asked for, then returns that same document. An annual declaration is read from the monthly statements.
 * @summary Get a commission statement document of a brokerage firm
 * {@link /brokerage-firms/:brokerageFirmId/commission-statements/documents}
 */
export async function brokerageFirmControllerGetCommissionStatementDocument(brokerageFirmId: BrokerageFirmControllerGetCommissionStatementDocumentPathParams["brokerageFirmId"], data: BrokerageFirmControllerGetCommissionStatementDocumentMutationRequest, config: Partial<RequestConfig<BrokerageFirmControllerGetCommissionStatementDocumentMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<BrokerageFirmControllerGetCommissionStatementDocumentMutationResponse, ResponseErrorConfig<BrokerageFirmControllerGetCommissionStatementDocument400 | BrokerageFirmControllerGetCommissionStatementDocument403 | BrokerageFirmControllerGetCommissionStatementDocument404>, BrokerageFirmControllerGetCommissionStatementDocumentMutationRequest>({ method : "POST", url : getBrokerageFirmControllerGetCommissionStatementDocumentUrl(brokerageFirmId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getBrokerageFirmControllerGetPaymentMethodSetupSecretUrl(brokerageFirmId: BrokerageFirmControllerGetPaymentMethodSetupSecretPathParams["brokerageFirmId"]) {
  const res = { method: 'GET', url: `/brokerage-firms/${brokerageFirmId}/payment-methods/secret` as const }
  return res
}

/**
 * @description Fetches a setup secret to initialize payment method configuration for the brokerage firm.
 * @summary Get Payment Method Setup Secret
 * {@link /brokerage-firms/:brokerageFirmId/payment-methods/secret}
 */
export async function brokerageFirmControllerGetPaymentMethodSetupSecret(brokerageFirmId: BrokerageFirmControllerGetPaymentMethodSetupSecretPathParams["brokerageFirmId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<BrokerageFirmControllerGetPaymentMethodSetupSecretQueryResponse, ResponseErrorConfig<BrokerageFirmControllerGetPaymentMethodSetupSecret404>, unknown>({ method : "GET", url : getBrokerageFirmControllerGetPaymentMethodSetupSecretUrl(brokerageFirmId).url.toString(), ... requestConfig })
  return res.data
}

function getBrokerageFirmControllerGetPaymentMethodsUrl(brokerageFirmId: BrokerageFirmControllerGetPaymentMethodsPathParams["brokerageFirmId"]) {
  const res = { method: 'GET', url: `/brokerage-firms/${brokerageFirmId}/payment-methods` as const }
  return res
}

/**
 * @description Retrieves the payment methods currently configured for the brokerage firm.
 * @summary Get Payment Methods
 * {@link /brokerage-firms/:brokerageFirmId/payment-methods}
 */
export async function brokerageFirmControllerGetPaymentMethods(brokerageFirmId: BrokerageFirmControllerGetPaymentMethodsPathParams["brokerageFirmId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<BrokerageFirmControllerGetPaymentMethodsQueryResponse, ResponseErrorConfig<BrokerageFirmControllerGetPaymentMethods404>, unknown>({ method : "GET", url : getBrokerageFirmControllerGetPaymentMethodsUrl(brokerageFirmId).url.toString(), ... requestConfig })
  return res.data
}

function getBrokerageFirmControllerGenerateDocumentsForSignatureUrl(brokerageFirmId: BrokerageFirmControllerGenerateDocumentsForSignaturePathParams["brokerageFirmId"]) {
  const res = { method: 'POST', url: `/brokerage-firms/${brokerageFirmId}/documents-for-signature` as const }
  return res
}

/**
 * @description Generates all required documents for a signature request for the brokerage firm based on product configuration.
 * @summary Generate necessary documents for signature request
 * {@link /brokerage-firms/:brokerageFirmId/documents-for-signature}
 */
export async function brokerageFirmControllerGenerateDocumentsForSignature(brokerageFirmId: BrokerageFirmControllerGenerateDocumentsForSignaturePathParams["brokerageFirmId"], params?: BrokerageFirmControllerGenerateDocumentsForSignatureQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<BrokerageFirmControllerGenerateDocumentsForSignatureMutationResponse, ResponseErrorConfig<BrokerageFirmControllerGenerateDocumentsForSignature404>, unknown>({ method : "POST", url : getBrokerageFirmControllerGenerateDocumentsForSignatureUrl(brokerageFirmId).url.toString(), params, ... requestConfig })
  return res.data
}

function getBrokerageFirmControllerGenerateSignatureRequestUrl(brokerageFirmId: BrokerageFirmControllerGenerateSignatureRequestPathParams["brokerageFirmId"]) {
  const res = { method: 'POST', url: `/brokerage-firms/${brokerageFirmId}/signature` as const }
  return res
}

/**
 * @description Creates a signature request for the brokerage firm using the provided payload.
 * @summary Generate signature request
 * {@link /brokerage-firms/:brokerageFirmId/signature}
 */
export async function brokerageFirmControllerGenerateSignatureRequest(brokerageFirmId: BrokerageFirmControllerGenerateSignatureRequestPathParams["brokerageFirmId"], data: BrokerageFirmControllerGenerateSignatureRequestMutationRequest, config: Partial<RequestConfig<BrokerageFirmControllerGenerateSignatureRequestMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<BrokerageFirmControllerGenerateSignatureRequestMutationResponse, ResponseErrorConfig<BrokerageFirmControllerGenerateSignatureRequest404>, BrokerageFirmControllerGenerateSignatureRequestMutationRequest>({ method : "POST", url : getBrokerageFirmControllerGenerateSignatureRequestUrl(brokerageFirmId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getBrokerageFirmControllerGenerateMandateSignatureRequestUrl(brokerageFirmId: BrokerageFirmControllerGenerateMandateSignatureRequestPathParams["brokerageFirmId"], paymentMethodId: BrokerageFirmControllerGenerateMandateSignatureRequestPathParams["paymentMethodId"]) {
  const res = { method: 'POST', url: `/brokerage-firms/${brokerageFirmId}/payment-methods/${paymentMethodId}/signature` as const }
  return res
}

/**
 * @description Creates a signature request for a SEPA mandate document for the brokerage firm payment method. The firm must already have a company name and an email address, since they identify the signer. If either is missing, the request fails with MISSING_BROKERAGE_FIRM_CONTACT_FIELDS.
 * @summary Generate mandate signature request
 * {@link /brokerage-firms/:brokerageFirmId/payment-methods/:paymentMethodId/signature}
 */
export async function brokerageFirmControllerGenerateMandateSignatureRequest(brokerageFirmId: BrokerageFirmControllerGenerateMandateSignatureRequestPathParams["brokerageFirmId"], paymentMethodId: BrokerageFirmControllerGenerateMandateSignatureRequestPathParams["paymentMethodId"], data: BrokerageFirmControllerGenerateMandateSignatureRequestMutationRequest, config: Partial<RequestConfig<BrokerageFirmControllerGenerateMandateSignatureRequestMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<BrokerageFirmControllerGenerateMandateSignatureRequestMutationResponse, ResponseErrorConfig<BrokerageFirmControllerGenerateMandateSignatureRequest400 | BrokerageFirmControllerGenerateMandateSignatureRequest404 | BrokerageFirmControllerGenerateMandateSignatureRequest409 | BrokerageFirmControllerGenerateMandateSignatureRequest425>, BrokerageFirmControllerGenerateMandateSignatureRequestMutationRequest>({ method : "POST", url : getBrokerageFirmControllerGenerateMandateSignatureRequestUrl(brokerageFirmId, paymentMethodId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getBrokerageFirmControllerUpdatePreferredPaymentMethodUrl(brokerageFirmId: BrokerageFirmControllerUpdatePreferredPaymentMethodPathParams["brokerageFirmId"], paymentMethodId: BrokerageFirmControllerUpdatePreferredPaymentMethodPathParams["paymentMethodId"]) {
  const res = { method: 'PUT', url: `/brokerage-firms/${brokerageFirmId}/payment-methods/${paymentMethodId}/preferred` as const }
  return res
}

/**
 * @summary Update brokerage firm preferred payment method
 * {@link /brokerage-firms/:brokerageFirmId/payment-methods/:paymentMethodId/preferred}
 */
export async function brokerageFirmControllerUpdatePreferredPaymentMethod(brokerageFirmId: BrokerageFirmControllerUpdatePreferredPaymentMethodPathParams["brokerageFirmId"], paymentMethodId: BrokerageFirmControllerUpdatePreferredPaymentMethodPathParams["paymentMethodId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<BrokerageFirmControllerUpdatePreferredPaymentMethodMutationResponse, ResponseErrorConfig<BrokerageFirmControllerUpdatePreferredPaymentMethod400 | BrokerageFirmControllerUpdatePreferredPaymentMethod404 | BrokerageFirmControllerUpdatePreferredPaymentMethod409>, unknown>({ method : "PUT", url : getBrokerageFirmControllerUpdatePreferredPaymentMethodUrl(brokerageFirmId, paymentMethodId).url.toString(), ... requestConfig })
  return res.data
}

function getBrokerageFirmControllerDeletePaymentMethodUrl(brokerageFirmId: BrokerageFirmControllerDeletePaymentMethodPathParams["brokerageFirmId"], paymentMethodId: BrokerageFirmControllerDeletePaymentMethodPathParams["paymentMethodId"]) {
  const res = { method: 'DELETE', url: `/brokerage-firms/${brokerageFirmId}/payment-methods/${paymentMethodId}` as const }
  return res
}

/**
 * @description The payment method stops being used for billing.
 * @summary Remove a brokerage firm payment method
 * {@link /brokerage-firms/:brokerageFirmId/payment-methods/:paymentMethodId}
 */
export async function brokerageFirmControllerDeletePaymentMethod(brokerageFirmId: BrokerageFirmControllerDeletePaymentMethodPathParams["brokerageFirmId"], paymentMethodId: BrokerageFirmControllerDeletePaymentMethodPathParams["paymentMethodId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<BrokerageFirmControllerDeletePaymentMethodMutationResponse, ResponseErrorConfig<BrokerageFirmControllerDeletePaymentMethod404 | BrokerageFirmControllerDeletePaymentMethod409>, unknown>({ method : "DELETE", url : getBrokerageFirmControllerDeletePaymentMethodUrl(brokerageFirmId, paymentMethodId).url.toString(), ... requestConfig })
  return res.data
}

function getBrokerageFirmControllerTransferPoliciesUrl(brokerageFirmId: BrokerageFirmControllerTransferPoliciesPathParams["brokerageFirmId"]) {
  const res = { method: 'POST', url: `/brokerage-firms/${brokerageFirmId}/transfer` as const }
  return res
}

/**
 * @description `brokerageFirmId` in the path is the target firm; `policyIds` (max 500) in the body are the policies to move, each moved from whatever firm it is currently on — no shared source is required or checked. Each transfer runs as its own async job: no approved distribution request for the target firm and product fails that job with DISTRIBUTION_REQUEST_CONFLICT. Applies to every branch, open or closed, so brokers on the old firm lose access and brokers on the new firm see the policy immediately. Korint staff only.
 * @summary Transfer policies to a different brokerage firm
 * {@link /brokerage-firms/:brokerageFirmId/transfer}
 */
export async function brokerageFirmControllerTransferPolicies(brokerageFirmId: BrokerageFirmControllerTransferPoliciesPathParams["brokerageFirmId"], data: BrokerageFirmControllerTransferPoliciesMutationRequest, config: Partial<RequestConfig<BrokerageFirmControllerTransferPoliciesMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<BrokerageFirmControllerTransferPoliciesMutationResponse, ResponseErrorConfig<BrokerageFirmControllerTransferPolicies404>, BrokerageFirmControllerTransferPoliciesMutationRequest>({ method : "POST", url : getBrokerageFirmControllerTransferPoliciesUrl(brokerageFirmId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getDistributionRequestControllerCreateManyDistributionRequestsUrl() {
  const res = { method: 'POST', url: `/distribution-requests` as const }
  return res
}

/**
 * @summary Create many distribution requests
 * {@link /distribution-requests}
 */
export async function distributionRequestControllerCreateManyDistributionRequests(data: DistributionRequestControllerCreateManyDistributionRequestsMutationRequest, config: Partial<RequestConfig<DistributionRequestControllerCreateManyDistributionRequestsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<DistributionRequestControllerCreateManyDistributionRequestsMutationResponse, ResponseErrorConfig<DistributionRequestControllerCreateManyDistributionRequests409>, DistributionRequestControllerCreateManyDistributionRequestsMutationRequest>({ method : "POST", url : getDistributionRequestControllerCreateManyDistributionRequestsUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getDistributionRequestControllerApproveDistributionRequestUrl(id: DistributionRequestControllerApproveDistributionRequestPathParams["id"]) {
  const res = { method: 'POST', url: `/distribution-requests/${id}/approve` as const }
  return res
}

/**
 * @summary Approve a distribution request
 * {@link /distribution-requests/:id/approve}
 */
export async function distributionRequestControllerApproveDistributionRequest(id: DistributionRequestControllerApproveDistributionRequestPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DistributionRequestControllerApproveDistributionRequestMutationResponse, ResponseErrorConfig<DistributionRequestControllerApproveDistributionRequest404 | DistributionRequestControllerApproveDistributionRequest409>, unknown>({ method : "POST", url : getDistributionRequestControllerApproveDistributionRequestUrl(id).url.toString(), ... requestConfig })
  return res.data
}

function getDistributionRequestControllerWaitingForSignatureDistributionRequestUrl(id: DistributionRequestControllerWaitingForSignatureDistributionRequestPathParams["id"]) {
  const res = { method: 'POST', url: `/distribution-requests/${id}/waiting-for-signature` as const }
  return res
}

/**
 * @summary Waiting for signature a distribution request
 * {@link /distribution-requests/:id/waiting-for-signature}
 */
export async function distributionRequestControllerWaitingForSignatureDistributionRequest(id: DistributionRequestControllerWaitingForSignatureDistributionRequestPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DistributionRequestControllerWaitingForSignatureDistributionRequestMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getDistributionRequestControllerWaitingForSignatureDistributionRequestUrl(id).url.toString(), ... requestConfig })
  return res.data
}

function getDistributionRequestControllerDenyDistributionRequestUrl(id: DistributionRequestControllerDenyDistributionRequestPathParams["id"]) {
  const res = { method: 'POST', url: `/distribution-requests/${id}/deny` as const }
  return res
}

/**
 * @summary Deny a distribution request
 * {@link /distribution-requests/:id/deny}
 */
export async function distributionRequestControllerDenyDistributionRequest(id: DistributionRequestControllerDenyDistributionRequestPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DistributionRequestControllerDenyDistributionRequestMutationResponse, ResponseErrorConfig<DistributionRequestControllerDenyDistributionRequest404 | DistributionRequestControllerDenyDistributionRequest409>, unknown>({ method : "POST", url : getDistributionRequestControllerDenyDistributionRequestUrl(id).url.toString(), ... requestConfig })
  return res.data
}

function getDistributionRequestControllerRevokeDistributionRequestUrl(id: DistributionRequestControllerRevokeDistributionRequestPathParams["id"]) {
  const res = { method: 'POST', url: `/distribution-requests/${id}/revoke` as const }
  return res
}

/**
 * @summary Revoke a distribution request
 * {@link /distribution-requests/:id/revoke}
 */
export async function distributionRequestControllerRevokeDistributionRequest(id: DistributionRequestControllerRevokeDistributionRequestPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DistributionRequestControllerRevokeDistributionRequestMutationResponse, ResponseErrorConfig<DistributionRequestControllerRevokeDistributionRequest404 | DistributionRequestControllerRevokeDistributionRequest409>, unknown>({ method : "POST", url : getDistributionRequestControllerRevokeDistributionRequestUrl(id).url.toString(), ... requestConfig })
  return res.data
}

function getDistributionRequestControllerGetDistributionRequestUrl(id: DistributionRequestControllerGetDistributionRequestPathParams["id"]) {
  const res = { method: 'GET', url: `/distribution-requests/${id}` as const }
  return res
}

/**
 * @summary Get distribution request
 * {@link /distribution-requests/:id}
 */
export async function distributionRequestControllerGetDistributionRequest(id: DistributionRequestControllerGetDistributionRequestPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DistributionRequestControllerGetDistributionRequestQueryResponse, ResponseErrorConfig<DistributionRequestControllerGetDistributionRequest404>, unknown>({ method : "GET", url : getDistributionRequestControllerGetDistributionRequestUrl(id).url.toString(), ... requestConfig })
  return res.data
}

function getDistributionRequestControllerDeleteDistributionRequestUrl(id: DistributionRequestControllerDeleteDistributionRequestPathParams["id"]) {
  const res = { method: 'DELETE', url: `/distribution-requests/${id}` as const }
  return res
}

/**
 * @summary Delete distribution request
 * {@link /distribution-requests/:id}
 */
export async function distributionRequestControllerDeleteDistributionRequest(id: DistributionRequestControllerDeleteDistributionRequestPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DistributionRequestControllerDeleteDistributionRequestMutationResponse, ResponseErrorConfig<DistributionRequestControllerDeleteDistributionRequest404>, unknown>({ method : "DELETE", url : getDistributionRequestControllerDeleteDistributionRequestUrl(id).url.toString(), ... requestConfig })
  return res.data
}

function getDistributionRequestControllerListDistributionRequestsUrl() {
  const res = { method: 'POST', url: `/distribution-requests/list` as const }
  return res
}

/**
 * @summary List distribution requests
 * {@link /distribution-requests/list}
 */
export async function distributionRequestControllerListDistributionRequests(data: DistributionRequestControllerListDistributionRequestsMutationRequest, params?: DistributionRequestControllerListDistributionRequestsQueryParams, config: Partial<RequestConfig<DistributionRequestControllerListDistributionRequestsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<DistributionRequestControllerListDistributionRequestsMutationResponse, ResponseErrorConfig<Error>, DistributionRequestControllerListDistributionRequestsMutationRequest>({ method : "POST", url : getDistributionRequestControllerListDistributionRequestsUrl().url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}

function getBrokerageFeeControllerCreateBrokerageFeeUrl(brokerageFirmId: BrokerageFeeControllerCreateBrokerageFeePathParams["brokerageFirmId"]) {
  const res = { method: 'POST', url: `/brokerage-firms/${brokerageFirmId}/fees` as const }
  return res
}

/**
 * @summary Create brokerage fee
 * {@link /brokerage-firms/:brokerageFirmId/fees}
 */
export async function brokerageFeeControllerCreateBrokerageFee(brokerageFirmId: BrokerageFeeControllerCreateBrokerageFeePathParams["brokerageFirmId"], data: BrokerageFeeControllerCreateBrokerageFeeMutationRequest, config: Partial<RequestConfig<BrokerageFeeControllerCreateBrokerageFeeMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<BrokerageFeeControllerCreateBrokerageFeeMutationResponse, ResponseErrorConfig<BrokerageFeeControllerCreateBrokerageFee404>, BrokerageFeeControllerCreateBrokerageFeeMutationRequest>({ method : "POST", url : getBrokerageFeeControllerCreateBrokerageFeeUrl(brokerageFirmId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getBrokerageFeeControllerUpdateBrokerageFeeUrl(brokerageFeeId: BrokerageFeeControllerUpdateBrokerageFeePathParams["brokerageFeeId"]) {
  const res = { method: 'PATCH', url: `/brokerage-fees/${brokerageFeeId}` as const }
  return res
}

/**
 * @summary Update brokerage fee
 * {@link /brokerage-fees/:brokerageFeeId}
 */
export async function brokerageFeeControllerUpdateBrokerageFee(brokerageFeeId: BrokerageFeeControllerUpdateBrokerageFeePathParams["brokerageFeeId"], data: BrokerageFeeControllerUpdateBrokerageFeeMutationRequest, config: Partial<RequestConfig<BrokerageFeeControllerUpdateBrokerageFeeMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<BrokerageFeeControllerUpdateBrokerageFeeMutationResponse, ResponseErrorConfig<BrokerageFeeControllerUpdateBrokerageFee404>, BrokerageFeeControllerUpdateBrokerageFeeMutationRequest>({ method : "PATCH", url : getBrokerageFeeControllerUpdateBrokerageFeeUrl(brokerageFeeId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getBrokerageFeeControllerDeleteBrokerageFeeUrl(brokerageFeeId: BrokerageFeeControllerDeleteBrokerageFeePathParams["brokerageFeeId"]) {
  const res = { method: 'DELETE', url: `/brokerage-fees/${brokerageFeeId}` as const }
  return res
}

/**
 * @summary Delete brokerage fee
 * {@link /brokerage-fees/:brokerageFeeId}
 */
export async function brokerageFeeControllerDeleteBrokerageFee(brokerageFeeId: BrokerageFeeControllerDeleteBrokerageFeePathParams["brokerageFeeId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<BrokerageFeeControllerDeleteBrokerageFeeMutationResponse, ResponseErrorConfig<BrokerageFeeControllerDeleteBrokerageFee404>, unknown>({ method : "DELETE", url : getBrokerageFeeControllerDeleteBrokerageFeeUrl(brokerageFeeId).url.toString(), ... requestConfig })
  return res.data
}

function getBrokerageFeeControllerGetBrokerFeesUrl() {
  const res = { method: 'GET', url: `/brokerage-fees` as const }
  return res
}

/**
 * @summary Get all brokerage fees defined for a firm
 * {@link /brokerage-fees}
 */
export async function brokerageFeeControllerGetBrokerFees(params: BrokerageFeeControllerGetBrokerFeesQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<BrokerageFeeControllerGetBrokerFeesQueryResponse, ResponseErrorConfig<BrokerageFeeControllerGetBrokerFees404>, unknown>({ method : "GET", url : getBrokerageFeeControllerGetBrokerFeesUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getTelematicsControllerUpsertExternalServiceUserIdUrl() {
  const res = { method: 'POST', url: `/telematics/external-service-user-id` as const }
  return res
}

/**
 * @summary Upsert an external service user id (super admin only)
 * {@link /telematics/external-service-user-id}
 */
export async function telematicsControllerUpsertExternalServiceUserId(data: TelematicsControllerUpsertExternalServiceUserIdMutationRequest, config: Partial<RequestConfig<TelematicsControllerUpsertExternalServiceUserIdMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<TelematicsControllerUpsertExternalServiceUserIdMutationResponse, ResponseErrorConfig<Error>, TelematicsControllerUpsertExternalServiceUserIdMutationRequest>({ method : "POST", url : getTelematicsControllerUpsertExternalServiceUserIdUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getTenantOnboardingControllerCreateAccountUrl() {
  const res = { method: 'POST', url: `/tenant-onboarding/accounts` as const }
  return res
}

/**
 * @summary Create a new Stripe account
 * {@link /tenant-onboarding/accounts}
 */
export async function tenantOnboardingControllerCreateAccount(data: TenantOnboardingControllerCreateAccountMutationRequest, config: Partial<RequestConfig<TenantOnboardingControllerCreateAccountMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<TenantOnboardingControllerCreateAccountMutationResponse, ResponseErrorConfig<Error>, TenantOnboardingControllerCreateAccountMutationRequest>({ method : "POST", url : getTenantOnboardingControllerCreateAccountUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getTenantOnboardingControllerCreateAccountLinkUrl(accountId: TenantOnboardingControllerCreateAccountLinkPathParams["accountId"]) {
  const res = { method: 'POST', url: `/tenant-onboarding/accounts/${accountId}/link` as const }
  return res
}

/**
 * @summary Create a Stripe account link
 * {@link /tenant-onboarding/accounts/:accountId/link}
 */
export async function tenantOnboardingControllerCreateAccountLink(accountId: TenantOnboardingControllerCreateAccountLinkPathParams["accountId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<TenantOnboardingControllerCreateAccountLinkMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getTenantOnboardingControllerCreateAccountLinkUrl(accountId).url.toString(), ... requestConfig })
  return res.data
}

function getPortfolioMigrationControllerStartMigrationWorkflowUrl() {
  const res = { method: 'POST', url: `/migration/workflow` as const }
  return res
}

/**
 * @summary Start portfolio migration workflow
 * {@link /migration/workflow}
 */
export async function portfolioMigrationControllerStartMigrationWorkflow(data: PortfolioMigrationControllerStartMigrationWorkflowMutationRequest, config: Partial<RequestConfig<PortfolioMigrationControllerStartMigrationWorkflowMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PortfolioMigrationControllerStartMigrationWorkflowMutationResponse, ResponseErrorConfig<Error>, PortfolioMigrationControllerStartMigrationWorkflowMutationRequest>({ method : "POST", url : getPortfolioMigrationControllerStartMigrationWorkflowUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getPaymentMethodsMigrationControllerStartPaymentMethodsMigrationWorkflowUrl() {
  const res = { method: 'POST', url: `/migration/payment-methods/workflow` as const }
  return res
}

/**
 * @summary Start payment methods migration workflow (reads transformed data from a previously-run main migration dir)
 * {@link /migration/payment-methods/workflow}
 */
export async function paymentMethodsMigrationControllerStartPaymentMethodsMigrationWorkflow(data: PaymentMethodsMigrationControllerStartPaymentMethodsMigrationWorkflowMutationRequest, config: Partial<RequestConfig<PaymentMethodsMigrationControllerStartPaymentMethodsMigrationWorkflowMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PaymentMethodsMigrationControllerStartPaymentMethodsMigrationWorkflowMutationResponse, ResponseErrorConfig<Error>, PaymentMethodsMigrationControllerStartPaymentMethodsMigrationWorkflowMutationRequest>({ method : "POST", url : getPaymentMethodsMigrationControllerStartPaymentMethodsMigrationWorkflowUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getEfficialeControllerCheckComplianceUrl() {
  const res = { method: 'GET', url: `/efficiale` as const }
  return res
}

/**
 * @summary Compliance check for one individual
 * {@link /efficiale}
 */
export async function efficialeControllerCheckCompliance(params: EfficialeControllerCheckComplianceQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<EfficialeControllerCheckComplianceQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getEfficialeControllerCheckComplianceUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getEfficialeControllerGetAlertsUrl() {
  const res = { method: 'GET', url: `/efficiale/alerts` as const }
  return res
}

/**
 * @summary Get alerts from Efficiale
 * {@link /efficiale/alerts}
 */
export async function efficialeControllerGetAlerts(params?: EfficialeControllerGetAlertsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<EfficialeControllerGetAlertsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getEfficialeControllerGetAlertsUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getEllisphereControllerOrderOnlineUrl() {
  const res = { method: 'POST', url: `/ellisphere/online-order` as const }
  return res
}

/**
 * @summary Get a company information from Ellisphere API
 * {@link /ellisphere/online-order}
 */
export async function ellisphereControllerOrderOnline(data: EllisphereControllerOrderOnlineMutationRequest, config: Partial<RequestConfig<EllisphereControllerOrderOnlineMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<EllisphereControllerOrderOnlineMutationResponse, ResponseErrorConfig<Error>, EllisphereControllerOrderOnlineMutationRequest>({ method : "POST", url : getEllisphereControllerOrderOnlineUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getSolvabilityControllerGetScoreUrl() {
  const res = { method: 'POST', url: `/solvability/score` as const }
  return res
}

/**
 * @summary Get solvability score for a company
 * {@link /solvability/score}
 */
export async function solvabilityControllerGetScore(data: SolvabilityControllerGetScoreMutationRequest, config: Partial<RequestConfig<SolvabilityControllerGetScoreMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<SolvabilityControllerGetScoreMutationResponse, ResponseErrorConfig<Error>, SolvabilityControllerGetScoreMutationRequest>({ method : "POST", url : getSolvabilityControllerGetScoreUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getMetabaseControllerGetIframeUrlUrl() {
  const res = { method: 'GET', url: `/metabase/iframe-url` as const }
  return res
}

/**
 * @description Returns a short-lived URL that embeds the analytics dashboard in an iframe.
 * @summary Get a signed analytics dashboard URL
 * {@link /metabase/iframe-url}
 */
export async function metabaseControllerGetIframeUrl(params?: MetabaseControllerGetIframeUrlQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<MetabaseControllerGetIframeUrlQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getMetabaseControllerGetIframeUrlUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getFvaControllerUploadFileUrl() {
  const res = { method: 'POST', url: `/fva/upload` as const }
  return res
}

/**
 * @summary Upload FVA report
 * {@link /fva/upload}
 */
export async function fvaControllerUploadFile(params: FvaControllerUploadFileQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<FvaControllerUploadFileMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getFvaControllerUploadFileUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getFvaControllerRetrieveReportOutcomeUrl() {
  const res = { method: 'GET', url: `/fva/report-outcome` as const }
  return res
}

/**
 * @summary Retrieve FVA report outcome
 * {@link /fva/report-outcome}
 */
export async function fvaControllerRetrieveReportOutcome(params: FvaControllerRetrieveReportOutcomeQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<FvaControllerRetrieveReportOutcomeQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getFvaControllerRetrieveReportOutcomeUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getDocumentValidityControllerGetPolicyValidityUrl(policyId: DocumentValidityControllerGetPolicyValidityPathParams["policyId"]) {
  const res = { method: 'GET', url: `/policies/${policyId}/documents/validity` as const }
  return res
}

/**
 * @summary List document validity results for a policy
 * {@link /policies/:policyId/documents/validity}
 */
export async function documentValidityControllerGetPolicyValidity(policyId: DocumentValidityControllerGetPolicyValidityPathParams["policyId"], params?: DocumentValidityControllerGetPolicyValidityQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DocumentValidityControllerGetPolicyValidityQueryResponse, ResponseErrorConfig<DocumentValidityControllerGetPolicyValidity404>, unknown>({ method : "GET", url : getDocumentValidityControllerGetPolicyValidityUrl(policyId).url.toString(), params, ... requestConfig })
  return res.data
}

function getDocumentValidityControllerGetDocumentValidityUrl(policyId: DocumentValidityControllerGetDocumentValidityPathParams["policyId"], documentId: DocumentValidityControllerGetDocumentValidityPathParams["documentId"]) {
  const res = { method: 'GET', url: `/policies/${policyId}/documents/validity/${documentId}` as const }
  return res
}

/**
 * @summary Get validity results for a specific document
 * {@link /policies/:policyId/documents/validity/:documentId}
 */
export async function documentValidityControllerGetDocumentValidity(policyId: DocumentValidityControllerGetDocumentValidityPathParams["policyId"], documentId: DocumentValidityControllerGetDocumentValidityPathParams["documentId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DocumentValidityControllerGetDocumentValidityQueryResponse, ResponseErrorConfig<DocumentValidityControllerGetDocumentValidity500>, unknown>({ method : "GET", url : getDocumentValidityControllerGetDocumentValidityUrl(policyId, documentId).url.toString(), ... requestConfig })
  return res.data
}

function getDocumentValidityControllerOverrideDocumentValidityUrl(policyId: DocumentValidityControllerOverrideDocumentValidityPathParams["policyId"], documentId: DocumentValidityControllerOverrideDocumentValidityPathParams["documentId"]) {
  const res = { method: 'PATCH', url: `/policies/${policyId}/documents/validity/${documentId}/override` as const }
  return res
}

/**
 * @summary Override validity status for a document
 * {@link /policies/:policyId/documents/validity/:documentId/override}
 */
export async function documentValidityControllerOverrideDocumentValidity(policyId: DocumentValidityControllerOverrideDocumentValidityPathParams["policyId"], documentId: DocumentValidityControllerOverrideDocumentValidityPathParams["documentId"], data: DocumentValidityControllerOverrideDocumentValidityMutationRequest, config: Partial<RequestConfig<DocumentValidityControllerOverrideDocumentValidityMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<DocumentValidityControllerOverrideDocumentValidityMutationResponse, ResponseErrorConfig<DocumentValidityControllerOverrideDocumentValidity500>, DocumentValidityControllerOverrideDocumentValidityMutationRequest>({ method : "PATCH", url : getDocumentValidityControllerOverrideDocumentValidityUrl(policyId, documentId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getBrokerageFirmDocumentValidityControllerGetBrokerageFirmValidityUrl(brokerageFirmId: BrokerageFirmDocumentValidityControllerGetBrokerageFirmValidityPathParams["brokerageFirmId"]) {
  const res = { method: 'GET', url: `/brokerage-firms/${brokerageFirmId}/documents/validity` as const }
  return res
}

/**
 * @summary List document validity results for a brokerage firm
 * {@link /brokerage-firms/:brokerageFirmId/documents/validity}
 */
export async function brokerageFirmDocumentValidityControllerGetBrokerageFirmValidity(brokerageFirmId: BrokerageFirmDocumentValidityControllerGetBrokerageFirmValidityPathParams["brokerageFirmId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<BrokerageFirmDocumentValidityControllerGetBrokerageFirmValidityQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getBrokerageFirmDocumentValidityControllerGetBrokerageFirmValidityUrl(brokerageFirmId).url.toString(), ... requestConfig })
  return res.data
}

function getBrokerageFirmDocumentValidityControllerOverrideDocumentValidityUrl(brokerageFirmId: BrokerageFirmDocumentValidityControllerOverrideDocumentValidityPathParams["brokerageFirmId"], documentId: BrokerageFirmDocumentValidityControllerOverrideDocumentValidityPathParams["documentId"]) {
  const res = { method: 'PATCH', url: `/brokerage-firms/${brokerageFirmId}/documents/validity/${documentId}/override` as const }
  return res
}

/**
 * @summary Override validity status for a brokerage firm document
 * {@link /brokerage-firms/:brokerageFirmId/documents/validity/:documentId/override}
 */
export async function brokerageFirmDocumentValidityControllerOverrideDocumentValidity(brokerageFirmId: BrokerageFirmDocumentValidityControllerOverrideDocumentValidityPathParams["brokerageFirmId"], documentId: BrokerageFirmDocumentValidityControllerOverrideDocumentValidityPathParams["documentId"], data: BrokerageFirmDocumentValidityControllerOverrideDocumentValidityMutationRequest, config: Partial<RequestConfig<BrokerageFirmDocumentValidityControllerOverrideDocumentValidityMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<BrokerageFirmDocumentValidityControllerOverrideDocumentValidityMutationResponse, ResponseErrorConfig<BrokerageFirmDocumentValidityControllerOverrideDocumentValidity500>, BrokerageFirmDocumentValidityControllerOverrideDocumentValidityMutationRequest>({ method : "PATCH", url : getBrokerageFirmDocumentValidityControllerOverrideDocumentValidityUrl(brokerageFirmId, documentId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getDocumentCoherenceControllerGetDocumentCoherenceUrl(entityId: DocumentCoherenceControllerGetDocumentCoherencePathParams["entityId"]) {
  const res = { method: 'GET', url: `/documents/coherence/${entityId}` as const }
  return res
}

/**
 * @summary Compare document extracted values with typed values
 * {@link /documents/coherence/:entityId}
 */
export async function documentCoherenceControllerGetDocumentCoherence(entityId: DocumentCoherenceControllerGetDocumentCoherencePathParams["entityId"], params?: DocumentCoherenceControllerGetDocumentCoherenceQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DocumentCoherenceControllerGetDocumentCoherenceQueryResponse, ResponseErrorConfig<DocumentCoherenceControllerGetDocumentCoherence400 | DocumentCoherenceControllerGetDocumentCoherence404>, unknown>({ method : "GET", url : getDocumentCoherenceControllerGetDocumentCoherenceUrl(entityId).url.toString(), params, ... requestConfig })
  return res.data
}

function getPolicyDocumentControllerAcceptUrl(policyId: PolicyDocumentControllerAcceptPathParams["policyId"], documentId: PolicyDocumentControllerAcceptPathParams["documentId"]) {
  const res = { method: 'POST', url: `/policies/${policyId}/documents/${documentId}/accept` as const }
  return res
}

/**
 * @summary Accept a policy document on a branch
 * {@link /policies/:policyId/documents/:documentId/accept}
 */
export async function policyDocumentControllerAccept(policyId: PolicyDocumentControllerAcceptPathParams["policyId"], documentId: PolicyDocumentControllerAcceptPathParams["documentId"], data: PolicyDocumentControllerAcceptMutationRequest, config: Partial<RequestConfig<PolicyDocumentControllerAcceptMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PolicyDocumentControllerAcceptMutationResponse, ResponseErrorConfig<PolicyDocumentControllerAccept404>, PolicyDocumentControllerAcceptMutationRequest>({ method : "POST", url : getPolicyDocumentControllerAcceptUrl(policyId, documentId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getPolicyDocumentControllerRejectUrl(policyId: PolicyDocumentControllerRejectPathParams["policyId"], documentId: PolicyDocumentControllerRejectPathParams["documentId"]) {
  const res = { method: 'POST', url: `/policies/${policyId}/documents/${documentId}/reject` as const }
  return res
}

/**
 * @summary Reject a policy document on a branch
 * {@link /policies/:policyId/documents/:documentId/reject}
 */
export async function policyDocumentControllerReject(policyId: PolicyDocumentControllerRejectPathParams["policyId"], documentId: PolicyDocumentControllerRejectPathParams["documentId"], data: PolicyDocumentControllerRejectMutationRequest, config: Partial<RequestConfig<PolicyDocumentControllerRejectMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PolicyDocumentControllerRejectMutationResponse, ResponseErrorConfig<PolicyDocumentControllerReject404>, PolicyDocumentControllerRejectMutationRequest>({ method : "POST", url : getPolicyDocumentControllerRejectUrl(policyId, documentId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getPolicyDocumentControllerAcceptAllUrl(policyId: PolicyDocumentControllerAcceptAllPathParams["policyId"]) {
  const res = { method: 'POST', url: `/policies/${policyId}/documents/accept-all` as const }
  return res
}

/**
 * @description With `onlyConform`, only the undecided documents whose verdict is CONFORM are accepted.
 * @summary Accept every reviewable document on a policy branch
 * {@link /policies/:policyId/documents/accept-all}
 */
export async function policyDocumentControllerAcceptAll(policyId: PolicyDocumentControllerAcceptAllPathParams["policyId"], data: PolicyDocumentControllerAcceptAllMutationRequest, config: Partial<RequestConfig<PolicyDocumentControllerAcceptAllMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PolicyDocumentControllerAcceptAllMutationResponse, ResponseErrorConfig<PolicyDocumentControllerAcceptAll409>, PolicyDocumentControllerAcceptAllMutationRequest>({ method : "POST", url : getPolicyDocumentControllerAcceptAllUrl(policyId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getPolicyDocumentControllerCancelUrl(policyId: PolicyDocumentControllerCancelPathParams["policyId"], conformityId: PolicyDocumentControllerCancelPathParams["conformityId"]) {
  const res = { method: 'POST', url: `/policies/${policyId}/documents/conformity/${conformityId}/cancel` as const }
  return res
}

/**
 * @summary Cancel an accept or reject decision
 * {@link /policies/:policyId/documents/conformity/:conformityId/cancel}
 */
export async function policyDocumentControllerCancel(policyId: PolicyDocumentControllerCancelPathParams["policyId"], conformityId: PolicyDocumentControllerCancelPathParams["conformityId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PolicyDocumentControllerCancelMutationResponse, ResponseErrorConfig<PolicyDocumentControllerCancel404>, unknown>({ method : "POST", url : getPolicyDocumentControllerCancelUrl(policyId, conformityId).url.toString(), ... requestConfig })
  return res.data
}

function getPolicyDocumentControllerGetPolicyDocumentConformityUrl(policyId: PolicyDocumentControllerGetPolicyDocumentConformityPathParams["policyId"]) {
  const res = { method: 'GET', url: `/policies/${policyId}/documents/conformity` as const }
  return res
}

/**
 * @summary Get effective document conformity for a policy branch
 * {@link /policies/:policyId/documents/conformity}
 */
export async function policyDocumentControllerGetPolicyDocumentConformity(policyId: PolicyDocumentControllerGetPolicyDocumentConformityPathParams["policyId"], params: PolicyDocumentControllerGetPolicyDocumentConformityQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PolicyDocumentControllerGetPolicyDocumentConformityQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getPolicyDocumentControllerGetPolicyDocumentConformityUrl(policyId).url.toString(), params, ... requestConfig })
  return res.data
}

function getPolicyDocumentControllerGetPolicyDocumentVerdictsUrl(policyId: PolicyDocumentControllerGetPolicyDocumentVerdictsPathParams["policyId"]) {
  const res = { method: 'GET', url: `/policies/${policyId}/documents/verdicts` as const }
  return res
}

/**
 * @summary Get the AI verdict for the documents of a policy branch
 * {@link /policies/:policyId/documents/verdicts}
 */
export async function policyDocumentControllerGetPolicyDocumentVerdicts(policyId: PolicyDocumentControllerGetPolicyDocumentVerdictsPathParams["policyId"], params: PolicyDocumentControllerGetPolicyDocumentVerdictsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PolicyDocumentControllerGetPolicyDocumentVerdictsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getPolicyDocumentControllerGetPolicyDocumentVerdictsUrl(policyId).url.toString(), params, ... requestConfig })
  return res.data
}

function getPolicyDocumentControllerGetPolicyDocumentFraudUrl(policyId: PolicyDocumentControllerGetPolicyDocumentFraudPathParams["policyId"]) {
  const res = { method: 'GET', url: `/policies/${policyId}/documents/fraud` as const }
  return res
}

/**
 * @summary Get current fraud results for the documents of a policy branch
 * {@link /policies/:policyId/documents/fraud}
 */
export async function policyDocumentControllerGetPolicyDocumentFraud(policyId: PolicyDocumentControllerGetPolicyDocumentFraudPathParams["policyId"], params: PolicyDocumentControllerGetPolicyDocumentFraudQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PolicyDocumentControllerGetPolicyDocumentFraudQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getPolicyDocumentControllerGetPolicyDocumentFraudUrl(policyId).url.toString(), params, ... requestConfig })
  return res.data
}

function getPolicyDocumentControllerCorrectPolicyDocumentFraudVerdictUrl(policyId: PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictPathParams["policyId"], documentId: PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictPathParams["documentId"]) {
  const res = { method: 'POST', url: `/policies/${policyId}/documents/fraud/${documentId}/verdict` as const }
  return res
}

/**
 * @summary Set the fraud verdict of a policy document after a human review
 * {@link /policies/:policyId/documents/fraud/:documentId/verdict}
 */
export async function policyDocumentControllerCorrectPolicyDocumentFraudVerdict(policyId: PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictPathParams["policyId"], documentId: PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictPathParams["documentId"], data: PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictMutationRequest, config: Partial<RequestConfig<PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictMutationResponse, ResponseErrorConfig<PolicyDocumentControllerCorrectPolicyDocumentFraudVerdict404 | PolicyDocumentControllerCorrectPolicyDocumentFraudVerdict409>, PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictMutationRequest>({ method : "POST", url : getPolicyDocumentControllerCorrectPolicyDocumentFraudVerdictUrl(policyId, documentId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getBrokerageFirmDocumentControllerAcceptBrokerageFirmDocumentUrl(brokerageFirmId: BrokerageFirmDocumentControllerAcceptBrokerageFirmDocumentPathParams["brokerageFirmId"], documentId: BrokerageFirmDocumentControllerAcceptBrokerageFirmDocumentPathParams["documentId"]) {
  const res = { method: 'POST', url: `/brokerage-firms/${brokerageFirmId}/documents/${documentId}/accept` as const }
  return res
}

/**
 * @summary Accept a brokerage-firm document
 * {@link /brokerage-firms/:brokerageFirmId/documents/:documentId/accept}
 */
export async function brokerageFirmDocumentControllerAcceptBrokerageFirmDocument(brokerageFirmId: BrokerageFirmDocumentControllerAcceptBrokerageFirmDocumentPathParams["brokerageFirmId"], documentId: BrokerageFirmDocumentControllerAcceptBrokerageFirmDocumentPathParams["documentId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<BrokerageFirmDocumentControllerAcceptBrokerageFirmDocumentMutationResponse, ResponseErrorConfig<BrokerageFirmDocumentControllerAcceptBrokerageFirmDocument404>, unknown>({ method : "POST", url : getBrokerageFirmDocumentControllerAcceptBrokerageFirmDocumentUrl(brokerageFirmId, documentId).url.toString(), ... requestConfig })
  return res.data
}

function getBrokerageFirmDocumentControllerRejectBrokerageFirmDocumentUrl(brokerageFirmId: BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentPathParams["brokerageFirmId"], documentId: BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentPathParams["documentId"]) {
  const res = { method: 'POST', url: `/brokerage-firms/${brokerageFirmId}/documents/${documentId}/reject` as const }
  return res
}

/**
 * @summary Reject a brokerage-firm document
 * {@link /brokerage-firms/:brokerageFirmId/documents/:documentId/reject}
 */
export async function brokerageFirmDocumentControllerRejectBrokerageFirmDocument(brokerageFirmId: BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentPathParams["brokerageFirmId"], documentId: BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentPathParams["documentId"], data: BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentMutationRequest, config: Partial<RequestConfig<BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentMutationResponse, ResponseErrorConfig<BrokerageFirmDocumentControllerRejectBrokerageFirmDocument404>, BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentMutationRequest>({ method : "POST", url : getBrokerageFirmDocumentControllerRejectBrokerageFirmDocumentUrl(brokerageFirmId, documentId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getBrokerageFirmDocumentControllerAcceptAllBrokerageFirmDocumentsUrl(brokerageFirmId: BrokerageFirmDocumentControllerAcceptAllBrokerageFirmDocumentsPathParams["brokerageFirmId"]) {
  const res = { method: 'POST', url: `/brokerage-firms/${brokerageFirmId}/documents/accept-all` as const }
  return res
}

/**
 * @summary Accept every reviewable document for a brokerage firm
 * {@link /brokerage-firms/:brokerageFirmId/documents/accept-all}
 */
export async function brokerageFirmDocumentControllerAcceptAllBrokerageFirmDocuments(brokerageFirmId: BrokerageFirmDocumentControllerAcceptAllBrokerageFirmDocumentsPathParams["brokerageFirmId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<BrokerageFirmDocumentControllerAcceptAllBrokerageFirmDocumentsMutationResponse, ResponseErrorConfig<BrokerageFirmDocumentControllerAcceptAllBrokerageFirmDocuments409>, unknown>({ method : "POST", url : getBrokerageFirmDocumentControllerAcceptAllBrokerageFirmDocumentsUrl(brokerageFirmId).url.toString(), ... requestConfig })
  return res.data
}

function getBrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformityUrl(brokerageFirmId: BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformityPathParams["brokerageFirmId"], conformityId: BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformityPathParams["conformityId"]) {
  const res = { method: 'POST', url: `/brokerage-firms/${brokerageFirmId}/documents/conformity/${conformityId}/cancel` as const }
  return res
}

/**
 * @summary Cancel a brokerage-firm document conformity decision
 * {@link /brokerage-firms/:brokerageFirmId/documents/conformity/:conformityId/cancel}
 */
export async function brokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformity(brokerageFirmId: BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformityPathParams["brokerageFirmId"], conformityId: BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformityPathParams["conformityId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformityMutationResponse, ResponseErrorConfig<BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformity404>, unknown>({ method : "POST", url : getBrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformityUrl(brokerageFirmId, conformityId).url.toString(), ... requestConfig })
  return res.data
}

function getBrokerageFirmDocumentControllerGetBrokerageFirmDocumentConformityUrl(brokerageFirmId: BrokerageFirmDocumentControllerGetBrokerageFirmDocumentConformityPathParams["brokerageFirmId"]) {
  const res = { method: 'GET', url: `/brokerage-firms/${brokerageFirmId}/documents/conformity` as const }
  return res
}

/**
 * @summary Get effective document conformity for a brokerage firm
 * {@link /brokerage-firms/:brokerageFirmId/documents/conformity}
 */
export async function brokerageFirmDocumentControllerGetBrokerageFirmDocumentConformity(brokerageFirmId: BrokerageFirmDocumentControllerGetBrokerageFirmDocumentConformityPathParams["brokerageFirmId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<BrokerageFirmDocumentControllerGetBrokerageFirmDocumentConformityQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getBrokerageFirmDocumentControllerGetBrokerageFirmDocumentConformityUrl(brokerageFirmId).url.toString(), ... requestConfig })
  return res.data
}

function getBrokerageFirmDocumentControllerGetBrokerageFirmDocumentFraudUrl(brokerageFirmId: BrokerageFirmDocumentControllerGetBrokerageFirmDocumentFraudPathParams["brokerageFirmId"]) {
  const res = { method: 'GET', url: `/brokerage-firms/${brokerageFirmId}/documents/fraud` as const }
  return res
}

/**
 * @summary Get current fraud results for the onboarding documents of a firm
 * {@link /brokerage-firms/:brokerageFirmId/documents/fraud}
 */
export async function brokerageFirmDocumentControllerGetBrokerageFirmDocumentFraud(brokerageFirmId: BrokerageFirmDocumentControllerGetBrokerageFirmDocumentFraudPathParams["brokerageFirmId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<BrokerageFirmDocumentControllerGetBrokerageFirmDocumentFraudQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getBrokerageFirmDocumentControllerGetBrokerageFirmDocumentFraudUrl(brokerageFirmId).url.toString(), ... requestConfig })
  return res.data
}

function getBrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictUrl(brokerageFirmId: BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictPathParams["brokerageFirmId"], documentId: BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictPathParams["documentId"]) {
  const res = { method: 'POST', url: `/brokerage-firms/${brokerageFirmId}/documents/fraud/${documentId}/verdict` as const }
  return res
}

/**
 * @summary Set the fraud verdict of a brokerage-firm document after a human review
 * {@link /brokerage-firms/:brokerageFirmId/documents/fraud/:documentId/verdict}
 */
export async function brokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdict(brokerageFirmId: BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictPathParams["brokerageFirmId"], documentId: BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictPathParams["documentId"], data: BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictMutationRequest, config: Partial<RequestConfig<BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictMutationResponse, ResponseErrorConfig<BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdict404 | BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdict409>, BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictMutationRequest>({ method : "POST", url : getBrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictUrl(brokerageFirmId, documentId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getPolicyDocumentCollectionControllerGetCollectionStateUrl(policyId: PolicyDocumentCollectionControllerGetCollectionStatePathParams["policyId"]) {
  const res = { method: 'GET', url: `/policies/${policyId}/document-collection` as const }
  return res
}

/**
 * @summary Get document collection status for a policy branch
 * {@link /policies/:policyId/document-collection}
 */
export async function policyDocumentCollectionControllerGetCollectionState(policyId: PolicyDocumentCollectionControllerGetCollectionStatePathParams["policyId"], params: PolicyDocumentCollectionControllerGetCollectionStateQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PolicyDocumentCollectionControllerGetCollectionStateQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getPolicyDocumentCollectionControllerGetCollectionStateUrl(policyId).url.toString(), params, ... requestConfig })
  return res.data
}

function getPolicyDocumentExtractionControllerGetPolicyExtractionsUrl(policyId: PolicyDocumentExtractionControllerGetPolicyExtractionsPathParams["policyId"]) {
  const res = { method: 'GET', url: `/policies/${policyId}/document-extractions` as const }
  return res
}

/**
 * @summary List document extractions for a policy
 * {@link /policies/:policyId/document-extractions}
 */
export async function policyDocumentExtractionControllerGetPolicyExtractions(policyId: PolicyDocumentExtractionControllerGetPolicyExtractionsPathParams["policyId"], params?: PolicyDocumentExtractionControllerGetPolicyExtractionsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PolicyDocumentExtractionControllerGetPolicyExtractionsQueryResponse, ResponseErrorConfig<PolicyDocumentExtractionControllerGetPolicyExtractions404>, unknown>({ method : "GET", url : getPolicyDocumentExtractionControllerGetPolicyExtractionsUrl(policyId).url.toString(), params, ... requestConfig })
  return res.data
}

function getDocumentExtractionControllerGetDocumentExtractionUrl(documentId: DocumentExtractionControllerGetDocumentExtractionPathParams["documentId"]) {
  const res = { method: 'GET', url: `/document-extractions/${documentId}` as const }
  return res
}

/**
 * @summary Get a specific document extraction
 * {@link /document-extractions/:documentId}
 */
export async function documentExtractionControllerGetDocumentExtraction(documentId: DocumentExtractionControllerGetDocumentExtractionPathParams["documentId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DocumentExtractionControllerGetDocumentExtractionQueryResponse, ResponseErrorConfig<DocumentExtractionControllerGetDocumentExtraction404>, unknown>({ method : "GET", url : getDocumentExtractionControllerGetDocumentExtractionUrl(documentId).url.toString(), ... requestConfig })
  return res.data
}

function getDocumentExtractionControllerRetryDocumentExtractionUrl(documentId: DocumentExtractionControllerRetryDocumentExtractionPathParams["documentId"]) {
  const res = { method: 'POST', url: `/document-extractions/${documentId}/retry` as const }
  return res
}

/**
 * @summary Retry a document extraction
 * {@link /document-extractions/:documentId/retry}
 */
export async function documentExtractionControllerRetryDocumentExtraction(documentId: DocumentExtractionControllerRetryDocumentExtractionPathParams["documentId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DocumentExtractionControllerRetryDocumentExtractionMutationResponse, ResponseErrorConfig<DocumentExtractionControllerRetryDocumentExtraction404>, unknown>({ method : "POST", url : getDocumentExtractionControllerRetryDocumentExtractionUrl(documentId).url.toString(), ... requestConfig })
  return res.data
}

function getDocumentExtractionControllerSubmitExtractionFeedbackUrl(documentId: DocumentExtractionControllerSubmitExtractionFeedbackPathParams["documentId"]) {
  const res = { method: 'POST', url: `/document-extractions/${documentId}/feedback` as const }
  return res
}

/**
 * @summary Submit feedback for a document extraction
 * {@link /document-extractions/:documentId/feedback}
 */
export async function documentExtractionControllerSubmitExtractionFeedback(documentId: DocumentExtractionControllerSubmitExtractionFeedbackPathParams["documentId"], data: DocumentExtractionControllerSubmitExtractionFeedbackMutationRequest, config: Partial<RequestConfig<DocumentExtractionControllerSubmitExtractionFeedbackMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<DocumentExtractionControllerSubmitExtractionFeedbackMutationResponse, ResponseErrorConfig<Error>, DocumentExtractionControllerSubmitExtractionFeedbackMutationRequest>({ method : "POST", url : getDocumentExtractionControllerSubmitExtractionFeedbackUrl(documentId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getDocumentExtractionControllerGetExtractionFeedbackUrl(documentId: DocumentExtractionControllerGetExtractionFeedbackPathParams["documentId"]) {
  const res = { method: 'GET', url: `/document-extractions/${documentId}/feedback` as const }
  return res
}

/**
 * @summary Get feedback for a document extraction
 * {@link /document-extractions/:documentId/feedback}
 */
export async function documentExtractionControllerGetExtractionFeedback(documentId: DocumentExtractionControllerGetExtractionFeedbackPathParams["documentId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DocumentExtractionControllerGetExtractionFeedbackQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getDocumentExtractionControllerGetExtractionFeedbackUrl(documentId).url.toString(), ... requestConfig })
  return res.data
}

function getBrokerageFirmDocumentExtractionControllerGetBrokerageFirmExtractionsUrl(brokerageFirmId: BrokerageFirmDocumentExtractionControllerGetBrokerageFirmExtractionsPathParams["brokerageFirmId"]) {
  const res = { method: 'GET', url: `/brokerage-firms/${brokerageFirmId}/document-extractions` as const }
  return res
}

/**
 * @summary List document extractions for a brokerage firm
 * {@link /brokerage-firms/:brokerageFirmId/document-extractions}
 */
export async function brokerageFirmDocumentExtractionControllerGetBrokerageFirmExtractions(brokerageFirmId: BrokerageFirmDocumentExtractionControllerGetBrokerageFirmExtractionsPathParams["brokerageFirmId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<BrokerageFirmDocumentExtractionControllerGetBrokerageFirmExtractionsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getBrokerageFirmDocumentExtractionControllerGetBrokerageFirmExtractionsUrl(brokerageFirmId).url.toString(), ... requestConfig })
  return res.data
}

function getDocumentPrefillControllerRecordOutcomeUrl() {
  const res = { method: 'POST', url: `/document-prefill/outcomes` as const }
  return res
}

/**
 * @summary Record the outcome of a single prefilled field (kept vs replaced)
 * {@link /document-prefill/outcomes}
 */
export async function documentPrefillControllerRecordOutcome(data: DocumentPrefillControllerRecordOutcomeMutationRequest, config: Partial<RequestConfig<DocumentPrefillControllerRecordOutcomeMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<DocumentPrefillControllerRecordOutcomeMutationResponse, ResponseErrorConfig<Error>, DocumentPrefillControllerRecordOutcomeMutationRequest>({ method : "POST", url : getDocumentPrefillControllerRecordOutcomeUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getJwksControllerGetJwksUrl() {
  const res = { method: 'GET', url: `/.well-known/jwks.json` as const }
  return res
}

/**
 * @description Advertises the public keys used to verify Korint-signed JWTs.
 * @summary Get the JSON Web Key Set
 * {@link /.well-known/jwks.json}
 */
export async function jwksControllerGetJwks(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<JwksControllerGetJwksQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getJwksControllerGetJwksUrl().url.toString(), ... requestConfig })
  return res.data
}

function getImpersonationControllerCreateSessionUrl() {
  const res = { method: 'POST', url: `/impersonation/sessions` as const }
  return res
}

/**
 * @summary Start an impersonation session for a tenant end user
 * {@link /impersonation/sessions}
 */
export async function impersonationControllerCreateSession(data: ImpersonationControllerCreateSessionMutationRequest, config: Partial<RequestConfig<ImpersonationControllerCreateSessionMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ImpersonationControllerCreateSessionMutationResponse, ResponseErrorConfig<Error>, ImpersonationControllerCreateSessionMutationRequest>({ method : "POST", url : getImpersonationControllerCreateSessionUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getImpersonationControllerListSessionsUrl() {
  const res = { method: 'GET', url: `/impersonation/sessions` as const }
  return res
}

/**
 * @summary List impersonation sessions, live or past
 * {@link /impersonation/sessions}
 */
export async function impersonationControllerListSessions(params?: ImpersonationControllerListSessionsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ImpersonationControllerListSessionsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getImpersonationControllerListSessionsUrl().url.toString(), params, ... requestConfig })
  return res.data
}

function getImpersonationControllerRevokeCurrentSessionUrl() {
  const res = { method: 'DELETE', url: `/impersonation/sessions/current` as const }
  return res
}

/**
 * @summary End the impersonation session presented in the Authorization header
 * {@link /impersonation/sessions/current}
 */
export async function impersonationControllerRevokeCurrentSession(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ImpersonationControllerRevokeCurrentSessionMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "DELETE", url : getImpersonationControllerRevokeCurrentSessionUrl().url.toString(), ... requestConfig })
  return res.data
}

function getImpersonationControllerRevokeSessionUrl(sessionId: ImpersonationControllerRevokeSessionPathParams["sessionId"]) {
  const res = { method: 'DELETE', url: `/impersonation/sessions/${sessionId}` as const }
  return res
}

/**
 * @summary Revoke an impersonation session
 * {@link /impersonation/sessions/:sessionId}
 */
export async function impersonationControllerRevokeSession(sessionId: ImpersonationControllerRevokeSessionPathParams["sessionId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ImpersonationControllerRevokeSessionMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "DELETE", url : getImpersonationControllerRevokeSessionUrl(sessionId).url.toString(), ... requestConfig })
  return res.data
}

function getFederatedSessionControllerRevokeCurrentSessionUrl() {
  const res = { method: 'DELETE', url: `/federated-sessions/current` as const }
  return res
}

/**
 * @summary End the federated session presented in the Authorization header
 * {@link /federated-sessions/current}
 */
export async function federatedSessionControllerRevokeCurrentSession(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<FederatedSessionControllerRevokeCurrentSessionMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "DELETE", url : getFederatedSessionControllerRevokeCurrentSessionUrl().url.toString(), ... requestConfig })
  return res.data
}

function getSpeechToTextControllerGetCredentialsUrl() {
  const res = { method: 'POST', url: `/speech-to-text/credentials` as const }
  return res
}

/**
 * @summary Get short-lived speech-to-text credentials
 * {@link /speech-to-text/credentials}
 */
export async function speechToTextControllerGetCredentials(data: SpeechToTextControllerGetCredentialsMutationRequest, config: Partial<RequestConfig<SpeechToTextControllerGetCredentialsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<SpeechToTextControllerGetCredentialsMutationResponse, ResponseErrorConfig<Error>, SpeechToTextControllerGetCredentialsMutationRequest>({ method : "POST", url : getSpeechToTextControllerGetCredentialsUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}

function getFcbWidgetControllerMintTokenUrl() {
  const res = { method: 'GET', url: `/fcb-widget/token` as const }
  return res
}

/**
 * @summary Mint a short-lived RS256 JWT for the FCB WhatsApp widget
 * {@link /fcb-widget/token}
 */
export async function fcbWidgetControllerMintToken(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<FcbWidgetControllerMintTokenQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getFcbWidgetControllerMintTokenUrl().url.toString(), ... requestConfig })
  return res.data
}

function getFcbWidgetControllerInitWhatsappConversationUrl() {
  const res = { method: 'POST', url: `/fcb-widget/whatsapp/init` as const }
  return res
}

/**
 * @summary Initialise a WhatsApp conversation for the authenticated user via FCB
 * {@link /fcb-widget/whatsapp/init}
 */
export async function fcbWidgetControllerInitWhatsappConversation(data: FcbWidgetControllerInitWhatsappConversationMutationRequest, config: Partial<RequestConfig<FcbWidgetControllerInitWhatsappConversationMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<FcbWidgetControllerInitWhatsappConversationMutationResponse, ResponseErrorConfig<Error>, FcbWidgetControllerInitWhatsappConversationMutationRequest>({ method : "POST", url : getFcbWidgetControllerInitWhatsappConversationUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}